/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@splidejs/splide/dist/js/splide.esm.js":
/*!*************************************************************!*\
  !*** ./node_modules/@splidejs/splide/dist/js/splide.esm.js ***!
  \*************************************************************/
/***/ ((module) => {

        /*!
         * Splide.js
         * Version  : 2.4.20
         * License  : MIT
         * Copyright: 2020 Naotoshi Fujita
         */
        (function webpackUniversalModuleDefinition(root, factory) {
          if (true)
            module.exports = factory();
          else { }
        })(self, function () {
          return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 311:
/***/ ((__unused_webpack_module, __webpack_exports__, __nested_webpack_require_627__) => {

                  // ESM COMPAT FLAG
                  __nested_webpack_require_627__.r(__webpack_exports__);

                  // EXPORTS
                  __nested_webpack_require_627__.d(__webpack_exports__, {
                    "default": () => /* binding */ module_Splide
                  });

                  // NAMESPACE OBJECT: ./src/js/constants/states.js
                  var states_namespaceObject = {};
                  __nested_webpack_require_627__.r(states_namespaceObject);
                  __nested_webpack_require_627__.d(states_namespaceObject, {
                    "CREATED": () => CREATED,
                    "DESTROYED": () => DESTROYED,
                    "IDLE": () => IDLE,
                    "MOUNTED": () => MOUNTED,
                    "MOVING": () => MOVING
                  });

                  ;// CONCATENATED MODULE: ./src/js/core/event.js
/**
 * The function for providing an Event object simply managing events.
 *
 * @author    Naotoshi Fujita
 * @copyright Naotoshi Fujita. All rights reserved.
 */

/**
 * The function for providing an Event object simply managing events.
 */
/* harmony default export */ const core_event = (function () {
                    /**
                     * Store all event data.
                     *
                     * @type {Array}
                     */
                    var data = [];
                    var Event = {
                      /**
                       * Subscribe the given event(s).
                       *
                       * @param {string}   events  - An event name. Use space to separate multiple events.
                       *                             Also, namespace is accepted by dot, such as 'resize.{namespace}'.
                       * @param {function} handler - A callback function.
                       * @param {Element}  elm     - Optional. Native event will be listened to when this arg is provided.
                       * @param {Object}   options - Optional. Options for addEventListener.
                       */
                      on: function on(events, handler, elm, options) {
                        if (elm === void 0) {
                          elm = null;
                        }

                        if (options === void 0) {
                          options = {};
                        }

                        events.split(' ').forEach(function (event) {
                          if (elm) {
                            elm.addEventListener(event, handler, options);
                          }

                          data.push({
                            event: event,
                            handler: handler,
                            elm: elm,
                            options: options
                          });
                        });
                      },

                      /**
                       * Unsubscribe the given event(s).
                       *
                       * @param {string}  events - A event name or names split by space.
                       * @param {Element} elm    - Optional. removeEventListener() will be called when this arg is provided.
                       */
                      off: function off(events, elm) {
                        if (elm === void 0) {
                          elm = null;
                        }

                        events.split(' ').forEach(function (event) {
                          data = data.filter(function (item) {
                            if (item && item.event === event && item.elm === elm) {
                              unsubscribe(item);
                              return false;
                            }

                            return true;
                          });
                        });
                      },

                      /**
                       * Emit an event.
                       * This method is only for custom events.
                       *
                       * @param {string}  event - An event name.
                       * @param {*}       args  - Any number of arguments passed to handlers.
                       */
                      emit: function emit(event) {
                        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                          args[_key - 1] = arguments[_key];
                        }

                        data.forEach(function (item) {
                          if (!item.elm && item.event.split('.')[0] === event) {
                            item.handler.apply(item, args);
                          }
                        });
                      },

                      /**
                       * Clear event data.
                       */
                      destroy: function destroy() {
                        data.forEach(unsubscribe);
                        data = [];
                      }
                    };
                    /**
                     * Remove the registered event listener.
                     *
                     * @param {Object} item - An object containing event data.
                     */

                    function unsubscribe(item) {
                      if (item.elm) {
                        item.elm.removeEventListener(item.event, item.handler, item.options);
                      }
                    }

                    return Event;
                  });
                  ;// CONCATENATED MODULE: ./src/js/core/state.js
/**
 * The function providing a super simple state system.
 *
 * @author    Naotoshi Fujita
 * @copyright Naotoshi Fujita. All rights reserved.
 */

/**
 * The function providing a super simple state system.
 *
 * @param {string|number} initialState - Provide the initial state value.
 */
/* harmony default export */ const state = (function (initialState) {
                    /**
                     * Store the current state.
                     *
                     * @type {string|number}
                     */
                    var curr = initialState;
                    return {
                      /**
                       * Change state.
                       *
                       * @param {string|number} state - A new state.
                       */
                      set: function set(state) {
                        curr = state;
                      },

                      /**
                       * Verify if the current state is given one or not.
                       *
                       * @param {string|number} state - A state name to be verified.
                       *
                       * @return {boolean} - True if the current state is the given one.
                       */
                      is: function is(state) {
                        return state === curr;
                      }
                    };
                  });
                  ;// CONCATENATED MODULE: ./src/js/utils/object.js
                  function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

                  /**
                   * Some utility functions related with Object, supporting IE.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */
                  var keys = Object.keys;
                  /**
                   * Iterate an object like Array.forEach.
                   * IE doesn't support forEach of HTMLCollection.
                   *
                   * @param {Object}    obj       - An object.
                   * @param {function}  callback  - A function handling each value. Arguments are value, property and index.
                   */

                  function each(obj, callback) {
                    keys(obj).some(function (key, index) {
                      return callback(obj[key], key, index);
                    });
                  }
                  /**
                   * Return values of the given object as an array.
                   * IE doesn't support Object.values.
                   *
                   * @param {Object} obj - An object.
                   *
                   * @return {Array} - An array containing all values of the given object.
                   */

                  function values(obj) {
                    return keys(obj).map(function (key) {
                      return obj[key];
                    });
                  }
                  /**
                   * Check if the given subject is object or not.
                   *
                   * @param {*} subject - A subject to be verified.
                   *
                   * @return {boolean} - True if object, false otherwise.
                   */

                  function isObject(subject) {
                    return typeof subject === 'object';
                  }
                  /**
                   * Merge two objects deeply.
                   *
                   * @param {Object} to   - An object where "from" is merged.
                   * @param {Object} from - An object merged to "to".
                   *
                   * @return {Object} - A merged object.
                   */

                  function merge(_ref, from) {
                    var to = _extends({}, _ref);

                    each(from, function (value, key) {
                      if (isObject(value)) {
                        if (!isObject(to[key])) {
                          to[key] = {};
                        }

                        to[key] = merge(to[key], value);
                      } else {
                        to[key] = value;
                      }
                    });
                    return to;
                  }
                  /**
                   * Assign all properties "from" to "to" object.
                   *
                   * @param {Object} to   - An object where properties are assigned.
                   * @param {Object} from - An object whose properties are assigned to "to".
                   *
                   * @return {Object} - An assigned object.
                   */

                  function object_assign(to, from) {
                    keys(from).forEach(function (key) {
                      if (!to[key]) {
                        Object.defineProperty(to, key, Object.getOwnPropertyDescriptor(from, key));
                      }
                    });
                    return to;
                  }
                  ;// CONCATENATED MODULE: ./src/js/utils/utils.js
                  /**
                   * A package of some miscellaneous utility functions.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */

                  /**
                   * Convert the given value to array.
                   *
                   * @param {*} value - Any value.
                   *
                   * @return {*[]} - Array containing the given value.
                   */

                  function toArray(value) {
                    return Array.isArray(value) ? value : [value];
                  }
                  /**
                   * Check if the given value is between min and max.
                   * Min will be returned when the value is less than min or max will do when greater than max.
                   *
                   * @param {number} value - A number to be checked.
                   * @param {number} m1    - Minimum or maximum number.
                   * @param {number} m2    - Maximum or minimum number.
                   *
                   * @return {number} - A value itself, min or max.
                   */

                  function between(value, m1, m2) {
                    return Math.min(Math.max(value, m1 > m2 ? m2 : m1), m1 > m2 ? m1 : m2);
                  }
                  /**
                   * The sprintf method with minimum functionality.
                   *
                   * @param {string}       format       - The string format.
                   * @param {string|Array} replacements - Replacements accepting multiple arguments.
                   *
                   * @returns {string} - Converted string.
                   */

                  function sprintf(format, replacements) {
                    var i = 0;
                    return format.replace(/%s/g, function () {
                      return toArray(replacements)[i++];
                    });
                  }
                  /**
                   * Append px unit to the given subject if necessary.
                   *
                   * @param {number|string} value - A value that may not include an unit.
                   *
                   * @return {string} - If the value is string, return itself.
                   *                    If number, do value + "px". An empty string, otherwise.
                   */

                  function unit(value) {
                    var type = typeof value;

                    if (type === 'number' && value > 0) {
                      return parseFloat(value) + 'px';
                    }

                    return type === 'string' ? value : '';
                  }
                  /**
                   * Pad start with 0.
                   *
                   * @param {number} number - A number to be filled with 0.
                   *
                   * @return {string|number} - Padded number.
                   */

                  function pad(number) {
                    return number < 10 ? '0' + number : number;
                  }
                  /**
                   * Convert the given value to pixel.
                   *
                   * @param {Element}       root  - Root element where a dummy div is appended.
                   * @param {string|number} value - CSS value to be converted, such as 10rem.
                   *
                   * @return {number} - Pixel.
                   */

                  function toPixel(root, value) {
                    if (typeof value === 'string') {
                      var div = create('div', {});
                      applyStyle(div, {
                        position: 'absolute',
                        width: value
                      });
                      append(root, div);
                      value = div.clientWidth;
                      dom_remove(div);
                    }

                    return +value || 0;
                  }
                  ;// CONCATENATED MODULE: ./src/js/utils/dom.js
                  /**
                   * Some utility functions related with DOM.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */


                  /**
                   * Find the first element matching the given selector.
                   * Be aware that all selectors after a space are ignored.
                   *
                   * @param {Element|Node}  elm       - An ancestor element.
                   * @param {string}        selector  - DOMString.
                   *
                   * @return {Element|null} - A found element or null.
                   */

                  function find(elm, selector) {
                    return elm ? elm.querySelector(selector.split(' ')[0]) : null;
                  }
                  /**
                   * Find a first child having the given tag or class name.
                   *
                   * @param {Element} parent         - A parent element.
                   * @param {string}  tagOrClassName - A tag or class name.
                   *
                   * @return {Element|undefined} - A found element on success or undefined on failure.
                   */

                  function child(parent, tagOrClassName) {
                    return children(parent, tagOrClassName)[0];
                  }
                  /**
                   * Return chile elements that matches the provided tag or class name.
                   *
                   * @param {Element} parent         - A parent element.
                   * @param {string}  tagOrClassName - A tag or class name.
                   *
                   * @return {Element[]} - Found elements.
                   */

                  function children(parent, tagOrClassName) {
                    if (parent) {
                      return values(parent.children).filter(function (child) {
                        return hasClass(child, tagOrClassName.split(' ')[0]) || child.tagName === tagOrClassName;
                      });
                    }

                    return [];
                  }
                  /**
                   * Create an element with some optional attributes.
                   *
                   * @param {string} tag   - A tag name.
                   * @param {Object} attrs - An object any attribute pairs of name and value.
                   *
                   * @return {Element} - A created element.
                   */

                  function create(tag, attrs) {
                    var elm = document.createElement(tag);
                    each(attrs, function (value, key) {
                      return setAttribute(elm, key, value);
                    });
                    return elm;
                  }
                  /**
                   * Convert HTML string to DOM node.
                   *
                   * @param {string} html - HTML string.
                   *
                   * @return {Node} - A created node.
                   */

                  function domify(html) {
                    var div = create('div', {});
                    div.innerHTML = html;
                    return div.firstChild;
                  }
                  /**
                   * Remove a given element from a DOM tree.
                   *
                   * @param {Element|Element[]} elms - Element(s) to be removed.
                   */

                  function dom_remove(elms) {
                    toArray(elms).forEach(function (elm) {
                      if (elm) {
                        var parent = elm.parentElement;
                        parent && parent.removeChild(elm);
                      }
                    });
                  }
                  /**
                   * Append a child to a given element.
                   *
                   * @param {Element} parent - A parent element.
                   * @param {Element} child  - An element to be appended.
                   */

                  function append(parent, child) {
                    if (parent) {
                      parent.appendChild(child);
                    }
                  }
                  /**
                   * Insert an element before the reference element.
                   *
                   * @param {Element|Node} ref - A reference element.
                   * @param {Element}      elm - An element to be inserted.
                   */

                  function before(elm, ref) {
                    if (elm && ref) {
                      var parent = ref.parentElement;
                      parent && parent.insertBefore(elm, ref);
                    }
                  }
                  /**
                   * Apply styles to the given element.
                   *
                   * @param {Element} elm     - An element where styles are applied.
                   * @param {Object}  styles  - Object containing styles.
                   */

                  function applyStyle(elm, styles) {
                    if (elm) {
                      each(styles, function (value, prop) {
                        if (value !== null) {
                          elm.style[prop] = value;
                        }
                      });
                    }
                  }
                  /**
                   * Add or remove classes to/from the element.
                   * This function is for internal usage.
                   *
                   * @param {Element}         elm     - An element where classes are added.
                   * @param {string|string[]} classes - Class names being added.
                   * @param {boolean}         remove  - Whether to remove or add classes.
                   */

                  function addOrRemoveClasses(elm, classes, remove) {
                    if (elm) {
                      toArray(classes).forEach(function (name) {
                        if (name) {
                          elm.classList[remove ? 'remove' : 'add'](name);
                        }
                      });
                    }
                  }
                  /**
                   * Add classes to the element.
                   *
                   * @param {Element}          elm     - An element where classes are added.
                   * @param {string|string[]}  classes - Class names being added.
                   */


                  function addClass(elm, classes) {
                    addOrRemoveClasses(elm, classes, false);
                  }
                  /**
                   * Remove a class from the element.
                   *
                   * @param {Element}         elm     - An element where classes are removed.
                   * @param {string|string[]} classes - A class name being removed.
                   */

                  function removeClass(elm, classes) {
                    addOrRemoveClasses(elm, classes, true);
                  }
                  /**
                   * Verify if the provided element has the class or not.
                   *
                   * @param {Element} elm       - An element.
                   * @param {string}  className - A class name.
                   *
                   * @return {boolean} - True if the element has the class or false if not.
                   */

                  function hasClass(elm, className) {
                    return !!elm && elm.classList.contains(className);
                  }
                  /**
                   * Set attribute to the given element.
                   *
                   * @param {Element}                 elm   - An element where an attribute is assigned.
                   * @param {string}                  name  - Attribute name.
                   * @param {string|number|boolean}   value - Attribute value.
                   */

                  function setAttribute(elm, name, value) {
                    if (elm) {
                      elm.setAttribute(name, value);
                    }
                  }
                  /**
                   * Get attribute from the given element.
                   *
                   * @param {Element} elm  - An element where an attribute is assigned.
                   * @param {string}  name - Attribute name.
                   *
                   * @return {string} - The value of the given attribute if available. An empty string if not.
                   */

                  function getAttribute(elm, name) {
                    return elm ? elm.getAttribute(name) : '';
                  }
                  /**
                   * Remove attribute from the given element.
                   *
                   * @param {Element|Element[]} elms  - An element where an attribute is removed.
                   * @param {string|string[]}      names - Attribute name.
                   */

                  function removeAttribute(elms, names) {
                    toArray(names).forEach(function (name) {
                      toArray(elms).forEach(function (elm) {
                        return elm && elm.removeAttribute(name);
                      });
                    });
                  }
                  /**
                   * Return the Rect object of the provided object.
                   *
                   * @param {Element} elm - An element.
                   *
                   * @return {ClientRect|DOMRect} - A rect object.
                   */

                  function getRect(elm) {
                    return elm.getBoundingClientRect();
                  }
                  /**
                   * Trigger the given callback after all images contained by the element are loaded.
                   *
                   * @param {Element}  elm      - Element that may contain images.
                   * @param {Function} callback - Callback function fired right after all images are loaded.
                   */

                  function loaded(elm, callback) {
                    var images = elm.querySelectorAll('img');
                    var length = images.length;

                    if (length) {
                      var count = 0;
                      each(images, function (img) {
                        img.onload = img.onerror = function () {
                          if (++count === length) {
                            callback();
                          }
                        };
                      });
                    } else {
                      // Trigger the callback immediately if there is no image.
                      callback();
                    }
                  }
                  ;// CONCATENATED MODULE: ./src/js/constants/types.js
                  /**
                   * Export slider types.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */

                  /**
                   * Normal slider.
                   *
                   * @type {string}
                   */
                  var SLIDE = 'slide';
                  /**
                   * Loop after the last slide and before the first one.
                   *
                   * @type {string}
                   */

                  var LOOP = 'loop';
                  /**
                   * The track doesn't move.
                   *
                   * @type {string}
                   */

                  var FADE = 'fade';
                  ;// CONCATENATED MODULE: ./src/js/transitions/slide/index.js
/**
 * The component for general slide effect transition.
 *
 * @author    Naotoshi Fujita
 * @copyright Naotoshi Fujita. All rights reserved.
 */


/**
 * The component for general slide effect transition.
 *
 * @param {Splide} Splide     - A Splide instance.
 * @param {Object} Components - An object containing components.
 *
 * @return {Object} - The component object.
 */

/* harmony default export */ const slide = (function (Splide, Components) {
                    /**
                     * Hold the list element.
                     *
                     * @type {Element}
                     */
                    var list;
                    /**
                     * Hold the onEnd callback function.
                     *
                     * @type {function}
                     */

                    var endCallback;
                    return {
                      /**
                       * Called when the component is mounted.
                       */
                      mount: function mount() {
                        list = Components.Elements.list;
                        Splide.on('transitionend', function (e) {
                          if (e.target === list && endCallback) {
                            endCallback();
                          }
                        }, list);
                      },

                      /**
                       * Start transition.
                       *
                       * @param {number}   destIndex - Destination slide index that might be clone's.
                       * @param {number}   newIndex  - New index.
                       * @param {number}   prevIndex - Previous index.
                       * @param {Object}   coord     - Destination coordinates.
                       * @param {function} done      - Callback function must be invoked when transition is completed.
                       */
                      start: function start(destIndex, newIndex, prevIndex, coord, done) {
                        var options = Splide.options;
                        var edgeIndex = Components.Controller.edgeIndex;
                        var speed = options.speed;
                        endCallback = done;

                        if (Splide.is(SLIDE)) {
                          if (prevIndex === 0 && newIndex >= edgeIndex || prevIndex >= edgeIndex && newIndex === 0) {
                            speed = options.rewindSpeed || speed;
                          }
                        }

                        applyStyle(list, {
                          transition: "transform " + speed + "ms " + options.easing,
                          transform: "translate(" + coord.x + "px," + coord.y + "px)"
                        });
                      }
                    };
                  });
                  ;// CONCATENATED MODULE: ./src/js/transitions/fade/index.js
/**
 * The component for fade transition.
 *
 * @author    Naotoshi Fujita
 * @copyright Naotoshi Fujita. All rights reserved.
 */


/**
 * The component for fade transition.
 *
 * @param {Splide} Splide     - A Splide instance.
 * @param {Object} Components - An object containing components.
 *
 * @return {Object} - The component object.
 */

/* harmony default export */ const fade = (function (Splide, Components) {
                    var Fade = {
                      /**
                       * Called when the component is mounted.
                       * Apply transition style to the first slide.
                       */
                      mount: function mount() {
                        apply(Splide.index);
                      },

                      /**
                       * Start transition.
                       *
                       * @param {number}    destIndex - Destination slide index that might be clone's.
                       * @param {number}    newIndex  - New index.
                       * @param {number}    prevIndex - Previous index.
                       * @param {Object}    coord     - Destination coordinates.
                       * @param {function}  done      - Callback function must be invoked when transition is completed.
                       */
                      start: function start(destIndex, newIndex, prevIndex, coord, done) {
                        var track = Components.Elements.track;
                        applyStyle(track, {
                          height: unit(track.clientHeight)
                        });
                        apply(newIndex);
                        setTimeout(function () {
                          done();
                          applyStyle(track, {
                            height: ''
                          });
                        });
                      }
                    };
                    /**
                     * Apply transition style to the slide specified by the given index.
                     *
                     * @param {number} index - A slide index.
                     */

                    function apply(index) {
                      var options = Splide.options;
                      applyStyle(Components.Elements.slides[index], {
                        transition: "opacity " + options.speed + "ms " + options.easing
                      });
                    }

                    return Fade;
                  });
                  ;// CONCATENATED MODULE: ./src/js/transitions/index.js
                  /**
                   * Export transition components.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */


                  ;// CONCATENATED MODULE: ./src/js/core/composer.js
                  /**
                   * Provide a function for composing components.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */



                  /**
                   * Compose components.
                   *
                   * @param {Splide}   Splide     - Splide instance.
                   * @param {Object}   Components - Additional components.
                   * @param {function} Transition - Change component for transition.
                   *
                   * @return {Object} - An object containing all components.
                   */

                  function compose(Splide, Components, Transition) {
                    var components = {};
                    each(Components, function (Component, name) {
                      components[name] = Component(Splide, components, name.toLowerCase());
                    });

                    if (!Transition) {
                      Transition = Splide.is(FADE) ? fade : slide;
                    }

                    components.Transition = Transition(Splide, components);
                    return components;
                  }
                  ;// CONCATENATED MODULE: ./src/js/utils/error.js
                  /**
                   * Utility functions for outputting logs.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */

                  /**
                   * Prefix of an error massage.
                   *
                   * @type {string}
                   */
                  var MESSAGE_PREFIX = '[SPLIDE]';
                  /**
                   * Display an error message on the browser console.
                   *
                   * @param {string} message - An error message.
                   */

                  function error(message) {
                    console.error(MESSAGE_PREFIX + " " + message);
                  }
                  /**
                   * Check existence of the given object and throw an error if it doesn't.
                   *
                   * @throws {Error}
                   *
                   * @param {*}      subject - A subject to be confirmed.
                   * @param {string} message - An error message.
                   */

                  function exist(subject, message) {
                    if (!subject) {
                      throw new Error(message);
                    }
                  }
                  ;// CONCATENATED MODULE: ./src/js/constants/classes.js
                  /**
                   * Export class names.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */

                  /**
                   * A root class name.
                   *
                   * @type {string}
                   */
                  var ROOT = 'splide';
                  /**
                   * The definition table of all classes for elements.
                   * They might be modified by options.
                   *
                   * @type {Object}
                   */

                  var ELEMENT_CLASSES = {
                    root: ROOT,
                    slider: ROOT + "__slider",
                    track: ROOT + "__track",
                    list: ROOT + "__list",
                    slide: ROOT + "__slide",
                    container: ROOT + "__slide__container",
                    arrows: ROOT + "__arrows",
                    arrow: ROOT + "__arrow",
                    prev: ROOT + "__arrow--prev",
                    next: ROOT + "__arrow--next",
                    pagination: ROOT + "__pagination",
                    page: ROOT + "__pagination__page",
                    clone: ROOT + "__slide--clone",
                    progress: ROOT + "__progress",
                    bar: ROOT + "__progress__bar",
                    autoplay: ROOT + "__autoplay",
                    play: ROOT + "__play",
                    pause: ROOT + "__pause",
                    spinner: ROOT + "__spinner",
                    sr: ROOT + "__sr"
                  };
                  /**
                   * Definitions of status classes.
                   *
                   * @type {Object}
                   */

                  var STATUS_CLASSES = {
                    active: 'is-active',
                    visible: 'is-visible',
                    loading: 'is-loading'
                  };
                  ;// CONCATENATED MODULE: ./src/js/constants/i18n.js
                  /**
                   * Export i18n texts as object.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */

                  /**
                   * Texts for i18n.
                   *
                   * @type {Object}
                   */
                  var I18N = {
                    prev: 'Previous slide',
                    next: 'Next slide',
                    first: 'Go to first slide',
                    last: 'Go to last slide',
                    slideX: 'Go to slide %s',
                    pageX: 'Go to page %s',
                    play: 'Start autoplay',
                    pause: 'Pause autoplay'
                  };
                  ;// CONCATENATED MODULE: ./src/js/constants/defaults.js
                  /**
                   * Export default options.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */


                  var DEFAULTS = {
                    /**
                     * Determine a slider type.
                     * - 'slide': Regular slider.
                     * - 'loop' : Carousel slider.
                     * - 'fade' : Change slides with fade transition. perPage, drag options are ignored.
                     *
                     * @type {string}
                     */
                    type: 'slide',

                    /**
                     * Whether to rewind a slider before the first slide or after the last one.
                     * In "loop" mode, this option is ignored.
                     *
                     * @type {boolean}
                     */
                    rewind: false,

                    /**
                     * Transition speed in milliseconds.
                     *
                     * @type {number}
                     */
                    speed: 400,

                    /**
                     * Transition speed on rewind in milliseconds.
                     *
                     * @type {number}
                     */
                    rewindSpeed: 0,

                    /**
                     * Whether to prevent any actions while a slider is transitioning.
                     * If false, navigation, drag and swipe work while the slider is running.
                     * Even so, it will be forced to wait for transition in some cases in the loop mode to shift a slider.
                     *
                     * @type {boolean}
                     */
                    waitForTransition: true,

                    /**
                     * Define slider max width.
                     *
                     * @type {number}
                     */
                    width: 0,

                    /**
                     * Define slider height.
                     *
                     * @type {number}
                     */
                    height: 0,

                    /**
                     * Fix width of slides. CSS format is allowed such as 10em, 80% or 80vw.
                     * perPage number will be ignored when this option is falsy.
                     *
                     * @type {number|string}
                     */
                    fixedWidth: 0,

                    /**
                     * Fix height of slides. CSS format is allowed such as 10em, 80vh but % unit is not accepted.
                     * heightRatio option will be ignored when this option is falsy.
                     *
                     * @type {number|string}
                     */
                    fixedHeight: 0,

                    /**
                     * Determine height of slides by ratio to a slider width.
                     * This will be ignored when the fixedHeight is provided.
                     *
                     * @type {number}
                     */
                    heightRatio: 0,

                    /**
                     * If true, slide width will be determined by the element width itself.
                     * - perPage/perMove should be 1.
                     *
                     * @type {boolean}
                     */
                    autoWidth: false,

                    /**
                     * If true, slide height will be determined by the element width itself.
                     * - perPage/perMove should be 1.
                     *
                     * @type {boolean}
                     */
                    autoHeight: false,

                    /**
                     * Determine how many slides should be displayed per page.
                     *
                     * @type {number}
                     */
                    perPage: 1,

                    /**
                     * Determine how many slides should be moved when a slider goes to next or perv.
                     *
                     * @type {number}
                     */
                    perMove: 0,

                    /**
                     * Determine manually how many clones should be generated on the left and right side.
                     * The total number of clones will be twice of this number.
                     *
                     * @type {number}
                     */
                    clones: 0,

                    /**
                     * Start index.
                     *
                     * @type {number}
                     */
                    start: 0,

                    /**
                     * Determine which slide should be focused if there are multiple slides in a page.
                     * A string "center" is acceptable for centering slides.
                     *
                     * @type {boolean|number|string}
                     */
                    focus: false,

                    /**
                     * Gap between slides. CSS format is allowed such as 1em.
                     *
                     * @type {number|string}
                     */
                    gap: 0,

                    /**
                     * Set padding-left/right in horizontal mode or padding-top/bottom in vertical one.
                     * Give a single value to set a same size for both sides or
                     * do an object for different sizes.
                     * Also, CSS format is allowed such as 1em.
                     *
                     * @example
                     * - 10: Number
                     * - '1em': CSS format.
                     * - { left: 0, right: 20 }: Object for different sizes in horizontal mode.
                     * - { top: 0, bottom: 20 }: Object for different sizes in vertical mode.
                     *
                     * @type {number|string|Object}
                     */
                    padding: 0,

                    /**
                     * Whether to append arrows.
                     *
                     * @type {boolean}
                     */
                    arrows: true,

                    /**
                     * Change the arrow SVG path like 'm7.61 0.807-2.12...'.
                     *
                     * @type {string}
                     */
                    arrowPath: '',

                    /**
                     * Whether to append pagination(indicator dots) or not.
                     *
                     * @type {boolean}
                     */
                    pagination: true,

                    /**
                     * Activate autoplay.
                     *
                     * @type {boolean}
                     */
                    autoplay: false,

                    /**
                     * Autoplay interval in milliseconds.
                     *
                     * @type {number}
                     */
                    interval: 5000,

                    /**
                     * Whether to stop autoplay when a slider is hovered.
                     *
                     * @type {boolean}
                     */
                    pauseOnHover: true,

                    /**
                     * Whether to stop autoplay when a slider elements are focused.
                     * True is recommended for accessibility.
                     *
                     * @type {boolean}
                     */
                    pauseOnFocus: true,

                    /**
                     * Whether to reset progress of the autoplay timer when resumed.
                     *
                     * @type {boolean}
                     */
                    resetProgress: true,

                    /**
                     * Loading images lazily.
                     * Image src must be provided by a data-splide-lazy attribute.
                     *
                     * - false: Do nothing.
                     * - 'nearby': Only images around an active slide will be loaded.
                     * - 'sequential': All images will be sequentially loaded.
                     *
                     * @type {boolean|string}
                     */
                    lazyLoad: false,

                    /**
                     * This option works only when a lazyLoad option is "nearby".
                     * Determine how many pages(not slides) around an active slide should be loaded beforehand.
                     *
                     * @type {number}
                     */
                    preloadPages: 1,

                    /**
                     * Easing for CSS transition. For example, linear, ease or cubic-bezier().
                     *
                     * @type {string}
                     */
                    easing: 'cubic-bezier(.42,.65,.27,.99)',

                    /**
                     * Whether to enable keyboard shortcuts
                     * - true or 'global': Listen to keydown event of the document.
                     * - 'focused': Listen to the keydown event of the slider root element. tabindex="0" will be added to the element.
                     * - false: Disable keyboard shortcuts.
                     *
                     * @type {boolean|string}
                     */
                    keyboard: 'global',

                    /**
                     * Whether to allow mouse drag and touch swipe.
                     *
                     * @type {boolean}
                     */
                    drag: true,

                    /**
                     * The angle threshold for drag.
                     * The slider starts moving only when the drag angle is less than this threshold.
                     *
                     * @type {number}
                     */
                    dragAngleThreshold: 30,

                    /**
                     * Distance threshold for determining if the action is "flick" or "swipe".
                     * When a drag distance is over this value, the action will be treated as "swipe", not "flick".
                     *
                     * @type {number}
                     */
                    swipeDistanceThreshold: 150,

                    /**
                     * Velocity threshold for determining if the action is "flick" or "swipe".
                     * Around 0.5 is recommended.
                     *
                     * @type {number}
                     */
                    flickVelocityThreshold: .6,

                    /**
                     * Determine power of flick. The larger number this is, the farther a slider runs by flick.
                     * Around 500 is recommended.
                     *
                     * @type {number}
                     */
                    flickPower: 600,

                    /**
                     * Limit a number of pages to move by flick.
                     *
                     * @type {number}
                     */
                    flickMaxPages: 1,

                    /**
                     * Slider direction.
                     * - 'ltr': Left to right.
                     * - 'rtl': Right to left.
                     * - 'ttb': Top to bottom.
                     *
                     * @type {string}
                     */
                    direction: 'ltr',

                    /**
                     * Set img src to background-image of its parent element.
                     * Images with various sizes can be displayed as same dimension without cropping work.
                     * fixedHeight or heightRatio is required.
                     *
                     * @type {boolean}
                     */
                    cover: false,

                    /**
                     * Whether to enable accessibility(aria and screen reader texts) or not.
                     *
                     * @type {boolean}
                     */
                    accessibility: true,

                    /**
                     * Whether to add tabindex="0" to visible slides or not.
                     *
                     * @type {boolean}
                     */
                    slideFocus: true,

                    /**
                     * Determine if a slider is navigation for another.
                     * Use "sync" API to synchronize two sliders.
                     *
                     * @type {boolean}
                     */
                    isNavigation: false,

                    /**
                     * Whether to trim spaces before the fist slide or after the last one when "focus" is not 0.
                     *
                     * @type {boolean}
                     */
                    trimSpace: true,

                    /**
                     * The "is-active" class is added after transition as default.
                     * If true, it will be added before move.
                     *
                     * @type {boolean}
                     */
                    updateOnMove: false,

                    /**
                     * Throttle duration in milliseconds for the resize event.
                     *
                     * @type {number}
                     */
                    throttle: 100,

                    /**
                     * Whether to destroy a slider or not.
                     *
                     * @type {boolean}
                     */
                    destroy: false,

                    /**
                     * Options for specific breakpoints.
                     *
                     * @example
                     * {
                     *   1000: {
                     *     perPage: 3,
                     *     gap: 20
                     *   },
                     *   600: {
                     *     perPage: 1,
                     *     gap: 5,
                     *   }
                     * }
                     *
                     * @type {boolean|Object}
                     */
                    breakpoints: false,

                    /**
                     * Collection of class names.
                     *
                     * @see ./classes.js
                     *
                     * @type {Object}
                     */
                    classes: ELEMENT_CLASSES,

                    /**
                     * Collection of i18n texts.
                     *
                     * @see ./i18n.js
                     *
                     * @type {Object}
                     */
                    i18n: I18N
                  };
                  ;// CONCATENATED MODULE: ./src/js/constants/states.js
                  /**
                   * Export state constants.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */

                  /**
                   * Splide has been just created.
                   *
                   * @type {number}
                   */
                  var CREATED = 1;
                  /**
                   * All components have been mounted and initialized.
                   *
                   * @type {number}
                   */

                  var MOUNTED = 2;
                  /**
                   * Splide is ready for transition.
                   *
                   * @type {number}
                   */

                  var IDLE = 3;
                  /**
                   * Splide is moving.
                   *
                   * @type {number}
                   */

                  var MOVING = 4;
                  /**
                   * Splide is moving.
                   *
                   * @type {number}
                   */

                  var DESTROYED = 5;
                  ;// CONCATENATED MODULE: ./src/js/splide.js
                  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

                  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

                  /**
                   * The main class for applying Splide to an element.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */








                  /**
                   * The main class for applying Splide to an element,
                   * providing some APIs to control the behavior.
                   */

                  var Splide = /*#__PURE__*/function () {
                    /**
                     * Splide constructor.
                     *
                     * @throws {Error} When the given root element or selector is invalid.
                     *
                     * @param {Element|string}  root       - A selector for a root element or an element itself.
                     * @param {Object}          options    - Optional. Options to change default behaviour.
                     * @param {Object}          Components - Optional. Components.
                     */
                    function Splide(root, options, Components) {
                      if (options === void 0) {
                        options = {};
                      }

                      if (Components === void 0) {
                        Components = {};
                      }

                      this.root = root instanceof Element ? root : document.querySelector(root);
                      exist(this.root, 'An invalid element/selector was given.');
                      this.Components = null;
                      this.Event = core_event();
                      this.State = state(CREATED);
                      this.STATES = states_namespaceObject;
                      this._o = merge(DEFAULTS, options);
                      this._i = 0;
                      this._c = Components;
                      this._e = {}; // Extensions

                      this._t = null; // Transition
                    }
                    /**
                     * Compose and mount components.
                     *
                     * @param {Object}   Extensions - Optional. Additional components.
                     * @param {function} Transition - Optional. Set a custom transition component.
                     *
                     * @return {Splide|undefined} - This instance or undefined if an exception occurred.
                     */


                    var _proto = Splide.prototype;

                    _proto.mount = function mount(Extensions, Transition) {
                      var _this = this;

                      if (Extensions === void 0) {
                        Extensions = this._e;
                      }

                      if (Transition === void 0) {
                        Transition = this._t;
                      }

                      // Reset the state.
                      this.State.set(CREATED);
                      this._e = Extensions;
                      this._t = Transition;
                      this.Components = compose(this, merge(this._c, Extensions), Transition);

                      try {
                        each(this.Components, function (component, key) {
                          var required = component.required;

                          if (required === undefined || required) {
                            component.mount && component.mount();
                          } else {
                            delete _this.Components[key];
                          }
                        });
                      } catch (e) {
                        error(e.message);
                        return;
                      }

                      var State = this.State;
                      State.set(MOUNTED);
                      each(this.Components, function (component) {
                        component.mounted && component.mounted();
                      });
                      this.emit('mounted');
                      State.set(IDLE);
                      this.emit('ready');
                      applyStyle(this.root, {
                        visibility: 'visible'
                      });
                      this.on('move drag', function () {
                        return State.set(MOVING);
                      }).on('moved dragged', function () {
                        return State.set(IDLE);
                      });
                      return this;
                    }
                      /**
                       * Set sync target.
                       *
                       * @param {Splide} splide - A Splide instance.
                       *
                       * @return {Splide} - This instance.
                       */
                      ;

                    _proto.sync = function sync(splide) {
                      this.sibling = splide;
                      return this;
                    }
                      /**
                       * Register callback fired on the given event(s).
                       *
                       * @param {string}   events  - An event name. Use space to separate multiple events.
                       *                             Also, namespace is accepted by dot, such as 'resize.{namespace}'.
                       * @param {function} handler - A callback function.
                       * @param {Element}  elm     - Optional. Native event will be listened to when this arg is provided.
                       * @param {Object}   options - Optional. Options for addEventListener.
                       *
                       * @return {Splide} - This instance.
                       */
                      ;

                    _proto.on = function on(events, handler, elm, options) {
                      if (elm === void 0) {
                        elm = null;
                      }

                      if (options === void 0) {
                        options = {};
                      }

                      this.Event.on(events, handler, elm, options);
                      return this;
                    }
                      /**
                       * Unsubscribe the given event.
                       *
                       * @param {string}  events - A event name.
                       * @param {Element} elm    - Optional. removeEventListener() will be called when this arg is provided.
                       *
                       * @return {Splide} - This instance.
                       */
                      ;

                    _proto.off = function off(events, elm) {
                      if (elm === void 0) {
                        elm = null;
                      }

                      this.Event.off(events, elm);
                      return this;
                    }
                      /**
                       * Emit an event.
                       *
                       * @param {string} event - An event name.
                       * @param {*}      args  - Any number of arguments passed to handlers.
                       */
                      ;

                    _proto.emit = function emit(event) {
                      var _this$Event;

                      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                        args[_key - 1] = arguments[_key];
                      }

                      (_this$Event = this.Event).emit.apply(_this$Event, [event].concat(args));

                      return this;
                    }
                      /**
                       * Go to the slide specified by the given control.
                       *
                       * @param {string|number} control - A control pattern.
                       * @param {boolean}       wait    - Optional. Whether to wait for transition.
                       */
                      ;

                    _proto.go = function go(control, wait) {
                      if (wait === void 0) {
                        wait = this.options.waitForTransition;
                      }

                      if (this.State.is(IDLE) || this.State.is(MOVING) && !wait) {
                        this.Components.Controller.go(control, false);
                      }

                      return this;
                    }
                      /**
                       * Verify whether the slider type is the given one or not.
                       *
                       * @param {string} type - A slider type.
                       *
                       * @return {boolean} - True if the slider type is the provided type or false if not.
                       */
                      ;

                    _proto.is = function is(type) {
                      return type === this._o.type;
                    }
                      /**
                       * Insert a slide.
                       *
                       * @param {Element|string} slide - A slide element to be added.
                       * @param {number}         index - A slide will be added at the position.
                       */
                      ;

                    _proto.add = function add(slide, index) {
                      if (index === void 0) {
                        index = -1;
                      }

                      this.Components.Elements.add(slide, index, this.refresh.bind(this));
                      return this;
                    }
                      /**
                       * Remove the slide designated by the index.
                       *
                       * @param {number} index - A slide index.
                       */
                      ;

                    _proto.remove = function remove(index) {
                      this.Components.Elements.remove(index);
                      this.refresh();
                      return this;
                    }
                      /**
                       * Destroy all Slide objects and clones and recreate them again.
                       */
                      ;

                    _proto.refresh = function refresh() {
                      this.emit('refresh:before').emit('refresh').emit('resize');
                      return this;
                    }
                      /**
                       * Destroy the Splide.
                       * "Completely" boolean is mainly for breakpoints.
                       *
                       * @param {boolean} completely - Destroy completely.
                       */
                      ;

                    _proto.destroy = function destroy(completely) {
                      var _this2 = this;

                      if (completely === void 0) {
                        completely = true;
                      }

                      // Postpone destroy because it should be done after mount.
                      if (this.State.is(CREATED)) {
                        this.on('ready', function () {
                          return _this2.destroy(completely);
                        });
                        return;
                      }

                      values(this.Components).reverse().forEach(function (component) {
                        component.destroy && component.destroy(completely);
                      });
                      this.emit('destroy', completely); // Destroy all event handlers, including ones for native events.

                      this.Event.destroy();
                      this.State.set(DESTROYED);
                      return this;
                    }
                      /**
                       * Return the current slide index.
                       *
                       * @return {number} - The current slide index.
                       // */
                      ;

                    _createClass(Splide, [{
                      key: "index",
                      get: function get() {
                        return this._i;
                      }
                      /**
                       * Set the current slide index.
                       *
                       * @param {number|string} index - A new index.
                       */
                      ,
                      set: function set(index) {
                        this._i = parseInt(index);
                      }
                      /**
                       * Return length of slides.
                       * This is an alias of Elements.length.
                       *
                       * @return {number} - A number of slides.
                       */

                    }, {
                      key: "length",
                      get: function get() {
                        return this.Components.Elements.length;
                      }
                      /**
                       * Return options.
                       *
                       * @return {Object} - Options object.
                       */

                    }, {
                      key: "options",
                      get: function get() {
                        return this._o;
                      }
                      /**
                       * Set options with merging the given object to the current one.
                       *
                       * @param {Object} options - New options.
                       */
                      ,
                      set: function set(options) {
                        var created = this.State.is(CREATED);

                        if (!created) {
                          this.emit('update');
                        }

                        this._o = merge(this._o, options);

                        if (!created) {
                          this.emit('updated', this._o);
                        }
                      }
                      /**
                       * Return the class list.
                       * This is an alias of Splide.options.classList.
                       *
                       * @return {Object} - An object containing all class list.
                       */

                    }, {
                      key: "classes",
                      get: function get() {
                        return this._o.classes;
                      }
                      /**
                       * Return the i18n strings.
                       * This is an alias of Splide.options.i18n.
                       *
                       * @return {Object} - An object containing all i18n strings.
                       */

                    }, {
                      key: "i18n",
                      get: function get() {
                        return this._o.i18n;
                      }
                    }]);

                    return Splide;
                  }();


                  ;// CONCATENATED MODULE: ./src/js/components/options/index.js
/**
 * The component for initializing options.
 *
 * @author    Naotoshi Fujita
 * @copyright Naotoshi Fujita. All rights reserved.
 */



/**
 * The component for initializing options.
 *
 * @param {Splide} Splide - A Splide instance.
 *
 * @return {Object} - The component object.
 */

/* harmony default export */ const options = (function (Splide) {
                    /**
                     * Retrieve options from the data attribute.
                     * Note that IE10 doesn't support dataset property.
                     *
                     * @type {string}
                     */
                    var options = getAttribute(Splide.root, 'data-splide');

                    if (options) {
                      try {
                        Splide.options = JSON.parse(options);
                      } catch (e) {
                        error(e.message);
                      }
                    }

                    return {
                      /**
                       * Called when the component is mounted.
                       */
                      mount: function mount() {
                        if (Splide.State.is(CREATED)) {
                          Splide.index = Splide.options.start;
                        }
                      }
                    };
                  });
                  ;// CONCATENATED MODULE: ./src/js/constants/directions.js
                  /**
                   * Export layout modes.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */

                  /**
                   * Enumerate slides from left to right.
                   *
                   * @type {string}
                   */
                  var LTR = 'ltr';
                  /**
                   * Enumerate slides from right to left.
                   *
                   * @type {string}
                   */

                  var RTL = 'rtl';
                  /**
                   * Enumerate slides in a col.
                   *
                   * @type {string}
                   */

                  var TTB = 'ttb';
                  ;// CONCATENATED MODULE: ./src/js/components/elements/slide.js
                  /**
                   * The sub component for handling each slide.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */






                  /**
                   * Events for restoring original styles.
                   *
                   * @type {string}
                   */

                  var STYLE_RESTORE_EVENTS = 'update.slide';
/**
 * The sub component for handling each slide.
 *
 * @param {Splide}  Splide    - A Splide instance.
 * @param {number}  index     - An unique slide index.
 * @param {number}  realIndex - Clones should pass a real slide index.
 * @param {Element} slide     - A slide element.
 *
 * @return {Object} - The sub component object.
 */

/* harmony default export */ const elements_slide = (function (Splide, index, realIndex, slide) {
                    /**
                     * Whether to update "is-active" class before or after transition.
                     *
                     * @type {boolean}
                     */
                    var updateOnMove = Splide.options.updateOnMove;
                    /**
                     * Events when the slide status is updated.
                     * Append a namespace to remove listeners later.
                     *
                     * @type {string}
                     */

                    var STATUS_UPDATE_EVENTS = 'ready.slide updated.slide resized.slide moved.slide' + (updateOnMove ? ' move.slide' : '');
                    /**
                     * Slide sub component object.
                     *
                     * @type {Object}
                     */

                    var Slide = {
                      /**
                       * Slide element.
                       *
                       * @type {Element}
                       */
                      slide: slide,

                      /**
                       * Slide index.
                       *
                       * @type {number}
                       */
                      index: index,

                      /**
                       * Real index for clones.
                       *
                       * @type {number}
                       */
                      realIndex: realIndex,

                      /**
                       * Container element if available.
                       *
                       * @type {Element|undefined}
                       */
                      container: child(slide, Splide.classes.container),

                      /**
                       * Whether this is a cloned slide or not.
                       *
                       * @type {boolean}
                       */
                      isClone: realIndex > -1,

                      /**
                       * Called when the component is mounted.
                       */
                      mount: function mount() {
                        var _this = this;

                        if (!this.isClone) {
                          slide.id = Splide.root.id + "-slide" + pad(index + 1);
                        }

                        Splide.on(STATUS_UPDATE_EVENTS, function () {
                          return _this.update();
                        }).on(STYLE_RESTORE_EVENTS, restoreStyles).on('click', function () {
                          return Splide.emit('click', _this);
                        }, slide);
                        /*
                         * Add "is-active" class to a clone element temporarily
                         * and it will be removed on "moved" event.
                         */

                        if (updateOnMove) {
                          Splide.on('move.slide', function (newIndex) {
                            if (newIndex === realIndex) {
                              _update(true, false);
                            }
                          });
                        } // Make sure the slide is shown.


                        applyStyle(slide, {
                          display: ''
                        }); // Hold the original styles.

                        this.styles = getAttribute(slide, 'style') || '';
                      },

                      /**
                       * Destroy.
                       */
                      destroy: function destroy() {
                        Splide.off(STATUS_UPDATE_EVENTS).off(STYLE_RESTORE_EVENTS).off('click', slide);
                        removeClass(slide, values(STATUS_CLASSES));
                        restoreStyles();
                        removeAttribute(this.container, 'style');
                      },

                      /**
                       * Update active and visible status.
                       */
                      update: function update() {
                        _update(this.isActive(), false);

                        _update(this.isVisible(), true);
                      },

                      /**
                       * Check whether this slide is active or not.
                       *
                       * @return {boolean} - True if the slide is active or false if not.
                       */
                      isActive: function isActive() {
                        return Splide.index === index;
                      },

                      /**
                       * Check whether this slide is visible in the viewport or not.
                       *
                       * @return {boolean} - True if the slide is visible or false if not.
                       */
                      isVisible: function isVisible() {
                        var active = this.isActive();

                        if (Splide.is(FADE) || active) {
                          return active;
                        }

                        var ceil = Math.ceil;
                        var trackRect = getRect(Splide.Components.Elements.track);
                        var slideRect = getRect(slide);

                        if (Splide.options.direction === TTB) {
                          return trackRect.top <= slideRect.top && slideRect.bottom <= ceil(trackRect.bottom);
                        }

                        return trackRect.left <= slideRect.left && slideRect.right <= ceil(trackRect.right);
                      },

                      /**
                       * Calculate how far this slide is from another slide and
                       * return true if the distance is within the given number.
                       *
                       * @param {number} from   - Index of a target slide.
                       * @param {number} within - True if the slide is within this number.
                       *
                       * @return {boolean} - True if the slide is within the number or false otherwise.
                       */
                      isWithin: function isWithin(from, within) {
                        var diff = Math.abs(from - index);

                        if (!Splide.is(SLIDE) && !this.isClone) {
                          diff = Math.min(diff, Splide.length - diff);
                        }

                        return diff < within;
                      }
                    };
                    /**
                     * Update classes for activity or visibility.
                     *
                     * @param {boolean} active        - Is active/visible or not.
                     * @param {boolean} forVisibility - Toggle classes for activity or visibility.
                     */

                    function _update(active, forVisibility) {
                      var type = forVisibility ? 'visible' : 'active';
                      var className = STATUS_CLASSES[type];

                      if (active) {
                        addClass(slide, className);
                        Splide.emit("" + type, Slide);
                      } else {
                        if (hasClass(slide, className)) {
                          removeClass(slide, className);
                          Splide.emit("" + (forVisibility ? 'hidden' : 'inactive'), Slide);
                        }
                      }
                    }
                    /**
                     * Restore the original styles.
                     */


                    function restoreStyles() {
                      setAttribute(slide, 'style', Slide.styles);
                    }

                    return Slide;
                  });
                  ;// CONCATENATED MODULE: ./src/js/components/elements/index.js
                  /**
                   * The component for main elements.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */





                  /**
                   * The property name for UID stored in a window object.
                   *
                   * @type {string}
                   */

                  var UID_NAME = 'uid';
/**
 * The component for main elements.
 *
 * @param {Splide} Splide     - A Splide instance.
 * @param {Object} Components - An object containing components.
 *
 * @return {Object} - The component object.
 */

/* harmony default export */ const components_elements = (function (Splide, Components) {
                    /**
                     * Hold the root element.
                     *
                     * @type {Element}
                     */
                    var root = Splide.root;
                    /**
                     * Hold the class list.
                     *
                     * @type {Object}
                     */

                    var classes = Splide.classes;
                    /**
                     * Store Slide objects.
                     *
                     * @type {Array}
                     */

                    var Slides = [];
                    /*
                     * Assign unique ID to the root element if it doesn't have the one.
                     * Note that IE doesn't support padStart() to fill the uid by 0.
                     */

                    if (!root.id) {
                      window.splide = window.splide || {};
                      var uid = window.splide[UID_NAME] || 0;
                      window.splide[UID_NAME] = ++uid;
                      root.id = "splide" + pad(uid);
                    }
                    /**
                     * Elements component object.
                     *
                     * @type {Object}
                     */


                    var Elements = {
                      /**
                       * Called when the component is mounted.
                       * Collect main elements and store them as member properties.
                       */
                      mount: function mount() {
                        var _this = this;

                        this.init();
                        Splide.on('refresh', function () {
                          _this.destroy();

                          _this.init();
                        }).on('updated', function () {
                          removeClass(root, getClasses());
                          addClass(root, getClasses());
                        });
                      },

                      /**
                       * Destroy.
                       */
                      destroy: function destroy() {
                        Slides.forEach(function (Slide) {
                          Slide.destroy();
                        });
                        Slides = [];
                        removeClass(root, getClasses());
                      },

                      /**
                       * Initialization.
                       */
                      init: function init() {
                        var _this2 = this;

                        collect();
                        addClass(root, getClasses());
                        this.slides.forEach(function (slide, index) {
                          _this2.register(slide, index, -1);
                        });
                      },

                      /**
                       * Register a slide to create a Slide object and handle its behavior.
                       *
                       * @param {Element} slide     - A slide element.
                       * @param {number}  index     - A unique index. This can be negative.
                       * @param {number}  realIndex - A real index for clones. Set -1 for real slides.
                       */
                      register: function register(slide, index, realIndex) {
                        var SlideObject = elements_slide(Splide, index, realIndex, slide);
                        SlideObject.mount();
                        Slides.push(SlideObject);
                      },

                      /**
                       * Return the Slide object designated by the index.
                       * Note that "find" is not supported by IE.
                       *
                       * @return {Object|undefined} - A Slide object if available. Undefined if not.
                       */
                      getSlide: function getSlide(index) {
                        return Slides.filter(function (Slide) {
                          return Slide.index === index;
                        })[0];
                      },

                      /**
                       * Return all Slide objects.
                       *
                       * @param {boolean} includeClones - Whether to include cloned slides or not.
                       *
                       * @return {Object[]} - Slide objects.
                       */
                      getSlides: function getSlides(includeClones) {
                        return includeClones ? Slides : Slides.filter(function (Slide) {
                          return !Slide.isClone;
                        });
                      },

                      /**
                       * Return Slide objects belonging to the given page.
                       *
                       * @param {number} page - A page number.
                       *
                       * @return {Object[]} - An array containing Slide objects.
                       */
                      getSlidesByPage: function getSlidesByPage(page) {
                        var idx = Components.Controller.toIndex(page);
                        var options = Splide.options;
                        var max = options.focus !== false ? 1 : options.perPage;
                        return Slides.filter(function (_ref) {
                          var index = _ref.index;
                          return idx <= index && index < idx + max;
                        });
                      },

                      /**
                       * Insert a slide to a slider.
                       * Need to refresh Splide after adding a slide.
                       *
                       * @param {Node|string} slide    - A slide element to be added.
                       * @param {number}      index    - A slide will be added at the position.
                       * @param {Function}    callback - Called right after the slide is added to the DOM tree.
                       */
                      add: function add(slide, index, callback) {
                        if (typeof slide === 'string') {
                          slide = domify(slide);
                        }

                        if (slide instanceof Element) {
                          var ref = this.slides[index]; // This will be removed in mount() of a Slide component.

                          applyStyle(slide, {
                            display: 'none'
                          });

                          if (ref) {
                            before(slide, ref);
                            this.slides.splice(index, 0, slide);
                          } else {
                            append(this.list, slide);
                            this.slides.push(slide);
                          }

                          loaded(slide, function () {
                            callback && callback(slide);
                          });
                        }
                      },

                      /**
                       * Remove a slide from a slider.
                       * Need to refresh Splide after removing a slide.
                       *
                       * @param index - Slide index.
                       */
                      remove: function remove(index) {
                        dom_remove(this.slides.splice(index, 1)[0]);
                      },

                      /**
                       * Trigger the provided callback for each Slide object.
                       *
                       * @param {Function} callback - A callback function. The first argument will be the Slide object.
                       */
                      each: function each(callback) {
                        Slides.forEach(callback);
                      },

                      /**
                       * Return slides length without clones.
                       *
                       * @return {number} - Slide length.
                       */
                      get length() {
                        return this.slides.length;
                      },

                      /**
                       * Return "SlideObjects" length including clones.
                       *
                       * @return {number} - Slide length including clones.
                       */
                      get total() {
                        return Slides.length;
                      }

                    };
                    /**
                     * Collect elements.
                     */

                    function collect() {
                      Elements.slider = child(root, classes.slider);
                      Elements.track = find(root, "." + classes.track);
                      Elements.list = child(Elements.track, classes.list);
                      exist(Elements.track && Elements.list, 'Track or list was not found.');
                      Elements.slides = children(Elements.list, classes.slide);
                      var arrows = findParts(classes.arrows);
                      Elements.arrows = {
                        prev: find(arrows, "." + classes.prev),
                        next: find(arrows, "." + classes.next)
                      };
                      var autoplay = findParts(classes.autoplay);
                      Elements.bar = find(findParts(classes.progress), "." + classes.bar);
                      Elements.play = find(autoplay, "." + classes.play);
                      Elements.pause = find(autoplay, "." + classes.pause);
                      Elements.track.id = Elements.track.id || root.id + "-track";
                      Elements.list.id = Elements.list.id || root.id + "-list";
                    }
                    /**
                     * Return class names for the root element.
                     */


                    function getClasses() {
                      var rootClass = classes.root;
                      var options = Splide.options;
                      return [rootClass + "--" + options.type, rootClass + "--" + options.direction, options.drag ? rootClass + "--draggable" : '', options.isNavigation ? rootClass + "--nav" : '', STATUS_CLASSES.active];
                    }
                    /**
                     * Find parts only from children of the root or track.
                     *
                     * @return {Element} - A found element or undefined.
                     */


                    function findParts(className) {
                      return child(root, className) || child(Elements.slider, className);
                    }

                    return Elements;
                  });
                  ;// CONCATENATED MODULE: ./src/js/components/controller/index.js
                  /**
                   * The component for controlling the track.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */



                  var floor = Math.floor;
/**
 * The component for controlling the track.
 *
 * @param {Splide} Splide     - A Splide instance.
 * @param {Object} Components - An object containing components.
 *
 * @return {Object} - The component object.
 */

/* harmony default export */ const controller = (function (Splide, Components) {
                    /**
                     * Store current options.
                     *
                     * @type {Object}
                     */
                    var options;
                    /**
                     * True if the slide is LOOP mode.
                     *
                     * @type {boolean}
                     */

                    var isLoop;
                    /**
                     * Controller component object.
                     *
                     * @type {Object}
                     */

                    var Controller = {
                      /**
                       * Called when the component is mounted.
                       */
                      mount: function mount() {
                        options = Splide.options;
                        isLoop = Splide.is(LOOP);
                        bind();
                      },

                      /**
                       * Make track run by the given control.
                       * - "+{i}" : Increment the slide index by i.
                       * - "-{i}" : Decrement the slide index by i.
                       * - "{i}"  : Go to the slide whose index is i.
                       * - ">"    : Go to next page.
                       * - "<"    : Go to prev page.
                       * - ">{i}" : Go to page i.
                       *
                       * @param {string|number} control  - A control pattern.
                       * @param {boolean}       silently - Go to the destination without event emission.
                       */
                      go: function go(control, silently) {
                        var destIndex = this.trim(this.parse(control));
                        Components.Track.go(destIndex, this.rewind(destIndex), silently);
                      },

                      /**
                       * Parse the given control and return the destination index for the track.
                       *
                       * @param {string} control - A control target pattern.
                       *
                       * @return {number} - A parsed target.
                       */
                      parse: function parse(control) {
                        var index = Splide.index;
                        var matches = String(control).match(/([+\-<>]+)(\d+)?/);
                        var indicator = matches ? matches[1] : '';
                        var number = matches ? parseInt(matches[2]) : 0;

                        switch (indicator) {
                          case '+':
                            index += number || 1;
                            break;

                          case '-':
                            index -= number || 1;
                            break;

                          case '>':
                          case '<':
                            index = parsePage(number, index, indicator === '<');
                            break;

                          default:
                            index = parseInt(control);
                        }

                        return index;
                      },

                      /**
                       * Compute index from the given page number.
                       *
                       * @param {number} page - Page number.
                       *
                       * @return {number} - A computed page number.
                       */
                      toIndex: function toIndex(page) {
                        if (hasFocus()) {
                          return page;
                        }

                        var length = Splide.length;
                        var perPage = options.perPage;
                        var index = page * perPage;
                        index = index - (this.pageLength * perPage - length) * floor(index / length); // Adjustment for the last page.

                        if (length - perPage <= index && index < length) {
                          index = length - perPage;
                        }

                        return index;
                      },

                      /**
                       * Compute page number from the given slide index.
                       *
                       * @param {number} index - Slide index.
                       *
                       * @return {number} - A computed page number.
                       */
                      toPage: function toPage(index) {
                        if (hasFocus()) {
                          return index;
                        }

                        var length = Splide.length;
                        var perPage = options.perPage; // Make the last "perPage" number of slides belong to the last page.

                        if (length - perPage <= index && index < length) {
                          return floor((length - 1) / perPage);
                        }

                        return floor(index / perPage);
                      },

                      /**
                       * Trim the given index according to the current mode.
                       * Index being returned could be less than 0 or greater than the length in Loop mode.
                       *
                       * @param {number} index - An index being trimmed.
                       *
                       * @return {number} - A trimmed index.
                       */
                      trim: function trim(index) {
                        if (!isLoop) {
                          index = options.rewind ? this.rewind(index) : between(index, 0, this.edgeIndex);
                        }

                        return index;
                      },

                      /**
                       * Rewind the given index if it's out of range.
                       *
                       * @param {number} index - An index.
                       *
                       * @return {number} - A rewound index.
                       */
                      rewind: function rewind(index) {
                        var edge = this.edgeIndex;

                        if (isLoop) {
                          while (index > edge) {
                            index -= edge + 1;
                          }

                          while (index < 0) {
                            index += edge + 1;
                          }
                        } else {
                          if (index > edge) {
                            index = 0;
                          } else if (index < 0) {
                            index = edge;
                          }
                        }

                        return index;
                      },

                      /**
                       * Check if the direction is "rtl" or not.
                       *
                       * @return {boolean} - True if "rtl" or false if not.
                       */
                      isRtl: function isRtl() {
                        return options.direction === RTL;
                      },

                      /**
                       * Return the page length.
                       *
                       * @return {number} - Max page number.
                       */
                      get pageLength() {
                        var length = Splide.length;
                        return hasFocus() ? length : Math.ceil(length / options.perPage);
                      },

                      /**
                       * Return the edge index.
                       *
                       * @return {number} - Edge index.
                       */
                      get edgeIndex() {
                        var length = Splide.length;

                        if (!length) {
                          return 0;
                        }

                        if (hasFocus() || options.isNavigation || isLoop) {
                          return length - 1;
                        }

                        return length - options.perPage;
                      },

                      /**
                       * Return the index of the previous slide.
                       *
                       * @return {number} - The index of the previous slide if available. -1 otherwise.
                       */
                      get prevIndex() {
                        var prev = Splide.index - 1;

                        if (isLoop || options.rewind) {
                          prev = this.rewind(prev);
                        }

                        return prev > -1 ? prev : -1;
                      },

                      /**
                       * Return the index of the next slide.
                       *
                       * @return {number} - The index of the next slide if available. -1 otherwise.
                       */
                      get nextIndex() {
                        var next = Splide.index + 1;

                        if (isLoop || options.rewind) {
                          next = this.rewind(next);
                        }

                        return Splide.index < next && next <= this.edgeIndex || next === 0 ? next : -1;
                      }

                    };
                    /**
                     * Listen to some events.
                     */

                    function bind() {
                      Splide.on('move', function (newIndex) {
                        Splide.index = newIndex;
                      }).on('updated refresh', function (newOptions) {
                        options = newOptions || options;
                        Splide.index = between(Splide.index, 0, Controller.edgeIndex);
                      });
                    }
                    /**
                     * Verify if the focus option is available or not.
                     *
                     * @return {boolean} - True if a slider has the focus option.
                     */


                    function hasFocus() {
                      return options.focus !== false;
                    }
                    /**
                     * Return the next or previous page index computed by the page number and current index.
                     *
                     * @param {number}  number - Specify the page number.
                     * @param {number}  index  - Current index.
                     * @param {boolean} prev   - Prev or next.
                     *
                     * @return {number} - Slide index.
                     */


                    function parsePage(number, index, prev) {
                      if (number > -1) {
                        return Controller.toIndex(number);
                      }

                      var perMove = options.perMove;
                      var sign = prev ? -1 : 1;

                      if (perMove) {
                        return index + perMove * sign;
                      }

                      return Controller.toIndex(Controller.toPage(index) + sign);
                    }

                    return Controller;
                  });
                  ;// CONCATENATED MODULE: ./src/js/components/track/index.js
                  /**
                   * The component for moving list in the track.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */





                  var abs = Math.abs;
/**
 * The component for moving list in the track.
 *
 * @param {Splide} Splide     - A Splide instance.
 * @param {Object} Components - An object containing components.
 *
 * @return {Object} - The component object.
 */

/* harmony default export */ const track = (function (Splide, Components) {
                    /**
                     * Hold the Layout component.
                     *
                     * @type {Object}
                     */
                    var Layout;
                    /**
                     * Hold the Layout component.
                     *
                     * @type {Object}
                     */

                    var Elements;
                    /**
                     * Store the list element.
                     *
                     * @type {Element}
                     */

                    var list;
                    /**
                     * Whether the current direction is vertical or not.
                     *
                     * @type {boolean}
                     */

                    var isVertical = Splide.options.direction === TTB;
                    /**
                     * Whether the slider type is FADE or not.
                     *
                     * @type {boolean}
                     */

                    var isFade = Splide.is(FADE);
                    /**
                     * Whether the slider direction is RTL or not.
                     *
                     * @type {boolean}
                     */

                    var isRTL = Splide.options.direction === RTL;
                    /**
                     * This will be true while transitioning from the last index to the first one.
                     *
                     * @type {boolean}
                     */

                    var isLoopPending = false;
                    /**
                     * Sign for the direction. Only RTL mode uses the positive sign.
                     *
                     * @type {number}
                     */

                    var sign = isRTL ? 1 : -1;
                    /**
                     * Track component object.
                     *
                     * @type {Object}
                     */

                    var Track = {
                      /**
                       * Make public the sign defined locally.
                       *
                       * @type {number}
                       */
                      sign: sign,

                      /**
                       * Called when the component is mounted.
                       */
                      mount: function mount() {
                        Elements = Components.Elements;
                        Layout = Components.Layout;
                        list = Elements.list;
                      },

                      /**
                       * Called after the component is mounted.
                       * The resize event must be registered after the Layout's one is done.
                       */
                      mounted: function mounted() {
                        var _this = this;

                        if (!isFade) {
                          this.jump(0);
                          Splide.on('mounted resize updated', function () {
                            _this.jump(Splide.index);
                          });
                        }
                      },

                      /**
                       * Go to the given destination index.
                       * After arriving there, the track is jump to the new index without animation, mainly for loop mode.
                       *
                       * @param {number}  destIndex - A destination index.
                       *                              This can be negative or greater than slides length for reaching clones.
                       * @param {number}  newIndex  - An actual new index. They are always same in Slide and Rewind mode.
                       * @param {boolean} silently  - If true, suppress emitting events.
                       */
                      go: function go(destIndex, newIndex, silently) {
                        var newPosition = getTrimmedPosition(destIndex);
                        var prevIndex = Splide.index; // Prevent any actions while transitioning from the last index to the first one for jump.

                        if (Splide.State.is(MOVING) && isLoopPending) {
                          return;
                        }

                        isLoopPending = destIndex !== newIndex;

                        if (!silently) {
                          Splide.emit('move', newIndex, prevIndex, destIndex);
                        }

                        if (Math.abs(newPosition - this.position) >= 1 || isFade) {
                          Components.Transition.start(destIndex, newIndex, prevIndex, this.toCoord(newPosition), function () {
                            onTransitionEnd(destIndex, newIndex, prevIndex, silently);
                          });
                        } else {
                          if (destIndex !== prevIndex && Splide.options.trimSpace === 'move') {
                            Components.Controller.go(destIndex + destIndex - prevIndex, silently);
                          } else {
                            onTransitionEnd(destIndex, newIndex, prevIndex, silently);
                          }
                        }
                      },

                      /**
                       * Move the track to the specified index.
                       *
                       * @param {number} index - A destination index where the track jumps.
                       */
                      jump: function jump(index) {
                        this.translate(getTrimmedPosition(index));
                      },

                      /**
                       * Set the list position by CSS translate property.
                       *
                       * @param {number} position - A new position value.
                       */
                      translate: function translate(position) {
                        applyStyle(list, {
                          transform: "translate" + (isVertical ? 'Y' : 'X') + "(" + position + "px)"
                        });
                      },

                      /**
                       * Cancel the transition and set the list position.
                       * Also, loop the slider if necessary.
                       */
                      cancel: function cancel() {
                        if (Splide.is(LOOP)) {
                          this.shift();
                        } else {
                          // Ensure the current position.
                          this.translate(this.position);
                        }

                        applyStyle(list, {
                          transition: ''
                        });
                      },

                      /**
                       * Shift the slider if it exceeds borders on the edge.
                       */
                      shift: function shift() {
                        var position = abs(this.position);
                        var left = abs(this.toPosition(0));
                        var right = abs(this.toPosition(Splide.length));
                        var innerSize = right - left;

                        if (position < left) {
                          position += innerSize;
                        } else if (position > right) {
                          position -= innerSize;
                        }

                        this.translate(sign * position);
                      },

                      /**
                       * Trim redundant spaces on the left or right edge if necessary.
                       *
                       * @param {number} position - Position value to be trimmed.
                       *
                       * @return {number} - Trimmed position.
                       */
                      trim: function trim(position) {
                        if (!Splide.options.trimSpace || Splide.is(LOOP)) {
                          return position;
                        }

                        var edge = sign * (Layout.totalSize() - Layout.size - Layout.gap);
                        return between(position, edge, 0);
                      },

                      /**
                       * Calculate the closest slide index from the given position.
                       *
                       * @param {number} position - A position converted to an slide index.
                       *
                       * @return {number} - The closest slide index.
                       */
                      toIndex: function toIndex(position) {
                        var _this2 = this;

                        var index = 0;
                        var minDistance = Infinity;
                        Elements.getSlides(true).forEach(function (Slide) {
                          var slideIndex = Slide.index;
                          var distance = abs(_this2.toPosition(slideIndex) - position);

                          if (distance < minDistance) {
                            minDistance = distance;
                            index = slideIndex;
                          }
                        });
                        return index;
                      },

                      /**
                       * Return coordinates object by the given position.
                       *
                       * @param {number} position - A position value.
                       *
                       * @return {Object} - A coordinates object.
                       */
                      toCoord: function toCoord(position) {
                        return {
                          x: isVertical ? 0 : position,
                          y: isVertical ? position : 0
                        };
                      },

                      /**
                       * Calculate the track position by a slide index.
                       *
                       * @param {number} index - Slide index.
                       *
                       * @return {Object} - Calculated position.
                       */
                      toPosition: function toPosition(index) {
                        var position = Layout.totalSize(index) - Layout.slideSize(index) - Layout.gap;
                        return sign * (position + this.offset(index));
                      },

                      /**
                       * Return the current offset value, considering direction.
                       *
                       * @return {number} - Offset amount.
                       */
                      offset: function offset(index) {
                        var focus = Splide.options.focus;
                        var slideSize = Layout.slideSize(index);

                        if (focus === 'center') {
                          return -(Layout.size - slideSize) / 2;
                        }

                        return -(parseInt(focus) || 0) * (slideSize + Layout.gap);
                      },

                      /**
                       * Return the current position.
                       * This returns the correct position even while transitioning by CSS.
                       *
                       * @return {number} - Current position.
                       */
                      get position() {
                        var prop = isVertical ? 'top' : isRTL ? 'right' : 'left';
                        return getRect(list)[prop] - (getRect(Elements.track)[prop] - Layout.padding[prop] * sign);
                      }

                    };
                    /**
                     * Called whenever slides arrive at a destination.
                     *
                     * @param {number}  destIndex - A destination index.
                     * @param {number}  newIndex  - A new index.
                     * @param {number}  prevIndex - A previous index.
                     * @param {boolean} silently  - If true, suppress emitting events.
                     */

                    function onTransitionEnd(destIndex, newIndex, prevIndex, silently) {
                      applyStyle(list, {
                        transition: ''
                      });
                      isLoopPending = false;

                      if (!isFade) {
                        Track.jump(newIndex);
                      }

                      if (!silently) {
                        Splide.emit('moved', newIndex, prevIndex, destIndex);
                      }
                    }
                    /**
                     * Convert index to the trimmed position.
                     *
                     * @return {number} - Trimmed position.
                     */


                    function getTrimmedPosition(index) {
                      return Track.trim(Track.toPosition(index));
                    }

                    return Track;
                  });
                  ;// CONCATENATED MODULE: ./src/js/components/clones/index.js
/**
 * The component for cloning some slides for "loop" mode of the track.
 *
 * @author    Naotoshi Fujita
 * @copyright Naotoshi Fujita. All rights reserved.
 */




/**
 * The component for cloning some slides for "loop" mode of the track.
 *
 * @param {Splide} Splide     - A Splide instance.
 * @param {Object} Components - An object containing components.
 *
 * @return {Object} - The component object.
 */

/* harmony default export */ const clones = (function (Splide, Components) {
                    /**
                     * Store information of all clones.
                     *
                     * @type {Array}
                     */
                    var clones = [];
                    /**
                     * Store the current clone count on one side.
                     *
                     * @type {number}
                     */

                    var cloneCount = 0;
                    /**
                     * Keep Elements component.
                     *
                     * @type {Object}
                     */

                    var Elements = Components.Elements;
                    /**
                     * Clones component object.
                     *
                     * @type {Object}
                     */

                    var Clones = {
                      /**
                       * Called when the component is mounted.
                       */
                      mount: function mount() {
                        var _this = this;

                        if (Splide.is(LOOP)) {
                          init();
                          Splide.on('refresh:before', function () {
                            _this.destroy();
                          }).on('refresh', init).on('resize', function () {
                            if (cloneCount !== getCloneCount()) {
                              // Destroy before refresh not to collect clones by the Elements component.
                              _this.destroy();

                              Splide.refresh();
                            }
                          });
                        }
                      },

                      /**
                       * Destroy.
                       */
                      destroy: function destroy() {
                        dom_remove(clones);
                        clones = [];
                      },

                      /**
                       * Return all clones.
                       *
                       * @return {Element[]} - Cloned elements.
                       */
                      get clones() {
                        return clones;
                      },

                      /**
                       * Return clone length.
                       *
                       * @return {number} - A length of clones.
                       */
                      get length() {
                        return clones.length;
                      }

                    };
                    /**
                     * Initialization.
                     */

                    function init() {
                      Clones.destroy();
                      cloneCount = getCloneCount();
                      generateClones(cloneCount);
                    }
                    /**
                     * Generate and append/prepend clones.
                     *
                     * @param {number} count - The half number of clones.
                     */


                    function generateClones(count) {
                      var length = Elements.length,
                        register = Elements.register;

                      if (length) {
                        var slides = Elements.slides;

                        while (slides.length < count) {
                          slides = slides.concat(slides);
                        } // Clones after the last element.


                        slides.slice(0, count).forEach(function (elm, index) {
                          var clone = cloneDeeply(elm);
                          append(Elements.list, clone);
                          clones.push(clone);
                          register(clone, index + length, index % length);
                        }); // Clones before the first element.

                        slides.slice(-count).forEach(function (elm, index) {
                          var clone = cloneDeeply(elm);
                          before(clone, slides[0]);
                          clones.push(clone);
                          register(clone, index - count, (length + index - count % length) % length);
                        });
                      }
                    }
                    /**
                     * Return half count of clones to be generated.
                     * Clone count is determined by:
                     * - "clones" value in the options.
                     * - Number of slides that can be placed in a view in "fixed" mode.
                     * - Max pages a flick action can move.
                     * - Whether the slide length is enough for perPage.
                     *
                     * @return {number} - Count for clones.
                     */


                    function getCloneCount() {
                      var options = Splide.options;

                      if (options.clones) {
                        return options.clones;
                      } // Use the slide length in autoWidth mode because the number cannot be calculated.


                      var baseCount = options.autoWidth || options.autoHeight ? Elements.length : options.perPage;
                      var dimension = options.direction === TTB ? 'Height' : 'Width';
                      var fixedSize = toPixel(Splide.root, options["fixed" + dimension]);

                      if (fixedSize) {
                        // Roughly calculate the count. This needs not to be strict.
                        baseCount = Math.ceil(Elements.track["client" + dimension] / fixedSize);
                      }

                      return baseCount * (options.drag ? options.flickMaxPages + 1 : 1);
                    }
                    /**
                     * Clone deeply the given element.
                     *
                     * @param {Element} elm - An element being duplicated.
                     *
                     * @return {Node} - A cloned node(element).
                     */


                    function cloneDeeply(elm) {
                      var clone = elm.cloneNode(true);
                      addClass(clone, Splide.classes.clone); // ID should not be duplicated.

                      removeAttribute(clone, 'id');
                      return clone;
                    }

                    return Clones;
                  });
                  ;// CONCATENATED MODULE: ./src/js/components/layout/directions/horizontal.js
/**
 * The resolver component for horizontal layout.
 *
 * @author    Naotoshi Fujita
 * @copyright Naotoshi Fujita. All rights reserved.
 */



/**
 * The resolver component for horizontal layout.
 *
 * @param {Splide} Splide     - A Splide instance.
 * @param {Object} Components - An object containing components.
 *
 * @return {Object} - The resolver object.
 */

/* harmony default export */ const horizontal = (function (Splide, Components) {
                    /**
                     * Keep the Elements component.
                     *
                     * @type {string}
                     */
                    var Elements = Components.Elements;
                    /**
                     * Keep the root element.
                     *
                     * @type {Element}
                     */

                    var root = Splide.root;
                    /**
                     * Keep the track element.
                     *
                     * @type {Element}
                     */

                    var track;
                    /**
                     * Keep the latest options.
                     *
                     * @type {Element}
                     */

                    var options = Splide.options;
                    return {
                      /**
                       * Margin property name.
                       *
                       * @type {string}
                       */
                      margin: 'margin' + (options.direction === RTL ? 'Left' : 'Right'),

                      /**
                       * Always 0 because the height will be determined by inner contents.
                       *
                       * @type {number}
                       */
                      height: 0,

                      /**
                       * Initialization.
                       */
                      init: function init() {
                        this.resize();
                      },

                      /**
                       * Resize gap and padding.
                       * This must be called on init.
                       */
                      resize: function resize() {
                        options = Splide.options;
                        track = Elements.track;
                        this.gap = toPixel(root, options.gap);
                        var padding = options.padding;
                        var left = toPixel(root, padding.left || padding);
                        var right = toPixel(root, padding.right || padding);
                        this.padding = {
                          left: left,
                          right: right
                        };
                        applyStyle(track, {
                          paddingLeft: unit(left),
                          paddingRight: unit(right)
                        });
                      },

                      /**
                       * Return total width from the left of the list to the right of the slide specified by the provided index.
                       *
                       * @param {number} index - Optional. A slide index. If undefined, total width of the slider will be returned.
                       *
                       * @return {number} - Total width to the right side of the specified slide, or 0 for an invalid index.
                       */
                      totalWidth: function totalWidth(index) {
                        if (index === void 0) {
                          index = Splide.length - 1;
                        }

                        var Slide = Elements.getSlide(index);
                        var width = 0;

                        if (Slide) {
                          var slideRect = getRect(Slide.slide);
                          var listRect = getRect(Elements.list);

                          if (options.direction === RTL) {
                            width = listRect.right - slideRect.left;
                          } else {
                            width = slideRect.right - listRect.left;
                          }

                          width += this.gap;
                        }

                        return width;
                      },

                      /**
                       * Return the slide width in px.
                       *
                       * @param {number} index - Slide index.
                       *
                       * @return {number} - The slide width.
                       */
                      slideWidth: function slideWidth(index) {
                        if (options.autoWidth) {
                          var Slide = Elements.getSlide(index);
                          return Slide ? Slide.slide.offsetWidth : 0;
                        }

                        var width = options.fixedWidth || (this.width + this.gap) / options.perPage - this.gap;
                        return toPixel(root, width);
                      },

                      /**
                       * Return the slide height in px.
                       *
                       * @return {number} - The slide height.
                       */
                      slideHeight: function slideHeight() {
                        var height = options.height || options.fixedHeight || this.width * options.heightRatio;
                        return toPixel(root, height);
                      },

                      /**
                       * Return slider width without padding.
                       *
                       * @return {number} - Current slider width.
                       */
                      get width() {
                        return track.clientWidth - this.padding.left - this.padding.right;
                      }

                    };
                  });
                  ;// CONCATENATED MODULE: ./src/js/components/layout/directions/vertical.js
/**
 * The resolver component for vertical layout.
 *
 * @author    Naotoshi Fujita
 * @copyright Naotoshi Fujita. All rights reserved.
 */



/**
 * The resolver component for vertical layout.
 *
 * @param {Splide} Splide     - A Splide instance.
 * @param {Object} Components - An object containing components.
 *
 * @return {Object} - The resolver object.
 */

/* harmony default export */ const vertical = (function (Splide, Components) {
                    /**
                     * Keep the Elements component.
                     *
                     * @type {string}
                     */
                    var Elements = Components.Elements;
                    /**
                     * Keep the root element.
                     *
                     * @type {Element}
                     */

                    var root = Splide.root;
                    /**
                     * Keep the track element.
                     *
                     * @type {Element}
                     */

                    var track;
                    /**
                     * Keep the latest options.
                     *
                     * @type {Element}
                     */

                    var options;
                    return {
                      /**
                       * Margin property name.
                       *
                       * @type {string}
                       */
                      margin: 'marginBottom',

                      /**
                       * Initialization.
                       */
                      init: function init() {
                        this.resize();
                      },

                      /**
                       * Resize gap and padding.
                       * This must be called on init.
                       */
                      resize: function resize() {
                        options = Splide.options;
                        track = Elements.track;
                        this.gap = toPixel(root, options.gap);
                        var padding = options.padding;
                        var top = toPixel(root, padding.top || padding);
                        var bottom = toPixel(root, padding.bottom || padding);
                        this.padding = {
                          top: top,
                          bottom: bottom
                        };
                        applyStyle(track, {
                          paddingTop: unit(top),
                          paddingBottom: unit(bottom)
                        });
                      },

                      /**
                       * Return total height from the top of the list to the bottom of the slide specified by the provided index.
                       *
                       * @param {number} index - Optional. A slide index. If undefined, total height of the slider will be returned.
                       *
                       * @return {number} - Total height to the bottom of the specified slide, or 0 for an invalid index.
                       */
                      totalHeight: function totalHeight(index) {
                        if (index === void 0) {
                          index = Splide.length - 1;
                        }

                        var Slide = Elements.getSlide(index);

                        if (Slide) {
                          return getRect(Slide.slide).bottom - getRect(Elements.list).top + this.gap;
                        }

                        return 0;
                      },

                      /**
                       * Return the slide width in px.
                       *
                       * @return {number} - The slide width.
                       */
                      slideWidth: function slideWidth() {
                        return toPixel(root, options.fixedWidth || this.width);
                      },

                      /**
                       * Return the slide height in px.
                       *
                       * @param {number} index - Slide index.
                       *
                       * @return {number} - The slide height.
                       */
                      slideHeight: function slideHeight(index) {
                        if (options.autoHeight) {
                          var Slide = Elements.getSlide(index);
                          return Slide ? Slide.slide.offsetHeight : 0;
                        }

                        var height = options.fixedHeight || (this.height + this.gap) / options.perPage - this.gap;
                        return toPixel(root, height);
                      },

                      /**
                       * Return slider width without padding.
                       *
                       * @return {number} - Current slider width.
                       */
                      get width() {
                        return track.clientWidth;
                      },

                      /**
                       * Return slide height without padding.
                       *
                       * @return {number} - Slider height.
                       */
                      get height() {
                        var height = options.height || this.width * options.heightRatio;
                        exist(height, '"height" or "heightRatio" is missing.');
                        return toPixel(root, height) - this.padding.top - this.padding.bottom;
                      }

                    };
                  });
                  ;// CONCATENATED MODULE: ./src/js/utils/time.js
                  /**
                   * A package of utility functions related with time.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */

                  /**
                   * Simple throttle function that controls how often the given function is executed.
                   *
                   * @param {function} func - A function to be throttled.
                   * @param {number}   wait - Time in millisecond for interval of execution.
                   *
                   * @return {Function} - A debounced function.
                   */
                  function throttle(func, wait) {
                    var timeout; // Declare function by the "function" keyword to prevent "this" from being inherited.

                    return function () {
                      if (!timeout) {
                        timeout = setTimeout(function () {
                          func();
                          timeout = null;
                        }, wait);
                      }
                    };
                  }
                  /**
                   * Custom setInterval function that provides progress rate as callback.
                   *
                   * @param {function} callback - A callback function fired every time the interval time passes.
                   * @param {number}   interval - Interval duration in milliseconds.
                   * @param {function} progress - A callback function fired whenever the progress goes.
                   *
                   * @return {Object} - An object containing play() and pause() functions.
                   */

                  function createInterval(callback, interval, progress) {
                    var _window = window,
                      requestAnimationFrame = _window.requestAnimationFrame;
                    var start,
                      elapse,
                      rate,
                      _pause = true;

                    var step = function step(timestamp) {
                      if (!_pause) {
                        if (!start) {
                          start = timestamp;

                          if (rate && rate < 1) {
                            start -= rate * interval;
                          }
                        }

                        elapse = timestamp - start;
                        rate = elapse / interval;

                        if (elapse >= interval) {
                          start = 0;
                          rate = 1;
                          callback();
                        }

                        if (progress) {
                          progress(rate);
                        }

                        requestAnimationFrame(step);
                      }
                    };

                    return {
                      pause: function pause() {
                        _pause = true;
                        start = 0;
                      },
                      play: function play(reset) {
                        start = 0;

                        if (reset) {
                          rate = 0;
                        }

                        if (_pause) {
                          _pause = false;
                          requestAnimationFrame(step);
                        }
                      }
                    };
                  }
                  ;// CONCATENATED MODULE: ./src/js/components/layout/index.js
/**
 * The component for handing slide layouts and their sizes.
 *
 * @author    Naotoshi Fujita
 * @copyright Naotoshi Fujita. All rights reserved.
 */







/**
 * The component for handing slide layouts and their sizes.
 *
 * @param {Splide} Splide     - A Splide instance.
 * @param {Object} Components - An object containing components.
 *
 * @return {Object} - The component object.
 */

/* harmony default export */ const layout = (function (Splide, Components) {
                    /**
                     * Keep the Elements component.
                     *
                     * @type {string}
                     */
                    var Elements = Components.Elements;
                    /**
                     * Whether the slider is vertical or not.
                     *
                     * @type {boolean}
                     */

                    var isVertical = Splide.options.direction === TTB;
                    /**
                     * Layout component object.
                     *
                     * @type {Object}
                     */

                    var Layout = object_assign({
                      /**
                       * Called when the component is mounted.
                       */
                      mount: function mount() {
                        bind();
                        init(); // The word "size" means width for a horizontal slider and height for a vertical slider.

                        this.totalSize = isVertical ? this.totalHeight : this.totalWidth;
                        this.slideSize = isVertical ? this.slideHeight : this.slideWidth;
                      },

                      /**
                       * Destroy the component.
                       */
                      destroy: function destroy() {
                        removeAttribute([Elements.list, Elements.track], 'style');
                      },

                      /**
                       * Return the slider height on the vertical mode or width on the horizontal mode.
                       *
                       * @return {number}
                       */
                      get size() {
                        return isVertical ? this.height : this.width;
                      }

                    }, isVertical ? vertical(Splide, Components) : horizontal(Splide, Components));
                    /**
                     * Init slider styles according to options.
                     */

                    function init() {
                      Layout.init();
                      applyStyle(Splide.root, {
                        maxWidth: unit(Splide.options.width)
                      });
                      Elements.each(function (Slide) {
                        Slide.slide.style[Layout.margin] = unit(Layout.gap);
                      });
                      resize();
                    }
                    /**
                     * Listen the resize native event with throttle.
                     * Initialize when the component is mounted or options are updated.
                     */


                    function bind() {
                      Splide.on('resize load', throttle(function () {
                        Splide.emit('resize');
                      }, Splide.options.throttle), window).on('resize', resize).on('updated refresh', init);
                    }
                    /**
                     * Resize the track and slide elements.
                     */


                    function resize() {
                      var options = Splide.options;
                      Layout.resize();
                      applyStyle(Elements.track, {
                        height: unit(Layout.height)
                      });
                      var slideHeight = options.autoHeight ? null : unit(Layout.slideHeight());
                      Elements.each(function (Slide) {
                        applyStyle(Slide.container, {
                          height: slideHeight
                        });
                        applyStyle(Slide.slide, {
                          width: options.autoWidth ? null : unit(Layout.slideWidth(Slide.index)),
                          height: Slide.container ? null : slideHeight
                        });
                      });
                      Splide.emit('resized');
                    }

                    return Layout;
                  });
                  ;// CONCATENATED MODULE: ./src/js/components/drag/index.js
                  /**
                   * The component for supporting mouse drag and swipe.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */





                  var drag_abs = Math.abs;
                  /**
                   * If the absolute velocity is greater thant this value,
                   * a slider always goes to a different slide after drag, not allowed to stay on a current slide.
                   */

                  var MIN_VELOCITY = 0.1;
                  /**
                   * Adjust how much the track can be pulled on the first or last page.
                   * The larger number this is, the farther the track moves.
                   * This should be around 5 - 9.
                   *
                   * @type {number}
                   */

                  var FRICTION_REDUCER = 7;
/**
 * The component supporting mouse drag and swipe.
 *
 * @param {Splide} Splide     - A Splide instance.
 * @param {Object} Components - An object containing components.
 *
 * @return {Object} - The component object.
 */

/* harmony default export */ const drag = (function (Splide, Components) {
                    /**
                     * Store the Move component.
                     *
                     * @type {Object}
                     */
                    var Track = Components.Track;
                    /**
                     * Store the Controller component.
                     *
                     * @type {Object}
                     */

                    var Controller = Components.Controller;
                    /**
                     * Coordinate of the track on starting drag.
                     *
                     * @type {Object}
                     */

                    var startCoord;
                    /**
                     * Analyzed info on starting drag.
                     *
                     * @type {Object|null}
                     */

                    var startInfo;
                    /**
                     * Analyzed info being updated while dragging/swiping.
                     *
                     * @type {Object}
                     */

                    var currentInfo;
                    /**
                     * Determine whether slides are being dragged or not.
                     *
                     * @type {boolean}
                     */

                    var isDragging;
                    /**
                     * Whether the slider direction is vertical or not.
                     *
                     * @type {boolean}
                     */

                    var isVertical = Splide.options.direction === TTB;
                    /**
                     * Axis for the direction.
                     *
                     * @type {string}
                     */

                    var axis = isVertical ? 'y' : 'x';
                    /**
                     * Drag component object.
                     *
                     * @type {Object}
                     */

                    var Drag = {
                      /**
                       * Whether dragging is disabled or not.
                       *
                       * @type {boolean}
                       */
                      disabled: false,

                      /**
                       * Called when the component is mounted.
                       */
                      mount: function mount() {
                        var _this = this;

                        var Elements = Components.Elements;
                        var track = Elements.track;
                        Splide.on('touchstart mousedown', start, track).on('touchmove mousemove', move, track, {
                          passive: false
                        }).on('touchend touchcancel mouseleave mouseup dragend', end, track).on('mounted refresh', function () {
                          // Prevent dragging an image or anchor itself.
                          each(Elements.list.querySelectorAll('img, a'), function (elm) {
                            Splide.off('dragstart', elm).on('dragstart', function (e) {
                              e.preventDefault();
                            }, elm, {
                              passive: false
                            });
                          });
                        }).on('mounted updated', function () {
                          _this.disabled = !Splide.options.drag;
                        });
                      }
                    };
                    /**
                     * Called when the track starts to be dragged.
                     *
                     * @param {TouchEvent|MouseEvent} e - TouchEvent or MouseEvent object.
                     */

                    function start(e) {
                      if (!Drag.disabled && !isDragging) {
                        // These prams are used to evaluate whether the slider should start moving.
                        init(e);
                      }
                    }
                    /**
                     * Initialize parameters.
                     *
                     * @param {TouchEvent|MouseEvent} e - TouchEvent or MouseEvent object.
                     */


                    function init(e) {
                      startCoord = Track.toCoord(Track.position);
                      startInfo = analyze(e, {});
                      currentInfo = startInfo;
                    }
                    /**
                     * Called while the track being dragged.
                     *
                     * @param {TouchEvent|MouseEvent} e - TouchEvent or MouseEvent object.
                     */


                    function move(e) {
                      if (startInfo) {
                        currentInfo = analyze(e, startInfo);

                        if (isDragging) {
                          if (e.cancelable) {
                            e.preventDefault();
                          }

                          if (!Splide.is(FADE)) {
                            var position = startCoord[axis] + currentInfo.offset[axis];
                            Track.translate(resist(position));
                          }
                        } else {
                          if (shouldMove(currentInfo)) {
                            Splide.emit('drag', startInfo);
                            isDragging = true;
                            Track.cancel(); // These params are actual drag data.

                            init(e);
                          }
                        }
                      }
                    }
                    /**
                     * Determine whether to start moving the track or not by drag angle.
                     *
                     * @param {Object} info - An information object.
                     *
                     * @return {boolean} - True if the track should be moved or false if not.
                     */


                    function shouldMove(_ref) {
                      var offset = _ref.offset;

                      if (Splide.State.is(MOVING) && Splide.options.waitForTransition) {
                        return false;
                      }

                      var angle = Math.atan(drag_abs(offset.y) / drag_abs(offset.x)) * 180 / Math.PI;

                      if (isVertical) {
                        angle = 90 - angle;
                      }

                      return angle < Splide.options.dragAngleThreshold;
                    }
                    /**
                     * Resist dragging the track on the first/last page because there is no more.
                     *
                     * @param {number} position - A position being applied to the track.
                     *
                     * @return {Object} - Adjusted position.
                     */


                    function resist(position) {
                      if (Splide.is(SLIDE)) {
                        var sign = Track.sign;

                        var _start = sign * Track.trim(Track.toPosition(0));

                        var _end = sign * Track.trim(Track.toPosition(Controller.edgeIndex));

                        position *= sign;

                        if (position < _start) {
                          position = _start - FRICTION_REDUCER * Math.log(_start - position);
                        } else if (position > _end) {
                          position = _end + FRICTION_REDUCER * Math.log(position - _end);
                        }

                        position *= sign;
                      }

                      return position;
                    }
                    /**
                     * Called when dragging ends.
                     */


                    function end() {
                      startInfo = null;

                      if (isDragging) {
                        Splide.emit('dragged', currentInfo);
                        go(currentInfo);
                        isDragging = false;
                      }
                    }
                    /**
                     * Go to the slide determined by the analyzed data.
                     *
                     * @param {Object} info - An info object.
                     */


                    function go(info) {
                      var velocity = info.velocity[axis];
                      var absV = drag_abs(velocity);

                      if (absV > 0) {
                        var options = Splide.options;
                        var index = Splide.index;
                        var sign = velocity < 0 ? -1 : 1;
                        var destIndex = index;

                        if (!Splide.is(FADE)) {
                          var destination = Track.position;

                          if (absV > options.flickVelocityThreshold && drag_abs(info.offset[axis]) < options.swipeDistanceThreshold) {
                            destination += sign * Math.min(absV * options.flickPower, Components.Layout.size * (options.flickMaxPages || 1));
                          }

                          destIndex = Track.toIndex(destination);
                        }
                        /*
                         * Do not allow the track to go to a previous position if there is enough velocity.
                         * Always use the adjacent index for the fade mode.
                         */


                        if (destIndex === index && absV > MIN_VELOCITY) {
                          destIndex = index + sign * Track.sign;
                        }

                        if (Splide.is(SLIDE)) {
                          destIndex = between(destIndex, 0, Controller.edgeIndex);
                        }

                        Controller.go(destIndex, options.isNavigation);
                      }
                    }
                    /**
                     * Analyze the given event object and return important information for handling swipe behavior.
                     *
                     * @param {Event}   e          - Touch or Mouse event object.
                     * @param {Object}  startInfo  - Information analyzed on start for calculating difference from the current one.
                     *
                     * @return {Object} - An object containing analyzed information, such as offset, velocity, etc.
                     */


                    function analyze(e, startInfo) {
                      var timeStamp = e.timeStamp,
                        touches = e.touches;

                      var _ref2 = touches ? touches[0] : e,
                        clientX = _ref2.clientX,
                        clientY = _ref2.clientY;

                      var _ref3 = startInfo.to || {},
                        _ref3$x = _ref3.x,
                        fromX = _ref3$x === void 0 ? clientX : _ref3$x,
                        _ref3$y = _ref3.y,
                        fromY = _ref3$y === void 0 ? clientY : _ref3$y;

                      var startTime = startInfo.time || 0;
                      var offset = {
                        x: clientX - fromX,
                        y: clientY - fromY
                      };
                      var duration = timeStamp - startTime;
                      var velocity = {
                        x: offset.x / duration,
                        y: offset.y / duration
                      };
                      return {
                        to: {
                          x: clientX,
                          y: clientY
                        },
                        offset: offset,
                        time: timeStamp,
                        velocity: velocity
                      };
                    }

                    return Drag;
                  });
                  ;// CONCATENATED MODULE: ./src/js/components/click/index.js
/**
 * The component for handling a click event.
 *
 * @author    Naotoshi Fujita
 * @copyright Naotoshi Fujita. All rights reserved.
 */

/**
 * The component for handling a click event.
 * Click should be disabled during drag/swipe.
 *
 * @param {Splide} Splide     - A Splide instance.
 * @param {Object} Components - An object containing components.
 *
 * @return {Object} - The component object.
 */
/* harmony default export */ const click = (function (Splide, Components) {
                    /**
                     * Whether click is disabled or not.
                     *
                     * @type {boolean}
                     */
                    var disabled = false;
                    /**
                     * Click component object.
                     *
                     * @type {Object}
                     */

                    var Click = {
                      /**
                       * Mount only when the drag is activated and the slide type is not "fade".
                       *
                       * @type {boolean}
                       */
                      required: Splide.options.drag,

                      /**
                       * Called when the component is mounted.
                       */
                      mount: function mount() {
                        Splide.on('click', onClick, Components.Elements.track, {
                          capture: true
                        }).on('drag', function () {
                          disabled = true;
                        }).on('dragged', function () {
                          // Make sure the flag is released after the click event is fired.
                          setTimeout(function () {
                            disabled = false;
                          });
                        });
                      }
                    };
                    /**
                     * Called when a track element is clicked.
                     *
                     * @param {Event} e - A click event.
                     */

                    function onClick(e) {
                      if (disabled) {
                        e.preventDefault();
                        e.stopPropagation();
                        e.stopImmediatePropagation();
                      }
                    }

                    return Click;
                  });
                  ;// CONCATENATED MODULE: ./src/js/components/autoplay/index.js
                  /**
                   * The component for playing slides automatically.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */


                  /**
                   * Set of pause flags.
                   */

                  var PAUSE_FLAGS = {
                    HOVER: 1,
                    FOCUS: 2,
                    MANUAL: 3
                  };
/**
 * The component for playing slides automatically.
 *
 * @param {Splide} Splide     - A Splide instance.
 * @param {Object} Components - An object containing components.
 * @param {string} name       - A component name as a lowercase string.
 *
 * @return {Object} - The component object.
 */

/* harmony default export */ const autoplay = (function (Splide, Components, name) {
                    /**
                     * Store pause flags.
                     *
                     * @type {Array}
                     */
                    var flags = [];
                    /**
                     * Store an interval object.
                     *
                     * @type {Object};
                     */

                    var interval;
                    /**
                     * Keep the Elements component.
                     *
                     * @type {string}
                     */

                    var Elements = Components.Elements;
                    /**
                     * Autoplay component object.
                     *
                     * @type {Object}
                     */

                    var Autoplay = {
                      /**
                       * Required only when the autoplay option is true.
                       *
                       * @type {boolean}
                       */
                      required: Splide.options.autoplay,

                      /**
                       * Called when the component is mounted.
                       * Note that autoplay starts only if there are slides over perPage number.
                       */
                      mount: function mount() {
                        var options = Splide.options;

                        if (Elements.slides.length > options.perPage) {
                          interval = createInterval(function () {
                            Splide.go('>');
                          }, options.interval, function (rate) {
                            Splide.emit(name + ":playing", rate);

                            if (Elements.bar) {
                              applyStyle(Elements.bar, {
                                width: rate * 100 + "%"
                              });
                            }
                          });
                          bind();
                          this.play();
                        }
                      },

                      /**
                       * Start autoplay.
                       *
                       * @param {number} flag - A pause flag to be removed.
                       */
                      play: function play(flag) {
                        if (flag === void 0) {
                          flag = 0;
                        }

                        flags = flags.filter(function (f) {
                          return f !== flag;
                        });

                        if (!flags.length) {
                          Splide.emit(name + ":play");
                          interval.play(Splide.options.resetProgress);
                        }
                      },

                      /**
                       * Pause autoplay.
                       * Note that Array.includes is not supported by IE.
                       *
                       * @param {number} flag - A pause flag to be added.
                       */
                      pause: function pause(flag) {
                        if (flag === void 0) {
                          flag = 0;
                        }

                        interval.pause();

                        if (flags.indexOf(flag) === -1) {
                          flags.push(flag);
                        }

                        if (flags.length === 1) {
                          Splide.emit(name + ":pause");
                        }
                      }
                    };
                    /**
                     * Listen some events.
                     */

                    function bind() {
                      var options = Splide.options;
                      var sibling = Splide.sibling;
                      var elms = [Splide.root, sibling ? sibling.root : null];

                      if (options.pauseOnHover) {
                        switchOn(elms, 'mouseleave', PAUSE_FLAGS.HOVER, true);
                        switchOn(elms, 'mouseenter', PAUSE_FLAGS.HOVER, false);
                      }

                      if (options.pauseOnFocus) {
                        switchOn(elms, 'focusout', PAUSE_FLAGS.FOCUS, true);
                        switchOn(elms, 'focusin', PAUSE_FLAGS.FOCUS, false);
                      }

                      if (Elements.play) {
                        Splide.on('click', function () {
                          // Need to be removed a focus flag at first.
                          Autoplay.play(PAUSE_FLAGS.FOCUS);
                          Autoplay.play(PAUSE_FLAGS.MANUAL);
                        }, Elements.play);
                      }

                      if (Elements.pause) {
                        switchOn([Elements.pause], 'click', PAUSE_FLAGS.MANUAL, false);
                      }

                      Splide.on('move refresh', function () {
                        Autoplay.play();
                      }) // Rewind the timer.
                        .on('destroy', function () {
                          Autoplay.pause();
                        });
                    }
                    /**
                     * Play or pause on the given event.
                     *
                     * @param {Element[]} elms  - Elements.
                     * @param {string}    event - An event name or names.
                     * @param {number}    flag  - A pause flag defined on the top.
                     * @param {boolean}   play  - Determine whether to play or pause.
                     */


                    function switchOn(elms, event, flag, play) {
                      elms.forEach(function (elm) {
                        Splide.on(event, function () {
                          Autoplay[play ? 'play' : 'pause'](flag);
                        }, elm);
                      });
                    }

                    return Autoplay;
                  });
                  ;// CONCATENATED MODULE: ./src/js/components/cover/index.js
/**
 * The component for change an img element to background image of its wrapper.
 *
 * @author    Naotoshi Fujita
 * @copyright Naotoshi Fujita. All rights reserved.
 */

/**
 * The component for change an img element to background image of its wrapper.
 *
 * @param {Splide} Splide     - A Splide instance.
 * @param {Object} Components - An object containing components.
 *
 * @return {Object} - The component object.
 */

/* harmony default export */ const cover = (function (Splide, Components) {
                    /**
                     * Hold options.
                     *
                     * @type {Object}
                     */
                    var options = Splide.options;
                    /**
                     * Cover component object.
                     *
                     * @type {Object}
                     */

                    var Cover = {
                      /**
                       * Required only when "cover" option is true.
                       *
                       * @type {boolean}
                       */
                      required: options.cover,

                      /**
                       * Called when the component is mounted.
                       */
                      mount: function mount() {
                        Splide.on('lazyload:loaded', function (img) {
                          cover(img, false);
                        });
                        Splide.on('mounted updated refresh', function () {
                          return apply(false);
                        });
                      },

                      /**
                       * Destroy.
                       */
                      destroy: function destroy() {
                        apply(true);
                      }
                    };
                    /**
                     * Apply "cover" to all slides.
                     *
                     * @param {boolean} uncover - If true, "cover" will be clear.
                     */

                    function apply(uncover) {
                      Components.Elements.each(function (Slide) {
                        var img = child(Slide.slide, 'IMG') || child(Slide.container, 'IMG');

                        if (img && img.src) {
                          cover(img, uncover);
                        }
                      });
                    }
                    /**
                     * Set background image of the parent element, using source of the given image element.
                     *
                     * @param {Element} img     - An image element.
                     * @param {boolean} uncover - Reset "cover".
                     */


                    function cover(img, uncover) {
                      applyStyle(img.parentElement, {
                        background: uncover ? '' : "center/cover no-repeat url(\"" + img.src + "\")"
                      });
                      applyStyle(img, {
                        display: uncover ? '' : 'none'
                      });
                    }

                    return Cover;
                  });
                  ;// CONCATENATED MODULE: ./src/js/components/arrows/path.js
                  /**
                   * Export vector path for an arrow.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */

                  /**
                   * Namespace definition for SVG element.
                   *
                   * @type {string}
                   */
                  var XML_NAME_SPACE = 'http://www.w3.org/2000/svg';
                  /**
                   * The arrow vector path.
                   *
                   * @type {number}
                   */

                  var PATH = 'm15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z';
                  /**
                   * SVG width and height.
                   *
                   * @type {number}
                   */

                  var SIZE = 40;
                  ;// CONCATENATED MODULE: ./src/js/components/arrows/index.js
/**
 * The component for appending prev/next arrows.
 *
 * @author    Naotoshi Fujita
 * @copyright Naotoshi Fujita. All rights reserved.
 */



/**
 * The component for appending prev/next arrows.
 *
 * @param {Splide} Splide     - A Splide instance.
 * @param {Object} Components - An object containing components.
 * @param {string} name       - A component name as a lowercase string.
 *
 * @return {Object} - The component object.
 */

/* harmony default export */ const arrows = (function (Splide, Components, name) {
                    /**
                     * Previous arrow element.
                     *
                     * @type {Element|undefined}
                     */
                    var prev;
                    /**
                     * Next arrow element.
                     *
                     * @type {Element|undefined}
                     */

                    var next;
                    /**
                     * Store the class list.
                     *
                     * @type {Object}
                     */

                    var classes = Splide.classes;
                    /**
                     * Hold the root element.
                     *
                     * @type {Element}
                     */

                    var root = Splide.root;
                    /**
                     * Whether arrows are created programmatically or not.
                     *
                     * @type {boolean}
                     */

                    var created;
                    /**
                     * Hold the Elements component.
                     *
                     * @type {Object}
                     */

                    var Elements = Components.Elements;
                    /**
                     * Arrows component object.
                     *
                     * @type {Object}
                     */

                    var Arrows = {
                      /**
                       * Required when the arrows option is true.
                       *
                       * @type {boolean}
                       */
                      required: Splide.options.arrows,

                      /**
                       * Called when the component is mounted.
                       */
                      mount: function mount() {
                        // Attempt to get arrows from HTML source.
                        prev = Elements.arrows.prev;
                        next = Elements.arrows.next; // If arrows were not found in HTML, let's generate them.

                        if ((!prev || !next) && Splide.options.arrows) {
                          prev = createArrow(true);
                          next = createArrow(false);
                          created = true;
                          appendArrows();
                        }

                        if (prev && next) {
                          bind();
                        }

                        this.arrows = {
                          prev: prev,
                          next: next
                        };
                      },

                      /**
                       * Called after all components are mounted.
                       */
                      mounted: function mounted() {
                        Splide.emit(name + ":mounted", prev, next);
                      },

                      /**
                       * Destroy.
                       */
                      destroy: function destroy() {
                        removeAttribute([prev, next], 'disabled');

                        if (created) {
                          dom_remove(prev.parentElement);
                        }
                      }
                    };
                    /**
                     * Listen to native and custom events.
                     */

                    function bind() {
                      Splide.on('click', function () {
                        Splide.go('<');
                      }, prev).on('click', function () {
                        Splide.go('>');
                      }, next).on('mounted move updated refresh', updateDisabled);
                    }
                    /**
                     * Update a disabled attribute.
                     */


                    function updateDisabled() {
                      var _Components$Controlle = Components.Controller,
                        prevIndex = _Components$Controlle.prevIndex,
                        nextIndex = _Components$Controlle.nextIndex;
                      var isEnough = Splide.length > Splide.options.perPage || Splide.is(LOOP);
                      prev.disabled = prevIndex < 0 || !isEnough;
                      next.disabled = nextIndex < 0 || !isEnough;
                      Splide.emit(name + ":updated", prev, next, prevIndex, nextIndex);
                    }
                    /**
                     * Create a wrapper element and append arrows.
                     */


                    function appendArrows() {
                      var wrapper = create('div', {
                        "class": classes.arrows
                      });
                      append(wrapper, prev);
                      append(wrapper, next);
                      var slider = Elements.slider;
                      var parent = Splide.options.arrows === 'slider' && slider ? slider : root;
                      before(wrapper, parent.firstElementChild);
                    }
                    /**
                     * Create an arrow element.
                     *
                     * @param {boolean} prev - Determine to create a prev arrow or next arrow.
                     *
                     * @return {Element} - A created arrow element.
                     */


                    function createArrow(prev) {
                      var arrow = "<button class=\"" + classes.arrow + " " + (prev ? classes.prev : classes.next) + "\" type=\"button\">" + ("<svg xmlns=\"" + XML_NAME_SPACE + "\"\tviewBox=\"0 0 " + SIZE + " " + SIZE + "\"\twidth=\"" + SIZE + "\"\theight=\"" + SIZE + "\">") + ("<path d=\"" + (Splide.options.arrowPath || PATH) + "\" />");
                      return domify(arrow);
                    }

                    return Arrows;
                  });
                  ;// CONCATENATED MODULE: ./src/js/components/pagination/index.js
                  /**
                   * The component for handling pagination
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */


                  /**
                   * The event name for updating some attributes of pagination nodes.
                   *
                   * @type {string}
                   */

                  var ATTRIBUTES_UPDATE_EVENT = 'move.page';
                  /**
                   * The event name for recreating pagination.
                   *
                   * @type {string}
                   */

                  var UPDATE_EVENT = 'updated.page refresh.page';
/**
 * The component for handling pagination
 *
 * @param {Splide} Splide     - A Splide instance.
 * @param {Object} Components - An object containing components.
 * @param {string} name       - A component name as a lowercase string.
 *
 * @return {Object} - The component object.
 */

/* harmony default export */ const pagination = (function (Splide, Components, name) {
                    /**
                     * Store all data for pagination.
                     * - list: A list element.
                     * - items: An array that contains objects(li, button, index, page).
                     *
                     * @type {Object}
                     */
                    var data = {};
                    /**
                     * Hold the Elements component.
                     *
                     * @type {Object}
                     */

                    var Elements = Components.Elements;
                    /**
                     * Pagination component object.
                     *
                     * @type {Object}
                     */

                    var Pagination = {
                      /**
                       * Called when the component is mounted.
                       */
                      mount: function mount() {
                        var pagination = Splide.options.pagination;

                        if (pagination) {
                          data = createPagination();
                          var slider = Elements.slider;
                          var parent = pagination === 'slider' && slider ? slider : Splide.root;
                          append(parent, data.list);
                          Splide.on(ATTRIBUTES_UPDATE_EVENT, updateAttributes);
                        }

                        Splide.off(UPDATE_EVENT).on(UPDATE_EVENT, function () {
                          Pagination.destroy();

                          if (Splide.options.pagination) {
                            Pagination.mount();
                            Pagination.mounted();
                          }
                        });
                      },

                      /**
                       * Called after all components are mounted.
                       */
                      mounted: function mounted() {
                        if (Splide.options.pagination) {
                          var index = Splide.index;
                          Splide.emit(name + ":mounted", data, this.getItem(index));
                          updateAttributes(index, -1);
                        }
                      },

                      /**
                       * Destroy the pagination.
                       * Be aware that node.remove() is not supported by IE.
                       */
                      destroy: function destroy() {
                        dom_remove(data.list);

                        if (data.items) {
                          data.items.forEach(function (item) {
                            Splide.off('click', item.button);
                          });
                        } // Do not remove UPDATE_EVENT to recreate pagination if needed.


                        Splide.off(ATTRIBUTES_UPDATE_EVENT);
                        data = {};
                      },

                      /**
                       * Return an item by index.
                       *
                       * @param {number} index - A slide index.
                       *
                       * @return {Object|undefined} - An item object on success or undefined on failure.
                       */
                      getItem: function getItem(index) {
                        return data.items[Components.Controller.toPage(index)];
                      },

                      /**
                       * Return object containing pagination data.
                       *
                       * @return {Object} - Pagination data including list and items.
                       */
                      get data() {
                        return data;
                      }

                    };
                    /**
                     * Update attributes.
                     *
                     * @param {number} index     - Active index.
                     * @param {number} prevIndex - Prev index.
                     */

                    function updateAttributes(index, prevIndex) {
                      var prev = Pagination.getItem(prevIndex);
                      var curr = Pagination.getItem(index);
                      var active = STATUS_CLASSES.active;

                      if (prev) {
                        removeClass(prev.button, active);
                      }

                      if (curr) {
                        addClass(curr.button, active);
                      }

                      Splide.emit(name + ":updated", data, prev, curr);
                    }
                    /**
                     * Create a wrapper and button elements.
                     *
                     * @return {Object} - An object contains all data.
                     */


                    function createPagination() {
                      var options = Splide.options;
                      var classes = Splide.classes;
                      var list = create('ul', {
                        "class": classes.pagination
                      });
                      var items = Elements.getSlides(false).filter(function (Slide) {
                        return options.focus !== false || Slide.index % options.perPage === 0;
                      }).map(function (Slide, page) {
                        var li = create('li', {});
                        var button = create('button', {
                          "class": classes.page,
                          type: 'button'
                        });
                        append(li, button);
                        append(list, li);
                        Splide.on('click', function () {
                          Splide.go(">" + page);
                        }, button);
                        return {
                          li: li,
                          button: button,
                          page: page,
                          Slides: Elements.getSlidesByPage(page)
                        };
                      });
                      return {
                        list: list,
                        items: items
                      };
                    }

                    return Pagination;
                  });
                  ;// CONCATENATED MODULE: ./src/js/components/lazyload/index.js
                  /**
                   * The component for loading slider images lazily.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */



                  /**
                   * The name for a data attribute of src.
                   *
                   * @type {string}
                   */

                  var SRC_DATA_NAME = 'data-splide-lazy';
                  /**
                   * The name for a data attribute of srcset.
                   *
                   * @type {string}
                   */

                  var SRCSET_DATA_NAME = 'data-splide-lazy-srcset';
/**
 * The component for loading slider images lazily.
 *
 * @param {Splide} Splide     - A Splide instance.
 * @param {Object} Components - An object containing components.
 * @param {string} name       - A component name as a lowercase string.
 *
 * @return {Object} - The component object.
 */

/* harmony default export */ const lazyload = (function (Splide, Components, name) {
                    /**
                     * Next index for sequential loading.
                     *
                     * @type {number}
                     */
                    var nextIndex;
                    /**
                     * Store objects containing an img element and a Slide object.
                     *
                     * @type {Object[]}
                     */

                    var images;
                    /**
                     * Store the options.
                     *
                     * @type {Object}
                     */

                    var options = Splide.options;
                    /**
                     * Whether to load images sequentially or not.
                     *
                     * @type {boolean}
                     */

                    var isSequential = options.lazyLoad === 'sequential';
                    /**
                     * Lazyload component object.
                     *
                     * @type {Object}
                     */

                    var Lazyload = {
                      /**
                       * Mount only when the lazyload option is provided.
                       *
                       * @type {boolean}
                       */
                      required: options.lazyLoad,

                      /**
                       * Called when the component is mounted.
                       */
                      mount: function mount() {
                        Splide.on('mounted refresh', function () {
                          init();
                          Components.Elements.each(function (Slide) {
                            each(Slide.slide.querySelectorAll("[" + SRC_DATA_NAME + "], [" + SRCSET_DATA_NAME + "]"), function (img) {
                              if (!img.src && !img.srcset) {
                                images.push({
                                  img: img,
                                  Slide: Slide
                                });
                                applyStyle(img, {
                                  display: 'none'
                                });
                              }
                            });
                          });

                          if (isSequential) {
                            loadNext();
                          }
                        });

                        if (!isSequential) {
                          Splide.on("mounted refresh moved." + name, check);
                        }
                      },

                      /**
                       * Destroy.
                       */
                      destroy: init
                    };
                    /**
                     * Initialize parameters.
                     */

                    function init() {
                      images = [];
                      nextIndex = 0;
                    }
                    /**
                     * Check how close each image is from the active slide and
                     * determine whether to start loading or not, according to the distance.
                     *
                     * @param {number} index - Current index.
                     */


                    function check(index) {
                      index = isNaN(index) ? Splide.index : index;
                      images = images.filter(function (image) {
                        if (image.Slide.isWithin(index, options.perPage * (options.preloadPages + 1))) {
                          load(image.img, image.Slide);
                          return false;
                        }

                        return true;
                      }); // Unbind if all images are loaded.

                      if (!images[0]) {
                        Splide.off("moved." + name);
                      }
                    }
                    /**
                     * Start loading an image.
                     * Creating a clone of the image element since setting src attribute directly to it
                     * often occurs 'hitch', blocking some other processes of a browser.
                     *
                     * @param {Element} img   - An image element.
                     * @param {Object}  Slide - A Slide object.
                     */


                    function load(img, Slide) {
                      addClass(Slide.slide, STATUS_CLASSES.loading);
                      var spinner = create('span', {
                        "class": Splide.classes.spinner
                      });
                      append(img.parentElement, spinner);

                      img.onload = function () {
                        loaded(img, spinner, Slide, false);
                      };

                      img.onerror = function () {
                        loaded(img, spinner, Slide, true);
                      };

                      setAttribute(img, 'srcset', getAttribute(img, SRCSET_DATA_NAME) || '');
                      setAttribute(img, 'src', getAttribute(img, SRC_DATA_NAME) || '');
                    }
                    /**
                     * Start loading a next image in images array.
                     */


                    function loadNext() {
                      if (nextIndex < images.length) {
                        var image = images[nextIndex];
                        load(image.img, image.Slide);
                      }

                      nextIndex++;
                    }
                    /**
                     * Called just after the image was loaded or loading was aborted by some error.
                     *
                     * @param {Element} img     - An image element.
                     * @param {Element} spinner - A spinner element.
                     * @param {Object}  Slide   - A Slide object.
                     * @param {boolean} error   - True if the image was loaded successfully or false on error.
                     */


                    function loaded(img, spinner, Slide, error) {
                      removeClass(Slide.slide, STATUS_CLASSES.loading);

                      if (!error) {
                        dom_remove(spinner);
                        applyStyle(img, {
                          display: ''
                        });
                        Splide.emit(name + ":loaded", img).emit('resize');
                      }

                      if (isSequential) {
                        loadNext();
                      }
                    }

                    return Lazyload;
                  });
                  ;// CONCATENATED MODULE: ./src/js/constants/a11y.js
                  /**
                   * Export aria attribute names.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */

                  /**
                   * Attribute name for aria-current.
                   *
                   * @type {string}
                   */
                  var ARIA_CURRENRT = 'aria-current';
                  /**
                   * Attribute name for aria-control.
                   *
                   * @type {string}
                   */

                  var ARIA_CONTROLS = 'aria-controls';
                  /**
                   * Attribute name for aria-control.
                   *
                   * @type {string}
                   */

                  var ARIA_LABEL = 'aria-label';
                  /**
                   * Attribute name for aria-labelledby.
                   *
                   * @type {string}
                   */

                  var ARIA_LABELLEDBY = 'aria-labelledby';
                  /**
                   * Attribute name for aria-hidden.
                   *
                   * @type {string}
                   */

                  var ARIA_HIDDEN = 'aria-hidden';
                  /**
                   * Attribute name for tab-index.
                   *
                   * @type {string}
                   */

                  var TAB_INDEX = 'tabindex';
                  ;// CONCATENATED MODULE: ./src/js/components/keyboard/index.js
                  /**
                   * The component for controlling slides via keyboard.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */


                  /**
                   * Map a key to a slide control.
                   *
                   * @type {Object}
                   */

                  var KEY_MAP = {
                    ltr: {
                      ArrowLeft: '<',
                      ArrowRight: '>',
                      // For IE.
                      Left: '<',
                      Right: '>'
                    },
                    rtl: {
                      ArrowLeft: '>',
                      ArrowRight: '<',
                      // For IE.
                      Left: '>',
                      Right: '<'
                    },
                    ttb: {
                      ArrowUp: '<',
                      ArrowDown: '>',
                      // For IE.
                      Up: '<',
                      Down: '>'
                    }
                  };
/**
 * The component for controlling slides via keyboard.
 *
 * @param {Splide} Splide - A Splide instance.
 *
 * @return {Object} - The component object.
 */

/* harmony default export */ const keyboard = (function (Splide) {
                    /**
                     * Hold the target element.
                     *
                     * @type {Element|Document|undefined}
                     */
                    var target;
                    return {
                      /**
                       * Called when the component is mounted.
                       */
                      mount: function mount() {
                        Splide.on('mounted updated', function () {
                          var options = Splide.options;
                          var root = Splide.root;
                          var map = KEY_MAP[options.direction];
                          var keyboard = options.keyboard;

                          if (target) {
                            Splide.off('keydown', target);
                            removeAttribute(root, TAB_INDEX);
                          }

                          if (keyboard) {
                            if (keyboard === 'focused') {
                              target = root;
                              setAttribute(root, TAB_INDEX, 0);
                            } else {
                              target = document;
                            }

                            Splide.on('keydown', function (e) {
                              if (map[e.key]) {
                                Splide.go(map[e.key]);
                              }
                            }, target);
                          }
                        });
                      }
                    };
                  });
                  ;// CONCATENATED MODULE: ./src/js/components/a11y/index.js
/**
 * The component for enhancing accessibility.
 *
 * @author    Naotoshi Fujita
 * @copyright Naotoshi Fujita. All rights reserved.
 */



/**
 * The component for enhancing accessibility.
 *
 * @param {Splide} Splide     - A Splide instance.
 * @param {Object} Components - An object containing components.
 *
 * @return {Object} - The component object.
 */

/* harmony default export */ const a11y = (function (Splide, Components) {
                    /**
                     * Hold a i18n object.
                     *
                     * @type {Object}
                     */
                    var i18n = Splide.i18n;
                    /**
                     * Hold the Elements component.
                     *
                     * @type {Object}
                     */

                    var Elements = Components.Elements;
                    /**
                     * All attributes related with A11y.
                     *
                     * @type {string[]}
                     */

                    var allAttributes = [ARIA_HIDDEN, TAB_INDEX, ARIA_CONTROLS, ARIA_LABEL, ARIA_CURRENRT, 'role'];
                    /**
                     * A11y component object.
                     *
                     * @type {Object}
                     */

                    var A11y = {
                      /**
                       * Required only when the accessibility option is true.
                       *
                       * @type {boolean}
                       */
                      required: Splide.options.accessibility,

                      /**
                       * Called when the component is mounted.
                       */
                      mount: function mount() {
                        Splide.on('visible', function (Slide) {
                          updateSlide(Slide.slide, true);
                        }).on('hidden', function (Slide) {
                          updateSlide(Slide.slide, false);
                        }).on('arrows:mounted', initArrows).on('arrows:updated', updateArrows).on('pagination:mounted', initPagination).on('pagination:updated', updatePagination).on('refresh', function () {
                          removeAttribute(Components.Clones.clones, allAttributes);
                        });

                        if (Splide.options.isNavigation) {
                          Splide.on('navigation:mounted navigation:updated', initNavigation).on('active', function (Slide) {
                            updateNavigation(Slide, true);
                          }).on('inactive', function (Slide) {
                            updateNavigation(Slide, false);
                          });
                        }

                        initAutoplay();
                      },

                      /**
                       * Destroy.
                       */
                      destroy: function destroy() {
                        var Arrows = Components.Arrows;
                        var arrows = Arrows ? Arrows.arrows : {};
                        removeAttribute(Elements.slides.concat([arrows.prev, arrows.next, Elements.play, Elements.pause]), allAttributes);
                      }
                    };
                    /**
                     * Update slide attributes when it gets visible or hidden.
                     *
                     * @param {Element} slide   - A slide element.
                     * @param {Boolean} visible - True when the slide gets visible, or false when hidden.
                     */

                    function updateSlide(slide, visible) {
                      setAttribute(slide, ARIA_HIDDEN, !visible);

                      if (Splide.options.slideFocus) {
                        setAttribute(slide, TAB_INDEX, visible ? 0 : -1);
                      }
                    }
                    /**
                     * Initialize arrows if they are available.
                     * Append screen reader elements and add aria-controls attribute.
                     *
                     * @param {Element} prev - Previous arrow element.
                     * @param {Element} next - Next arrow element.
                     */


                    function initArrows(prev, next) {
                      var controls = Elements.track.id;
                      setAttribute(prev, ARIA_CONTROLS, controls);
                      setAttribute(next, ARIA_CONTROLS, controls);
                    }
                    /**
                     * Update arrow attributes.
                     *
                     * @param {Element} prev      - Previous arrow element.
                     * @param {Element} next      - Next arrow element.
                     * @param {number}  prevIndex - Previous slide index or -1 when there is no precede slide.
                     * @param {number}  nextIndex - Next slide index or -1 when there is no next slide.
                     */


                    function updateArrows(prev, next, prevIndex, nextIndex) {
                      var index = Splide.index;
                      var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
                      var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
                      setAttribute(prev, ARIA_LABEL, prevLabel);
                      setAttribute(next, ARIA_LABEL, nextLabel);
                    }
                    /**
                     * Initialize pagination if it's available.
                     * Append a screen reader element and add aria-controls/label attribute to each item.
                     *
                     * @param {Object} data       - Data object containing all items.
                     * @param {Object} activeItem - An initial active item.
                     */


                    function initPagination(data, activeItem) {
                      if (activeItem) {
                        setAttribute(activeItem.button, ARIA_CURRENRT, true);
                      }

                      data.items.forEach(function (item) {
                        var options = Splide.options;
                        var text = options.focus === false && options.perPage > 1 ? i18n.pageX : i18n.slideX;
                        var label = sprintf(text, item.page + 1);
                        var button = item.button;
                        var controls = item.Slides.map(function (Slide) {
                          return Slide.slide.id;
                        });
                        setAttribute(button, ARIA_CONTROLS, controls.join(' '));
                        setAttribute(button, ARIA_LABEL, label);
                      });
                    }
                    /**
                     * Update pagination attributes.
                     *
                     * @param {Object}  data - Data object containing all items.
                     * @param {Element} prev - A previous active element.
                     * @param {Element} curr - A current active element.
                     */


                    function updatePagination(data, prev, curr) {
                      if (prev) {
                        removeAttribute(prev.button, ARIA_CURRENRT);
                      }

                      if (curr) {
                        setAttribute(curr.button, ARIA_CURRENRT, true);
                      }
                    }
                    /**
                     * Initialize autoplay buttons.
                     */


                    function initAutoplay() {
                      ['play', 'pause'].forEach(function (name) {
                        var elm = Elements[name];

                        if (elm) {
                          if (!isButton(elm)) {
                            setAttribute(elm, 'role', 'button');
                          }

                          setAttribute(elm, ARIA_CONTROLS, Elements.track.id);
                          setAttribute(elm, ARIA_LABEL, i18n[name]);
                        }
                      });
                    }
                    /**
                     * Initialize navigation slider.
                     * Add button role, aria-label, aria-controls to slide elements and append screen reader text to them.
                     *
                     * @param {Splide} main - A main Splide instance.
                     */


                    function initNavigation(main) {
                      Elements.each(function (Slide) {
                        var slide = Slide.slide;
                        var realIndex = Slide.realIndex;

                        if (!isButton(slide)) {
                          setAttribute(slide, 'role', 'button');
                        }

                        var slideIndex = realIndex > -1 ? realIndex : Slide.index;
                        var label = sprintf(i18n.slideX, slideIndex + 1);
                        var mainSlide = main.Components.Elements.getSlide(slideIndex);
                        setAttribute(slide, ARIA_LABEL, label);

                        if (mainSlide) {
                          setAttribute(slide, ARIA_CONTROLS, mainSlide.slide.id);
                        }
                      });
                    }
                    /**
                     * Update navigation attributes.
                     *
                     * @param {Object}  Slide  - A target Slide object.
                     * @param {boolean} active - True if the slide is active or false if inactive.
                     */


                    function updateNavigation(_ref, active) {
                      var slide = _ref.slide;

                      if (active) {
                        setAttribute(slide, ARIA_CURRENRT, true);
                      } else {
                        removeAttribute(slide, ARIA_CURRENRT);
                      }
                    }
                    /**
                     * Check if the given element is button or not.
                     *
                     * @param {Element} elm - An element to be checked.
                     *
                     * @return {boolean} - True if the given element is button.
                     */


                    function isButton(elm) {
                      return elm.tagName === 'BUTTON';
                    }

                    return A11y;
                  });
                  ;// CONCATENATED MODULE: ./src/js/components/sync/index.js
                  /**
                   * The component for synchronizing a slider with another.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */


                  /**
                   * The event name for sync.
                   *
                   * @type {string}
                   */

                  var SYNC_EVENT = 'move.sync';
                  /**
                   * The event names for click navigation.
                   * @type {string}
                   */

                  var CLICK_EVENTS = 'mouseup touchend';
                  /**
                   * The keys for triggering the navigation button.
                   *
                   * @type {String[]}
                   */

                  var TRIGGER_KEYS = [' ', 'Enter', 'Spacebar'];
/**
 * The component for synchronizing a slider with another.
 *
 * @param {Splide} Splide - A Splide instance.
 *
 * @return {Object} - The component object.
 */

/* harmony default export */ const sync = (function (Splide) {
                    /**
                     * Keep the sibling Splide instance.
                     *
                     * @type {Splide}
                     */
                    var sibling = Splide.sibling;
                    /**
                     * Whether the sibling slider is navigation or not.
                     *
                     * @type {Splide|boolean}
                     */

                    var isNavigation = sibling && sibling.options.isNavigation;
                    /**
                     * Layout component object.
                     *
                     * @type {Object}
                     */

                    var Sync = {
                      /**
                       * Required only when the sub slider is available.
                       *
                       * @type {boolean}
                       */
                      required: !!sibling,

                      /**
                       * Called when the component is mounted.
                       */
                      mount: function mount() {
                        syncMain();
                        syncSibling();

                        if (isNavigation) {
                          bind();
                          Splide.on('refresh', function () {
                            setTimeout(function () {
                              bind();
                              sibling.emit('navigation:updated', Splide);
                            });
                          });
                        }
                      },

                      /**
                       * Called after all components are mounted.
                       */
                      mounted: function mounted() {
                        if (isNavigation) {
                          sibling.emit('navigation:mounted', Splide);
                        }
                      }
                    };
                    /**
                     * Listen the primary slider event to move secondary one.
                     * Must unbind a handler at first to avoid infinite loop.
                     */

                    function syncMain() {
                      Splide.on(SYNC_EVENT, function (newIndex, prevIndex, destIndex) {
                        sibling.off(SYNC_EVENT).go(sibling.is(LOOP) ? destIndex : newIndex, false);
                        syncSibling();
                      });
                    }
                    /**
                     * Listen the secondary slider event to move primary one.
                     * Must unbind a handler at first to avoid infinite loop.
                     */


                    function syncSibling() {
                      sibling.on(SYNC_EVENT, function (newIndex, prevIndex, destIndex) {
                        Splide.off(SYNC_EVENT).go(Splide.is(LOOP) ? destIndex : newIndex, false);
                        syncMain();
                      });
                    }
                    /**
                     * Listen some events on each slide.
                     */


                    function bind() {
                      sibling.Components.Elements.each(function (_ref) {
                        var slide = _ref.slide,
                          index = _ref.index;

                        /*
                         * Listen mouseup and touchend events to handle click.
                         */
                        Splide.off(CLICK_EVENTS, slide).on(CLICK_EVENTS, function (e) {
                          // Ignore a middle or right click.
                          if (!e.button || e.button === 0) {
                            moveSibling(index);
                          }
                        }, slide);
                        /*
                         * Subscribe keyup to handle Enter and Space key.
                         * Note that Array.includes is not supported by IE.
                         */

                        Splide.off('keyup', slide).on('keyup', function (e) {
                          if (TRIGGER_KEYS.indexOf(e.key) > -1) {
                            e.preventDefault();
                            moveSibling(index);
                          }
                        }, slide, {
                          passive: false
                        });
                      });
                    }
                    /**
                     * Move the sibling to the given index.
                     * Need to check "IDLE" status because slides can be moving by Drag component.
                     *
                     * @param {number} index - Target index.
                     */


                    function moveSibling(index) {
                      if (Splide.State.is(IDLE)) {
                        sibling.go(index);
                      }
                    }

                    return Sync;
                  });
                  ;// CONCATENATED MODULE: ./src/js/components/breakpoints/index.js
                  /**
                   * The component for updating options according to a current window width.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */


                  /**
                   * Interval time for throttle.
                   *
                   * @type {number}
                   */

                  var THROTTLE = 50;
/**
 * The component for updating options according to a current window width.
 *
 * @param {Splide} Splide - A Splide instance.
 *
 * @return {Object} - The component object.
 */

/* harmony default export */ const breakpoints = (function (Splide) {
                    /**
                     * Store breakpoints.
                     *
                     * @type {Object|boolean}
                     */
                    var breakpoints = Splide.options.breakpoints;
                    /**
                     * The check function whose frequency of call is reduced.
                     *
                     * @type {Function}
                     */

                    var throttledCheck = throttle(check, THROTTLE);
                    /**
                     * Keep initial options.
                     *
                     * @type {Object}
                     */

                    var initialOptions;
                    /**
                     * An array containing objects of point and MediaQueryList.
                     *
                     * @type {Object[]}
                     */

                    var map = [];
                    /**
                     * Hold the previous breakpoint.
                     *
                     * @type {number|undefined}
                     */

                    var prevPoint;
                    /**
                     * Breakpoints component object.
                     *
                     * @type {Object}
                     */

                    var Breakpoints = {
                      /**
                       * Required only when the breakpoints definition is provided and browser supports matchMedia.
                       *
                       * @type {boolean}
                       */
                      required: breakpoints && matchMedia,

                      /**
                       * Called when the component is mounted.
                       */
                      mount: function mount() {
                        map = Object.keys(breakpoints).sort(function (n, m) {
                          return +n - +m;
                        }).map(function (point) {
                          return {
                            point: point,
                            mql: matchMedia("(max-width:" + point + "px)")
                          };
                        });
                        /*
                         * To keep monitoring resize event after destruction without "completely",
                         * use native addEventListener instead of Splide.on.
                         */

                        this.destroy(true);
                        addEventListener('resize', throttledCheck); // Keep initial options to apply them when no breakpoint matches.

                        initialOptions = Splide.options;
                        check();
                      },

                      /**
                       * Destroy.
                       *
                       * @param {boolean} completely - Whether to destroy Splide completely.
                       */
                      destroy: function destroy(completely) {
                        if (completely) {
                          removeEventListener('resize', throttledCheck);
                        }
                      }
                    };
                    /**
                     * Check the breakpoint.
                     */

                    function check() {
                      var point = getPoint();

                      if (point !== prevPoint) {
                        prevPoint = point;
                        var State = Splide.State;
                        var options = breakpoints[point] || initialOptions;
                        var destroy = options.destroy;

                        if (destroy) {
                          Splide.options = initialOptions;
                          Splide.destroy(destroy === 'completely');
                        } else {
                          if (State.is(DESTROYED)) {
                            Splide.mount();
                          }

                          Splide.options = options;
                        }
                      }
                    }
                    /**
                     * Return the breakpoint matching current window width.
                     * Note that Array.prototype.find is not supported by IE.
                     *
                     * @return {number|string} - A breakpoint as number or string. -1 if no point matches.
                     */


                    function getPoint() {
                      var item = map.filter(function (item) {
                        return item.mql.matches;
                      })[0];
                      return item ? item.point : -1;
                    }

                    return Breakpoints;
                  });
                  ;// CONCATENATED MODULE: ./src/js/components/index.js
                  /**
                   * Export components.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */

















                  var COMPLETE = {
                    Options: options,
                    Breakpoints: breakpoints,
                    Controller: controller,
                    Elements: components_elements,
                    Track: track,
                    Clones: clones,
                    Layout: layout,
                    Drag: drag,
                    Click: click,
                    Autoplay: autoplay,
                    Cover: cover,
                    Arrows: arrows,
                    Pagination: pagination,
                    LazyLoad: lazyload,
                    Keyboard: keyboard,
                    Sync: sync,
                    A11y: a11y
                  };
                  var LIGHT = {
                    Options: options,
                    Controller: controller,
                    Elements: components_elements,
                    Track: track,
                    Clones: clones,
                    Layout: layout,
                    Drag: drag,
                    Click: click,
                    Arrows: arrows,
                    Pagination: pagination,
                    A11y: a11y
                  };
                  ;// CONCATENATED MODULE: ./build/module/module.js
                  function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

                  /**
                   * Export Splide class for import.
                   *
                   * @author    Naotoshi Fujita
                   * @copyright Naotoshi Fujita. All rights reserved.
                   */


                  /**
                   * Export Splide class for import from other projects.
                   */

                  var module_Splide = /*#__PURE__*/function (_Core) {
                    _inheritsLoose(Splide, _Core);

                    function Splide(root, options) {
                      return _Core.call(this, root, options, COMPLETE) || this;
                    }

                    return Splide;
                  }(Splide);



                  /***/
})

              /******/
});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/
/******/ 	// The require function
/******/ 	function __nested_webpack_require_139193__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if (__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
                /******/
}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
                /******/
};
/******/
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __nested_webpack_require_139193__);
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
              /******/
}
/******/
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__nested_webpack_require_139193__.d = (exports, definition) => {
/******/ 			for (var key in definition) {
/******/ 				if (__nested_webpack_require_139193__.o(definition, key) && !__nested_webpack_require_139193__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
                    /******/
}
                  /******/
}
                /******/
};
              /******/
})();
/******/
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__nested_webpack_require_139193__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop)
              /******/
})();
/******/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__nested_webpack_require_139193__.r = (exports) => {
/******/ 			if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
                  /******/
}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
                /******/
};
              /******/
})();
/******/
/************************************************************************/
/******/ 	// module exports must be returned from runtime so entry inlining is disabled
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_139193__(311);
            /******/
})()
            ;
        });

        /***/
}),

/***/ "./assets/js/component/c-account_menu.js":
/*!***********************************************!*\
  !*** ./assets/js/component/c-account_menu.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);



        jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", ".c-account_menu__btn", function () {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).next(".c-account_menu__container").slideToggle(400);
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).toggleClass("is-open");
        });

        /***/
}),

/***/ "./assets/js/component/c-announce_bar.js":
/*!***********************************************!*\
  !*** ./assets/js/component/c-announce_bar.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);



        document.addEventListener("DOMContentLoaded", function () {
          if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(".c-announce_bar").length) {
            var announceBar = sessionStorage.getItem("announceBar");

            if (announceBar == "hide") {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(".c-announce_bar").hide();
            }
          }
        });
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", ".c-announce_bar__close", function () {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(".c-announce_bar").hide();
          var headerH = jquery__WEBPACK_IMPORTED_MODULE_0___default()(".l-header").outerHeight();
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(".l-container").css("padding-top", headerH);
          sessionStorage.setItem("announceBar", "hide");
        });

        /***/
}),

/***/ "./assets/js/component/c-fixed_popup.js":
/*!**********************************************!*\
  !*** ./assets/js/component/c-fixed_popup.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);



        document.addEventListener("DOMContentLoaded", function () {
          if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(".c-fixed_popup").length) {
            var fixedPopup = sessionStorage.getItem("fixedPopup");

            if (fixedPopup != "hide") {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(".c-fixed_popup").addClass("is-show");
            }
          }
        });
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", ".c-fixed_popup__close", function () {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(".c-fixed_popup").addClass("is-hide");
          sessionStorage.setItem("fixedPopup", "hide");
        });
        document.addEventListener("DOMContentLoaded", function () {
          if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(".c-fixed_popup").length) {
            if (window.matchMedia("(max-width: 720px)").matches) {
              var popupH = jquery__WEBPACK_IMPORTED_MODULE_0___default()(".c-fixed_popup").height();
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(".l-wrapper").css("padding-bottom", popupH);
            }
          }
        });

        /***/
}),

/***/ "./assets/js/component/c-gmenu.js":
/*!****************************************!*\
  !*** ./assets/js/component/c-gmenu.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var throttle_debounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! throttle-debounce */ "./node_modules/throttle-debounce/esm/index.js");
        // "use strict"

        {
          /**
           * whenever mobile safari address bar is resized,
           * and the `resize` event is fired, the available space is retrieved.
           */
          const updateHeight = (0, throttle_debounce__WEBPACK_IMPORTED_MODULE_0__.debounce)(200, () => {
            html.style.setProperty("--screen-height", `${window.innerHeight}px`);
          });
          window.addEventListener("resize", updateHeight);
          updateHeight();
          /**
           * scrollable side menu with prevent scroll chaining.
           * TODO: use `overscroll-beavior` once fully implemented in mobile safari.
           */

          const html = document.documentElement;
          const body = document.body;
          const contents = document.querySelector("main.l-container");
          const globalMenu = document.querySelector(".c-gmenu");
          const searchMenu = document.querySelector(".p-search_menu");
          const closeButton = document.querySelectorAll(".js-close-menu"); // prevent scroll chaining

          const fixContent = _ref => {
            let {
              activatingElement
            } = _ref;
            return () => {
              // keep scroll position
              const scrollTop = contents.offsetTop - html.scrollTop;
              body.style.setProperty("top", `${scrollTop}px`);
              html.classList.add("js-prevent-body-scroll");
              activatingElement.classList.add("is-active");
              closeButton.forEach(button => button.addEventListener("click", releaseContent({
                deactivatingElement: activatingElement,
                scrollTop
              })));
            };
          }; // make body scrollable again


          const releaseContent = _ref2 => {
            let {
              deactivatingElement,
              scrollTop
            } = _ref2;
            return () => {
              // restore scroll position
              html.scrollTop = scrollTop * -1;
              body.style.removeProperty("top");
              html.classList.remove("js-prevent-body-scroll");
              deactivatingElement.classList.remove("is-active");
              closeButton.forEach(button => button.removeEventListener("click", releaseContent({
                deactivatingElement
              })));
            };
          };

          document.querySelector(".l-header__inner__block__item--menu").addEventListener("click", fixContent({
            activatingElement: globalMenu
          }));
          document.querySelector(".l-header__inner__block__item--search").addEventListener("click", fixContent({
            activatingElement: searchMenu
          }));
        }

        /***/
}),

/***/ "./assets/js/component/c-order_quantity.js":
/*!*************************************************!*\
  !*** ./assets/js/component/c-order_quantity.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);



        document.addEventListener("DOMContentLoaded", function () {
          if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(".c-order_quantity").length) {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", ".c-order_quantity__minus", function () {
              var n = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).siblings(".c-order_quantity__input").val();
              n--;

              if (0 <= n) {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).siblings(".c-order_quantity__input").val(n);
              }
            });
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", ".c-order_quantity__plus", function () {
              var n = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).siblings(".c-order_quantity__input").val();
              n++;

              if (n <= 10) {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).siblings(".c-order_quantity__input").val(n);
              }
            });
          }
        });

        /***/
}),

/***/ "./assets/js/component/c-product_img.js":
/*!**********************************************!*\
  !*** ./assets/js/component/c-product_img.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var _splidejs_splide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @splidejs/splide */ "./node_modules/@splidejs/splide/dist/js/splide.esm.js");
/* harmony import */ var _splidejs_splide__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_splidejs_splide__WEBPACK_IMPORTED_MODULE_0__);

        {
          const img = document.querySelector(".c-product_img");
          const slider = img === null || img === void 0 ? void 0 : img.querySelector(".c-product_img__slider--main");
          const thumbnails = img === null || img === void 0 ? void 0 : img.querySelector(".c-product_img__slider--thumbnail");

          if (slider && thumbnails) {
            const mainSlider = new (_splidejs_splide__WEBPACK_IMPORTED_MODULE_0___default())(slider, {
              type: "fade",
              pagination: false,
              arrows: false
            });
            const thumbSlider = new (_splidejs_splide__WEBPACK_IMPORTED_MODULE_0___default())(thumbnails, {
              fixedWidth: 80,
              fixedHeight: 106,
              isNavigation: true,
              rewind: true,
              pagination: false,
              gap: "20px",
              breakpoints: {
                720: {
                  fixedWidth: "16vw",
                  fixedHeight: "21.3vw",
                  gap: "2.93vw"
                }
              }
            }); // 呼び出しの順番変えると動かないから注意

            mainSlider.sync(thumbSlider);
            thumbSlider.mount();
            mainSlider.mount();
          }
        }

        /***/
}),

/***/ "./assets/js/component/c-recommend_product.js":
/*!****************************************************!*\
  !*** ./assets/js/component/c-recommend_product.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


        if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(".p-recommend_product").length) {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()("#recommend_product__slick").slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: true,
            prevArrow: '<span class="slick-prev"></span>',
            nextArrow: '<span class="slick-next"></span>',
            appendArrows: ".p-recommend_product__inner .slider-nav",
            appendDots: ".p-recommend_product__inner .slider-nav",
            responsive: [{
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            }, {
              breakpoint: 720,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                rows: 2
              }
            }]
          });
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on("load resize", function () {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(".p-recommend_product .slick-next").insertAfter(".p-recommend_product .slick-dots");
          });
        }

        /***/
}),

/***/ "./assets/js/component/c-review_star.js":
/*!**********************************************!*\
  !*** ./assets/js/component/c-review_star.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);



        document.addEventListener("DOMContentLoaded", function () {
          if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(".c-review_star").length) {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(".c-review_star__item__input").hover(function () {
              var value = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).val();
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(".c-review_star").attr("data-score", value);
            }, function () {
              var score = jquery__WEBPACK_IMPORTED_MODULE_0___default()(".c-review_star__item__input:checked").val();

              if (score != undefined) {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(".c-review_star").attr("data-score", score);
              } else {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(".c-review_star").attr("data-score", "0");
              }
            });
          }
        });

        /***/
}),

/***/ "./assets/js/component/c-subscribe-form.js":
/*!*************************************************!*\
  !*** ./assets/js/component/c-subscribe-form.js ***!
  \*************************************************/
/***/ (() => {

        "use srtict";

        document.addEventListener("DOMContentLoaded", function () {
          if (document.getElementsByClassName("js-signup-form").length) {
            const key = location.hostname + "_emailData";
            const submitBtn = document.querySelector(".js-signup-form-submit");
            const mailInput = document.querySelector(".js-signup-form-input");
            submitBtn.addEventListener("click", function () {
              const mailVal = mailInput.value;
              sessionStorage.setItem(key, mailVal);
              location.href = "/shop/customers/sign_up";
            });
          }
        });

        /***/
}),

/***/ "./assets/js/component/c-welcome_modal.js":
/*!************************************************!*\
  !*** ./assets/js/component/c-welcome_modal.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);



        document.addEventListener("DOMContentLoaded", function () {
          if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(".c-welcome_modal").length) {
            var welcomeModal = sessionStorage.getItem("welcomeModal");

            if (welcomeModal != "hide") {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on("load", function () {
                setTimeout(function () {
                  jquery__WEBPACK_IMPORTED_MODULE_0___default()(".c-welcome_modal").addClass("is-show");
                }, 1200);
              });
            }
          }
        });
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", ".c-welcome_modal__overlay,.c-welcome_modal__win__btn", function () {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(".c-welcome_modal").addClass("is-hide");
          sessionStorage.setItem("welcomeModal", "hide");
        });

        /***/
}),

/***/ "./assets/js/foundation/ua.js":
/*!************************************!*\
  !*** ./assets/js/foundation/ua.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var ua_parser_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ua-parser-js */ "./node_modules/ua-parser-js/src/ua-parser.js");
/* harmony import */ var ua_parser_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(ua_parser_js__WEBPACK_IMPORTED_MODULE_0__);

        {
          // set ua
          const browserInfo = (0, ua_parser_js__WEBPACK_IMPORTED_MODULE_0__.UAParser)();

          const toLowerSnakeCase = string => string.toLowerCase().replace(/ /g, "_");

          document.documentElement.classList.add(toLowerSnakeCase(browserInfo.os.name), toLowerSnakeCase(browserInfo.browser.name), browserInfo.browser.version);
        }

        /***/
}),

/***/ "./assets/js/layout/l-container.js":
/*!*****************************************!*\
  !*** ./assets/js/layout/l-container.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);



        jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on("load", function () {
          var headerH = jquery__WEBPACK_IMPORTED_MODULE_0___default()(".l-header").outerHeight();
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(".l-container").css("padding-top", headerH);
        });

        /***/
}),

/***/ "./assets/js/layout/l-wrapper.js":
/*!***************************************!*\
  !*** ./assets/js/layout/l-wrapper.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


        // 読み込み

        jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on("load", function () {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(".l-wrapper").addClass("is-complete");
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(".l-wrapper-none").addClass("is-complete");
        }); // 遷移

        jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", 'a:not([href^="#"]):not([target]):not(".js-notransition")', function (e) {
          e.preventDefault();
          var url = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr("href");

          if (url == "javascript:void(0);") {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(".l-wrapper-none").addClass("is-remove");
          }

          if (url !== "") {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(".l-wrapper").addClass("is-remove");
            window.location = url;
          }

          return false;
        });

        window.onpageshow = function (event) {
          if (event.persisted) {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(".l-wrapper").removeClass("is-remove");
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(".l-wrapper-none").removeClass("is-remove");
          }
        };

        /***/
}),

/***/ "./assets/js/project/p-browsing_history.js":
/*!*************************************************!*\
  !*** ./assets/js/project/p-browsing_history.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);



        const browsingHistory = {
          mounted: function () {
            if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(".js-browsing-history-slider").length) {
              browsingHistory.initHistorySlider();
            }
          },
          initHistorySlider: function () {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(".js-browsing-history-slider").slick({
              slidesToShow: 4,
              slidesToScroll: 4,
              infinite: false,
              arrows: true,
              dots: true,
              responsive: [{
                breakpoint: 720,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              }]
            });
          }
        };
        document.addEventListener("DOMContentLoaded", function () {
          browsingHistory.mounted();
        });

        /***/
}),

/***/ "./assets/js/project/p-checkout.js":
/*!*****************************************!*\
  !*** ./assets/js/project/p-checkout.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);



        jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("change", '.p-checkout__list__block__inner__shipping--select select[name="order[shipping_address_id]"]', function () {
          if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).val() == "new") {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".p-checkout__list__block__inner__shipping--select").next(".p-checkout__list__block__inner__shipping--new").slideDown(400);
          } else {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".p-checkout__list__block__inner__shipping--select").next(".p-checkout__list__block__inner__shipping--new").slideUp(400);
          }
        });
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("load change", '.p-checkout__list__block__inner__payment--select select[name="order[payment_attributes][payment_method_id]"]', function () {
          if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).val() == "1") {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".p-checkout__list__block__inner__payment--select").next(".p-checkout__list__block__inner__payment--credit").slideDown(400);
          } else {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".p-checkout__list__block__inner__payment--select").next(".p-checkout__list__block__inner__payment--credit").slideUp(400);
          }
        });
        document.addEventListener("DOMContentLoaded", function () {
          if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(".p-checkout__list__block__inner__shipping--select").length) {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on("load", function () {
              var shinpping = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.p-checkout__list__block__inner__shipping--select select[name="order[shipping_address_id]"]').val();

              if (shinpping == "new") {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(".p-checkout__list__block__inner__shipping--new").show();
              }
            });
          }

          if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(".p-checkout__list__block__inner__payment--select").length) {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on("load", function () {
              var payment = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.p-checkout__list__block__inner__payment--select select[name="order[payment_attributes][payment_method_id]"]').val();

              if (payment == "1") {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(".p-checkout__list__block__inner__payment--credit").show();
              }
            });
          }
        });

        /***/
}),

/***/ "./assets/js/project/p-faq.js":
/*!************************************!*\
  !*** ./assets/js/project/p-faq.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);



        document.addEventListener("DOMContentLoaded", function () {
          if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(".p-faq").length) {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", ".p-faq__inner__list__item__question", function () {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).next().slideToggle(400);
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).toggleClass("is-open");
            });
          }
        });

        /***/
}),

/***/ "./assets/js/project/p-instagram.js":
/*!******************************************!*\
  !*** ./assets/js/project/p-instagram.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);



        document.addEventListener("DOMContentLoaded", function () {
          if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(".p-instagram").length) {
            jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax({
              type: "GET",
              url: "https://graph.facebook.com/v5.0/【InstagramビジネスアカウントID】?fields=name%2Cmedia.limit(【表示したい画像数】)%7Bcaption%2Clike_count%2Cmedia_url%2Cpermalink%2Cthumbnail_url%7D&access_token=【アクセストークン】",
              dataType: "json",
              success: function (json) {
                var ig = json.media.data;
                var html = "";

                for (var i = 0; i < ig.length; i++) {
                  var link = ig[i].permalink;
                  var image;

                  if (!ig[i].thumbnail_url) {
                    // 動画の場合はこちら
                    image = ig[i].media_url;
                  } else {
                    // 写真の場合はこちら
                    image = ig[i].thumbnail_url;
                  }

                  html += `<li class="p-instagram__inner__list__item"><a class="p-instagram__inner__list__item__inner" href="${link}" target="_blank" style="background-image: url('${image}');"></a></li>`;
                }

                jquery__WEBPACK_IMPORTED_MODULE_0___default()(".p-instagram__inner__list").append(html);
              }
            });
          }
        });

        /***/
}),

/***/ "./assets/js/project/p-kv_slider.js":
/*!******************************************!*\
  !*** ./assets/js/project/p-kv_slider.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var _splidejs_splide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @splidejs/splide */ "./node_modules/@splidejs/splide/dist/js/splide.esm.js");
/* harmony import */ var _splidejs_splide__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_splidejs_splide__WEBPACK_IMPORTED_MODULE_0__);

        document.addEventListener("DOMContentLoaded", function () {
          const splideConf = {
            type: "fade",
            rewind: true,
            speed: 1600,
            rewindSpeed: 1600,
            arrows: "slider",
            pagination: false
          };
          const currentClassName = "is-current";
          document.querySelectorAll(".p-kv_slider").forEach(slider => {
            const interval = Number.parseInt(slider.querySelector(".p-kv_slider__track__list").dataset.interval, 10);
            const options = {
              ...splideConf
            };

            if (Number.isInteger(interval)) {
              options.autoplay = true;
              options.interval = interval * 1000;
            }

            const kvSlider = new (_splidejs_splide__WEBPACK_IMPORTED_MODULE_0___default())(slider, options);
            const dots = slider.querySelectorAll(".p-kv_slider__nav__pagination__dot");

            const onDotClick = e => {
              const dot = e.currentTarget; // get index of dot

              const index = Array.from(dot.parentNode.children).indexOf(dot);
              kvSlider.go(index);
            };

            const onSliderMoved = (nextIndex, prevIndex) => {
              dots[prevIndex].classList.remove(currentClassName);
              dots[nextIndex].classList.add(currentClassName);
            };

            kvSlider.on("moved", onSliderMoved);
            dots.forEach(dot => dot.addEventListener("click", onDotClick));
            kvSlider.mount();
          });
        });

        /***/
}),

/***/ "./assets/js/project/p-movie.js":
/*!**************************************!*\
  !*** ./assets/js/project/p-movie.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! color */ "./node_modules/color/index.js");
/* harmony import */ var color__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(color__WEBPACK_IMPORTED_MODULE_0__);
        /* global YT */


        function onPlayerReadyModal(event) {
          event.target.mute();
        }

        async function createYoutubePlayer(el_section) {
          let player = null;
          const buttonClassName = ".p-movie__info__view__btn";
          const playerClassName = ".ytplayer";
          const useModal = el_section.classList.contains("--large");
          const videoId = el_section.dataset.id;
          const el_button = el_section.querySelector(buttonClassName);
          const el_player = el_section.querySelector(playerClassName);
          const playerId = el_player.getAttribute("id");
          const options = {
            playerVars: {
              playsinline: 1,
              start: 1,
              mute: 1,
              playlist: videoId
            },
            videoId,
            events: {
              onReady: onPlayerReadyModal
            }
          };
          createScriptTag("youtube_player_api");
          player = await new Promise(resolve => {
            let player = null;
            const options = {
              events: {
                onReady: e => {
                  e.target.mute();
                  e.target.playVideo();
                }
              }
            }; // YT object is not defined

            if (window.YT === undefined) {
              window.onYouTubePlayerAPIReady = function () {
                player = new YT.Player(playerId, options);
                resolve(player);
              };
            } else {
              player = new YT.Player(playerId, options);
              resolve(player);
            }
          });

          if (el_button && useModal) {
            el_button.addEventListener("click", showModal(player, options));
          }
        }

        const showModal = (backgroundPlayer, options) => e => {
          var _document$querySelect;

          e.preventDefault();
          e.stopPropagation();
          const modalPlayerId = "ytplayer-modal";
          const modalPlayer = new YT.Player(modalPlayerId, options);
          (_document$querySelect = document.querySelector(".c-movie_modal")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.add("show");
          backgroundPlayer.pauseVideo();
          document.body.addEventListener("click", closeModal(backgroundPlayer, modalPlayer), {
            useCapture: true,
            once: true
          });
        };

        const closeModal = (backgroundPlayer, modalPlayer) => e => {
          var _document$querySelect2;

          e.stopPropagation();
          (_document$querySelect2 = document.querySelector(".c-movie_modal")) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.classList.remove("show");
          modalPlayer.destroy();
          backgroundPlayer.playVideo();
        };

        const createScriptTag = id => {
          if (document.getElementById(id)) {
            return;
          }

          const tag = document.createElement("script");
          tag.src = "https://www.youtube.com/player_api";
          tag.id = id;
          const firstScriptTag = document.getElementsByTagName("script")[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        };

        {
          // 動画セクション背景色
          const el = document.querySelector(".p-movie--theme");

          if (el) {
            const style = window.getComputedStyle(el);
            const theme = style.getPropertyValue("--theme-color").trim();
            const manipulated = color__WEBPACK_IMPORTED_MODULE_0___default()(theme).rotate(5.2).desaturate(0.05).lightness(96.9).hsl().toString();
            document.querySelectorAll(".p-movie--theme").forEach(l => l.style.setProperty("background-color", manipulated));
          }
        }
        document.addEventListener("DOMContentLoaded", () => {
          document.querySelectorAll(".p-movie").forEach(el => createYoutubePlayer(el));
        });

        /***/
}),

/***/ "./assets/js/project/p-payment_list.js":
/*!*********************************************!*\
  !*** ./assets/js/project/p-payment_list.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);



        document.addEventListener("DOMContentLoaded", function () {
          if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(".p-payment_list").length) {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", ".p-payment_list__add__btn", function () {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).next(".p-payment_list__add__win").slideDown(400);
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).hide();
            });
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", ".p-account__inner__content__form__bottom__link", function () {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(".p-payment_list__add__win").slideUp(400);
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(".p-payment_list__add__btn").show();
            });
          }
        });

        /***/
}),

/***/ "./assets/js/project/p-product_slider.js":
/*!***********************************************!*\
  !*** ./assets/js/project/p-product_slider.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
        {
          const options = {
            infinite: false,
            arrows: true,
            dots: true,
            prevArrow: '<span class="slick--prev"></span>',
            nextArrow: '<span class="slick--next"></span>'
          };
          const responsiveOptions = [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          }, {
            breakpoint: 720,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              rows: 1
            }
          }];

          const buildSliders = () => {
            const firstWindowWidth = window.innerWidth;
            document.querySelectorAll(".p-product_slider.slick").forEach((el, i) => {
              const slider = el.querySelector(".p-product_slider__list");
              const nav = el.querySelector(".p-product_slider__nav");
              const dataSlidesToShow = Number.parseInt(slider.dataset.slides) || 4;
              const useRowStyle = dataSlidesToShow < 3;
              const forceRowStyle = el.dataset.forceRowStyle !== undefined;
              const opt = {
                ...options,
                appendDots: nav,
                appendArrows: nav,
                slidesToShow: dataSlidesToShow,
                slidesToScroll: dataSlidesToShow,
                responsive: responsiveOptions.filter(option => !(option.breakpoint === 1024 && forceRowStyle))
              };

              const onBreakpoint = (_e, _s, b) => el.querySelectorAll(".c-product_item").forEach(l => {
                l.classList.toggle("--row-style", forceRowStyle || b === null);
              });

              slider.classList.add(`slider-${i}`);

              try {
                const $slick = $(slider).slick(opt);

                if (useRowStyle) {
                  $slick.on("breakpoint", onBreakpoint);
                  $slick.trigger("breakpoint", [$slick, firstWindowWidth > 1024 ? null : firstWindowWidth]);
                }
              } catch (e) {
                /**
                 * TODO: ecforce との二重管理をやめる
                 *
                 * すでに slick による初期化が完了した要素を .slick() すると
                 *   Uncaught TypeError: Cannot read properties of null (reading 'add')
                 * という例外が発生するため、ここで握りつぶす。
                 *
                 * 初期化済みの要素が生まれてしまうのは
                 * ecforce が持つ slick のコードの方が早く実行されてしまうため。
                 */
              }
            });
          };

          document.addEventListener("DOMContentLoaded", buildSliders);
        } // TODO: Migrate to Splide
        // import Splide from "@splidejs/splide"
        //
        // {
        //   const options = {
        //     type: "slide",
        //     rewind: false,
        //     perPage: 4,
        //     perMove: 1,
        //     gap: "20px",
        //     grid: false,
        //     arrows: true,
        //     pagination: true,
        //     breakpoints: {
        //       720: {
        //         perPage: 2,
        //         grid: {
        //           rows: 2,
        //         },
        //       },
        //     },
        //   }
        //
        //   document.querySelectorAll(".p-product_slider.splide").forEach((el) => {
        //     new Splide(el, options).mount()
        //   })
        // }

        /***/
}),

/***/ "./assets/js/project/p-registration.js":
/*!*********************************************!*\
  !*** ./assets/js/project/p-registration.js ***!
  \*********************************************/
/***/ (() => {

        "use strict";


        document.addEventListener("DOMContentLoaded", function () {
          if (document.getElementById("customers-registrations-sign-up-view")) {
            const key = location.hostname + "_emailData";
            const mailData = sessionStorage.getItem(key);

            if (mailData && mailData != "") {
              document.querySelector(".js-registration-email-input").value = mailData;
            }
          }
        }, false);

        /***/
}),

/***/ "./assets/js/project/p-review.js":
/*!***************************************!*\
  !*** ./assets/js/project/p-review.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);



        jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", ".p-review__inner__entry__btn", function () {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).next(".p-review__inner__entry__content").slideToggle(400);
        });
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", ".p-review__inner__entry__content__form__cancel", function () {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".p-review__inner__entry__content").slideUp(400);
        });
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", ".p-review__inner__all__btn", function () {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).toggleClass("is-open").prev(".p-review__inner__all__list").slideToggle({
            duration: 400,
            start: function () {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).css("display", "flex");
            }
          });

          if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).hasClass("is-open")) {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).text("閉じる");
          } else {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).text("もっと見る");
          }
        });

        /***/
}),

/***/ "./assets/js/project/p-set.js":
/*!************************************!*\
  !*** ./assets/js/project/p-set.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);



        const _this = {
          sp: false,
          selectionsInit: function () {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(".js-toggle-selections").on("click", function () {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(".js-selections-content").slideToggle("400");
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(".js-selections-price").slideToggle("400");
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).toggleClass("is-open");
            });
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(".js-select-clear-alt").on("click", function () {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(".select_clear").click();
            });
          },
          resetStyles: function () {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(".js-selections-content").show();
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(".js-toggle-selections").removeClass("is-open");
          },
          isSp: function () {
            return window.matchMedia("screen and (max-width: 720px)").matches;
          }
        };
        document.addEventListener("DOMContentLoaded", function () {
          if (document.getElementById("set-show-view") || document.getElementById("set-edit-view")) {
            _this.sp = _this.isSp();

            _this.selectionsInit();

            window.addEventListener("resize", function () {
              if (_this.sp && !_this.isSp()) {
                _this.resetStyles();
              }
            });
          }
        }, false);

        /***/
}),

/***/ "./assets/js/project/p-subscription_detail.js":
/*!****************************************************!*\
  !*** ./assets/js/project/p-subscription_detail.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);

        const _this = {
          mounted: function () {
            if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(".js-subs-detail-productslider").length) {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(".js-subs-detail-productslider").slick({
                slidesToShow: 4,
                slidesToScroll: 4,
                infinite: false,
                arrows: true,
                dots: true,
                responsive: [{
                  breakpoint: 720,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                }]
              });
            }
          }
        };
        document.addEventListener("DOMContentLoaded", function () {
          _this.mounted();
        });

        /***/
}),

/***/ "./node_modules/color-name/index.js":
/*!******************************************!*\
  !*** ./node_modules/color-name/index.js ***!
  \******************************************/
/***/ ((module) => {

        "use strict";


        module.exports = {
          "aliceblue": [240, 248, 255],
          "antiquewhite": [250, 235, 215],
          "aqua": [0, 255, 255],
          "aquamarine": [127, 255, 212],
          "azure": [240, 255, 255],
          "beige": [245, 245, 220],
          "bisque": [255, 228, 196],
          "black": [0, 0, 0],
          "blanchedalmond": [255, 235, 205],
          "blue": [0, 0, 255],
          "blueviolet": [138, 43, 226],
          "brown": [165, 42, 42],
          "burlywood": [222, 184, 135],
          "cadetblue": [95, 158, 160],
          "chartreuse": [127, 255, 0],
          "chocolate": [210, 105, 30],
          "coral": [255, 127, 80],
          "cornflowerblue": [100, 149, 237],
          "cornsilk": [255, 248, 220],
          "crimson": [220, 20, 60],
          "cyan": [0, 255, 255],
          "darkblue": [0, 0, 139],
          "darkcyan": [0, 139, 139],
          "darkgoldenrod": [184, 134, 11],
          "darkgray": [169, 169, 169],
          "darkgreen": [0, 100, 0],
          "darkgrey": [169, 169, 169],
          "darkkhaki": [189, 183, 107],
          "darkmagenta": [139, 0, 139],
          "darkolivegreen": [85, 107, 47],
          "darkorange": [255, 140, 0],
          "darkorchid": [153, 50, 204],
          "darkred": [139, 0, 0],
          "darksalmon": [233, 150, 122],
          "darkseagreen": [143, 188, 143],
          "darkslateblue": [72, 61, 139],
          "darkslategray": [47, 79, 79],
          "darkslategrey": [47, 79, 79],
          "darkturquoise": [0, 206, 209],
          "darkviolet": [148, 0, 211],
          "deeppink": [255, 20, 147],
          "deepskyblue": [0, 191, 255],
          "dimgray": [105, 105, 105],
          "dimgrey": [105, 105, 105],
          "dodgerblue": [30, 144, 255],
          "firebrick": [178, 34, 34],
          "floralwhite": [255, 250, 240],
          "forestgreen": [34, 139, 34],
          "fuchsia": [255, 0, 255],
          "gainsboro": [220, 220, 220],
          "ghostwhite": [248, 248, 255],
          "gold": [255, 215, 0],
          "goldenrod": [218, 165, 32],
          "gray": [128, 128, 128],
          "green": [0, 128, 0],
          "greenyellow": [173, 255, 47],
          "grey": [128, 128, 128],
          "honeydew": [240, 255, 240],
          "hotpink": [255, 105, 180],
          "indianred": [205, 92, 92],
          "indigo": [75, 0, 130],
          "ivory": [255, 255, 240],
          "khaki": [240, 230, 140],
          "lavender": [230, 230, 250],
          "lavenderblush": [255, 240, 245],
          "lawngreen": [124, 252, 0],
          "lemonchiffon": [255, 250, 205],
          "lightblue": [173, 216, 230],
          "lightcoral": [240, 128, 128],
          "lightcyan": [224, 255, 255],
          "lightgoldenrodyellow": [250, 250, 210],
          "lightgray": [211, 211, 211],
          "lightgreen": [144, 238, 144],
          "lightgrey": [211, 211, 211],
          "lightpink": [255, 182, 193],
          "lightsalmon": [255, 160, 122],
          "lightseagreen": [32, 178, 170],
          "lightskyblue": [135, 206, 250],
          "lightslategray": [119, 136, 153],
          "lightslategrey": [119, 136, 153],
          "lightsteelblue": [176, 196, 222],
          "lightyellow": [255, 255, 224],
          "lime": [0, 255, 0],
          "limegreen": [50, 205, 50],
          "linen": [250, 240, 230],
          "magenta": [255, 0, 255],
          "maroon": [128, 0, 0],
          "mediumaquamarine": [102, 205, 170],
          "mediumblue": [0, 0, 205],
          "mediumorchid": [186, 85, 211],
          "mediumpurple": [147, 112, 219],
          "mediumseagreen": [60, 179, 113],
          "mediumslateblue": [123, 104, 238],
          "mediumspringgreen": [0, 250, 154],
          "mediumturquoise": [72, 209, 204],
          "mediumvioletred": [199, 21, 133],
          "midnightblue": [25, 25, 112],
          "mintcream": [245, 255, 250],
          "mistyrose": [255, 228, 225],
          "moccasin": [255, 228, 181],
          "navajowhite": [255, 222, 173],
          "navy": [0, 0, 128],
          "oldlace": [253, 245, 230],
          "olive": [128, 128, 0],
          "olivedrab": [107, 142, 35],
          "orange": [255, 165, 0],
          "orangered": [255, 69, 0],
          "orchid": [218, 112, 214],
          "palegoldenrod": [238, 232, 170],
          "palegreen": [152, 251, 152],
          "paleturquoise": [175, 238, 238],
          "palevioletred": [219, 112, 147],
          "papayawhip": [255, 239, 213],
          "peachpuff": [255, 218, 185],
          "peru": [205, 133, 63],
          "pink": [255, 192, 203],
          "plum": [221, 160, 221],
          "powderblue": [176, 224, 230],
          "purple": [128, 0, 128],
          "rebeccapurple": [102, 51, 153],
          "red": [255, 0, 0],
          "rosybrown": [188, 143, 143],
          "royalblue": [65, 105, 225],
          "saddlebrown": [139, 69, 19],
          "salmon": [250, 128, 114],
          "sandybrown": [244, 164, 96],
          "seagreen": [46, 139, 87],
          "seashell": [255, 245, 238],
          "sienna": [160, 82, 45],
          "silver": [192, 192, 192],
          "skyblue": [135, 206, 235],
          "slateblue": [106, 90, 205],
          "slategray": [112, 128, 144],
          "slategrey": [112, 128, 144],
          "snow": [255, 250, 250],
          "springgreen": [0, 255, 127],
          "steelblue": [70, 130, 180],
          "tan": [210, 180, 140],
          "teal": [0, 128, 128],
          "thistle": [216, 191, 216],
          "tomato": [255, 99, 71],
          "turquoise": [64, 224, 208],
          "violet": [238, 130, 238],
          "wheat": [245, 222, 179],
          "white": [255, 255, 255],
          "whitesmoke": [245, 245, 245],
          "yellow": [255, 255, 0],
          "yellowgreen": [154, 205, 50]
        };


        /***/
}),

/***/ "./node_modules/color-string/index.js":
/*!********************************************!*\
  !*** ./node_modules/color-string/index.js ***!
  \********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

        /* MIT license */
        var colorNames = __webpack_require__(/*! color-name */ "./node_modules/color-name/index.js");
        var swizzle = __webpack_require__(/*! simple-swizzle */ "./node_modules/simple-swizzle/index.js");
        var hasOwnProperty = Object.hasOwnProperty;

        var reverseNames = {};

        // create a list of reverse color names
        for (var name in colorNames) {
          if (hasOwnProperty.call(colorNames, name)) {
            reverseNames[colorNames[name]] = name;
          }
        }

        var cs = module.exports = {
          to: {},
          get: {}
        };

        cs.get = function (string) {
          var prefix = string.substring(0, 3).toLowerCase();
          var val;
          var model;
          switch (prefix) {
            case 'hsl':
              val = cs.get.hsl(string);
              model = 'hsl';
              break;
            case 'hwb':
              val = cs.get.hwb(string);
              model = 'hwb';
              break;
            default:
              val = cs.get.rgb(string);
              model = 'rgb';
              break;
          }

          if (!val) {
            return null;
          }

          return { model: model, value: val };
        };

        cs.get.rgb = function (string) {
          if (!string) {
            return null;
          }

          var abbr = /^#([a-f0-9]{3,4})$/i;
          var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
          var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
          var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
          var keyword = /^(\w+)$/;

          var rgb = [0, 0, 0, 1];
          var match;
          var i;
          var hexAlpha;

          if (match = string.match(hex)) {
            hexAlpha = match[2];
            match = match[1];

            for (i = 0; i < 3; i++) {
              // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
              var i2 = i * 2;
              rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
            }

            if (hexAlpha) {
              rgb[3] = parseInt(hexAlpha, 16) / 255;
            }
          } else if (match = string.match(abbr)) {
            match = match[1];
            hexAlpha = match[3];

            for (i = 0; i < 3; i++) {
              rgb[i] = parseInt(match[i] + match[i], 16);
            }

            if (hexAlpha) {
              rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
            }
          } else if (match = string.match(rgba)) {
            for (i = 0; i < 3; i++) {
              rgb[i] = parseInt(match[i + 1], 0);
            }

            if (match[4]) {
              if (match[5]) {
                rgb[3] = parseFloat(match[4]) * 0.01;
              } else {
                rgb[3] = parseFloat(match[4]);
              }
            }
          } else if (match = string.match(per)) {
            for (i = 0; i < 3; i++) {
              rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
            }

            if (match[4]) {
              if (match[5]) {
                rgb[3] = parseFloat(match[4]) * 0.01;
              } else {
                rgb[3] = parseFloat(match[4]);
              }
            }
          } else if (match = string.match(keyword)) {
            if (match[1] === 'transparent') {
              return [0, 0, 0, 0];
            }

            if (!hasOwnProperty.call(colorNames, match[1])) {
              return null;
            }

            rgb = colorNames[match[1]];
            rgb[3] = 1;

            return rgb;
          } else {
            return null;
          }

          for (i = 0; i < 3; i++) {
            rgb[i] = clamp(rgb[i], 0, 255);
          }
          rgb[3] = clamp(rgb[3], 0, 1);

          return rgb;
        };

        cs.get.hsl = function (string) {
          if (!string) {
            return null;
          }

          var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
          var match = string.match(hsl);

          if (match) {
            var alpha = parseFloat(match[4]);
            var h = ((parseFloat(match[1]) % 360) + 360) % 360;
            var s = clamp(parseFloat(match[2]), 0, 100);
            var l = clamp(parseFloat(match[3]), 0, 100);
            var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);

            return [h, s, l, a];
          }

          return null;
        };

        cs.get.hwb = function (string) {
          if (!string) {
            return null;
          }

          var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
          var match = string.match(hwb);

          if (match) {
            var alpha = parseFloat(match[4]);
            var h = ((parseFloat(match[1]) % 360) + 360) % 360;
            var w = clamp(parseFloat(match[2]), 0, 100);
            var b = clamp(parseFloat(match[3]), 0, 100);
            var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [h, w, b, a];
          }

          return null;
        };

        cs.to.hex = function () {
          var rgba = swizzle(arguments);

          return (
            '#' +
            hexDouble(rgba[0]) +
            hexDouble(rgba[1]) +
            hexDouble(rgba[2]) +
            (rgba[3] < 1
              ? (hexDouble(Math.round(rgba[3] * 255)))
              : '')
          );
        };

        cs.to.rgb = function () {
          var rgba = swizzle(arguments);

          return rgba.length < 4 || rgba[3] === 1
            ? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')'
            : 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
        };

        cs.to.rgb.percent = function () {
          var rgba = swizzle(arguments);

          var r = Math.round(rgba[0] / 255 * 100);
          var g = Math.round(rgba[1] / 255 * 100);
          var b = Math.round(rgba[2] / 255 * 100);

          return rgba.length < 4 || rgba[3] === 1
            ? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)'
            : 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
        };

        cs.to.hsl = function () {
          var hsla = swizzle(arguments);
          return hsla.length < 4 || hsla[3] === 1
            ? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)'
            : 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
        };

        // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
        // (hwb have alpha optional & 1 is default value)
        cs.to.hwb = function () {
          var hwba = swizzle(arguments);

          var a = '';
          if (hwba.length >= 4 && hwba[3] !== 1) {
            a = ', ' + hwba[3];
          }

          return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
        };

        cs.to.keyword = function (rgb) {
          return reverseNames[rgb.slice(0, 3)];
        };

        // helpers
        function clamp(num, min, max) {
          return Math.min(Math.max(min, num), max);
        }

        function hexDouble(num) {
          var str = Math.round(num).toString(16).toUpperCase();
          return (str.length < 2) ? '0' + str : str;
        }


        /***/
}),

/***/ "./node_modules/color/index.js":
/*!*************************************!*\
  !*** ./node_modules/color/index.js ***!
  \*************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

        const colorString = __webpack_require__(/*! color-string */ "./node_modules/color-string/index.js");
        const convert = __webpack_require__(/*! color-convert */ "./node_modules/color/node_modules/color-convert/index.js");

        const skippedModels = [
          // To be honest, I don't really feel like keyword belongs in color convert, but eh.
          'keyword',

          // Gray conflicts with some method names, and has its own method defined.
          'gray',

          // Shouldn't really be in color-convert either...
          'hex',
        ];

        const hashedModelKeys = {};
        for (const model of Object.keys(convert)) {
          hashedModelKeys[[...convert[model].labels].sort().join('')] = model;
        }

        const limiters = {};

        function Color(object, model) {
          if (!(this instanceof Color)) {
            return new Color(object, model);
          }

          if (model && model in skippedModels) {
            model = null;
          }

          if (model && !(model in convert)) {
            throw new Error('Unknown model: ' + model);
          }

          let i;
          let channels;

          if (object == null) { // eslint-disable-line no-eq-null,eqeqeq
            this.model = 'rgb';
            this.color = [0, 0, 0];
            this.valpha = 1;
          } else if (object instanceof Color) {
            this.model = object.model;
            this.color = [...object.color];
            this.valpha = object.valpha;
          } else if (typeof object === 'string') {
            const result = colorString.get(object);
            if (result === null) {
              throw new Error('Unable to parse color from string: ' + object);
            }

            this.model = result.model;
            channels = convert[this.model].channels;
            this.color = result.value.slice(0, channels);
            this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
          } else if (object.length > 0) {
            this.model = model || 'rgb';
            channels = convert[this.model].channels;
            const newArray = Array.prototype.slice.call(object, 0, channels);
            this.color = zeroArray(newArray, channels);
            this.valpha = typeof object[channels] === 'number' ? object[channels] : 1;
          } else if (typeof object === 'number') {
            // This is always RGB - can be converted later on.
            this.model = 'rgb';
            this.color = [
              (object >> 16) & 0xFF,
              (object >> 8) & 0xFF,
              object & 0xFF,
            ];
            this.valpha = 1;
          } else {
            this.valpha = 1;

            const keys = Object.keys(object);
            if ('alpha' in object) {
              keys.splice(keys.indexOf('alpha'), 1);
              this.valpha = typeof object.alpha === 'number' ? object.alpha : 0;
            }

            const hashedKeys = keys.sort().join('');
            if (!(hashedKeys in hashedModelKeys)) {
              throw new Error('Unable to parse color from object: ' + JSON.stringify(object));
            }

            this.model = hashedModelKeys[hashedKeys];

            const { labels } = convert[this.model];
            const color = [];
            for (i = 0; i < labels.length; i++) {
              color.push(object[labels[i]]);
            }

            this.color = zeroArray(color);
          }

          // Perform limitations (clamping, etc.)
          if (limiters[this.model]) {
            channels = convert[this.model].channels;
            for (i = 0; i < channels; i++) {
              const limit = limiters[this.model][i];
              if (limit) {
                this.color[i] = limit(this.color[i]);
              }
            }
          }

          this.valpha = Math.max(0, Math.min(1, this.valpha));

          if (Object.freeze) {
            Object.freeze(this);
          }
        }

        Color.prototype = {
          toString() {
            return this.string();
          },

          toJSON() {
            return this[this.model]();
          },

          string(places) {
            let self = this.model in colorString.to ? this : this.rgb();
            self = self.round(typeof places === 'number' ? places : 1);
            const args = self.valpha === 1 ? self.color : [...self.color, this.valpha];
            return colorString.to[self.model](args);
          },

          percentString(places) {
            const self = this.rgb().round(typeof places === 'number' ? places : 1);
            const args = self.valpha === 1 ? self.color : [...self.color, this.valpha];
            return colorString.to.rgb.percent(args);
          },

          array() {
            return this.valpha === 1 ? [...this.color] : [...this.color, this.valpha];
          },

          object() {
            const result = {};
            const { channels } = convert[this.model];
            const { labels } = convert[this.model];

            for (let i = 0; i < channels; i++) {
              result[labels[i]] = this.color[i];
            }

            if (this.valpha !== 1) {
              result.alpha = this.valpha;
            }

            return result;
          },

          unitArray() {
            const rgb = this.rgb().color;
            rgb[0] /= 255;
            rgb[1] /= 255;
            rgb[2] /= 255;

            if (this.valpha !== 1) {
              rgb.push(this.valpha);
            }

            return rgb;
          },

          unitObject() {
            const rgb = this.rgb().object();
            rgb.r /= 255;
            rgb.g /= 255;
            rgb.b /= 255;

            if (this.valpha !== 1) {
              rgb.alpha = this.valpha;
            }

            return rgb;
          },

          round(places) {
            places = Math.max(places || 0, 0);
            return new Color([...this.color.map(roundToPlace(places)), this.valpha], this.model);
          },

          alpha(value) {
            if (value !== undefined) {
              return new Color([...this.color, Math.max(0, Math.min(1, value))], this.model);
            }

            return this.valpha;
          },

          // Rgb
          red: getset('rgb', 0, maxfn(255)),
          green: getset('rgb', 1, maxfn(255)),
          blue: getset('rgb', 2, maxfn(255)),

          hue: getset(['hsl', 'hsv', 'hsl', 'hwb', 'hcg'], 0, value => ((value % 360) + 360) % 360),

          saturationl: getset('hsl', 1, maxfn(100)),
          lightness: getset('hsl', 2, maxfn(100)),

          saturationv: getset('hsv', 1, maxfn(100)),
          value: getset('hsv', 2, maxfn(100)),

          chroma: getset('hcg', 1, maxfn(100)),
          gray: getset('hcg', 2, maxfn(100)),

          white: getset('hwb', 1, maxfn(100)),
          wblack: getset('hwb', 2, maxfn(100)),

          cyan: getset('cmyk', 0, maxfn(100)),
          magenta: getset('cmyk', 1, maxfn(100)),
          yellow: getset('cmyk', 2, maxfn(100)),
          black: getset('cmyk', 3, maxfn(100)),

          x: getset('xyz', 0, maxfn(95.047)),
          y: getset('xyz', 1, maxfn(100)),
          z: getset('xyz', 2, maxfn(108.833)),

          l: getset('lab', 0, maxfn(100)),
          a: getset('lab', 1),
          b: getset('lab', 2),

          keyword(value) {
            if (value !== undefined) {
              return new Color(value);
            }

            return convert[this.model].keyword(this.color);
          },

          hex(value) {
            if (value !== undefined) {
              return new Color(value);
            }

            return colorString.to.hex(this.rgb().round().color);
          },

          hexa(value) {
            if (value !== undefined) {
              return new Color(value);
            }

            const rgbArray = this.rgb().round().color;

            let alphaHex = Math.round(this.valpha * 255).toString(16).toUpperCase();
            if (alphaHex.length === 1) {
              alphaHex = '0' + alphaHex;
            }

            return colorString.to.hex(rgbArray) + alphaHex;
          },

          rgbNumber() {
            const rgb = this.rgb().color;
            return ((rgb[0] & 0xFF) << 16) | ((rgb[1] & 0xFF) << 8) | (rgb[2] & 0xFF);
          },

          luminosity() {
            // http://www.w3.org/TR/WCAG20/#relativeluminancedef
            const rgb = this.rgb().color;

            const lum = [];
            for (const [i, element] of rgb.entries()) {
              const chan = element / 255;
              lum[i] = (chan <= 0.04045) ? chan / 12.92 : ((chan + 0.055) / 1.055) ** 2.4;
            }

            return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
          },

          contrast(color2) {
            // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
            const lum1 = this.luminosity();
            const lum2 = color2.luminosity();

            if (lum1 > lum2) {
              return (lum1 + 0.05) / (lum2 + 0.05);
            }

            return (lum2 + 0.05) / (lum1 + 0.05);
          },

          level(color2) {
            // https://www.w3.org/TR/WCAG/#contrast-enhanced
            const contrastRatio = this.contrast(color2);
            if (contrastRatio >= 7) {
              return 'AAA';
            }

            return (contrastRatio >= 4.5) ? 'AA' : '';
          },

          isDark() {
            // YIQ equation from http://24ways.org/2010/calculating-color-contrast
            const rgb = this.rgb().color;
            const yiq = (rgb[0] * 2126 + rgb[1] * 7152 + rgb[2] * 722) / 10000;
            return yiq < 128;
          },

          isLight() {
            return !this.isDark();
          },

          negate() {
            const rgb = this.rgb();
            for (let i = 0; i < 3; i++) {
              rgb.color[i] = 255 - rgb.color[i];
            }

            return rgb;
          },

          lighten(ratio) {
            const hsl = this.hsl();
            hsl.color[2] += hsl.color[2] * ratio;
            return hsl;
          },

          darken(ratio) {
            const hsl = this.hsl();
            hsl.color[2] -= hsl.color[2] * ratio;
            return hsl;
          },

          saturate(ratio) {
            const hsl = this.hsl();
            hsl.color[1] += hsl.color[1] * ratio;
            return hsl;
          },

          desaturate(ratio) {
            const hsl = this.hsl();
            hsl.color[1] -= hsl.color[1] * ratio;
            return hsl;
          },

          whiten(ratio) {
            const hwb = this.hwb();
            hwb.color[1] += hwb.color[1] * ratio;
            return hwb;
          },

          blacken(ratio) {
            const hwb = this.hwb();
            hwb.color[2] += hwb.color[2] * ratio;
            return hwb;
          },

          grayscale() {
            // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
            const rgb = this.rgb().color;
            const value = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
            return Color.rgb(value, value, value);
          },

          fade(ratio) {
            return this.alpha(this.valpha - (this.valpha * ratio));
          },

          opaquer(ratio) {
            return this.alpha(this.valpha + (this.valpha * ratio));
          },

          rotate(degrees) {
            const hsl = this.hsl();
            let hue = hsl.color[0];
            hue = (hue + degrees) % 360;
            hue = hue < 0 ? 360 + hue : hue;
            hsl.color[0] = hue;
            return hsl;
          },

          mix(mixinColor, weight) {
            // Ported from sass implementation in C
            // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
            if (!mixinColor || !mixinColor.rgb) {
              throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
            }

            const color1 = mixinColor.rgb();
            const color2 = this.rgb();
            const p = weight === undefined ? 0.5 : weight;

            const w = 2 * p - 1;
            const a = color1.alpha() - color2.alpha();

            const w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2;
            const w2 = 1 - w1;

            return Color.rgb(
              w1 * color1.red() + w2 * color2.red(),
              w1 * color1.green() + w2 * color2.green(),
              w1 * color1.blue() + w2 * color2.blue(),
              color1.alpha() * p + color2.alpha() * (1 - p));
          },
        };

        // Model conversion methods and static constructors
        for (const model of Object.keys(convert)) {
          if (skippedModels.includes(model)) {
            continue;
          }

          const { channels } = convert[model];

          // Conversion methods
          Color.prototype[model] = function (...args) {
            if (this.model === model) {
              return new Color(this);
            }

            if (args.length > 0) {
              return new Color(args, model);
            }

            return new Color([...assertArray(convert[this.model][model].raw(this.color)), this.valpha], model);
          };

          // 'static' construction methods
          Color[model] = function (...args) {
            let color = args[0];
            if (typeof color === 'number') {
              color = zeroArray(args, channels);
            }

            return new Color(color, model);
          };
        }

        function roundTo(number, places) {
          return Number(number.toFixed(places));
        }

        function roundToPlace(places) {
          return function (number) {
            return roundTo(number, places);
          };
        }

        function getset(model, channel, modifier) {
          model = Array.isArray(model) ? model : [model];

          for (const m of model) {
            (limiters[m] || (limiters[m] = []))[channel] = modifier;
          }

          model = model[0];

          return function (value) {
            let result;

            if (value !== undefined) {
              if (modifier) {
                value = modifier(value);
              }

              result = this[model]();
              result.color[channel] = value;
              return result;
            }

            result = this[model]().color[channel];
            if (modifier) {
              result = modifier(result);
            }

            return result;
          };
        }

        function maxfn(max) {
          return function (v) {
            return Math.max(0, Math.min(max, v));
          };
        }

        function assertArray(value) {
          return Array.isArray(value) ? value : [value];
        }

        function zeroArray(array, length) {
          for (let i = 0; i < length; i++) {
            if (typeof array[i] !== 'number') {
              array[i] = 0;
            }
          }

          return array;
        }

        module.exports = Color;


        /***/
}),

/***/ "./node_modules/color/node_modules/color-convert/conversions.js":
/*!**********************************************************************!*\
  !*** ./node_modules/color/node_modules/color-convert/conversions.js ***!
  \**********************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

        /* MIT license */
        /* eslint-disable no-mixed-operators */
        const cssKeywords = __webpack_require__(/*! color-name */ "./node_modules/color/node_modules/color-name/index.js");

        // NOTE: conversions should only return primitive values (i.e. arrays, or
        //       values that give correct `typeof` results).
        //       do not use box values types (i.e. Number(), String(), etc.)

        const reverseKeywords = {};
        for (const key of Object.keys(cssKeywords)) {
          reverseKeywords[cssKeywords[key]] = key;
        }

        const convert = {
          rgb: { channels: 3, labels: 'rgb' },
          hsl: { channels: 3, labels: 'hsl' },
          hsv: { channels: 3, labels: 'hsv' },
          hwb: { channels: 3, labels: 'hwb' },
          cmyk: { channels: 4, labels: 'cmyk' },
          xyz: { channels: 3, labels: 'xyz' },
          lab: { channels: 3, labels: 'lab' },
          lch: { channels: 3, labels: 'lch' },
          hex: { channels: 1, labels: ['hex'] },
          keyword: { channels: 1, labels: ['keyword'] },
          ansi16: { channels: 1, labels: ['ansi16'] },
          ansi256: { channels: 1, labels: ['ansi256'] },
          hcg: { channels: 3, labels: ['h', 'c', 'g'] },
          apple: { channels: 3, labels: ['r16', 'g16', 'b16'] },
          gray: { channels: 1, labels: ['gray'] }
        };

        module.exports = convert;

        // Hide .channels and .labels properties
        for (const model of Object.keys(convert)) {
          if (!('channels' in convert[model])) {
            throw new Error('missing channels property: ' + model);
          }

          if (!('labels' in convert[model])) {
            throw new Error('missing channel labels property: ' + model);
          }

          if (convert[model].labels.length !== convert[model].channels) {
            throw new Error('channel and label counts mismatch: ' + model);
          }

          const { channels, labels } = convert[model];
          delete convert[model].channels;
          delete convert[model].labels;
          Object.defineProperty(convert[model], 'channels', { value: channels });
          Object.defineProperty(convert[model], 'labels', { value: labels });
        }

        convert.rgb.hsl = function (rgb) {
          const r = rgb[0] / 255;
          const g = rgb[1] / 255;
          const b = rgb[2] / 255;
          const min = Math.min(r, g, b);
          const max = Math.max(r, g, b);
          const delta = max - min;
          let h;
          let s;

          if (max === min) {
            h = 0;
          } else if (r === max) {
            h = (g - b) / delta;
          } else if (g === max) {
            h = 2 + (b - r) / delta;
          } else if (b === max) {
            h = 4 + (r - g) / delta;
          }

          h = Math.min(h * 60, 360);

          if (h < 0) {
            h += 360;
          }

          const l = (min + max) / 2;

          if (max === min) {
            s = 0;
          } else if (l <= 0.5) {
            s = delta / (max + min);
          } else {
            s = delta / (2 - max - min);
          }

          return [h, s * 100, l * 100];
        };

        convert.rgb.hsv = function (rgb) {
          let rdif;
          let gdif;
          let bdif;
          let h;
          let s;

          const r = rgb[0] / 255;
          const g = rgb[1] / 255;
          const b = rgb[2] / 255;
          const v = Math.max(r, g, b);
          const diff = v - Math.min(r, g, b);
          const diffc = function (c) {
            return (v - c) / 6 / diff + 1 / 2;
          };

          if (diff === 0) {
            h = 0;
            s = 0;
          } else {
            s = diff / v;
            rdif = diffc(r);
            gdif = diffc(g);
            bdif = diffc(b);

            if (r === v) {
              h = bdif - gdif;
            } else if (g === v) {
              h = (1 / 3) + rdif - bdif;
            } else if (b === v) {
              h = (2 / 3) + gdif - rdif;
            }

            if (h < 0) {
              h += 1;
            } else if (h > 1) {
              h -= 1;
            }
          }

          return [
            h * 360,
            s * 100,
            v * 100
          ];
        };

        convert.rgb.hwb = function (rgb) {
          const r = rgb[0];
          const g = rgb[1];
          let b = rgb[2];
          const h = convert.rgb.hsl(rgb)[0];
          const w = 1 / 255 * Math.min(r, Math.min(g, b));

          b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

          return [h, w * 100, b * 100];
        };

        convert.rgb.cmyk = function (rgb) {
          const r = rgb[0] / 255;
          const g = rgb[1] / 255;
          const b = rgb[2] / 255;

          const k = Math.min(1 - r, 1 - g, 1 - b);
          const c = (1 - r - k) / (1 - k) || 0;
          const m = (1 - g - k) / (1 - k) || 0;
          const y = (1 - b - k) / (1 - k) || 0;

          return [c * 100, m * 100, y * 100, k * 100];
        };

        function comparativeDistance(x, y) {
          /*
            See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
          */
          return (
            ((x[0] - y[0]) ** 2) +
            ((x[1] - y[1]) ** 2) +
            ((x[2] - y[2]) ** 2)
          );
        }

        convert.rgb.keyword = function (rgb) {
          const reversed = reverseKeywords[rgb];
          if (reversed) {
            return reversed;
          }

          let currentClosestDistance = Infinity;
          let currentClosestKeyword;

          for (const keyword of Object.keys(cssKeywords)) {
            const value = cssKeywords[keyword];

            // Compute comparative distance
            const distance = comparativeDistance(rgb, value);

            // Check if its less, if so set as closest
            if (distance < currentClosestDistance) {
              currentClosestDistance = distance;
              currentClosestKeyword = keyword;
            }
          }

          return currentClosestKeyword;
        };

        convert.keyword.rgb = function (keyword) {
          return cssKeywords[keyword];
        };

        convert.rgb.xyz = function (rgb) {
          let r = rgb[0] / 255;
          let g = rgb[1] / 255;
          let b = rgb[2] / 255;

          // Assume sRGB
          r = r > 0.04045 ? (((r + 0.055) / 1.055) ** 2.4) : (r / 12.92);
          g = g > 0.04045 ? (((g + 0.055) / 1.055) ** 2.4) : (g / 12.92);
          b = b > 0.04045 ? (((b + 0.055) / 1.055) ** 2.4) : (b / 12.92);

          const x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
          const y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
          const z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

          return [x * 100, y * 100, z * 100];
        };

        convert.rgb.lab = function (rgb) {
          const xyz = convert.rgb.xyz(rgb);
          let x = xyz[0];
          let y = xyz[1];
          let z = xyz[2];

          x /= 95.047;
          y /= 100;
          z /= 108.883;

          x = x > 0.008856 ? (x ** (1 / 3)) : (7.787 * x) + (16 / 116);
          y = y > 0.008856 ? (y ** (1 / 3)) : (7.787 * y) + (16 / 116);
          z = z > 0.008856 ? (z ** (1 / 3)) : (7.787 * z) + (16 / 116);

          const l = (116 * y) - 16;
          const a = 500 * (x - y);
          const b = 200 * (y - z);

          return [l, a, b];
        };

        convert.hsl.rgb = function (hsl) {
          const h = hsl[0] / 360;
          const s = hsl[1] / 100;
          const l = hsl[2] / 100;
          let t2;
          let t3;
          let val;

          if (s === 0) {
            val = l * 255;
            return [val, val, val];
          }

          if (l < 0.5) {
            t2 = l * (1 + s);
          } else {
            t2 = l + s - l * s;
          }

          const t1 = 2 * l - t2;

          const rgb = [0, 0, 0];
          for (let i = 0; i < 3; i++) {
            t3 = h + 1 / 3 * -(i - 1);
            if (t3 < 0) {
              t3++;
            }

            if (t3 > 1) {
              t3--;
            }

            if (6 * t3 < 1) {
              val = t1 + (t2 - t1) * 6 * t3;
            } else if (2 * t3 < 1) {
              val = t2;
            } else if (3 * t3 < 2) {
              val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
            } else {
              val = t1;
            }

            rgb[i] = val * 255;
          }

          return rgb;
        };

        convert.hsl.hsv = function (hsl) {
          const h = hsl[0];
          let s = hsl[1] / 100;
          let l = hsl[2] / 100;
          let smin = s;
          const lmin = Math.max(l, 0.01);

          l *= 2;
          s *= (l <= 1) ? l : 2 - l;
          smin *= lmin <= 1 ? lmin : 2 - lmin;
          const v = (l + s) / 2;
          const sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

          return [h, sv * 100, v * 100];
        };

        convert.hsv.rgb = function (hsv) {
          const h = hsv[0] / 60;
          const s = hsv[1] / 100;
          let v = hsv[2] / 100;
          const hi = Math.floor(h) % 6;

          const f = h - Math.floor(h);
          const p = 255 * v * (1 - s);
          const q = 255 * v * (1 - (s * f));
          const t = 255 * v * (1 - (s * (1 - f)));
          v *= 255;

          switch (hi) {
            case 0:
              return [v, t, p];
            case 1:
              return [q, v, p];
            case 2:
              return [p, v, t];
            case 3:
              return [p, q, v];
            case 4:
              return [t, p, v];
            case 5:
              return [v, p, q];
          }
        };

        convert.hsv.hsl = function (hsv) {
          const h = hsv[0];
          const s = hsv[1] / 100;
          const v = hsv[2] / 100;
          const vmin = Math.max(v, 0.01);
          let sl;
          let l;

          l = (2 - s) * v;
          const lmin = (2 - s) * vmin;
          sl = s * vmin;
          sl /= (lmin <= 1) ? lmin : 2 - lmin;
          sl = sl || 0;
          l /= 2;

          return [h, sl * 100, l * 100];
        };

        // http://dev.w3.org/csswg/css-color/#hwb-to-rgb
        convert.hwb.rgb = function (hwb) {
          const h = hwb[0] / 360;
          let wh = hwb[1] / 100;
          let bl = hwb[2] / 100;
          const ratio = wh + bl;
          let f;

          // Wh + bl cant be > 1
          if (ratio > 1) {
            wh /= ratio;
            bl /= ratio;
          }

          const i = Math.floor(6 * h);
          const v = 1 - bl;
          f = 6 * h - i;

          if ((i & 0x01) !== 0) {
            f = 1 - f;
          }

          const n = wh + f * (v - wh); // Linear interpolation

          let r;
          let g;
          let b;
          /* eslint-disable max-statements-per-line,no-multi-spaces */
          switch (i) {
            default:
            case 6:
            case 0: r = v; g = n; b = wh; break;
            case 1: r = n; g = v; b = wh; break;
            case 2: r = wh; g = v; b = n; break;
            case 3: r = wh; g = n; b = v; break;
            case 4: r = n; g = wh; b = v; break;
            case 5: r = v; g = wh; b = n; break;
          }
          /* eslint-enable max-statements-per-line,no-multi-spaces */

          return [r * 255, g * 255, b * 255];
        };

        convert.cmyk.rgb = function (cmyk) {
          const c = cmyk[0] / 100;
          const m = cmyk[1] / 100;
          const y = cmyk[2] / 100;
          const k = cmyk[3] / 100;

          const r = 1 - Math.min(1, c * (1 - k) + k);
          const g = 1 - Math.min(1, m * (1 - k) + k);
          const b = 1 - Math.min(1, y * (1 - k) + k);

          return [r * 255, g * 255, b * 255];
        };

        convert.xyz.rgb = function (xyz) {
          const x = xyz[0] / 100;
          const y = xyz[1] / 100;
          const z = xyz[2] / 100;
          let r;
          let g;
          let b;

          r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
          g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
          b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

          // Assume sRGB
          r = r > 0.0031308
            ? ((1.055 * (r ** (1.0 / 2.4))) - 0.055)
            : r * 12.92;

          g = g > 0.0031308
            ? ((1.055 * (g ** (1.0 / 2.4))) - 0.055)
            : g * 12.92;

          b = b > 0.0031308
            ? ((1.055 * (b ** (1.0 / 2.4))) - 0.055)
            : b * 12.92;

          r = Math.min(Math.max(0, r), 1);
          g = Math.min(Math.max(0, g), 1);
          b = Math.min(Math.max(0, b), 1);

          return [r * 255, g * 255, b * 255];
        };

        convert.xyz.lab = function (xyz) {
          let x = xyz[0];
          let y = xyz[1];
          let z = xyz[2];

          x /= 95.047;
          y /= 100;
          z /= 108.883;

          x = x > 0.008856 ? (x ** (1 / 3)) : (7.787 * x) + (16 / 116);
          y = y > 0.008856 ? (y ** (1 / 3)) : (7.787 * y) + (16 / 116);
          z = z > 0.008856 ? (z ** (1 / 3)) : (7.787 * z) + (16 / 116);

          const l = (116 * y) - 16;
          const a = 500 * (x - y);
          const b = 200 * (y - z);

          return [l, a, b];
        };

        convert.lab.xyz = function (lab) {
          const l = lab[0];
          const a = lab[1];
          const b = lab[2];
          let x;
          let y;
          let z;

          y = (l + 16) / 116;
          x = a / 500 + y;
          z = y - b / 200;

          const y2 = y ** 3;
          const x2 = x ** 3;
          const z2 = z ** 3;
          y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
          x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
          z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

          x *= 95.047;
          y *= 100;
          z *= 108.883;

          return [x, y, z];
        };

        convert.lab.lch = function (lab) {
          const l = lab[0];
          const a = lab[1];
          const b = lab[2];
          let h;

          const hr = Math.atan2(b, a);
          h = hr * 360 / 2 / Math.PI;

          if (h < 0) {
            h += 360;
          }

          const c = Math.sqrt(a * a + b * b);

          return [l, c, h];
        };

        convert.lch.lab = function (lch) {
          const l = lch[0];
          const c = lch[1];
          const h = lch[2];

          const hr = h / 360 * 2 * Math.PI;
          const a = c * Math.cos(hr);
          const b = c * Math.sin(hr);

          return [l, a, b];
        };

        convert.rgb.ansi16 = function (args, saturation = null) {
          const [r, g, b] = args;
          let value = saturation === null ? convert.rgb.hsv(args)[2] : saturation; // Hsv -> ansi16 optimization

          value = Math.round(value / 50);

          if (value === 0) {
            return 30;
          }

          let ansi = 30
            + ((Math.round(b / 255) << 2)
              | (Math.round(g / 255) << 1)
              | Math.round(r / 255));

          if (value === 2) {
            ansi += 60;
          }

          return ansi;
        };

        convert.hsv.ansi16 = function (args) {
          // Optimization here; we already know the value and don't need to get
          // it converted for us.
          return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
        };

        convert.rgb.ansi256 = function (args) {
          const r = args[0];
          const g = args[1];
          const b = args[2];

          // We use the extended greyscale palette here, with the exception of
          // black and white. normal palette only has 4 greyscale shades.
          if (r === g && g === b) {
            if (r < 8) {
              return 16;
            }

            if (r > 248) {
              return 231;
            }

            return Math.round(((r - 8) / 247) * 24) + 232;
          }

          const ansi = 16
            + (36 * Math.round(r / 255 * 5))
            + (6 * Math.round(g / 255 * 5))
            + Math.round(b / 255 * 5);

          return ansi;
        };

        convert.ansi16.rgb = function (args) {
          let color = args % 10;

          // Handle greyscale
          if (color === 0 || color === 7) {
            if (args > 50) {
              color += 3.5;
            }

            color = color / 10.5 * 255;

            return [color, color, color];
          }

          const mult = (~~(args > 50) + 1) * 0.5;
          const r = ((color & 1) * mult) * 255;
          const g = (((color >> 1) & 1) * mult) * 255;
          const b = (((color >> 2) & 1) * mult) * 255;

          return [r, g, b];
        };

        convert.ansi256.rgb = function (args) {
          // Handle greyscale
          if (args >= 232) {
            const c = (args - 232) * 10 + 8;
            return [c, c, c];
          }

          args -= 16;

          let rem;
          const r = Math.floor(args / 36) / 5 * 255;
          const g = Math.floor((rem = args % 36) / 6) / 5 * 255;
          const b = (rem % 6) / 5 * 255;

          return [r, g, b];
        };

        convert.rgb.hex = function (args) {
          const integer = ((Math.round(args[0]) & 0xFF) << 16)
            + ((Math.round(args[1]) & 0xFF) << 8)
            + (Math.round(args[2]) & 0xFF);

          const string = integer.toString(16).toUpperCase();
          return '000000'.substring(string.length) + string;
        };

        convert.hex.rgb = function (args) {
          const match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
          if (!match) {
            return [0, 0, 0];
          }

          let colorString = match[0];

          if (match[0].length === 3) {
            colorString = colorString.split('').map(char => {
              return char + char;
            }).join('');
          }

          const integer = parseInt(colorString, 16);
          const r = (integer >> 16) & 0xFF;
          const g = (integer >> 8) & 0xFF;
          const b = integer & 0xFF;

          return [r, g, b];
        };

        convert.rgb.hcg = function (rgb) {
          const r = rgb[0] / 255;
          const g = rgb[1] / 255;
          const b = rgb[2] / 255;
          const max = Math.max(Math.max(r, g), b);
          const min = Math.min(Math.min(r, g), b);
          const chroma = (max - min);
          let grayscale;
          let hue;

          if (chroma < 1) {
            grayscale = min / (1 - chroma);
          } else {
            grayscale = 0;
          }

          if (chroma <= 0) {
            hue = 0;
          } else
            if (max === r) {
              hue = ((g - b) / chroma) % 6;
            } else
              if (max === g) {
                hue = 2 + (b - r) / chroma;
              } else {
                hue = 4 + (r - g) / chroma;
              }

          hue /= 6;
          hue %= 1;

          return [hue * 360, chroma * 100, grayscale * 100];
        };

        convert.hsl.hcg = function (hsl) {
          const s = hsl[1] / 100;
          const l = hsl[2] / 100;

          const c = l < 0.5 ? (2.0 * s * l) : (2.0 * s * (1.0 - l));

          let f = 0;
          if (c < 1.0) {
            f = (l - 0.5 * c) / (1.0 - c);
          }

          return [hsl[0], c * 100, f * 100];
        };

        convert.hsv.hcg = function (hsv) {
          const s = hsv[1] / 100;
          const v = hsv[2] / 100;

          const c = s * v;
          let f = 0;

          if (c < 1.0) {
            f = (v - c) / (1 - c);
          }

          return [hsv[0], c * 100, f * 100];
        };

        convert.hcg.rgb = function (hcg) {
          const h = hcg[0] / 360;
          const c = hcg[1] / 100;
          const g = hcg[2] / 100;

          if (c === 0.0) {
            return [g * 255, g * 255, g * 255];
          }

          const pure = [0, 0, 0];
          const hi = (h % 1) * 6;
          const v = hi % 1;
          const w = 1 - v;
          let mg = 0;

          /* eslint-disable max-statements-per-line */
          switch (Math.floor(hi)) {
            case 0:
              pure[0] = 1; pure[1] = v; pure[2] = 0; break;
            case 1:
              pure[0] = w; pure[1] = 1; pure[2] = 0; break;
            case 2:
              pure[0] = 0; pure[1] = 1; pure[2] = v; break;
            case 3:
              pure[0] = 0; pure[1] = w; pure[2] = 1; break;
            case 4:
              pure[0] = v; pure[1] = 0; pure[2] = 1; break;
            default:
              pure[0] = 1; pure[1] = 0; pure[2] = w;
          }
          /* eslint-enable max-statements-per-line */

          mg = (1.0 - c) * g;

          return [
            (c * pure[0] + mg) * 255,
            (c * pure[1] + mg) * 255,
            (c * pure[2] + mg) * 255
          ];
        };

        convert.hcg.hsv = function (hcg) {
          const c = hcg[1] / 100;
          const g = hcg[2] / 100;

          const v = c + g * (1.0 - c);
          let f = 0;

          if (v > 0.0) {
            f = c / v;
          }

          return [hcg[0], f * 100, v * 100];
        };

        convert.hcg.hsl = function (hcg) {
          const c = hcg[1] / 100;
          const g = hcg[2] / 100;

          const l = g * (1.0 - c) + 0.5 * c;
          let s = 0;

          if (l > 0.0 && l < 0.5) {
            s = c / (2 * l);
          } else
            if (l >= 0.5 && l < 1.0) {
              s = c / (2 * (1 - l));
            }

          return [hcg[0], s * 100, l * 100];
        };

        convert.hcg.hwb = function (hcg) {
          const c = hcg[1] / 100;
          const g = hcg[2] / 100;
          const v = c + g * (1.0 - c);
          return [hcg[0], (v - c) * 100, (1 - v) * 100];
        };

        convert.hwb.hcg = function (hwb) {
          const w = hwb[1] / 100;
          const b = hwb[2] / 100;
          const v = 1 - b;
          const c = v - w;
          let g = 0;

          if (c < 1) {
            g = (v - c) / (1 - c);
          }

          return [hwb[0], c * 100, g * 100];
        };

        convert.apple.rgb = function (apple) {
          return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
        };

        convert.rgb.apple = function (rgb) {
          return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
        };

        convert.gray.rgb = function (args) {
          return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
        };

        convert.gray.hsl = function (args) {
          return [0, 0, args[0]];
        };

        convert.gray.hsv = convert.gray.hsl;

        convert.gray.hwb = function (gray) {
          return [0, 100, gray[0]];
        };

        convert.gray.cmyk = function (gray) {
          return [0, 0, 0, gray[0]];
        };

        convert.gray.lab = function (gray) {
          return [gray[0], 0, 0];
        };

        convert.gray.hex = function (gray) {
          const val = Math.round(gray[0] / 100 * 255) & 0xFF;
          const integer = (val << 16) + (val << 8) + val;

          const string = integer.toString(16).toUpperCase();
          return '000000'.substring(string.length) + string;
        };

        convert.rgb.gray = function (rgb) {
          const val = (rgb[0] + rgb[1] + rgb[2]) / 3;
          return [val / 255 * 100];
        };


        /***/
}),

/***/ "./node_modules/color/node_modules/color-convert/index.js":
/*!****************************************************************!*\
  !*** ./node_modules/color/node_modules/color-convert/index.js ***!
  \****************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

        const conversions = __webpack_require__(/*! ./conversions */ "./node_modules/color/node_modules/color-convert/conversions.js");
        const route = __webpack_require__(/*! ./route */ "./node_modules/color/node_modules/color-convert/route.js");

        const convert = {};

        const models = Object.keys(conversions);

        function wrapRaw(fn) {
          const wrappedFn = function (...args) {
            const arg0 = args[0];
            if (arg0 === undefined || arg0 === null) {
              return arg0;
            }

            if (arg0.length > 1) {
              args = arg0;
            }

            return fn(args);
          };

          // Preserve .conversion property if there is one
          if ('conversion' in fn) {
            wrappedFn.conversion = fn.conversion;
          }

          return wrappedFn;
        }

        function wrapRounded(fn) {
          const wrappedFn = function (...args) {
            const arg0 = args[0];

            if (arg0 === undefined || arg0 === null) {
              return arg0;
            }

            if (arg0.length > 1) {
              args = arg0;
            }

            const result = fn(args);

            // We're assuming the result is an array here.
            // see notice in conversions.js; don't use box types
            // in conversion functions.
            if (typeof result === 'object') {
              for (let len = result.length, i = 0; i < len; i++) {
                result[i] = Math.round(result[i]);
              }
            }

            return result;
          };

          // Preserve .conversion property if there is one
          if ('conversion' in fn) {
            wrappedFn.conversion = fn.conversion;
          }

          return wrappedFn;
        }

        models.forEach(fromModel => {
          convert[fromModel] = {};

          Object.defineProperty(convert[fromModel], 'channels', { value: conversions[fromModel].channels });
          Object.defineProperty(convert[fromModel], 'labels', { value: conversions[fromModel].labels });

          const routes = route(fromModel);
          const routeModels = Object.keys(routes);

          routeModels.forEach(toModel => {
            const fn = routes[toModel];

            convert[fromModel][toModel] = wrapRounded(fn);
            convert[fromModel][toModel].raw = wrapRaw(fn);
          });
        });

        module.exports = convert;


        /***/
}),

/***/ "./node_modules/color/node_modules/color-convert/route.js":
/*!****************************************************************!*\
  !*** ./node_modules/color/node_modules/color-convert/route.js ***!
  \****************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

        const conversions = __webpack_require__(/*! ./conversions */ "./node_modules/color/node_modules/color-convert/conversions.js");

        /*
          This function routes a model to all other models.
        
          all functions that are routed have a property `.conversion` attached
          to the returned synthetic function. This property is an array
          of strings, each with the steps in between the 'from' and 'to'
          color models (inclusive).
        
          conversions that are not possible simply are not included.
        */

        function buildGraph() {
          const graph = {};
          // https://jsperf.com/object-keys-vs-for-in-with-closure/3
          const models = Object.keys(conversions);

          for (let len = models.length, i = 0; i < len; i++) {
            graph[models[i]] = {
              // http://jsperf.com/1-vs-infinity
              // micro-opt, but this is simple.
              distance: -1,
              parent: null
            };
          }

          return graph;
        }

        // https://en.wikipedia.org/wiki/Breadth-first_search
        function deriveBFS(fromModel) {
          const graph = buildGraph();
          const queue = [fromModel]; // Unshift -> queue -> pop

          graph[fromModel].distance = 0;

          while (queue.length) {
            const current = queue.pop();
            const adjacents = Object.keys(conversions[current]);

            for (let len = adjacents.length, i = 0; i < len; i++) {
              const adjacent = adjacents[i];
              const node = graph[adjacent];

              if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
              }
            }
          }

          return graph;
        }

        function link(from, to) {
          return function (args) {
            return to(from(args));
          };
        }

        function wrapConversion(toModel, graph) {
          const path = [graph[toModel].parent, toModel];
          let fn = conversions[graph[toModel].parent][toModel];

          let cur = graph[toModel].parent;
          while (graph[cur].parent) {
            path.unshift(graph[cur].parent);
            fn = link(conversions[graph[cur].parent][cur], fn);
            cur = graph[cur].parent;
          }

          fn.conversion = path;
          return fn;
        }

        module.exports = function (fromModel) {
          const graph = deriveBFS(fromModel);
          const conversion = {};

          const models = Object.keys(graph);
          for (let len = models.length, i = 0; i < len; i++) {
            const toModel = models[i];
            const node = graph[toModel];

            if (node.parent === null) {
              // No possible conversion, or this node is the source model.
              continue;
            }

            conversion[toModel] = wrapConversion(toModel, graph);
          }

          return conversion;
        };



        /***/
}),

/***/ "./node_modules/color/node_modules/color-name/index.js":
/*!*************************************************************!*\
  !*** ./node_modules/color/node_modules/color-name/index.js ***!
  \*************************************************************/
/***/ ((module) => {

        "use strict";


        module.exports = {
          "aliceblue": [240, 248, 255],
          "antiquewhite": [250, 235, 215],
          "aqua": [0, 255, 255],
          "aquamarine": [127, 255, 212],
          "azure": [240, 255, 255],
          "beige": [245, 245, 220],
          "bisque": [255, 228, 196],
          "black": [0, 0, 0],
          "blanchedalmond": [255, 235, 205],
          "blue": [0, 0, 255],
          "blueviolet": [138, 43, 226],
          "brown": [165, 42, 42],
          "burlywood": [222, 184, 135],
          "cadetblue": [95, 158, 160],
          "chartreuse": [127, 255, 0],
          "chocolate": [210, 105, 30],
          "coral": [255, 127, 80],
          "cornflowerblue": [100, 149, 237],
          "cornsilk": [255, 248, 220],
          "crimson": [220, 20, 60],
          "cyan": [0, 255, 255],
          "darkblue": [0, 0, 139],
          "darkcyan": [0, 139, 139],
          "darkgoldenrod": [184, 134, 11],
          "darkgray": [169, 169, 169],
          "darkgreen": [0, 100, 0],
          "darkgrey": [169, 169, 169],
          "darkkhaki": [189, 183, 107],
          "darkmagenta": [139, 0, 139],
          "darkolivegreen": [85, 107, 47],
          "darkorange": [255, 140, 0],
          "darkorchid": [153, 50, 204],
          "darkred": [139, 0, 0],
          "darksalmon": [233, 150, 122],
          "darkseagreen": [143, 188, 143],
          "darkslateblue": [72, 61, 139],
          "darkslategray": [47, 79, 79],
          "darkslategrey": [47, 79, 79],
          "darkturquoise": [0, 206, 209],
          "darkviolet": [148, 0, 211],
          "deeppink": [255, 20, 147],
          "deepskyblue": [0, 191, 255],
          "dimgray": [105, 105, 105],
          "dimgrey": [105, 105, 105],
          "dodgerblue": [30, 144, 255],
          "firebrick": [178, 34, 34],
          "floralwhite": [255, 250, 240],
          "forestgreen": [34, 139, 34],
          "fuchsia": [255, 0, 255],
          "gainsboro": [220, 220, 220],
          "ghostwhite": [248, 248, 255],
          "gold": [255, 215, 0],
          "goldenrod": [218, 165, 32],
          "gray": [128, 128, 128],
          "green": [0, 128, 0],
          "greenyellow": [173, 255, 47],
          "grey": [128, 128, 128],
          "honeydew": [240, 255, 240],
          "hotpink": [255, 105, 180],
          "indianred": [205, 92, 92],
          "indigo": [75, 0, 130],
          "ivory": [255, 255, 240],
          "khaki": [240, 230, 140],
          "lavender": [230, 230, 250],
          "lavenderblush": [255, 240, 245],
          "lawngreen": [124, 252, 0],
          "lemonchiffon": [255, 250, 205],
          "lightblue": [173, 216, 230],
          "lightcoral": [240, 128, 128],
          "lightcyan": [224, 255, 255],
          "lightgoldenrodyellow": [250, 250, 210],
          "lightgray": [211, 211, 211],
          "lightgreen": [144, 238, 144],
          "lightgrey": [211, 211, 211],
          "lightpink": [255, 182, 193],
          "lightsalmon": [255, 160, 122],
          "lightseagreen": [32, 178, 170],
          "lightskyblue": [135, 206, 250],
          "lightslategray": [119, 136, 153],
          "lightslategrey": [119, 136, 153],
          "lightsteelblue": [176, 196, 222],
          "lightyellow": [255, 255, 224],
          "lime": [0, 255, 0],
          "limegreen": [50, 205, 50],
          "linen": [250, 240, 230],
          "magenta": [255, 0, 255],
          "maroon": [128, 0, 0],
          "mediumaquamarine": [102, 205, 170],
          "mediumblue": [0, 0, 205],
          "mediumorchid": [186, 85, 211],
          "mediumpurple": [147, 112, 219],
          "mediumseagreen": [60, 179, 113],
          "mediumslateblue": [123, 104, 238],
          "mediumspringgreen": [0, 250, 154],
          "mediumturquoise": [72, 209, 204],
          "mediumvioletred": [199, 21, 133],
          "midnightblue": [25, 25, 112],
          "mintcream": [245, 255, 250],
          "mistyrose": [255, 228, 225],
          "moccasin": [255, 228, 181],
          "navajowhite": [255, 222, 173],
          "navy": [0, 0, 128],
          "oldlace": [253, 245, 230],
          "olive": [128, 128, 0],
          "olivedrab": [107, 142, 35],
          "orange": [255, 165, 0],
          "orangered": [255, 69, 0],
          "orchid": [218, 112, 214],
          "palegoldenrod": [238, 232, 170],
          "palegreen": [152, 251, 152],
          "paleturquoise": [175, 238, 238],
          "palevioletred": [219, 112, 147],
          "papayawhip": [255, 239, 213],
          "peachpuff": [255, 218, 185],
          "peru": [205, 133, 63],
          "pink": [255, 192, 203],
          "plum": [221, 160, 221],
          "powderblue": [176, 224, 230],
          "purple": [128, 0, 128],
          "rebeccapurple": [102, 51, 153],
          "red": [255, 0, 0],
          "rosybrown": [188, 143, 143],
          "royalblue": [65, 105, 225],
          "saddlebrown": [139, 69, 19],
          "salmon": [250, 128, 114],
          "sandybrown": [244, 164, 96],
          "seagreen": [46, 139, 87],
          "seashell": [255, 245, 238],
          "sienna": [160, 82, 45],
          "silver": [192, 192, 192],
          "skyblue": [135, 206, 235],
          "slateblue": [106, 90, 205],
          "slategray": [112, 128, 144],
          "slategrey": [112, 128, 144],
          "snow": [255, 250, 250],
          "springgreen": [0, 255, 127],
          "steelblue": [70, 130, 180],
          "tan": [210, 180, 140],
          "teal": [0, 128, 128],
          "thistle": [216, 191, 216],
          "tomato": [255, 99, 71],
          "turquoise": [64, 224, 208],
          "violet": [238, 130, 238],
          "wheat": [245, 222, 179],
          "white": [255, 255, 255],
          "whitesmoke": [245, 245, 245],
          "yellow": [255, 255, 0],
          "yellowgreen": [154, 205, 50]
        };


        /***/
}),

/***/ "./node_modules/jquery/dist/jquery.js":
/*!********************************************!*\
  !*** ./node_modules/jquery/dist/jquery.js ***!
  \********************************************/
/***/ (function (module, exports) {

        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.6.0
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-03-02T17:08Z
 */
        (function (global, factory) {

          "use strict";

          if (true && typeof module.exports === "object") {

            // For CommonJS and CommonJS-like environments where a proper `window`
            // is present, execute the factory and get jQuery.
            // For environments that do not have a `window` with a `document`
            // (such as Node.js), expose a factory as module.exports.
            // This accentuates the need for the creation of a real `window`.
            // e.g. var jQuery = require("jquery")(window);
            // See ticket #14549 for more info.
            module.exports = global.document ?
              factory(global, true) :
              function (w) {
                if (!w.document) {
                  throw new Error("jQuery requires a window with a document");
                }
                return factory(w);
              };
          } else {
            factory(global);
          }

          // Pass this if window is not defined yet
        })(typeof window !== "undefined" ? window : this, function (window, noGlobal) {

          // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
          // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
          // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
          // enough that all such attempts are guarded in a try block.
          "use strict";

          var arr = [];

          var getProto = Object.getPrototypeOf;

          var slice = arr.slice;

          var flat = arr.flat ? function (array) {
            return arr.flat.call(array);
          } : function (array) {
            return arr.concat.apply([], array);
          };


          var push = arr.push;

          var indexOf = arr.indexOf;

          var class2type = {};

          var toString = class2type.toString;

          var hasOwn = class2type.hasOwnProperty;

          var fnToString = hasOwn.toString;

          var ObjectFunctionString = fnToString.call(Object);

          var support = {};

          var isFunction = function isFunction(obj) {

            // Support: Chrome <=57, Firefox <=52
            // In some browsers, typeof returns "function" for HTML <object> elements
            // (i.e., `typeof document.createElement( "object" ) === "function"`).
            // We don't want to classify *any* DOM node as a function.
            // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
            // Plus for old WebKit, typeof returns "function" for HTML collections
            // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
            return typeof obj === "function" && typeof obj.nodeType !== "number" &&
              typeof obj.item !== "function";
          };


          var isWindow = function isWindow(obj) {
            return obj != null && obj === obj.window;
          };


          var document = window.document;



          var preservedScriptAttributes = {
            type: true,
            src: true,
            nonce: true,
            noModule: true
          };

          function DOMEval(code, node, doc) {
            doc = doc || document;

            var i, val,
              script = doc.createElement("script");

            script.text = code;
            if (node) {
              for (i in preservedScriptAttributes) {

                // Support: Firefox 64+, Edge 18+
                // Some browsers don't support the "nonce" property on scripts.
                // On the other hand, just using `getAttribute` is not enough as
                // the `nonce` attribute is reset to an empty string whenever it
                // becomes browsing-context connected.
                // See https://github.com/whatwg/html/issues/2369
                // See https://html.spec.whatwg.org/#nonce-attributes
                // The `node.getAttribute` check was added for the sake of
                // `jQuery.globalEval` so that it can fake a nonce-containing node
                // via an object.
                val = node[i] || node.getAttribute && node.getAttribute(i);
                if (val) {
                  script.setAttribute(i, val);
                }
              }
            }
            doc.head.appendChild(script).parentNode.removeChild(script);
          }


          function toType(obj) {
            if (obj == null) {
              return obj + "";
            }

            // Support: Android <=2.3 only (functionish RegExp)
            return typeof obj === "object" || typeof obj === "function" ?
              class2type[toString.call(obj)] || "object" :
              typeof obj;
          }
          /* global Symbol */
          // Defining this global in .eslintrc.json would create a danger of using the global
          // unguarded in another place, it seems safer to define global only for this module



          var
            version = "3.6.0",

            // Define a local copy of jQuery
            jQuery = function (selector, context) {

              // The jQuery object is actually just the init constructor 'enhanced'
              // Need init if jQuery is called (just allow error to be thrown if not included)
              return new jQuery.fn.init(selector, context);
            };

          jQuery.fn = jQuery.prototype = {

            // The current version of jQuery being used
            jquery: version,

            constructor: jQuery,

            // The default length of a jQuery object is 0
            length: 0,

            toArray: function () {
              return slice.call(this);
            },

            // Get the Nth element in the matched element set OR
            // Get the whole matched element set as a clean array
            get: function (num) {

              // Return all the elements in a clean array
              if (num == null) {
                return slice.call(this);
              }

              // Return just the one element from the set
              return num < 0 ? this[num + this.length] : this[num];
            },

            // Take an array of elements and push it onto the stack
            // (returning the new matched element set)
            pushStack: function (elems) {

              // Build a new jQuery matched element set
              var ret = jQuery.merge(this.constructor(), elems);

              // Add the old object onto the stack (as a reference)
              ret.prevObject = this;

              // Return the newly-formed element set
              return ret;
            },

            // Execute a callback for every element in the matched set.
            each: function (callback) {
              return jQuery.each(this, callback);
            },

            map: function (callback) {
              return this.pushStack(jQuery.map(this, function (elem, i) {
                return callback.call(elem, i, elem);
              }));
            },

            slice: function () {
              return this.pushStack(slice.apply(this, arguments));
            },

            first: function () {
              return this.eq(0);
            },

            last: function () {
              return this.eq(-1);
            },

            even: function () {
              return this.pushStack(jQuery.grep(this, function (_elem, i) {
                return (i + 1) % 2;
              }));
            },

            odd: function () {
              return this.pushStack(jQuery.grep(this, function (_elem, i) {
                return i % 2;
              }));
            },

            eq: function (i) {
              var len = this.length,
                j = +i + (i < 0 ? len : 0);
              return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
            },

            end: function () {
              return this.prevObject || this.constructor();
            },

            // For internal use only.
            // Behaves like an Array's method, not like a jQuery method.
            push: push,
            sort: arr.sort,
            splice: arr.splice
          };

          jQuery.extend = jQuery.fn.extend = function () {
            var options, name, src, copy, copyIsArray, clone,
              target = arguments[0] || {},
              i = 1,
              length = arguments.length,
              deep = false;

            // Handle a deep copy situation
            if (typeof target === "boolean") {
              deep = target;

              // Skip the boolean and the target
              target = arguments[i] || {};
              i++;
            }

            // Handle case when target is a string or something (possible in deep copy)
            if (typeof target !== "object" && !isFunction(target)) {
              target = {};
            }

            // Extend jQuery itself if only one argument is passed
            if (i === length) {
              target = this;
              i--;
            }

            for (; i < length; i++) {

              // Only deal with non-null/undefined values
              if ((options = arguments[i]) != null) {

                // Extend the base object
                for (name in options) {
                  copy = options[name];

                  // Prevent Object.prototype pollution
                  // Prevent never-ending loop
                  if (name === "__proto__" || target === copy) {
                    continue;
                  }

                  // Recurse if we're merging plain objects or arrays
                  if (deep && copy && (jQuery.isPlainObject(copy) ||
                    (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];

                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) {
                      clone = [];
                    } else if (!copyIsArray && !jQuery.isPlainObject(src)) {
                      clone = {};
                    } else {
                      clone = src;
                    }
                    copyIsArray = false;

                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);

                    // Don't bring in undefined values
                  } else if (copy !== undefined) {
                    target[name] = copy;
                  }
                }
              }
            }

            // Return the modified object
            return target;
          };

          jQuery.extend({

            // Unique for each copy of jQuery on the page
            expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),

            // Assume jQuery is ready without the ready module
            isReady: true,

            error: function (msg) {
              throw new Error(msg);
            },

            noop: function () { },

            isPlainObject: function (obj) {
              var proto, Ctor;

              // Detect obvious negatives
              // Use toString instead of jQuery.type to catch host objects
              if (!obj || toString.call(obj) !== "[object Object]") {
                return false;
              }

              proto = getProto(obj);

              // Objects with no prototype (e.g., `Object.create( null )`) are plain
              if (!proto) {
                return true;
              }

              // Objects with prototype are plain iff they were constructed by a global Object function
              Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
              return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
            },

            isEmptyObject: function (obj) {
              var name;

              for (name in obj) {
                return false;
              }
              return true;
            },

            // Evaluates a script in a provided context; falls back to the global one
            // if not specified.
            globalEval: function (code, options, doc) {
              DOMEval(code, { nonce: options && options.nonce }, doc);
            },

            each: function (obj, callback) {
              var length, i = 0;

              if (isArrayLike(obj)) {
                length = obj.length;
                for (; i < length; i++) {
                  if (callback.call(obj[i], i, obj[i]) === false) {
                    break;
                  }
                }
              } else {
                for (i in obj) {
                  if (callback.call(obj[i], i, obj[i]) === false) {
                    break;
                  }
                }
              }

              return obj;
            },

            // results is for internal usage only
            makeArray: function (arr, results) {
              var ret = results || [];

              if (arr != null) {
                if (isArrayLike(Object(arr))) {
                  jQuery.merge(ret,
                    typeof arr === "string" ?
                      [arr] : arr
                  );
                } else {
                  push.call(ret, arr);
                }
              }

              return ret;
            },

            inArray: function (elem, arr, i) {
              return arr == null ? -1 : indexOf.call(arr, elem, i);
            },

            // Support: Android <=4.0 only, PhantomJS 1 only
            // push.apply(_, arraylike) throws on ancient WebKit
            merge: function (first, second) {
              var len = +second.length,
                j = 0,
                i = first.length;

              for (; j < len; j++) {
                first[i++] = second[j];
              }

              first.length = i;

              return first;
            },

            grep: function (elems, callback, invert) {
              var callbackInverse,
                matches = [],
                i = 0,
                length = elems.length,
                callbackExpect = !invert;

              // Go through the array, only saving the items
              // that pass the validator function
              for (; i < length; i++) {
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) {
                  matches.push(elems[i]);
                }
              }

              return matches;
            },

            // arg is for internal usage only
            map: function (elems, callback, arg) {
              var length, value,
                i = 0,
                ret = [];

              // Go through the array, translating each of the items to their new values
              if (isArrayLike(elems)) {
                length = elems.length;
                for (; i < length; i++) {
                  value = callback(elems[i], i, arg);

                  if (value != null) {
                    ret.push(value);
                  }
                }

                // Go through every key on the object,
              } else {
                for (i in elems) {
                  value = callback(elems[i], i, arg);

                  if (value != null) {
                    ret.push(value);
                  }
                }
              }

              // Flatten any nested arrays
              return flat(ret);
            },

            // A global GUID counter for objects
            guid: 1,

            // jQuery.support is not used in Core but other projects attach their
            // properties to it so it needs to exist.
            support: support
          });

          if (typeof Symbol === "function") {
            jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
          }

          // Populate the class2type map
          jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),
            function (_i, name) {
              class2type["[object " + name + "]"] = name.toLowerCase();
            });

          function isArrayLike(obj) {

            // Support: real iOS 8.2 only (not reproducible in simulator)
            // `in` check used to prevent JIT error (gh-2145)
            // hasOwn isn't used here due to false negatives
            // regarding Nodelist length in IE
            var length = !!obj && "length" in obj && obj.length,
              type = toType(obj);

            if (isFunction(obj) || isWindow(obj)) {
              return false;
            }

            return type === "array" || length === 0 ||
              typeof length === "number" && length > 0 && (length - 1) in obj;
          }
          var Sizzle =
            /*!
             * Sizzle CSS Selector Engine v2.3.6
             * https://sizzlejs.com/
             *
             * Copyright JS Foundation and other contributors
             * Released under the MIT license
             * https://js.foundation/
             *
             * Date: 2021-02-16
             */
            (function (window) {
              var i,
                support,
                Expr,
                getText,
                isXML,
                tokenize,
                compile,
                select,
                outermostContext,
                sortInput,
                hasDuplicate,

                // Local document vars
                setDocument,
                document,
                docElem,
                documentIsHTML,
                rbuggyQSA,
                rbuggyMatches,
                matches,
                contains,

                // Instance-specific data
                expando = "sizzle" + 1 * new Date(),
                preferredDoc = window.document,
                dirruns = 0,
                done = 0,
                classCache = createCache(),
                tokenCache = createCache(),
                compilerCache = createCache(),
                nonnativeSelectorCache = createCache(),
                sortOrder = function (a, b) {
                  if (a === b) {
                    hasDuplicate = true;
                  }
                  return 0;
                },

                // Instance methods
                hasOwn = ({}).hasOwnProperty,
                arr = [],
                pop = arr.pop,
                pushNative = arr.push,
                push = arr.push,
                slice = arr.slice,

                // Use a stripped-down indexOf as it's faster than native
                // https://jsperf.com/thor-indexof-vs-for/5
                indexOf = function (list, elem) {
                  var i = 0,
                    len = list.length;
                  for (; i < len; i++) {
                    if (list[i] === elem) {
                      return i;
                    }
                  }
                  return -1;
                },

                booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
                  "ismap|loop|multiple|open|readonly|required|scoped",

                // Regular expressions

                // http://www.w3.org/TR/css3-selectors/#whitespace
                whitespace = "[\\x20\\t\\r\\n\\f]",

                // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
                identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
                  "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

                // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
                attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

                  // Operator (capture 2)
                  "*([*^$|!~]?=)" + whitespace +

                  // "Attribute values must be CSS identifiers [capture 5]
                  // or strings [capture 3 or capture 4]"
                  "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
                  whitespace + "*\\]",

                pseudos = ":(" + identifier + ")(?:\\((" +

                  // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
                  // 1. quoted (capture 3; capture 4 or capture 5)
                  "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

                  // 2. simple (capture 6)
                  "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

                  // 3. anything else (capture 2)
                  ".*" +
                  ")\\)|)",

                // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
                rwhitespace = new RegExp(whitespace + "+", "g"),
                rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
                  whitespace + "+$", "g"),

                rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
                rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
                  "*"),
                rdescend = new RegExp(whitespace + "|>"),

                rpseudo = new RegExp(pseudos),
                ridentifier = new RegExp("^" + identifier + "$"),

                matchExpr = {
                  "ID": new RegExp("^#(" + identifier + ")"),
                  "CLASS": new RegExp("^\\.(" + identifier + ")"),
                  "TAG": new RegExp("^(" + identifier + "|[*])"),
                  "ATTR": new RegExp("^" + attributes),
                  "PSEUDO": new RegExp("^" + pseudos),
                  "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
                    whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
                    whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
                  "bool": new RegExp("^(?:" + booleans + ")$", "i"),

                  // For use in libraries implementing .is()
                  // We use this for POS matching in `select`
                  "needsContext": new RegExp("^" + whitespace +
                    "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
                    "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
                },

                rhtml = /HTML$/i,
                rinputs = /^(?:input|select|textarea|button)$/i,
                rheader = /^h\d$/i,

                rnative = /^[^{]+\{\s*\[native \w/,

                // Easily-parseable/retrievable ID or TAG or CLASS selectors
                rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

                rsibling = /[+~]/,

                // CSS escapes
                // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
                runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"),
                funescape = function (escape, nonHex) {
                  var high = "0x" + escape.slice(1) - 0x10000;

                  return nonHex ?

                    // Strip the backslash prefix from a non-hex escape sequence
                    nonHex :

                    // Replace a hexadecimal escape sequence with the encoded Unicode code point
                    // Support: IE <=11+
                    // For values outside the Basic Multilingual Plane (BMP), manually construct a
                    // surrogate pair
                    high < 0 ?
                      String.fromCharCode(high + 0x10000) :
                      String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
                },

                // CSS string/identifier serialization
                // https://drafts.csswg.org/cssom/#common-serializing-idioms
                rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                fcssescape = function (ch, asCodePoint) {
                  if (asCodePoint) {

                    // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                    if (ch === "\0") {
                      return "\uFFFD";
                    }

                    // Control characters and (dependent upon position) numbers get escaped as code points
                    return ch.slice(0, -1) + "\\" +
                      ch.charCodeAt(ch.length - 1).toString(16) + " ";
                  }

                  // Other potentially-special ASCII characters get backslash-escaped
                  return "\\" + ch;
                },

                // Used for iframes
                // See setDocument()
                // Removing the function wrapper causes a "Permission Denied"
                // error in IE
                unloadHandler = function () {
                  setDocument();
                },

                inDisabledFieldset = addCombinator(
                  function (elem) {
                    return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
                  },
                  { dir: "parentNode", next: "legend" }
                );

              // Optimize for push.apply( _, NodeList )
              try {
                push.apply(
                  (arr = slice.call(preferredDoc.childNodes)),
                  preferredDoc.childNodes
                );

                // Support: Android<4.0
                // Detect silently failing push.apply
                // eslint-disable-next-line no-unused-expressions
                arr[preferredDoc.childNodes.length].nodeType;
              } catch (e) {
                push = {
                  apply: arr.length ?

                    // Leverage slice if possible
                    function (target, els) {
                      pushNative.apply(target, slice.call(els));
                    } :

                    // Support: IE<9
                    // Otherwise append directly
                    function (target, els) {
                      var j = target.length,
                        i = 0;

                      // Can't trust NodeList.length
                      while ((target[j++] = els[i++])) { }
                      target.length = j - 1;
                    }
                };
              }

              function Sizzle(selector, context, results, seed) {
                var m, i, elem, nid, match, groups, newSelector,
                  newContext = context && context.ownerDocument,

                  // nodeType defaults to 9, since context defaults to document
                  nodeType = context ? context.nodeType : 9;

                results = results || [];

                // Return early from calls with invalid selector or context
                if (typeof selector !== "string" || !selector ||
                  nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {

                  return results;
                }

                // Try to shortcut find operations (as opposed to filters) in HTML documents
                if (!seed) {
                  setDocument(context);
                  context = context || document;

                  if (documentIsHTML) {

                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {

                      // ID selector
                      if ((m = match[1])) {

                        // Document context
                        if (nodeType === 9) {
                          if ((elem = context.getElementById(m))) {

                            // Support: IE, Opera, Webkit
                            // TODO: identify versions
                            // getElementById can match elements by name instead of ID
                            if (elem.id === m) {
                              results.push(elem);
                              return results;
                            }
                          } else {
                            return results;
                          }

                          // Element context
                        } else {

                          // Support: IE, Opera, Webkit
                          // TODO: identify versions
                          // getElementById can match elements by name instead of ID
                          if (newContext && (elem = newContext.getElementById(m)) &&
                            contains(context, elem) &&
                            elem.id === m) {

                            results.push(elem);
                            return results;
                          }
                        }

                        // Type selector
                      } else if (match[2]) {
                        push.apply(results, context.getElementsByTagName(selector));
                        return results;

                        // Class selector
                      } else if ((m = match[3]) && support.getElementsByClassName &&
                        context.getElementsByClassName) {

                        push.apply(results, context.getElementsByClassName(m));
                        return results;
                      }
                    }

                    // Take advantage of querySelectorAll
                    if (support.qsa &&
                      !nonnativeSelectorCache[selector + " "] &&
                      (!rbuggyQSA || !rbuggyQSA.test(selector)) &&

                      // Support: IE 8 only
                      // Exclude object elements
                      (nodeType !== 1 || context.nodeName.toLowerCase() !== "object")) {

                      newSelector = selector;
                      newContext = context;

                      // qSA considers elements outside a scoping root when evaluating child or
                      // descendant combinators, which is not what we want.
                      // In such cases, we work around the behavior by prefixing every selector in the
                      // list with an ID selector referencing the scope context.
                      // The technique has to be used as well when a leading combinator is used
                      // as such selectors are not recognized by querySelectorAll.
                      // Thanks to Andrew Dupont for this technique.
                      if (nodeType === 1 &&
                        (rdescend.test(selector) || rcombinators.test(selector))) {

                        // Expand context for sibling selectors
                        newContext = rsibling.test(selector) && testContext(context.parentNode) ||
                          context;

                        // We can use :scope instead of the ID hack if the browser
                        // supports it & if we're not changing the context.
                        if (newContext !== context || !support.scope) {

                          // Capture the context ID, setting it first if necessary
                          if ((nid = context.getAttribute("id"))) {
                            nid = nid.replace(rcssescape, fcssescape);
                          } else {
                            context.setAttribute("id", (nid = expando));
                          }
                        }

                        // Prefix every selector in the list
                        groups = tokenize(selector);
                        i = groups.length;
                        while (i--) {
                          groups[i] = (nid ? "#" + nid : ":scope") + " " +
                            toSelector(groups[i]);
                        }
                        newSelector = groups.join(",");
                      }

                      try {
                        push.apply(results,
                          newContext.querySelectorAll(newSelector)
                        );
                        return results;
                      } catch (qsaError) {
                        nonnativeSelectorCache(selector, true);
                      } finally {
                        if (nid === expando) {
                          context.removeAttribute("id");
                        }
                      }
                    }
                  }
                }

                // All others
                return select(selector.replace(rtrim, "$1"), context, results, seed);
              }

              /**
               * Create key-value caches of limited size
               * @returns {function(string, object)} Returns the Object data after storing it on itself with
               *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
               *	deleting the oldest entry
               */
              function createCache() {
                var keys = [];

                function cache(key, value) {

                  // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                  if (keys.push(key + " ") > Expr.cacheLength) {

                    // Only keep the most recent entries
                    delete cache[keys.shift()];
                  }
                  return (cache[key + " "] = value);
                }
                return cache;
              }

              /**
               * Mark a function for special use by Sizzle
               * @param {Function} fn The function to mark
               */
              function markFunction(fn) {
                fn[expando] = true;
                return fn;
              }

              /**
               * Support testing using an element
               * @param {Function} fn Passed the created element and returns a boolean result
               */
              function assert(fn) {
                var el = document.createElement("fieldset");

                try {
                  return !!fn(el);
                } catch (e) {
                  return false;
                } finally {

                  // Remove from its parent by default
                  if (el.parentNode) {
                    el.parentNode.removeChild(el);
                  }

                  // release memory in IE
                  el = null;
                }
              }

              /**
               * Adds the same handler for all of the specified attrs
               * @param {String} attrs Pipe-separated list of attributes
               * @param {Function} handler The method that will be applied
               */
              function addHandle(attrs, handler) {
                var arr = attrs.split("|"),
                  i = arr.length;

                while (i--) {
                  Expr.attrHandle[arr[i]] = handler;
                }
              }

              /**
               * Checks document order of two siblings
               * @param {Element} a
               * @param {Element} b
               * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
               */
              function siblingCheck(a, b) {
                var cur = b && a,
                  diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
                    a.sourceIndex - b.sourceIndex;

                // Use IE sourceIndex if available on both nodes
                if (diff) {
                  return diff;
                }

                // Check if b follows a
                if (cur) {
                  while ((cur = cur.nextSibling)) {
                    if (cur === b) {
                      return -1;
                    }
                  }
                }

                return a ? 1 : -1;
              }

              /**
               * Returns a function to use in pseudos for input types
               * @param {String} type
               */
              function createInputPseudo(type) {
                return function (elem) {
                  var name = elem.nodeName.toLowerCase();
                  return name === "input" && elem.type === type;
                };
              }

              /**
               * Returns a function to use in pseudos for buttons
               * @param {String} type
               */
              function createButtonPseudo(type) {
                return function (elem) {
                  var name = elem.nodeName.toLowerCase();
                  return (name === "input" || name === "button") && elem.type === type;
                };
              }

              /**
               * Returns a function to use in pseudos for :enabled/:disabled
               * @param {Boolean} disabled true for :disabled; false for :enabled
               */
              function createDisabledPseudo(disabled) {

                // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
                return function (elem) {

                  // Only certain elements can match :enabled or :disabled
                  // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                  // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                  if ("form" in elem) {

                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {

                      // Option elements defer to a parent optgroup if present
                      if ("label" in elem) {
                        if ("label" in elem.parentNode) {
                          return elem.parentNode.disabled === disabled;
                        } else {
                          return elem.disabled === disabled;
                        }
                      }

                      // Support: IE 6 - 11
                      // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                      return elem.isDisabled === disabled ||

                        // Where there is no isDisabled, check manually
                        /* jshint -W018 */
                        elem.isDisabled !== !disabled &&
                        inDisabledFieldset(elem) === disabled;
                    }

                    return elem.disabled === disabled;

                    // Try to winnow out elements that can't be disabled before trusting the disabled property.
                    // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                    // even exist on them, let alone have a boolean value.
                  } else if ("label" in elem) {
                    return elem.disabled === disabled;
                  }

                  // Remaining elements are neither :enabled nor :disabled
                  return false;
                };
              }

              /**
               * Returns a function to use in pseudos for positionals
               * @param {Function} fn
               */
              function createPositionalPseudo(fn) {
                return markFunction(function (argument) {
                  argument = +argument;
                  return markFunction(function (seed, matches) {
                    var j,
                      matchIndexes = fn([], seed.length, argument),
                      i = matchIndexes.length;

                    // Match elements found at the specified indexes
                    while (i--) {
                      if (seed[(j = matchIndexes[i])]) {
                        seed[j] = !(matches[j] = seed[j]);
                      }
                    }
                  });
                });
              }

              /**
               * Checks a node for validity as a Sizzle context
               * @param {Element|Object=} context
               * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
               */
              function testContext(context) {
                return context && typeof context.getElementsByTagName !== "undefined" && context;
              }

              // Expose support vars for convenience
              support = Sizzle.support = {};

              /**
               * Detects XML nodes
               * @param {Element|Object} elem An element or a document
               * @returns {Boolean} True iff elem is a non-HTML XML node
               */
              isXML = Sizzle.isXML = function (elem) {
                var namespace = elem && elem.namespaceURI,
                  docElem = elem && (elem.ownerDocument || elem).documentElement;

                // Support: IE <=8
                // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
                // https://bugs.jquery.com/ticket/4833
                return !rhtml.test(namespace || docElem && docElem.nodeName || "HTML");
              };

              /**
               * Sets document-related variables once based on the current document
               * @param {Element|Object} [doc] An element or document object to use to set the document
               * @returns {Object} Returns the current document
               */
              setDocument = Sizzle.setDocument = function (node) {
                var hasCompare, subWindow,
                  doc = node ? node.ownerDocument || node : preferredDoc;

                // Return early if doc is invalid or already selected
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                if (doc == document || doc.nodeType !== 9 || !doc.documentElement) {
                  return document;
                }

                // Update global variables
                document = doc;
                docElem = document.documentElement;
                documentIsHTML = !isXML(document);

                // Support: IE 9 - 11+, Edge 12 - 18+
                // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                if (preferredDoc != document &&
                  (subWindow = document.defaultView) && subWindow.top !== subWindow) {

                  // Support: IE 11, Edge
                  if (subWindow.addEventListener) {
                    subWindow.addEventListener("unload", unloadHandler, false);

                    // Support: IE 9 - 10 only
                  } else if (subWindow.attachEvent) {
                    subWindow.attachEvent("onunload", unloadHandler);
                  }
                }

                // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
                // Safari 4 - 5 only, Opera <=11.6 - 12.x only
                // IE/Edge & older browsers don't support the :scope pseudo-class.
                // Support: Safari 6.0 only
                // Safari 6.0 supports :scope but it's an alias of :root there.
                support.scope = assert(function (el) {
                  docElem.appendChild(el).appendChild(document.createElement("div"));
                  return typeof el.querySelectorAll !== "undefined" &&
                    !el.querySelectorAll(":scope fieldset div").length;
                });

                /* Attributes
                ---------------------------------------------------------------------- */

                // Support: IE<8
                // Verify that getAttribute really returns attributes and not properties
                // (excepting IE8 booleans)
                support.attributes = assert(function (el) {
                  el.className = "i";
                  return !el.getAttribute("className");
                });

                /* getElement(s)By*
                ---------------------------------------------------------------------- */

                // Check if getElementsByTagName("*") returns only elements
                support.getElementsByTagName = assert(function (el) {
                  el.appendChild(document.createComment(""));
                  return !el.getElementsByTagName("*").length;
                });

                // Support: IE<9
                support.getElementsByClassName = rnative.test(document.getElementsByClassName);

                // Support: IE<10
                // Check if getElementById returns elements by name
                // The broken getElementById methods don't pick up programmatically-set names,
                // so use a roundabout getElementsByName test
                support.getById = assert(function (el) {
                  docElem.appendChild(el).id = expando;
                  return !document.getElementsByName || !document.getElementsByName(expando).length;
                });

                // ID filter and find
                if (support.getById) {
                  Expr.filter["ID"] = function (id) {
                    var attrId = id.replace(runescape, funescape);
                    return function (elem) {
                      return elem.getAttribute("id") === attrId;
                    };
                  };
                  Expr.find["ID"] = function (id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                      var elem = context.getElementById(id);
                      return elem ? [elem] : [];
                    }
                  };
                } else {
                  Expr.filter["ID"] = function (id) {
                    var attrId = id.replace(runescape, funescape);
                    return function (elem) {
                      var node = typeof elem.getAttributeNode !== "undefined" &&
                        elem.getAttributeNode("id");
                      return node && node.value === attrId;
                    };
                  };

                  // Support: IE 6 - 7 only
                  // getElementById is not reliable as a find shortcut
                  Expr.find["ID"] = function (id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                      var node, i, elems,
                        elem = context.getElementById(id);

                      if (elem) {

                        // Verify the id attribute
                        node = elem.getAttributeNode("id");
                        if (node && node.value === id) {
                          return [elem];
                        }

                        // Fall back on getElementsByName
                        elems = context.getElementsByName(id);
                        i = 0;
                        while ((elem = elems[i++])) {
                          node = elem.getAttributeNode("id");
                          if (node && node.value === id) {
                            return [elem];
                          }
                        }
                      }

                      return [];
                    }
                  };
                }

                // Tag
                Expr.find["TAG"] = support.getElementsByTagName ?
                  function (tag, context) {
                    if (typeof context.getElementsByTagName !== "undefined") {
                      return context.getElementsByTagName(tag);

                      // DocumentFragment nodes don't have gEBTN
                    } else if (support.qsa) {
                      return context.querySelectorAll(tag);
                    }
                  } :

                  function (tag, context) {
                    var elem,
                      tmp = [],
                      i = 0,

                      // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                      results = context.getElementsByTagName(tag);

                    // Filter out possible comments
                    if (tag === "*") {
                      while ((elem = results[i++])) {
                        if (elem.nodeType === 1) {
                          tmp.push(elem);
                        }
                      }

                      return tmp;
                    }
                    return results;
                  };

                // Class
                Expr.find["CLASS"] = support.getElementsByClassName && function (className, context) {
                  if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
                    return context.getElementsByClassName(className);
                  }
                };

                /* QSA/matchesSelector
                ---------------------------------------------------------------------- */

                // QSA and matchesSelector support

                // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
                rbuggyMatches = [];

                // qSa(:focus) reports false when true (Chrome 21)
                // We allow this because of a bug in IE8/9 that throws an error
                // whenever `document.activeElement` is accessed on an iframe
                // So, we allow :focus to pass through QSA all the time to avoid the IE error
                // See https://bugs.jquery.com/ticket/13378
                rbuggyQSA = [];

                if ((support.qsa = rnative.test(document.querySelectorAll))) {

                  // Build QSA regex
                  // Regex strategy adopted from Diego Perini
                  assert(function (el) {

                    var input;

                    // Select is set to empty string on purpose
                    // This is to test IE's treatment of not explicitly
                    // setting a boolean content attribute,
                    // since its presence should be enough
                    // https://bugs.jquery.com/ticket/12359
                    docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" +
                      "<select id='" + expando + "-\r\\' msallowcapture=''>" +
                      "<option selected=''></option></select>";

                    // Support: IE8, Opera 11-12.16
                    // Nothing should be selected when empty strings follow ^= or $= or *=
                    // The test attribute must be unknown in Opera but "safe" for WinRT
                    // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                    if (el.querySelectorAll("[msallowcapture^='']").length) {
                      rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
                    }

                    // Support: IE8
                    // Boolean attributes and "value" are not treated correctly
                    if (!el.querySelectorAll("[selected]").length) {
                      rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                    }

                    // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                    if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
                      rbuggyQSA.push("~=");
                    }

                    // Support: IE 11+, Edge 15 - 18+
                    // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                    // Adding a temporary attribute to the document before the selection works
                    // around the issue.
                    // Interestingly, IE 10 & older don't seem to have the issue.
                    input = document.createElement("input");
                    input.setAttribute("name", "");
                    el.appendChild(input);
                    if (!el.querySelectorAll("[name='']").length) {
                      rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" +
                        whitespace + "*(?:''|\"\")");
                    }

                    // Webkit/Opera - :checked should return selected option elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    // IE8 throws error here and will not see later tests
                    if (!el.querySelectorAll(":checked").length) {
                      rbuggyQSA.push(":checked");
                    }

                    // Support: Safari 8+, iOS 8+
                    // https://bugs.webkit.org/show_bug.cgi?id=136851
                    // In-page `selector#id sibling-combinator selector` fails
                    if (!el.querySelectorAll("a#" + expando + "+*").length) {
                      rbuggyQSA.push(".#.+[+~]");
                    }

                    // Support: Firefox <=3.6 - 5 only
                    // Old Firefox doesn't throw on a badly-escaped identifier.
                    el.querySelectorAll("\\\f");
                    rbuggyQSA.push("[\\r\\n\\f]");
                  });

                  assert(function (el) {
                    el.innerHTML = "<a href='' disabled='disabled'></a>" +
                      "<select disabled='disabled'><option/></select>";

                    // Support: Windows 8 Native Apps
                    // The type and name attributes are restricted during .innerHTML assignment
                    var input = document.createElement("input");
                    input.setAttribute("type", "hidden");
                    el.appendChild(input).setAttribute("name", "D");

                    // Support: IE8
                    // Enforce case-sensitivity of name attribute
                    if (el.querySelectorAll("[name=d]").length) {
                      rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
                    }

                    // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                    // IE8 throws error here and will not see later tests
                    if (el.querySelectorAll(":enabled").length !== 2) {
                      rbuggyQSA.push(":enabled", ":disabled");
                    }

                    // Support: IE9-11+
                    // IE's :disabled selector does not pick up the children of disabled fieldsets
                    docElem.appendChild(el).disabled = true;
                    if (el.querySelectorAll(":disabled").length !== 2) {
                      rbuggyQSA.push(":enabled", ":disabled");
                    }

                    // Support: Opera 10 - 11 only
                    // Opera 10-11 does not throw on post-comma invalid pseudos
                    el.querySelectorAll("*,:x");
                    rbuggyQSA.push(",.*:");
                  });
                }

                if ((support.matchesSelector = rnative.test((matches = docElem.matches ||
                  docElem.webkitMatchesSelector ||
                  docElem.mozMatchesSelector ||
                  docElem.oMatchesSelector ||
                  docElem.msMatchesSelector)))) {

                  assert(function (el) {

                    // Check to see if it's possible to do matchesSelector
                    // on a disconnected node (IE 9)
                    support.disconnectedMatch = matches.call(el, "*");

                    // This should fail with an exception
                    // Gecko does not error, returns false instead
                    matches.call(el, "[s!='']:x");
                    rbuggyMatches.push("!=", pseudos);
                  });
                }

                rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
                rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));

                /* Contains
                ---------------------------------------------------------------------- */
                hasCompare = rnative.test(docElem.compareDocumentPosition);

                // Element contains another
                // Purposefully self-exclusive
                // As in, an element does not contain itself
                contains = hasCompare || rnative.test(docElem.contains) ?
                  function (a, b) {
                    var adown = a.nodeType === 9 ? a.documentElement : a,
                      bup = b && b.parentNode;
                    return a === bup || !!(bup && bup.nodeType === 1 && (
                      adown.contains ?
                        adown.contains(bup) :
                        a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16
                    ));
                  } :
                  function (a, b) {
                    if (b) {
                      while ((b = b.parentNode)) {
                        if (b === a) {
                          return true;
                        }
                      }
                    }
                    return false;
                  };

                /* Sorting
                ---------------------------------------------------------------------- */

                // Document order sorting
                sortOrder = hasCompare ?
                  function (a, b) {

                    // Flag for duplicate removal
                    if (a === b) {
                      hasDuplicate = true;
                      return 0;
                    }

                    // Sort on method existence if only one input has compareDocumentPosition
                    var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                    if (compare) {
                      return compare;
                    }

                    // Calculate position if both inputs belong to the same document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    compare = (a.ownerDocument || a) == (b.ownerDocument || b) ?
                      a.compareDocumentPosition(b) :

                      // Otherwise we know they are disconnected
                      1;

                    // Disconnected nodes
                    if (compare & 1 ||
                      (!support.sortDetached && b.compareDocumentPosition(a) === compare)) {

                      // Choose the first element that is related to our preferred document
                      // Support: IE 11+, Edge 17 - 18+
                      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                      // two documents; shallow comparisons work.
                      // eslint-disable-next-line eqeqeq
                      if (a == document || a.ownerDocument == preferredDoc &&
                        contains(preferredDoc, a)) {
                        return -1;
                      }

                      // Support: IE 11+, Edge 17 - 18+
                      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                      // two documents; shallow comparisons work.
                      // eslint-disable-next-line eqeqeq
                      if (b == document || b.ownerDocument == preferredDoc &&
                        contains(preferredDoc, b)) {
                        return 1;
                      }

                      // Maintain original order
                      return sortInput ?
                        (indexOf(sortInput, a) - indexOf(sortInput, b)) :
                        0;
                    }

                    return compare & 4 ? -1 : 1;
                  } :
                  function (a, b) {

                    // Exit early if the nodes are identical
                    if (a === b) {
                      hasDuplicate = true;
                      return 0;
                    }

                    var cur,
                      i = 0,
                      aup = a.parentNode,
                      bup = b.parentNode,
                      ap = [a],
                      bp = [b];

                    // Parentless nodes are either documents or disconnected
                    if (!aup || !bup) {

                      // Support: IE 11+, Edge 17 - 18+
                      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                      // two documents; shallow comparisons work.
                      /* eslint-disable eqeqeq */
                      return a == document ? -1 :
                        b == document ? 1 :
                          /* eslint-enable eqeqeq */
                          aup ? -1 :
                            bup ? 1 :
                              sortInput ?
                                (indexOf(sortInput, a) - indexOf(sortInput, b)) :
                                0;

                      // If the nodes are siblings, we can do a quick check
                    } else if (aup === bup) {
                      return siblingCheck(a, b);
                    }

                    // Otherwise we need full lists of their ancestors for comparison
                    cur = a;
                    while ((cur = cur.parentNode)) {
                      ap.unshift(cur);
                    }
                    cur = b;
                    while ((cur = cur.parentNode)) {
                      bp.unshift(cur);
                    }

                    // Walk down the tree looking for a discrepancy
                    while (ap[i] === bp[i]) {
                      i++;
                    }

                    return i ?

                      // Do a sibling check if the nodes have a common ancestor
                      siblingCheck(ap[i], bp[i]) :

                      // Otherwise nodes in our document sort first
                      // Support: IE 11+, Edge 17 - 18+
                      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                      // two documents; shallow comparisons work.
                      /* eslint-disable eqeqeq */
                      ap[i] == preferredDoc ? -1 :
                        bp[i] == preferredDoc ? 1 :
                          /* eslint-enable eqeqeq */
                          0;
                  };

                return document;
              };

              Sizzle.matches = function (expr, elements) {
                return Sizzle(expr, null, null, elements);
              };

              Sizzle.matchesSelector = function (elem, expr) {
                setDocument(elem);

                if (support.matchesSelector && documentIsHTML &&
                  !nonnativeSelectorCache[expr + " "] &&
                  (!rbuggyMatches || !rbuggyMatches.test(expr)) &&
                  (!rbuggyQSA || !rbuggyQSA.test(expr))) {

                  try {
                    var ret = matches.call(elem, expr);

                    // IE 9's matchesSelector returns false on disconnected nodes
                    if (ret || support.disconnectedMatch ||

                      // As well, disconnected nodes are said to be in a document
                      // fragment in IE 9
                      elem.document && elem.document.nodeType !== 11) {
                      return ret;
                    }
                  } catch (e) {
                    nonnativeSelectorCache(expr, true);
                  }
                }

                return Sizzle(expr, document, null, [elem]).length > 0;
              };

              Sizzle.contains = function (context, elem) {

                // Set document vars if needed
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                if ((context.ownerDocument || context) != document) {
                  setDocument(context);
                }
                return contains(context, elem);
              };

              Sizzle.attr = function (elem, name) {

                // Set document vars if needed
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                if ((elem.ownerDocument || elem) != document) {
                  setDocument(elem);
                }

                var fn = Expr.attrHandle[name.toLowerCase()],

                  // Don't get fooled by Object.prototype properties (jQuery #13807)
                  val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ?
                    fn(elem, name, !documentIsHTML) :
                    undefined;

                return val !== undefined ?
                  val :
                  support.attributes || !documentIsHTML ?
                    elem.getAttribute(name) :
                    (val = elem.getAttributeNode(name)) && val.specified ?
                      val.value :
                      null;
              };

              Sizzle.escape = function (sel) {
                return (sel + "").replace(rcssescape, fcssescape);
              };

              Sizzle.error = function (msg) {
                throw new Error("Syntax error, unrecognized expression: " + msg);
              };

              /**
               * Document sorting and removing duplicates
               * @param {ArrayLike} results
               */
              Sizzle.uniqueSort = function (results) {
                var elem,
                  duplicates = [],
                  j = 0,
                  i = 0;

                // Unless we *know* we can detect duplicates, assume their presence
                hasDuplicate = !support.detectDuplicates;
                sortInput = !support.sortStable && results.slice(0);
                results.sort(sortOrder);

                if (hasDuplicate) {
                  while ((elem = results[i++])) {
                    if (elem === results[i]) {
                      j = duplicates.push(i);
                    }
                  }
                  while (j--) {
                    results.splice(duplicates[j], 1);
                  }
                }

                // Clear input after sorting to release objects
                // See https://github.com/jquery/sizzle/pull/225
                sortInput = null;

                return results;
              };

              /**
               * Utility function for retrieving the text value of an array of DOM nodes
               * @param {Array|Element} elem
               */
              getText = Sizzle.getText = function (elem) {
                var node,
                  ret = "",
                  i = 0,
                  nodeType = elem.nodeType;

                if (!nodeType) {

                  // If no nodeType, this is expected to be an array
                  while ((node = elem[i++])) {

                    // Do not traverse comment nodes
                    ret += getText(node);
                  }
                } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {

                  // Use textContent for elements
                  // innerText usage removed for consistency of new lines (jQuery #11153)
                  if (typeof elem.textContent === "string") {
                    return elem.textContent;
                  } else {

                    // Traverse its children
                    for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
                      ret += getText(elem);
                    }
                  }
                } else if (nodeType === 3 || nodeType === 4) {
                  return elem.nodeValue;
                }

                // Do not include comment or processing instruction nodes

                return ret;
              };

              Expr = Sizzle.selectors = {

                // Can be adjusted by the user
                cacheLength: 50,

                createPseudo: markFunction,

                match: matchExpr,

                attrHandle: {},

                find: {},

                relative: {
                  ">": { dir: "parentNode", first: true },
                  " ": { dir: "parentNode" },
                  "+": { dir: "previousSibling", first: true },
                  "~": { dir: "previousSibling" }
                },

                preFilter: {
                  "ATTR": function (match) {
                    match[1] = match[1].replace(runescape, funescape);

                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] ||
                      match[5] || "").replace(runescape, funescape);

                    if (match[2] === "~=") {
                      match[3] = " " + match[3] + " ";
                    }

                    return match.slice(0, 4);
                  },

                  "CHILD": function (match) {

                    /* matches from matchExpr["CHILD"]
                      1 type (only|nth|...)
                      2 what (child|of-type)
                      3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
                      4 xn-component of xn+y argument ([+-]?\d*n|)
                      5 sign of xn-component
                      6 x of xn-component
                      7 sign of y-component
                      8 y of y-component
                    */
                    match[1] = match[1].toLowerCase();

                    if (match[1].slice(0, 3) === "nth") {

                      // nth-* requires argument
                      if (!match[3]) {
                        Sizzle.error(match[0]);
                      }

                      // numeric x and y parameters for Expr.filter.CHILD
                      // remember that false/true cast respectively to 0/1
                      match[4] = +(match[4] ?
                        match[5] + (match[6] || 1) :
                        2 * (match[3] === "even" || match[3] === "odd"));
                      match[5] = +((match[7] + match[8]) || match[3] === "odd");

                      // other types prohibit arguments
                    } else if (match[3]) {
                      Sizzle.error(match[0]);
                    }

                    return match;
                  },

                  "PSEUDO": function (match) {
                    var excess,
                      unquoted = !match[6] && match[2];

                    if (matchExpr["CHILD"].test(match[0])) {
                      return null;
                    }

                    // Accept quoted arguments as-is
                    if (match[3]) {
                      match[2] = match[4] || match[5] || "";

                      // Strip excess characters from unquoted arguments
                    } else if (unquoted && rpseudo.test(unquoted) &&

                      // Get excess from tokenize (recursively)
                      (excess = tokenize(unquoted, true)) &&

                      // advance to the next closing parenthesis
                      (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {

                      // excess is a negative index
                      match[0] = match[0].slice(0, excess);
                      match[2] = unquoted.slice(0, excess);
                    }

                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                  }
                },

                filter: {

                  "TAG": function (nodeNameSelector) {
                    var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ?
                      function () {
                        return true;
                      } :
                      function (elem) {
                        return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                      };
                  },

                  "CLASS": function (className) {
                    var pattern = classCache[className + " "];

                    return pattern ||
                      (pattern = new RegExp("(^|" + whitespace +
                        ")" + className + "(" + whitespace + "|$)")) && classCache(
                          className, function (elem) {
                            return pattern.test(
                              typeof elem.className === "string" && elem.className ||
                              typeof elem.getAttribute !== "undefined" &&
                              elem.getAttribute("class") ||
                              ""
                            );
                          });
                  },

                  "ATTR": function (name, operator, check) {
                    return function (elem) {
                      var result = Sizzle.attr(elem, name);

                      if (result == null) {
                        return operator === "!=";
                      }
                      if (!operator) {
                        return true;
                      }

                      result += "";

                      /* eslint-disable max-len */

                      return operator === "=" ? result === check :
                        operator === "!=" ? result !== check :
                          operator === "^=" ? check && result.indexOf(check) === 0 :
                            operator === "*=" ? check && result.indexOf(check) > -1 :
                              operator === "$=" ? check && result.slice(-check.length) === check :
                                operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 :
                                  operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" :
                                    false;
                      /* eslint-enable max-len */

                    };
                  },

                  "CHILD": function (type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth",
                      forward = type.slice(-4) !== "last",
                      ofType = what === "of-type";

                    return first === 1 && last === 0 ?

                      // Shortcut for :nth-*(n)
                      function (elem) {
                        return !!elem.parentNode;
                      } :

                      function (elem, _context, xml) {
                        var cache, uniqueCache, outerCache, node, nodeIndex, start,
                          dir = simple !== forward ? "nextSibling" : "previousSibling",
                          parent = elem.parentNode,
                          name = ofType && elem.nodeName.toLowerCase(),
                          useCache = !xml && !ofType,
                          diff = false;

                        if (parent) {

                          // :(first|last|only)-(child|of-type)
                          if (simple) {
                            while (dir) {
                              node = elem;
                              while ((node = node[dir])) {
                                if (ofType ?
                                  node.nodeName.toLowerCase() === name :
                                  node.nodeType === 1) {

                                  return false;
                                }
                              }

                              // Reverse direction for :only-* (if we haven't yet done so)
                              start = dir = type === "only" && !start && "nextSibling";
                            }
                            return true;
                          }

                          start = [forward ? parent.firstChild : parent.lastChild];

                          // non-xml :nth-child(...) stores cache data on `parent`
                          if (forward && useCache) {

                            // Seek `elem` from a previously-cached index

                            // ...in a gzip-friendly way
                            node = parent;
                            outerCache = node[expando] || (node[expando] = {});

                            // Support: IE <9 only
                            // Defend against cloned attroperties (jQuery gh-1709)
                            uniqueCache = outerCache[node.uniqueID] ||
                              (outerCache[node.uniqueID] = {});

                            cache = uniqueCache[type] || [];
                            nodeIndex = cache[0] === dirruns && cache[1];
                            diff = nodeIndex && cache[2];
                            node = nodeIndex && parent.childNodes[nodeIndex];

                            while ((node = ++nodeIndex && node && node[dir] ||

                              // Fallback to seeking `elem` from the start
                              (diff = nodeIndex = 0) || start.pop())) {

                              // When found, cache indexes on `parent` and break
                              if (node.nodeType === 1 && ++diff && node === elem) {
                                uniqueCache[type] = [dirruns, nodeIndex, diff];
                                break;
                              }
                            }

                          } else {

                            // Use previously-cached element index if available
                            if (useCache) {

                              // ...in a gzip-friendly way
                              node = elem;
                              outerCache = node[expando] || (node[expando] = {});

                              // Support: IE <9 only
                              // Defend against cloned attroperties (jQuery gh-1709)
                              uniqueCache = outerCache[node.uniqueID] ||
                                (outerCache[node.uniqueID] = {});

                              cache = uniqueCache[type] || [];
                              nodeIndex = cache[0] === dirruns && cache[1];
                              diff = nodeIndex;
                            }

                            // xml :nth-child(...)
                            // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                            if (diff === false) {

                              // Use the same loop as above to seek `elem` from the start
                              while ((node = ++nodeIndex && node && node[dir] ||
                                (diff = nodeIndex = 0) || start.pop())) {

                                if ((ofType ?
                                  node.nodeName.toLowerCase() === name :
                                  node.nodeType === 1) &&
                                  ++diff) {

                                  // Cache the index of each encountered element
                                  if (useCache) {
                                    outerCache = node[expando] ||
                                      (node[expando] = {});

                                    // Support: IE <9 only
                                    // Defend against cloned attroperties (jQuery gh-1709)
                                    uniqueCache = outerCache[node.uniqueID] ||
                                      (outerCache[node.uniqueID] = {});

                                    uniqueCache[type] = [dirruns, diff];
                                  }

                                  if (node === elem) {
                                    break;
                                  }
                                }
                              }
                            }
                          }

                          // Incorporate the offset, then check against cycle size
                          diff -= last;
                          return diff === first || (diff % first === 0 && diff / first >= 0);
                        }
                      };
                  },

                  "PSEUDO": function (pseudo, argument) {

                    // pseudo-class names are case-insensitive
                    // http://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args,
                      fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] ||
                        Sizzle.error("unsupported pseudo: " + pseudo);

                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as Sizzle does
                    if (fn[expando]) {
                      return fn(argument);
                    }

                    // But maintain support for old signatures
                    if (fn.length > 1) {
                      args = [pseudo, pseudo, "", argument];
                      return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ?
                        markFunction(function (seed, matches) {
                          var idx,
                            matched = fn(seed, argument),
                            i = matched.length;
                          while (i--) {
                            idx = indexOf(seed, matched[i]);
                            seed[idx] = !(matches[idx] = matched[i]);
                          }
                        }) :
                        function (elem) {
                          return fn(elem, 0, args);
                        };
                    }

                    return fn;
                  }
                },

                pseudos: {

                  // Potentially complex pseudos
                  "not": markFunction(function (selector) {

                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [],
                      results = [],
                      matcher = compile(selector.replace(rtrim, "$1"));

                    return matcher[expando] ?
                      markFunction(function (seed, matches, _context, xml) {
                        var elem,
                          unmatched = matcher(seed, null, xml, []),
                          i = seed.length;

                        // Match elements unmatched by `matcher`
                        while (i--) {
                          if ((elem = unmatched[i])) {
                            seed[i] = !(matches[i] = elem);
                          }
                        }
                      }) :
                      function (elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);

                        // Don't keep the element (issue #299)
                        input[0] = null;
                        return !results.pop();
                      };
                  }),

                  "has": markFunction(function (selector) {
                    return function (elem) {
                      return Sizzle(selector, elem).length > 0;
                    };
                  }),

                  "contains": markFunction(function (text) {
                    text = text.replace(runescape, funescape);
                    return function (elem) {
                      return (elem.textContent || getText(elem)).indexOf(text) > -1;
                    };
                  }),

                  // "Whether an element is represented by a :lang() selector
                  // is based solely on the element's language value
                  // being equal to the identifier C,
                  // or beginning with the identifier C immediately followed by "-".
                  // The matching of C against the element's language value is performed case-insensitively.
                  // The identifier C does not have to be a valid language name."
                  // http://www.w3.org/TR/selectors/#lang-pseudo
                  "lang": markFunction(function (lang) {

                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) {
                      Sizzle.error("unsupported lang: " + lang);
                    }
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function (elem) {
                      var elemLang;
                      do {
                        if ((elemLang = documentIsHTML ?
                          elem.lang :
                          elem.getAttribute("xml:lang") || elem.getAttribute("lang"))) {

                          elemLang = elemLang.toLowerCase();
                          return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                      } while ((elem = elem.parentNode) && elem.nodeType === 1);
                      return false;
                    };
                  }),

                  // Miscellaneous
                  "target": function (elem) {
                    var hash = window.location && window.location.hash;
                    return hash && hash.slice(1) === elem.id;
                  },

                  "root": function (elem) {
                    return elem === docElem;
                  },

                  "focus": function (elem) {
                    return elem === document.activeElement &&
                      (!document.hasFocus || document.hasFocus()) &&
                      !!(elem.type || elem.href || ~elem.tabIndex);
                  },

                  // Boolean properties
                  "enabled": createDisabledPseudo(false),
                  "disabled": createDisabledPseudo(true),

                  "checked": function (elem) {

                    // In CSS3, :checked should return both checked and selected elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    var nodeName = elem.nodeName.toLowerCase();
                    return (nodeName === "input" && !!elem.checked) ||
                      (nodeName === "option" && !!elem.selected);
                  },

                  "selected": function (elem) {

                    // Accessing this property makes selected-by-default
                    // options in Safari work properly
                    if (elem.parentNode) {
                      // eslint-disable-next-line no-unused-expressions
                      elem.parentNode.selectedIndex;
                    }

                    return elem.selected === true;
                  },

                  // Contents
                  "empty": function (elem) {

                    // http://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
                      if (elem.nodeType < 6) {
                        return false;
                      }
                    }
                    return true;
                  },

                  "parent": function (elem) {
                    return !Expr.pseudos["empty"](elem);
                  },

                  // Element/input types
                  "header": function (elem) {
                    return rheader.test(elem.nodeName);
                  },

                  "input": function (elem) {
                    return rinputs.test(elem.nodeName);
                  },

                  "button": function (elem) {
                    var name = elem.nodeName.toLowerCase();
                    return name === "input" && elem.type === "button" || name === "button";
                  },

                  "text": function (elem) {
                    var attr;
                    return elem.nodeName.toLowerCase() === "input" &&
                      elem.type === "text" &&

                      // Support: IE<8
                      // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                      ((attr = elem.getAttribute("type")) == null ||
                        attr.toLowerCase() === "text");
                  },

                  // Position-in-collection
                  "first": createPositionalPseudo(function () {
                    return [0];
                  }),

                  "last": createPositionalPseudo(function (_matchIndexes, length) {
                    return [length - 1];
                  }),

                  "eq": createPositionalPseudo(function (_matchIndexes, length, argument) {
                    return [argument < 0 ? argument + length : argument];
                  }),

                  "even": createPositionalPseudo(function (matchIndexes, length) {
                    var i = 0;
                    for (; i < length; i += 2) {
                      matchIndexes.push(i);
                    }
                    return matchIndexes;
                  }),

                  "odd": createPositionalPseudo(function (matchIndexes, length) {
                    var i = 1;
                    for (; i < length; i += 2) {
                      matchIndexes.push(i);
                    }
                    return matchIndexes;
                  }),

                  "lt": createPositionalPseudo(function (matchIndexes, length, argument) {
                    var i = argument < 0 ?
                      argument + length :
                      argument > length ?
                        length :
                        argument;
                    for (; --i >= 0;) {
                      matchIndexes.push(i);
                    }
                    return matchIndexes;
                  }),

                  "gt": createPositionalPseudo(function (matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for (; ++i < length;) {
                      matchIndexes.push(i);
                    }
                    return matchIndexes;
                  })
                }
              };

              Expr.pseudos["nth"] = Expr.pseudos["eq"];

              // Add button/input type pseudos
              for (i in { radio: true, checkbox: true, file: true, password: true, image: true }) {
                Expr.pseudos[i] = createInputPseudo(i);
              }
              for (i in { submit: true, reset: true }) {
                Expr.pseudos[i] = createButtonPseudo(i);
              }

              // Easy API for creating new setFilters
              function setFilters() { }
              setFilters.prototype = Expr.filters = Expr.pseudos;
              Expr.setFilters = new setFilters();

              tokenize = Sizzle.tokenize = function (selector, parseOnly) {
                var matched, match, tokens, type,
                  soFar, groups, preFilters,
                  cached = tokenCache[selector + " "];

                if (cached) {
                  return parseOnly ? 0 : cached.slice(0);
                }

                soFar = selector;
                groups = [];
                preFilters = Expr.preFilter;

                while (soFar) {

                  // Comma and first run
                  if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) {

                      // Don't consume trailing commas as valid
                      soFar = soFar.slice(match[0].length) || soFar;
                    }
                    groups.push((tokens = []));
                  }

                  matched = false;

                  // Combinators
                  if ((match = rcombinators.exec(soFar))) {
                    matched = match.shift();
                    tokens.push({
                      value: matched,

                      // Cast descendant combinators to space
                      type: match[0].replace(rtrim, " ")
                    });
                    soFar = soFar.slice(matched.length);
                  }

                  // Filters
                  for (type in Expr.filter) {
                    if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] ||
                      (match = preFilters[type](match)))) {
                      matched = match.shift();
                      tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                      });
                      soFar = soFar.slice(matched.length);
                    }
                  }

                  if (!matched) {
                    break;
                  }
                }

                // Return the length of the invalid excess
                // if we're just parsing
                // Otherwise, throw an error or return tokens
                return parseOnly ?
                  soFar.length :
                  soFar ?
                    Sizzle.error(selector) :

                    // Cache the tokens
                    tokenCache(selector, groups).slice(0);
              };

              function toSelector(tokens) {
                var i = 0,
                  len = tokens.length,
                  selector = "";
                for (; i < len; i++) {
                  selector += tokens[i].value;
                }
                return selector;
              }

              function addCombinator(matcher, combinator, base) {
                var dir = combinator.dir,
                  skip = combinator.next,
                  key = skip || dir,
                  checkNonElements = base && key === "parentNode",
                  doneName = done++;

                return combinator.first ?

                  // Check against closest ancestor/preceding element
                  function (elem, context, xml) {
                    while ((elem = elem[dir])) {
                      if (elem.nodeType === 1 || checkNonElements) {
                        return matcher(elem, context, xml);
                      }
                    }
                    return false;
                  } :

                  // Check against all ancestor/preceding elements
                  function (elem, context, xml) {
                    var oldCache, uniqueCache, outerCache,
                      newCache = [dirruns, doneName];

                    // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                    if (xml) {
                      while ((elem = elem[dir])) {
                        if (elem.nodeType === 1 || checkNonElements) {
                          if (matcher(elem, context, xml)) {
                            return true;
                          }
                        }
                      }
                    } else {
                      while ((elem = elem[dir])) {
                        if (elem.nodeType === 1 || checkNonElements) {
                          outerCache = elem[expando] || (elem[expando] = {});

                          // Support: IE <9 only
                          // Defend against cloned attroperties (jQuery gh-1709)
                          uniqueCache = outerCache[elem.uniqueID] ||
                            (outerCache[elem.uniqueID] = {});

                          if (skip && skip === elem.nodeName.toLowerCase()) {
                            elem = elem[dir] || elem;
                          } else if ((oldCache = uniqueCache[key]) &&
                            oldCache[0] === dirruns && oldCache[1] === doneName) {

                            // Assign to newCache so results back-propagate to previous elements
                            return (newCache[2] = oldCache[2]);
                          } else {

                            // Reuse newcache so results back-propagate to previous elements
                            uniqueCache[key] = newCache;

                            // A match means we're done; a fail means we have to keep checking
                            if ((newCache[2] = matcher(elem, context, xml))) {
                              return true;
                            }
                          }
                        }
                      }
                    }
                    return false;
                  };
              }

              function elementMatcher(matchers) {
                return matchers.length > 1 ?
                  function (elem, context, xml) {
                    var i = matchers.length;
                    while (i--) {
                      if (!matchers[i](elem, context, xml)) {
                        return false;
                      }
                    }
                    return true;
                  } :
                  matchers[0];
              }

              function multipleContexts(selector, contexts, results) {
                var i = 0,
                  len = contexts.length;
                for (; i < len; i++) {
                  Sizzle(selector, contexts[i], results);
                }
                return results;
              }

              function condense(unmatched, map, filter, context, xml) {
                var elem,
                  newUnmatched = [],
                  i = 0,
                  len = unmatched.length,
                  mapped = map != null;

                for (; i < len; i++) {
                  if ((elem = unmatched[i])) {
                    if (!filter || filter(elem, context, xml)) {
                      newUnmatched.push(elem);
                      if (mapped) {
                        map.push(i);
                      }
                    }
                  }
                }

                return newUnmatched;
              }

              function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
                if (postFilter && !postFilter[expando]) {
                  postFilter = setMatcher(postFilter);
                }
                if (postFinder && !postFinder[expando]) {
                  postFinder = setMatcher(postFinder, postSelector);
                }
                return markFunction(function (seed, results, context, xml) {
                  var temp, i, elem,
                    preMap = [],
                    postMap = [],
                    preexisting = results.length,

                    // Get initial elements from seed or context
                    elems = seed || multipleContexts(
                      selector || "*",
                      context.nodeType ? [context] : context,
                      []
                    ),

                    // Prefilter to get matcher input, preserving a map for seed-results synchronization
                    matcherIn = preFilter && (seed || !selector) ?
                      condense(elems, preMap, preFilter, context, xml) :
                      elems,

                    matcherOut = matcher ?

                      // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                      postFinder || (seed ? preFilter : preexisting || postFilter) ?

                        // ...intermediate processing is necessary
                        [] :

                        // ...otherwise use results directly
                        results :
                      matcherIn;

                  // Find primary matches
                  if (matcher) {
                    matcher(matcherIn, matcherOut, context, xml);
                  }

                  // Apply postFilter
                  if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);

                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while (i--) {
                      if ((elem = temp[i])) {
                        matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                      }
                    }
                  }

                  if (seed) {
                    if (postFinder || preFilter) {
                      if (postFinder) {

                        // Get the final matcherOut by condensing this intermediate into postFinder contexts
                        temp = [];
                        i = matcherOut.length;
                        while (i--) {
                          if ((elem = matcherOut[i])) {

                            // Restore matcherIn since elem is not yet a final match
                            temp.push((matcherIn[i] = elem));
                          }
                        }
                        postFinder(null, (matcherOut = []), temp, xml);
                      }

                      // Move matched elements from seed to results to keep them synchronized
                      i = matcherOut.length;
                      while (i--) {
                        if ((elem = matcherOut[i]) &&
                          (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) {

                          seed[temp] = !(results[temp] = elem);
                        }
                      }
                    }

                    // Add elements to results, through postFinder if defined
                  } else {
                    matcherOut = condense(
                      matcherOut === results ?
                        matcherOut.splice(preexisting, matcherOut.length) :
                        matcherOut
                    );
                    if (postFinder) {
                      postFinder(null, results, matcherOut, xml);
                    } else {
                      push.apply(results, matcherOut);
                    }
                  }
                });
              }

              function matcherFromTokens(tokens) {
                var checkContext, matcher, j,
                  len = tokens.length,
                  leadingRelative = Expr.relative[tokens[0].type],
                  implicitRelative = leadingRelative || Expr.relative[" "],
                  i = leadingRelative ? 1 : 0,

                  // The foundational matcher ensures that elements are reachable from top-level context(s)
                  matchContext = addCombinator(function (elem) {
                    return elem === checkContext;
                  }, implicitRelative, true),
                  matchAnyContext = addCombinator(function (elem) {
                    return indexOf(checkContext, elem) > -1;
                  }, implicitRelative, true),
                  matchers = [function (elem, context, xml) {
                    var ret = (!leadingRelative && (xml || context !== outermostContext)) || (
                      (checkContext = context).nodeType ?
                        matchContext(elem, context, xml) :
                        matchAnyContext(elem, context, xml));

                    // Avoid hanging onto element (issue #299)
                    checkContext = null;
                    return ret;
                  }];

                for (; i < len; i++) {
                  if ((matcher = Expr.relative[tokens[i].type])) {
                    matchers = [addCombinator(elementMatcher(matchers), matcher)];
                  } else {
                    matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);

                    // Return special upon seeing a positional matcher
                    if (matcher[expando]) {

                      // Find the next relative operator (if any) for proper handling
                      j = ++i;
                      for (; j < len; j++) {
                        if (Expr.relative[tokens[j].type]) {
                          break;
                        }
                      }
                      return setMatcher(
                        i > 1 && elementMatcher(matchers),
                        i > 1 && toSelector(

                          // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                          tokens
                            .slice(0, i - 1)
                            .concat({ value: tokens[i - 2].type === " " ? "*" : "" })
                        ).replace(rtrim, "$1"),
                        matcher,
                        i < j && matcherFromTokens(tokens.slice(i, j)),
                        j < len && matcherFromTokens((tokens = tokens.slice(j))),
                        j < len && toSelector(tokens)
                      );
                    }
                    matchers.push(matcher);
                  }
                }

                return elementMatcher(matchers);
              }

              function matcherFromGroupMatchers(elementMatchers, setMatchers) {
                var bySet = setMatchers.length > 0,
                  byElement = elementMatchers.length > 0,
                  superMatcher = function (seed, context, xml, results, outermost) {
                    var elem, j, matcher,
                      matchedCount = 0,
                      i = "0",
                      unmatched = seed && [],
                      setMatched = [],
                      contextBackup = outermostContext,

                      // We must always have either seed elements or outermost context
                      elems = seed || byElement && Expr.find["TAG"]("*", outermost),

                      // Use integer dirruns iff this is the outermost matcher
                      dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
                      len = elems.length;

                    if (outermost) {

                      // Support: IE 11+, Edge 17 - 18+
                      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                      // two documents; shallow comparisons work.
                      // eslint-disable-next-line eqeqeq
                      outermostContext = context == document || context || outermost;
                    }

                    // Add elements passing elementMatchers directly to results
                    // Support: IE<9, Safari
                    // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                    for (; i !== len && (elem = elems[i]) != null; i++) {
                      if (byElement && elem) {
                        j = 0;

                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                          setDocument(elem);
                          xml = !documentIsHTML;
                        }
                        while ((matcher = elementMatchers[j++])) {
                          if (matcher(elem, context || document, xml)) {
                            results.push(elem);
                            break;
                          }
                        }
                        if (outermost) {
                          dirruns = dirrunsUnique;
                        }
                      }

                      // Track unmatched elements for set filters
                      if (bySet) {

                        // They will have gone through all possible matchers
                        if ((elem = !matcher && elem)) {
                          matchedCount--;
                        }

                        // Lengthen the array for every element, matched or not
                        if (seed) {
                          unmatched.push(elem);
                        }
                      }
                    }

                    // `i` is now the count of elements visited above, and adding it to `matchedCount`
                    // makes the latter nonnegative.
                    matchedCount += i;

                    // Apply set filters to unmatched elements
                    // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                    // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                    // no element matchers and no seed.
                    // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                    // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                    // numerically zero.
                    if (bySet && i !== matchedCount) {
                      j = 0;
                      while ((matcher = setMatchers[j++])) {
                        matcher(unmatched, setMatched, context, xml);
                      }

                      if (seed) {

                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                          while (i--) {
                            if (!(unmatched[i] || setMatched[i])) {
                              setMatched[i] = pop.call(results);
                            }
                          }
                        }

                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                      }

                      // Add matches to results
                      push.apply(results, setMatched);

                      // Seedless set matches succeeding multiple successful matchers stipulate sorting
                      if (outermost && !seed && setMatched.length > 0 &&
                        (matchedCount + setMatchers.length) > 1) {

                        Sizzle.uniqueSort(results);
                      }
                    }

                    // Override manipulation of globals by nested matchers
                    if (outermost) {
                      dirruns = dirrunsUnique;
                      outermostContext = contextBackup;
                    }

                    return unmatched;
                  };

                return bySet ?
                  markFunction(superMatcher) :
                  superMatcher;
              }

              compile = Sizzle.compile = function (selector, match /* Internal Use Only */) {
                var i,
                  setMatchers = [],
                  elementMatchers = [],
                  cached = compilerCache[selector + " "];

                if (!cached) {

                  // Generate a function of recursive functions that can be used to check each element
                  if (!match) {
                    match = tokenize(selector);
                  }
                  i = match.length;
                  while (i--) {
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) {
                      setMatchers.push(cached);
                    } else {
                      elementMatchers.push(cached);
                    }
                  }

                  // Cache the compiled function
                  cached = compilerCache(
                    selector,
                    matcherFromGroupMatchers(elementMatchers, setMatchers)
                  );

                  // Save selector and tokenization
                  cached.selector = selector;
                }
                return cached;
              };

              /**
               * A low-level selection function that works with Sizzle's compiled
               *  selector functions
               * @param {String|Function} selector A selector or a pre-compiled
               *  selector function built with Sizzle.compile
               * @param {Element} context
               * @param {Array} [results]
               * @param {Array} [seed] A set of elements to match against
               */
              select = Sizzle.select = function (selector, context, results, seed) {
                var i, tokens, token, type, find,
                  compiled = typeof selector === "function" && selector,
                  match = !seed && tokenize((selector = compiled.selector || selector));

                results = results || [];

                // Try to minimize operations if there is only one selector in the list and no seed
                // (the latter of which guarantees us context)
                if (match.length === 1) {

                  // Reduce context if the leading compound selector is an ID
                  tokens = match[0] = match[0].slice(0);
                  if (tokens.length > 2 && (token = tokens[0]).type === "ID" &&
                    context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {

                    context = (Expr.find["ID"](token.matches[0]
                      .replace(runescape, funescape), context) || [])[0];
                    if (!context) {
                      return results;

                      // Precompiled matchers will still verify ancestry, so step up a level
                    } else if (compiled) {
                      context = context.parentNode;
                    }

                    selector = selector.slice(tokens.shift().value.length);
                  }

                  // Fetch a seed set for right-to-left matching
                  i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
                  while (i--) {
                    token = tokens[i];

                    // Abort if we hit a combinator
                    if (Expr.relative[(type = token.type)]) {
                      break;
                    }
                    if ((find = Expr.find[type])) {

                      // Search, expanding context for leading sibling combinators
                      if ((seed = find(
                        token.matches[0].replace(runescape, funescape),
                        rsibling.test(tokens[0].type) && testContext(context.parentNode) ||
                        context
                      ))) {

                        // If seed is empty or no tokens remain, we can return early
                        tokens.splice(i, 1);
                        selector = seed.length && toSelector(tokens);
                        if (!selector) {
                          push.apply(results, seed);
                          return results;
                        }

                        break;
                      }
                    }
                  }
                }

                // Compile and execute a filtering function if one is not provided
                // Provide `match` to avoid retokenization if we modified the selector above
                (compiled || compile(selector, match))(
                  seed,
                  context,
                  !documentIsHTML,
                  results,
                  !context || rsibling.test(selector) && testContext(context.parentNode) || context
                );
                return results;
              };

              // One-time assignments

              // Sort stability
              support.sortStable = expando.split("").sort(sortOrder).join("") === expando;

              // Support: Chrome 14-35+
              // Always assume duplicates if they aren't passed to the comparison function
              support.detectDuplicates = !!hasDuplicate;

              // Initialize against the default document
              setDocument();

              // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
              // Detached nodes confoundingly follow *each other*
              support.sortDetached = assert(function (el) {

                // Should return 1, but returns 4 (following)
                return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
              });

              // Support: IE<8
              // Prevent attribute/property "interpolation"
              // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
              if (!assert(function (el) {
                el.innerHTML = "<a href='#'></a>";
                return el.firstChild.getAttribute("href") === "#";
              })) {
                addHandle("type|href|height|width", function (elem, name, isXML) {
                  if (!isXML) {
                    return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
                  }
                });
              }

              // Support: IE<9
              // Use defaultValue in place of getAttribute("value")
              if (!support.attributes || !assert(function (el) {
                el.innerHTML = "<input/>";
                el.firstChild.setAttribute("value", "");
                return el.firstChild.getAttribute("value") === "";
              })) {
                addHandle("value", function (elem, _name, isXML) {
                  if (!isXML && elem.nodeName.toLowerCase() === "input") {
                    return elem.defaultValue;
                  }
                });
              }

              // Support: IE<9
              // Use getAttributeNode to fetch booleans when getAttribute lies
              if (!assert(function (el) {
                return el.getAttribute("disabled") == null;
              })) {
                addHandle(booleans, function (elem, name, isXML) {
                  var val;
                  if (!isXML) {
                    return elem[name] === true ? name.toLowerCase() :
                      (val = elem.getAttributeNode(name)) && val.specified ?
                        val.value :
                        null;
                  }
                });
              }

              return Sizzle;

            })(window);



          jQuery.find = Sizzle;
          jQuery.expr = Sizzle.selectors;

          // Deprecated
          jQuery.expr[":"] = jQuery.expr.pseudos;
          jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
          jQuery.text = Sizzle.getText;
          jQuery.isXMLDoc = Sizzle.isXML;
          jQuery.contains = Sizzle.contains;
          jQuery.escapeSelector = Sizzle.escape;




          var dir = function (elem, dir, until) {
            var matched = [],
              truncate = until !== undefined;

            while ((elem = elem[dir]) && elem.nodeType !== 9) {
              if (elem.nodeType === 1) {
                if (truncate && jQuery(elem).is(until)) {
                  break;
                }
                matched.push(elem);
              }
            }
            return matched;
          };


          var siblings = function (n, elem) {
            var matched = [];

            for (; n; n = n.nextSibling) {
              if (n.nodeType === 1 && n !== elem) {
                matched.push(n);
              }
            }

            return matched;
          };


          var rneedsContext = jQuery.expr.match.needsContext;



          function nodeName(elem, name) {

            return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

          }
          var rsingleTag = (/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i);



          // Implement the identical functionality for filter and not
          function winnow(elements, qualifier, not) {
            if (isFunction(qualifier)) {
              return jQuery.grep(elements, function (elem, i) {
                return !!qualifier.call(elem, i, elem) !== not;
              });
            }

            // Single element
            if (qualifier.nodeType) {
              return jQuery.grep(elements, function (elem) {
                return (elem === qualifier) !== not;
              });
            }

            // Arraylike of elements (jQuery, arguments, Array)
            if (typeof qualifier !== "string") {
              return jQuery.grep(elements, function (elem) {
                return (indexOf.call(qualifier, elem) > -1) !== not;
              });
            }

            // Filtered directly for both simple and complex selectors
            return jQuery.filter(qualifier, elements, not);
          }

          jQuery.filter = function (expr, elems, not) {
            var elem = elems[0];

            if (not) {
              expr = ":not(" + expr + ")";
            }

            if (elems.length === 1 && elem.nodeType === 1) {
              return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
            }

            return jQuery.find.matches(expr, jQuery.grep(elems, function (elem) {
              return elem.nodeType === 1;
            }));
          };

          jQuery.fn.extend({
            find: function (selector) {
              var i, ret,
                len = this.length,
                self = this;

              if (typeof selector !== "string") {
                return this.pushStack(jQuery(selector).filter(function () {
                  for (i = 0; i < len; i++) {
                    if (jQuery.contains(self[i], this)) {
                      return true;
                    }
                  }
                }));
              }

              ret = this.pushStack([]);

              for (i = 0; i < len; i++) {
                jQuery.find(selector, self[i], ret);
              }

              return len > 1 ? jQuery.uniqueSort(ret) : ret;
            },
            filter: function (selector) {
              return this.pushStack(winnow(this, selector || [], false));
            },
            not: function (selector) {
              return this.pushStack(winnow(this, selector || [], true));
            },
            is: function (selector) {
              return !!winnow(
                this,

                // If this is a positional/relative selector, check membership in the returned set
                // so $("p:first").is("p:last") won't return true for a doc with two "p".
                typeof selector === "string" && rneedsContext.test(selector) ?
                  jQuery(selector) :
                  selector || [],
                false
              ).length;
            }
          });


          // Initialize a jQuery object


          // A central reference to the root jQuery(document)
          var rootjQuery,

            // A simple way to check for HTML strings
            // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
            // Strict HTML recognition (#11290: must start with <)
            // Shortcut simple #id case for speed
            rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

            init = jQuery.fn.init = function (selector, context, root) {
              var match, elem;

              // HANDLE: $(""), $(null), $(undefined), $(false)
              if (!selector) {
                return this;
              }

              // Method init() accepts an alternate rootjQuery
              // so migrate can support jQuery.sub (gh-2101)
              root = root || rootjQuery;

              // Handle HTML strings
              if (typeof selector === "string") {
                if (selector[0] === "<" &&
                  selector[selector.length - 1] === ">" &&
                  selector.length >= 3) {

                  // Assume that strings that start and end with <> are HTML and skip the regex check
                  match = [null, selector, null];

                } else {
                  match = rquickExpr.exec(selector);
                }

                // Match html or make sure no context is specified for #id
                if (match && (match[1] || !context)) {

                  // HANDLE: $(html) -> $(array)
                  if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;

                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(
                      match[1],
                      context && context.nodeType ? context.ownerDocument || context : document,
                      true
                    ));

                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                      for (match in context) {

                        // Properties of context are called as methods if possible
                        if (isFunction(this[match])) {
                          this[match](context[match]);

                          // ...and otherwise set as attributes
                        } else {
                          this.attr(match, context[match]);
                        }
                      }
                    }

                    return this;

                    // HANDLE: $(#id)
                  } else {
                    elem = document.getElementById(match[2]);

                    if (elem) {

                      // Inject the element directly into the jQuery object
                      this[0] = elem;
                      this.length = 1;
                    }
                    return this;
                  }

                  // HANDLE: $(expr, $(...))
                } else if (!context || context.jquery) {
                  return (context || root).find(selector);

                  // HANDLE: $(expr, context)
                  // (which is just equivalent to: $(context).find(expr)
                } else {
                  return this.constructor(context).find(selector);
                }

                // HANDLE: $(DOMElement)
              } else if (selector.nodeType) {
                this[0] = selector;
                this.length = 1;
                return this;

                // HANDLE: $(function)
                // Shortcut for document ready
              } else if (isFunction(selector)) {
                return root.ready !== undefined ?
                  root.ready(selector) :

                  // Execute immediately if ready is not present
                  selector(jQuery);
              }

              return jQuery.makeArray(selector, this);
            };

          // Give the init function the jQuery prototype for later instantiation
          init.prototype = jQuery.fn;

          // Initialize central reference
          rootjQuery = jQuery(document);


          var rparentsprev = /^(?:parents|prev(?:Until|All))/,

            // Methods guaranteed to produce a unique set when starting from a unique set
            guaranteedUnique = {
              children: true,
              contents: true,
              next: true,
              prev: true
            };

          jQuery.fn.extend({
            has: function (target) {
              var targets = jQuery(target, this),
                l = targets.length;

              return this.filter(function () {
                var i = 0;
                for (; i < l; i++) {
                  if (jQuery.contains(this, targets[i])) {
                    return true;
                  }
                }
              });
            },

            closest: function (selectors, context) {
              var cur,
                i = 0,
                l = this.length,
                matched = [],
                targets = typeof selectors !== "string" && jQuery(selectors);

              // Positional selectors never match, since there's no _selection_ context
              if (!rneedsContext.test(selectors)) {
                for (; i < l; i++) {
                  for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {

                    // Always skip document fragments
                    if (cur.nodeType < 11 && (targets ?
                      targets.index(cur) > -1 :

                      // Don't pass non-elements to Sizzle
                      cur.nodeType === 1 &&
                      jQuery.find.matchesSelector(cur, selectors))) {

                      matched.push(cur);
                      break;
                    }
                  }
                }
              }

              return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
            },

            // Determine the position of an element within the set
            index: function (elem) {

              // No argument, return index in parent
              if (!elem) {
                return (this[0] && this[0].parentNode) ? this.first().prevAll().length : -1;
              }

              // Index in selector
              if (typeof elem === "string") {
                return indexOf.call(jQuery(elem), this[0]);
              }

              // Locate the position of the desired element
              return indexOf.call(this,

                // If it receives a jQuery object, the first element is used
                elem.jquery ? elem[0] : elem
              );
            },

            add: function (selector, context) {
              return this.pushStack(
                jQuery.uniqueSort(
                  jQuery.merge(this.get(), jQuery(selector, context))
                )
              );
            },

            addBack: function (selector) {
              return this.add(selector == null ?
                this.prevObject : this.prevObject.filter(selector)
              );
            }
          });

          function sibling(cur, dir) {
            while ((cur = cur[dir]) && cur.nodeType !== 1) { }
            return cur;
          }

          jQuery.each({
            parent: function (elem) {
              var parent = elem.parentNode;
              return parent && parent.nodeType !== 11 ? parent : null;
            },
            parents: function (elem) {
              return dir(elem, "parentNode");
            },
            parentsUntil: function (elem, _i, until) {
              return dir(elem, "parentNode", until);
            },
            next: function (elem) {
              return sibling(elem, "nextSibling");
            },
            prev: function (elem) {
              return sibling(elem, "previousSibling");
            },
            nextAll: function (elem) {
              return dir(elem, "nextSibling");
            },
            prevAll: function (elem) {
              return dir(elem, "previousSibling");
            },
            nextUntil: function (elem, _i, until) {
              return dir(elem, "nextSibling", until);
            },
            prevUntil: function (elem, _i, until) {
              return dir(elem, "previousSibling", until);
            },
            siblings: function (elem) {
              return siblings((elem.parentNode || {}).firstChild, elem);
            },
            children: function (elem) {
              return siblings(elem.firstChild);
            },
            contents: function (elem) {
              if (elem.contentDocument != null &&

                // Support: IE 11+
                // <object> elements with no `data` attribute has an object
                // `contentDocument` with a `null` prototype.
                getProto(elem.contentDocument)) {

                return elem.contentDocument;
              }

              // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
              // Treat the template element as a regular one in browsers that
              // don't support it.
              if (nodeName(elem, "template")) {
                elem = elem.content || elem;
              }

              return jQuery.merge([], elem.childNodes);
            }
          }, function (name, fn) {
            jQuery.fn[name] = function (until, selector) {
              var matched = jQuery.map(this, fn, until);

              if (name.slice(-5) !== "Until") {
                selector = until;
              }

              if (selector && typeof selector === "string") {
                matched = jQuery.filter(selector, matched);
              }

              if (this.length > 1) {

                // Remove duplicates
                if (!guaranteedUnique[name]) {
                  jQuery.uniqueSort(matched);
                }

                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) {
                  matched.reverse();
                }
              }

              return this.pushStack(matched);
            };
          });
          var rnothtmlwhite = (/[^\x20\t\r\n\f]+/g);



          // Convert String-formatted options into Object-formatted ones
          function createOptions(options) {
            var object = {};
            jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
              object[flag] = true;
            });
            return object;
          }

          /*
           * Create a callback list using the following parameters:
           *
           *	options: an optional list of space-separated options that will change how
           *			the callback list behaves or a more traditional option object
           *
           * By default a callback list will act like an event callback list and can be
           * "fired" multiple times.
           *
           * Possible options:
           *
           *	once:			will ensure the callback list can only be fired once (like a Deferred)
           *
           *	memory:			will keep track of previous values and will call any callback added
           *					after the list has been fired right away with the latest "memorized"
           *					values (like a Deferred)
           *
           *	unique:			will ensure a callback can only be added once (no duplicate in the list)
           *
           *	stopOnFalse:	interrupt callings when a callback returns false
           *
           */
          jQuery.Callbacks = function (options) {

            // Convert options from String-formatted to Object-formatted if needed
            // (we check in cache first)
            options = typeof options === "string" ?
              createOptions(options) :
              jQuery.extend({}, options);

            var // Flag to know if list is currently firing
              firing,

              // Last fire value for non-forgettable lists
              memory,

              // Flag to know if list was already fired
              fired,

              // Flag to prevent firing
              locked,

              // Actual callback list
              list = [],

              // Queue of execution data for repeatable lists
              queue = [],

              // Index of currently firing callback (modified by add/remove as needed)
              firingIndex = -1,

              // Fire callbacks
              fire = function () {

                // Enforce single-firing
                locked = locked || options.once;

                // Execute callbacks for all pending executions,
                // respecting firingIndex overrides and runtime changes
                fired = firing = true;
                for (; queue.length; firingIndex = -1) {
                  memory = queue.shift();
                  while (++firingIndex < list.length) {

                    // Run callback and check for early termination
                    if (list[firingIndex].apply(memory[0], memory[1]) === false &&
                      options.stopOnFalse) {

                      // Jump to end and forget the data so .add doesn't re-fire
                      firingIndex = list.length;
                      memory = false;
                    }
                  }
                }

                // Forget the data if we're done with it
                if (!options.memory) {
                  memory = false;
                }

                firing = false;

                // Clean up if we're done firing for good
                if (locked) {

                  // Keep an empty list if we have data for future add calls
                  if (memory) {
                    list = [];

                    // Otherwise, this object is spent
                  } else {
                    list = "";
                  }
                }
              },

              // Actual Callbacks object
              self = {

                // Add a callback or a collection of callbacks to the list
                add: function () {
                  if (list) {

                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                      firingIndex = list.length - 1;
                      queue.push(memory);
                    }

                    (function add(args) {
                      jQuery.each(args, function (_, arg) {
                        if (isFunction(arg)) {
                          if (!options.unique || !self.has(arg)) {
                            list.push(arg);
                          }
                        } else if (arg && arg.length && toType(arg) !== "string") {

                          // Inspect recursively
                          add(arg);
                        }
                      });
                    })(arguments);

                    if (memory && !firing) {
                      fire();
                    }
                  }
                  return this;
                },

                // Remove a callback from the list
                remove: function () {
                  jQuery.each(arguments, function (_, arg) {
                    var index;
                    while ((index = jQuery.inArray(arg, list, index)) > -1) {
                      list.splice(index, 1);

                      // Handle firing indexes
                      if (index <= firingIndex) {
                        firingIndex--;
                      }
                    }
                  });
                  return this;
                },

                // Check if a given callback is in the list.
                // If no argument is given, return whether or not list has callbacks attached.
                has: function (fn) {
                  return fn ?
                    jQuery.inArray(fn, list) > -1 :
                    list.length > 0;
                },

                // Remove all callbacks from the list
                empty: function () {
                  if (list) {
                    list = [];
                  }
                  return this;
                },

                // Disable .fire and .add
                // Abort any current/pending executions
                // Clear all callbacks and values
                disable: function () {
                  locked = queue = [];
                  list = memory = "";
                  return this;
                },
                disabled: function () {
                  return !list;
                },

                // Disable .fire
                // Also disable .add unless we have memory (since it would have no effect)
                // Abort any pending executions
                lock: function () {
                  locked = queue = [];
                  if (!memory && !firing) {
                    list = memory = "";
                  }
                  return this;
                },
                locked: function () {
                  return !!locked;
                },

                // Call all callbacks with the given context and arguments
                fireWith: function (context, args) {
                  if (!locked) {
                    args = args || [];
                    args = [context, args.slice ? args.slice() : args];
                    queue.push(args);
                    if (!firing) {
                      fire();
                    }
                  }
                  return this;
                },

                // Call all the callbacks with the given arguments
                fire: function () {
                  self.fireWith(this, arguments);
                  return this;
                },

                // To know if the callbacks have already been called at least once
                fired: function () {
                  return !!fired;
                }
              };

            return self;
          };


          function Identity(v) {
            return v;
          }
          function Thrower(ex) {
            throw ex;
          }

          function adoptValue(value, resolve, reject, noValue) {
            var method;

            try {

              // Check for promise aspect first to privilege synchronous behavior
              if (value && isFunction((method = value.promise))) {
                method.call(value).done(resolve).fail(reject);

                // Other thenables
              } else if (value && isFunction((method = value.then))) {
                method.call(value, resolve, reject);

                // Other non-thenables
              } else {

                // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
                // * false: [ value ].slice( 0 ) => resolve( value )
                // * true: [ value ].slice( 1 ) => resolve()
                resolve.apply(undefined, [value].slice(noValue));
              }

              // For Promises/A+, convert exceptions into rejections
              // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
              // Deferred#then to conditionally suppress rejection.
            } catch (value) {

              // Support: Android 4.0 only
              // Strict mode functions invoked without .call/.apply get global-object context
              reject.apply(undefined, [value]);
            }
          }

          jQuery.extend({

            Deferred: function (func) {
              var tuples = [

                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                ["notify", "progress", jQuery.Callbacks("memory"),
                  jQuery.Callbacks("memory"), 2],
                ["resolve", "done", jQuery.Callbacks("once memory"),
                  jQuery.Callbacks("once memory"), 0, "resolved"],
                ["reject", "fail", jQuery.Callbacks("once memory"),
                  jQuery.Callbacks("once memory"), 1, "rejected"]
              ],
                state = "pending",
                promise = {
                  state: function () {
                    return state;
                  },
                  always: function () {
                    deferred.done(arguments).fail(arguments);
                    return this;
                  },
                  "catch": function (fn) {
                    return promise.then(null, fn);
                  },

                  // Keep pipe for back-compat
                  pipe: function ( /* fnDone, fnFail, fnProgress */) {
                    var fns = arguments;

                    return jQuery.Deferred(function (newDefer) {
                      jQuery.each(tuples, function (_i, tuple) {

                        // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                        var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];

                        // deferred.progress(function() { bind to newDefer or newDefer.notify })
                        // deferred.done(function() { bind to newDefer or newDefer.resolve })
                        // deferred.fail(function() { bind to newDefer or newDefer.reject })
                        deferred[tuple[1]](function () {
                          var returned = fn && fn.apply(this, arguments);
                          if (returned && isFunction(returned.promise)) {
                            returned.promise()
                              .progress(newDefer.notify)
                              .done(newDefer.resolve)
                              .fail(newDefer.reject);
                          } else {
                            newDefer[tuple[0] + "With"](
                              this,
                              fn ? [returned] : arguments
                            );
                          }
                        });
                      });
                      fns = null;
                    }).promise();
                  },
                  then: function (onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                      return function () {
                        var that = this,
                          args = arguments,
                          mightThrow = function () {
                            var returned, then;

                            // Support: Promises/A+ section 2.3.3.3.3
                            // https://promisesaplus.com/#point-59
                            // Ignore double-resolution attempts
                            if (depth < maxDepth) {
                              return;
                            }

                            returned = handler.apply(that, args);

                            // Support: Promises/A+ section 2.3.1
                            // https://promisesaplus.com/#point-48
                            if (returned === deferred.promise()) {
                              throw new TypeError("Thenable self-resolution");
                            }

                            // Support: Promises/A+ sections 2.3.3.1, 3.5
                            // https://promisesaplus.com/#point-54
                            // https://promisesaplus.com/#point-75
                            // Retrieve `then` only once
                            then = returned &&

                              // Support: Promises/A+ section 2.3.4
                              // https://promisesaplus.com/#point-64
                              // Only check objects and functions for thenability
                              (typeof returned === "object" ||
                                typeof returned === "function") &&
                              returned.then;

                            // Handle a returned thenable
                            if (isFunction(then)) {

                              // Special processors (notify) just wait for resolution
                              if (special) {
                                then.call(
                                  returned,
                                  resolve(maxDepth, deferred, Identity, special),
                                  resolve(maxDepth, deferred, Thrower, special)
                                );

                                // Normal processors (resolve) also hook into progress
                              } else {

                                // ...and disregard older resolution values
                                maxDepth++;

                                then.call(
                                  returned,
                                  resolve(maxDepth, deferred, Identity, special),
                                  resolve(maxDepth, deferred, Thrower, special),
                                  resolve(maxDepth, deferred, Identity,
                                    deferred.notifyWith)
                                );
                              }

                              // Handle all other returned values
                            } else {

                              // Only substitute handlers pass on context
                              // and multiple values (non-spec behavior)
                              if (handler !== Identity) {
                                that = undefined;
                                args = [returned];
                              }

                              // Process the value(s)
                              // Default process is resolve
                              (special || deferred.resolveWith)(that, args);
                            }
                          },

                          // Only normal processors (resolve) catch and reject exceptions
                          process = special ?
                            mightThrow :
                            function () {
                              try {
                                mightThrow();
                              } catch (e) {

                                if (jQuery.Deferred.exceptionHook) {
                                  jQuery.Deferred.exceptionHook(e,
                                    process.stackTrace);
                                }

                                // Support: Promises/A+ section 2.3.3.3.4.1
                                // https://promisesaplus.com/#point-61
                                // Ignore post-resolution exceptions
                                if (depth + 1 >= maxDepth) {

                                  // Only substitute handlers pass on context
                                  // and multiple values (non-spec behavior)
                                  if (handler !== Thrower) {
                                    that = undefined;
                                    args = [e];
                                  }

                                  deferred.rejectWith(that, args);
                                }
                              }
                            };

                        // Support: Promises/A+ section 2.3.3.3.1
                        // https://promisesaplus.com/#point-57
                        // Re-resolve promises immediately to dodge false rejection from
                        // subsequent errors
                        if (depth) {
                          process();
                        } else {

                          // Call an optional hook to record the stack, in case of exception
                          // since it's otherwise lost when execution goes async
                          if (jQuery.Deferred.getStackHook) {
                            process.stackTrace = jQuery.Deferred.getStackHook();
                          }
                          window.setTimeout(process);
                        }
                      };
                    }

                    return jQuery.Deferred(function (newDefer) {

                      // progress_handlers.add( ... )
                      tuples[0][3].add(
                        resolve(
                          0,
                          newDefer,
                          isFunction(onProgress) ?
                            onProgress :
                            Identity,
                          newDefer.notifyWith
                        )
                      );

                      // fulfilled_handlers.add( ... )
                      tuples[1][3].add(
                        resolve(
                          0,
                          newDefer,
                          isFunction(onFulfilled) ?
                            onFulfilled :
                            Identity
                        )
                      );

                      // rejected_handlers.add( ... )
                      tuples[2][3].add(
                        resolve(
                          0,
                          newDefer,
                          isFunction(onRejected) ?
                            onRejected :
                            Thrower
                        )
                      );
                    }).promise();
                  },

                  // Get a promise for this deferred
                  // If obj is provided, the promise aspect is added to the object
                  promise: function (obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                  }
                },
                deferred = {};

              // Add list-specific methods
              jQuery.each(tuples, function (i, tuple) {
                var list = tuple[2],
                  stateString = tuple[5];

                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;

                // Handle state
                if (stateString) {
                  list.add(
                    function () {

                      // state = "resolved" (i.e., fulfilled)
                      // state = "rejected"
                      state = stateString;
                    },

                    // rejected_callbacks.disable
                    // fulfilled_callbacks.disable
                    tuples[3 - i][2].disable,

                    // rejected_handlers.disable
                    // fulfilled_handlers.disable
                    tuples[3 - i][3].disable,

                    // progress_callbacks.lock
                    tuples[0][2].lock,

                    // progress_handlers.lock
                    tuples[0][3].lock
                  );
                }

                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);

                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function () {
                  deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                  return this;
                };

                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
              });

              // Make the deferred a promise
              promise.promise(deferred);

              // Call given func if any
              if (func) {
                func.call(deferred, deferred);
              }

              // All done!
              return deferred;
            },

            // Deferred helper
            when: function (singleValue) {
              var

                // count of uncompleted subordinates
                remaining = arguments.length,

                // count of unprocessed arguments
                i = remaining,

                // subordinate fulfillment data
                resolveContexts = Array(i),
                resolveValues = slice.call(arguments),

                // the primary Deferred
                primary = jQuery.Deferred(),

                // subordinate callback factory
                updateFunc = function (i) {
                  return function (value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!(--remaining)) {
                      primary.resolveWith(resolveContexts, resolveValues);
                    }
                  };
                };

              // Single- and empty arguments are adopted like Promise.resolve
              if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject,
                  !remaining);

                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" ||
                  isFunction(resolveValues[i] && resolveValues[i].then)) {

                  return primary.then();
                }
              }

              // Multiple arguments are aggregated like Promise.all array elements
              while (i--) {
                adoptValue(resolveValues[i], updateFunc(i), primary.reject);
              }

              return primary.promise();
            }
          });


          // These usually indicate a programmer mistake during development,
          // warn about them ASAP rather than swallowing them by default.
          var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

          jQuery.Deferred.exceptionHook = function (error, stack) {

            // Support: IE 8 - 9 only
            // Console exists when dev tools are open, which can happen at any time
            if (window.console && window.console.warn && error && rerrorNames.test(error.name)) {
              window.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
            }
          };




          jQuery.readyException = function (error) {
            window.setTimeout(function () {
              throw error;
            });
          };




          // The deferred used on DOM ready
          var readyList = jQuery.Deferred();

          jQuery.fn.ready = function (fn) {

            readyList
              .then(fn)

              // Wrap jQuery.readyException in a function so that the lookup
              // happens at the time of error handling instead of callback
              // registration.
              .catch(function (error) {
                jQuery.readyException(error);
              });

            return this;
          };

          jQuery.extend({

            // Is the DOM ready to be used? Set to true once it occurs.
            isReady: false,

            // A counter to track how many items to wait for before
            // the ready event fires. See #6781
            readyWait: 1,

            // Handle when the DOM is ready
            ready: function (wait) {

              // Abort if there are pending holds or we're already ready
              if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
                return;
              }

              // Remember that the DOM is ready
              jQuery.isReady = true;

              // If a normal DOM Ready event fired, decrement, and wait if need be
              if (wait !== true && --jQuery.readyWait > 0) {
                return;
              }

              // If there are functions bound, to execute
              readyList.resolveWith(document, [jQuery]);
            }
          });

          jQuery.ready.then = readyList.then;

          // The ready event handler and self cleanup method
          function completed() {
            document.removeEventListener("DOMContentLoaded", completed);
            window.removeEventListener("load", completed);
            jQuery.ready();
          }

          // Catch cases where $(document).ready() is called
          // after the browser event has already occurred.
          // Support: IE <=9 - 10 only
          // Older IE sometimes signals "interactive" too soon
          if (document.readyState === "complete" ||
            (document.readyState !== "loading" && !document.documentElement.doScroll)) {

            // Handle it asynchronously to allow scripts the opportunity to delay ready
            window.setTimeout(jQuery.ready);

          } else {

            // Use the handy event callback
            document.addEventListener("DOMContentLoaded", completed);

            // A fallback to window.onload, that will always work
            window.addEventListener("load", completed);
          }




          // Multifunctional method to get and set values of a collection
          // The value/s can optionally be executed if it's a function
          var access = function (elems, fn, key, value, chainable, emptyGet, raw) {
            var i = 0,
              len = elems.length,
              bulk = key == null;

            // Sets many values
            if (toType(key) === "object") {
              chainable = true;
              for (i in key) {
                access(elems, fn, i, key[i], true, emptyGet, raw);
              }

              // Sets one value
            } else if (value !== undefined) {
              chainable = true;

              if (!isFunction(value)) {
                raw = true;
              }

              if (bulk) {

                // Bulk operations run against the entire set
                if (raw) {
                  fn.call(elems, value);
                  fn = null;

                  // ...except when executing function values
                } else {
                  bulk = fn;
                  fn = function (elem, _key, value) {
                    return bulk.call(jQuery(elem), value);
                  };
                }
              }

              if (fn) {
                for (; i < len; i++) {
                  fn(
                    elems[i], key, raw ?
                    value :
                    value.call(elems[i], i, fn(elems[i], key))
                  );
                }
              }
            }

            if (chainable) {
              return elems;
            }

            // Gets
            if (bulk) {
              return fn.call(elems);
            }

            return len ? fn(elems[0], key) : emptyGet;
          };


          // Matches dashed string for camelizing
          var rmsPrefix = /^-ms-/,
            rdashAlpha = /-([a-z])/g;

          // Used by camelCase as callback to replace()
          function fcamelCase(_all, letter) {
            return letter.toUpperCase();
          }

          // Convert dashed to camelCase; used by the css and data modules
          // Support: IE <=9 - 11, Edge 12 - 15
          // Microsoft forgot to hump their vendor prefix (#9572)
          function camelCase(string) {
            return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
          }
          var acceptData = function (owner) {

            // Accepts only:
            //  - Node
            //    - Node.ELEMENT_NODE
            //    - Node.DOCUMENT_NODE
            //  - Object
            //    - Any
            return owner.nodeType === 1 || owner.nodeType === 9 || !(+owner.nodeType);
          };




          function Data() {
            this.expando = jQuery.expando + Data.uid++;
          }

          Data.uid = 1;

          Data.prototype = {

            cache: function (owner) {

              // Check if the owner object already has a cache
              var value = owner[this.expando];

              // If not, create one
              if (!value) {
                value = {};

                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see #8335.
                // Always return an empty object.
                if (acceptData(owner)) {

                  // If it is a node unlikely to be stringify-ed or looped over
                  // use plain assignment
                  if (owner.nodeType) {
                    owner[this.expando] = value;

                    // Otherwise secure it in a non-enumerable property
                    // configurable must be true to allow the property to be
                    // deleted when data is removed
                  } else {
                    Object.defineProperty(owner, this.expando, {
                      value: value,
                      configurable: true
                    });
                  }
                }
              }

              return value;
            },
            set: function (owner, data, value) {
              var prop,
                cache = this.cache(owner);

              // Handle: [ owner, key, value ] args
              // Always use camelCase key (gh-2257)
              if (typeof data === "string") {
                cache[camelCase(data)] = value;

                // Handle: [ owner, { properties } ] args
              } else {

                // Copy the properties one-by-one to the cache object
                for (prop in data) {
                  cache[camelCase(prop)] = data[prop];
                }
              }
              return cache;
            },
            get: function (owner, key) {
              return key === undefined ?
                this.cache(owner) :

                // Always use camelCase key (gh-2257)
                owner[this.expando] && owner[this.expando][camelCase(key)];
            },
            access: function (owner, key, value) {

              // In cases where either:
              //
              //   1. No key was specified
              //   2. A string key was specified, but no value provided
              //
              // Take the "read" path and allow the get method to determine
              // which value to return, respectively either:
              //
              //   1. The entire cache object
              //   2. The data stored at the key
              //
              if (key === undefined ||
                ((key && typeof key === "string") && value === undefined)) {

                return this.get(owner, key);
              }

              // When the key is not a string, or both a key and value
              // are specified, set or extend (existing objects) with either:
              //
              //   1. An object of properties
              //   2. A key and value
              //
              this.set(owner, key, value);

              // Since the "set" path can have two possible entry points
              // return the expected data based on which path was taken[*]
              return value !== undefined ? value : key;
            },
            remove: function (owner, key) {
              var i,
                cache = owner[this.expando];

              if (cache === undefined) {
                return;
              }

              if (key !== undefined) {

                // Support array or space separated string of keys
                if (Array.isArray(key)) {

                  // If key is an array of keys...
                  // We always set camelCase keys, so remove that.
                  key = key.map(camelCase);
                } else {
                  key = camelCase(key);

                  // If a key with the spaces exists, use it.
                  // Otherwise, create an array by matching non-whitespace
                  key = key in cache ?
                    [key] :
                    (key.match(rnothtmlwhite) || []);
                }

                i = key.length;

                while (i--) {
                  delete cache[key[i]];
                }
              }

              // Remove the expando if there's no more data
              if (key === undefined || jQuery.isEmptyObject(cache)) {

                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) {
                  owner[this.expando] = undefined;
                } else {
                  delete owner[this.expando];
                }
              }
            },
            hasData: function (owner) {
              var cache = owner[this.expando];
              return cache !== undefined && !jQuery.isEmptyObject(cache);
            }
          };
          var dataPriv = new Data();

          var dataUser = new Data();



          //	Implementation Summary
          //
          //	1. Enforce API surface and semantic compatibility with 1.9.x branch
          //	2. Improve the module's maintainability by reducing the storage
          //		paths to a single mechanism.
          //	3. Use the same single mechanism to support "private" and "user" data.
          //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
          //	5. Avoid exposing implementation details on user objects (eg. expando properties)
          //	6. Provide a clear path for implementation upgrade to WeakMap in 2014

          var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            rmultiDash = /[A-Z]/g;

          function getData(data) {
            if (data === "true") {
              return true;
            }

            if (data === "false") {
              return false;
            }

            if (data === "null") {
              return null;
            }

            // Only convert to a number if it doesn't change the string
            if (data === +data + "") {
              return +data;
            }

            if (rbrace.test(data)) {
              return JSON.parse(data);
            }

            return data;
          }

          function dataAttr(elem, key, data) {
            var name;

            // If nothing was found internally, try to fetch any
            // data from the HTML5 data-* attribute
            if (data === undefined && elem.nodeType === 1) {
              name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
              data = elem.getAttribute(name);

              if (typeof data === "string") {
                try {
                  data = getData(data);
                } catch (e) { }

                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
              } else {
                data = undefined;
              }
            }
            return data;
          }

          jQuery.extend({
            hasData: function (elem) {
              return dataUser.hasData(elem) || dataPriv.hasData(elem);
            },

            data: function (elem, name, data) {
              return dataUser.access(elem, name, data);
            },

            removeData: function (elem, name) {
              dataUser.remove(elem, name);
            },

            // TODO: Now that all calls to _data and _removeData have been replaced
            // with direct calls to dataPriv methods, these can be deprecated.
            _data: function (elem, name, data) {
              return dataPriv.access(elem, name, data);
            },

            _removeData: function (elem, name) {
              dataPriv.remove(elem, name);
            }
          });

          jQuery.fn.extend({
            data: function (key, value) {
              var i, name, data,
                elem = this[0],
                attrs = elem && elem.attributes;

              // Gets all values
              if (key === undefined) {
                if (this.length) {
                  data = dataUser.get(elem);

                  if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                    i = attrs.length;
                    while (i--) {

                      // Support: IE 11 only
                      // The attrs elements can be null (#14894)
                      if (attrs[i]) {
                        name = attrs[i].name;
                        if (name.indexOf("data-") === 0) {
                          name = camelCase(name.slice(5));
                          dataAttr(elem, name, data[name]);
                        }
                      }
                    }
                    dataPriv.set(elem, "hasDataAttrs", true);
                  }
                }

                return data;
              }

              // Sets multiple values
              if (typeof key === "object") {
                return this.each(function () {
                  dataUser.set(this, key);
                });
              }

              return access(this, function (value) {
                var data;

                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {

                  // Attempt to get data from the cache
                  // The key will always be camelCased in Data
                  data = dataUser.get(elem, key);
                  if (data !== undefined) {
                    return data;
                  }

                  // Attempt to "discover" the data in
                  // HTML5 custom data-* attrs
                  data = dataAttr(elem, key);
                  if (data !== undefined) {
                    return data;
                  }

                  // We tried really hard, but the data doesn't exist.
                  return;
                }

                // Set the data...
                this.each(function () {

                  // We always store the camelCased key
                  dataUser.set(this, key, value);
                });
              }, null, value, arguments.length > 1, null, true);
            },

            removeData: function (key) {
              return this.each(function () {
                dataUser.remove(this, key);
              });
            }
          });


          jQuery.extend({
            queue: function (elem, type, data) {
              var queue;

              if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);

                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                  if (!queue || Array.isArray(data)) {
                    queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                  } else {
                    queue.push(data);
                  }
                }
                return queue || [];
              }
            },

            dequeue: function (elem, type) {
              type = type || "fx";

              var queue = jQuery.queue(elem, type),
                startLength = queue.length,
                fn = queue.shift(),
                hooks = jQuery._queueHooks(elem, type),
                next = function () {
                  jQuery.dequeue(elem, type);
                };

              // If the fx queue is dequeued, always remove the progress sentinel
              if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
              }

              if (fn) {

                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") {
                  queue.unshift("inprogress");
                }

                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
              }

              if (!startLength && hooks) {
                hooks.empty.fire();
              }
            },

            // Not public - generate a queueHooks object, or return the current one
            _queueHooks: function (elem, type) {
              var key = type + "queueHooks";
              return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function () {
                  dataPriv.remove(elem, [type + "queue", key]);
                })
              });
            }
          });

          jQuery.fn.extend({
            queue: function (type, data) {
              var setter = 2;

              if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
              }

              if (arguments.length < setter) {
                return jQuery.queue(this[0], type);
              }

              return data === undefined ?
                this :
                this.each(function () {
                  var queue = jQuery.queue(this, type, data);

                  // Ensure a hooks for this queue
                  jQuery._queueHooks(this, type);

                  if (type === "fx" && queue[0] !== "inprogress") {
                    jQuery.dequeue(this, type);
                  }
                });
            },
            dequeue: function (type) {
              return this.each(function () {
                jQuery.dequeue(this, type);
              });
            },
            clearQueue: function (type) {
              return this.queue(type || "fx", []);
            },

            // Get a promise resolved when queues of a certain type
            // are emptied (fx is the type by default)
            promise: function (type, obj) {
              var tmp,
                count = 1,
                defer = jQuery.Deferred(),
                elements = this,
                i = this.length,
                resolve = function () {
                  if (!(--count)) {
                    defer.resolveWith(elements, [elements]);
                  }
                };

              if (typeof type !== "string") {
                obj = type;
                type = undefined;
              }
              type = type || "fx";

              while (i--) {
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                  count++;
                  tmp.empty.add(resolve);
                }
              }
              resolve();
              return defer.promise(obj);
            }
          });
          var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;

          var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");


          var cssExpand = ["Top", "Right", "Bottom", "Left"];

          var documentElement = document.documentElement;



          var isAttached = function (elem) {
            return jQuery.contains(elem.ownerDocument, elem);
          },
            composed = { composed: true };

          // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
          // Check attachment across shadow DOM boundaries when possible (gh-3504)
          // Support: iOS 10.0-10.2 only
          // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
          // leading to errors. We need to check for `getRootNode`.
          if (documentElement.getRootNode) {
            isAttached = function (elem) {
              return jQuery.contains(elem.ownerDocument, elem) ||
                elem.getRootNode(composed) === elem.ownerDocument;
            };
          }
          var isHiddenWithinTree = function (elem, el) {

            // isHiddenWithinTree might be called from jQuery#filter function;
            // in that case, element will be second argument
            elem = el || elem;

            // Inline style trumps all
            return elem.style.display === "none" ||
              elem.style.display === "" &&

              // Otherwise, check computed style
              // Support: Firefox <=43 - 45
              // Disconnected elements can have computed display: none, so first confirm that elem is
              // in the document.
              isAttached(elem) &&

              jQuery.css(elem, "display") === "none";
          };



          function adjustCSS(elem, prop, valueParts, tween) {
            var adjusted, scale,
              maxIterations = 20,
              currentValue = tween ?
                function () {
                  return tween.cur();
                } :
                function () {
                  return jQuery.css(elem, prop, "");
                },
              initial = currentValue(),
              unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"),

              // Starting value computation is required for potential unit mismatches
              initialInUnit = elem.nodeType &&
                (jQuery.cssNumber[prop] || unit !== "px" && +initial) &&
                rcssNum.exec(jQuery.css(elem, prop));

            if (initialInUnit && initialInUnit[3] !== unit) {

              // Support: Firefox <=54
              // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
              initial = initial / 2;

              // Trust units reported by jQuery.css
              unit = unit || initialInUnit[3];

              // Iteratively approximate from a nonzero starting point
              initialInUnit = +initial || 1;

              while (maxIterations--) {

                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
                  maxIterations = 0;
                }
                initialInUnit = initialInUnit / scale;

              }

              initialInUnit = initialInUnit * 2;
              jQuery.style(elem, prop, initialInUnit + unit);

              // Make sure we update the tween properties later on
              valueParts = valueParts || [];
            }

            if (valueParts) {
              initialInUnit = +initialInUnit || +initial || 0;

              // Apply relative offset (+=/-=) if specified
              adjusted = valueParts[1] ?
                initialInUnit + (valueParts[1] + 1) * valueParts[2] :
                +valueParts[2];
              if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
              }
            }
            return adjusted;
          }


          var defaultDisplayMap = {};

          function getDefaultDisplay(elem) {
            var temp,
              doc = elem.ownerDocument,
              nodeName = elem.nodeName,
              display = defaultDisplayMap[nodeName];

            if (display) {
              return display;
            }

            temp = doc.body.appendChild(doc.createElement(nodeName));
            display = jQuery.css(temp, "display");

            temp.parentNode.removeChild(temp);

            if (display === "none") {
              display = "block";
            }
            defaultDisplayMap[nodeName] = display;

            return display;
          }

          function showHide(elements, show) {
            var display, elem,
              values = [],
              index = 0,
              length = elements.length;

            // Determine new display value for elements that need to change
            for (; index < length; index++) {
              elem = elements[index];
              if (!elem.style) {
                continue;
              }

              display = elem.style.display;
              if (show) {

                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                  values[index] = dataPriv.get(elem, "display") || null;
                  if (!values[index]) {
                    elem.style.display = "";
                  }
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) {
                  values[index] = getDefaultDisplay(elem);
                }
              } else {
                if (display !== "none") {
                  values[index] = "none";

                  // Remember what we're overwriting
                  dataPriv.set(elem, "display", display);
                }
              }
            }

            // Set the display of the elements in a second loop to avoid constant reflow
            for (index = 0; index < length; index++) {
              if (values[index] != null) {
                elements[index].style.display = values[index];
              }
            }

            return elements;
          }

          jQuery.fn.extend({
            show: function () {
              return showHide(this, true);
            },
            hide: function () {
              return showHide(this);
            },
            toggle: function (state) {
              if (typeof state === "boolean") {
                return state ? this.show() : this.hide();
              }

              return this.each(function () {
                if (isHiddenWithinTree(this)) {
                  jQuery(this).show();
                } else {
                  jQuery(this).hide();
                }
              });
            }
          });
          var rcheckableType = (/^(?:checkbox|radio)$/i);

          var rtagName = (/<([a-z][^\/\0>\x20\t\r\n\f]*)/i);

          var rscriptType = (/^$|^module$|\/(?:java|ecma)script/i);



          (function () {
            var fragment = document.createDocumentFragment(),
              div = fragment.appendChild(document.createElement("div")),
              input = document.createElement("input");

            // Support: Android 4.0 - 4.3 only
            // Check state lost if the name is set (#11217)
            // Support: Windows Web Apps (WWA)
            // `name` and `type` must use .setAttribute for WWA (#14901)
            input.setAttribute("type", "radio");
            input.setAttribute("checked", "checked");
            input.setAttribute("name", "t");

            div.appendChild(input);

            // Support: Android <=4.1 only
            // Older WebKit doesn't clone checked state correctly in fragments
            support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;

            // Support: IE <=11 only
            // Make sure textarea (and checkbox) defaultValue is properly cloned
            div.innerHTML = "<textarea>x</textarea>";
            support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;

            // Support: IE <=9 only
            // IE <=9 replaces <option> tags with their contents when inserted outside of
            // the select element.
            div.innerHTML = "<option></option>";
            support.option = !!div.lastChild;
          })();


          // We have to close these tags to support XHTML (#13200)
          var wrapMap = {

            // XHTML parsers do not magically insert elements in the
            // same way that tag soup parsers do. So we cannot shorten
            // this by omitting <tbody> or other required elements.
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],

            _default: [0, "", ""]
          };

          wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
          wrapMap.th = wrapMap.td;

          // Support: IE <=9 only
          if (!support.option) {
            wrapMap.optgroup = wrapMap.option = [1, "<select multiple='multiple'>", "</select>"];
          }


          function getAll(context, tag) {

            // Support: IE <=9 - 11 only
            // Use typeof to avoid zero-argument method invocation on host objects (#15151)
            var ret;

            if (typeof context.getElementsByTagName !== "undefined") {
              ret = context.getElementsByTagName(tag || "*");

            } else if (typeof context.querySelectorAll !== "undefined") {
              ret = context.querySelectorAll(tag || "*");

            } else {
              ret = [];
            }

            if (tag === undefined || tag && nodeName(context, tag)) {
              return jQuery.merge([context], ret);
            }

            return ret;
          }


          // Mark scripts as having already been evaluated
          function setGlobalEval(elems, refElements) {
            var i = 0,
              l = elems.length;

            for (; i < l; i++) {
              dataPriv.set(
                elems[i],
                "globalEval",
                !refElements || dataPriv.get(refElements[i], "globalEval")
              );
            }
          }


          var rhtml = /<|&#?\w+;/;

          function buildFragment(elems, context, scripts, selection, ignored) {
            var elem, tmp, tag, wrap, attached, j,
              fragment = context.createDocumentFragment(),
              nodes = [],
              i = 0,
              l = elems.length;

            for (; i < l; i++) {
              elem = elems[i];

              if (elem || elem === 0) {

                // Add nodes directly
                if (toType(elem) === "object") {

                  // Support: Android <=4.0 only, PhantomJS 1 only
                  // push.apply(_, arraylike) throws on ancient WebKit
                  jQuery.merge(nodes, elem.nodeType ? [elem] : elem);

                  // Convert non-html into a text node
                } else if (!rhtml.test(elem)) {
                  nodes.push(context.createTextNode(elem));

                  // Convert html into DOM nodes
                } else {
                  tmp = tmp || fragment.appendChild(context.createElement("div"));

                  // Deserialize a standard representation
                  tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
                  wrap = wrapMap[tag] || wrapMap._default;
                  tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];

                  // Descend through wrappers to the right content
                  j = wrap[0];
                  while (j--) {
                    tmp = tmp.lastChild;
                  }

                  // Support: Android <=4.0 only, PhantomJS 1 only
                  // push.apply(_, arraylike) throws on ancient WebKit
                  jQuery.merge(nodes, tmp.childNodes);

                  // Remember the top-level container
                  tmp = fragment.firstChild;

                  // Ensure the created nodes are orphaned (#12392)
                  tmp.textContent = "";
                }
              }
            }

            // Remove wrapper from fragment
            fragment.textContent = "";

            i = 0;
            while ((elem = nodes[i++])) {

              // Skip elements already in the context collection (trac-4087)
              if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) {
                  ignored.push(elem);
                }
                continue;
              }

              attached = isAttached(elem);

              // Append to fragment
              tmp = getAll(fragment.appendChild(elem), "script");

              // Preserve script evaluation history
              if (attached) {
                setGlobalEval(tmp);
              }

              // Capture executables
              if (scripts) {
                j = 0;
                while ((elem = tmp[j++])) {
                  if (rscriptType.test(elem.type || "")) {
                    scripts.push(elem);
                  }
                }
              }
            }

            return fragment;
          }


          var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

          function returnTrue() {
            return true;
          }

          function returnFalse() {
            return false;
          }

          // Support: IE <=9 - 11+
          // focus() and blur() are asynchronous, except when they are no-op.
          // So expect focus to be synchronous when the element is already active,
          // and blur to be synchronous when the element is not already active.
          // (focus and blur are always synchronous in other supported browsers,
          // this just defines when we can count on it).
          function expectSync(elem, type) {
            return (elem === safeActiveElement()) === (type === "focus");
          }

          // Support: IE <=9 only
          // Accessing document.activeElement can throw unexpectedly
          // https://bugs.jquery.com/ticket/13393
          function safeActiveElement() {
            try {
              return document.activeElement;
            } catch (err) { }
          }

          function on(elem, types, selector, data, fn, one) {
            var origFn, type;

            // Types can be a map of types/handlers
            if (typeof types === "object") {

              // ( types-Object, selector, data )
              if (typeof selector !== "string") {

                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
              }
              for (type in types) {
                on(elem, type, selector, data, types[type], one);
              }
              return elem;
            }

            if (data == null && fn == null) {

              // ( types, fn )
              fn = selector;
              data = selector = undefined;
            } else if (fn == null) {
              if (typeof selector === "string") {

                // ( types, selector, fn )
                fn = data;
                data = undefined;
              } else {

                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
              }
            }
            if (fn === false) {
              fn = returnFalse;
            } else if (!fn) {
              return elem;
            }

            if (one === 1) {
              origFn = fn;
              fn = function (event) {

                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
              };

              // Use same guid so caller can remove using origFn
              fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
            }
            return elem.each(function () {
              jQuery.event.add(this, types, fn, data, selector);
            });
          }

          /*
           * Helper functions for managing events -- not part of the public interface.
           * Props to Dean Edwards' addEvent library for many of the ideas.
           */
          jQuery.event = {

            global: {},

            add: function (elem, types, handler, data, selector) {

              var handleObjIn, eventHandle, tmp,
                events, t, handleObj,
                special, handlers, type, namespaces, origType,
                elemData = dataPriv.get(elem);

              // Only attach events to objects that accept data
              if (!acceptData(elem)) {
                return;
              }

              // Caller can pass in an object of custom data in lieu of the handler
              if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
              }

              // Ensure that invalid selectors throw exceptions at attach time
              // Evaluate against documentElement in case elem is a non-element node (e.g., document)
              if (selector) {
                jQuery.find.matchesSelector(documentElement, selector);
              }

              // Make sure that the handler has a unique ID, used to find/remove it later
              if (!handler.guid) {
                handler.guid = jQuery.guid++;
              }

              // Init the element's event structure and main handler, if this is the first
              if (!(events = elemData.events)) {
                events = elemData.events = Object.create(null);
              }
              if (!(eventHandle = elemData.handle)) {
                eventHandle = elemData.handle = function (e) {

                  // Discard the second event of a jQuery.event.trigger() and
                  // when an event is called after a page has unloaded
                  return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
                    jQuery.event.dispatch.apply(elem, arguments) : undefined;
                };
              }

              // Handle multiple events separated by a space
              types = (types || "").match(rnothtmlwhite) || [""];
              t = types.length;
              while (t--) {
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();

                // There *must* be a type, no attaching namespace-only handlers
                if (!type) {
                  continue;
                }

                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};

                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;

                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};

                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                  type: type,
                  origType: origType,
                  data: data,
                  handler: handler,
                  guid: handler.guid,
                  selector: selector,
                  needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                  namespace: namespaces.join(".")
                }, handleObjIn);

                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                  handlers = events[type] = [];
                  handlers.delegateCount = 0;

                  // Only use addEventListener if the special events handler returns false
                  if (!special.setup ||
                    special.setup.call(elem, data, namespaces, eventHandle) === false) {

                    if (elem.addEventListener) {
                      elem.addEventListener(type, eventHandle);
                    }
                  }
                }

                if (special.add) {
                  special.add.call(elem, handleObj);

                  if (!handleObj.handler.guid) {
                    handleObj.handler.guid = handler.guid;
                  }
                }

                // Add to the element's handler list, delegates in front
                if (selector) {
                  handlers.splice(handlers.delegateCount++, 0, handleObj);
                } else {
                  handlers.push(handleObj);
                }

                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
              }

            },

            // Detach an event or set of events from an element
            remove: function (elem, types, handler, selector, mappedTypes) {

              var j, origCount, tmp,
                events, t, handleObj,
                special, handlers, type, namespaces, origType,
                elemData = dataPriv.hasData(elem) && dataPriv.get(elem);

              if (!elemData || !(events = elemData.events)) {
                return;
              }

              // Once for each type.namespace in types; type may be omitted
              types = (types || "").match(rnothtmlwhite) || [""];
              t = types.length;
              while (t--) {
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();

                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                  for (type in events) {
                    jQuery.event.remove(elem, type + types[t], handler, selector, true);
                  }
                  continue;
                }

                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] &&
                  new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");

                // Remove matching events
                origCount = j = handlers.length;
                while (j--) {
                  handleObj = handlers[j];

                  if ((mappedTypes || origType === handleObj.origType) &&
                    (!handler || handler.guid === handleObj.guid) &&
                    (!tmp || tmp.test(handleObj.namespace)) &&
                    (!selector || selector === handleObj.selector ||
                      selector === "**" && handleObj.selector)) {
                    handlers.splice(j, 1);

                    if (handleObj.selector) {
                      handlers.delegateCount--;
                    }
                    if (special.remove) {
                      special.remove.call(elem, handleObj);
                    }
                  }
                }

                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                  if (!special.teardown ||
                    special.teardown.call(elem, namespaces, elemData.handle) === false) {

                    jQuery.removeEvent(elem, type, elemData.handle);
                  }

                  delete events[type];
                }
              }

              // Remove data and the expando if it's no longer used
              if (jQuery.isEmptyObject(events)) {
                dataPriv.remove(elem, "handle events");
              }
            },

            dispatch: function (nativeEvent) {

              var i, j, ret, matched, handleObj, handlerQueue,
                args = new Array(arguments.length),

                // Make a writable jQuery.Event from the native event object
                event = jQuery.event.fix(nativeEvent),

                handlers = (
                  dataPriv.get(this, "events") || Object.create(null)
                )[event.type] || [],
                special = jQuery.event.special[event.type] || {};

              // Use the fix-ed jQuery.Event rather than the (read-only) native event
              args[0] = event;

              for (i = 1; i < arguments.length; i++) {
                args[i] = arguments[i];
              }

              event.delegateTarget = this;

              // Call the preDispatch hook for the mapped type, and let it bail if desired
              if (special.preDispatch && special.preDispatch.call(this, event) === false) {
                return;
              }

              // Determine handlers
              handlerQueue = jQuery.event.handlers.call(this, event, handlers);

              // Run delegates first; they may want to stop propagation beneath us
              i = 0;
              while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
                event.currentTarget = matched.elem;

                j = 0;
                while ((handleObj = matched.handlers[j++]) &&
                  !event.isImmediatePropagationStopped()) {

                  // If the event is namespaced, then each handler is only invoked if it is
                  // specially universal or its namespaces are a superset of the event's.
                  if (!event.rnamespace || handleObj.namespace === false ||
                    event.rnamespace.test(handleObj.namespace)) {

                    event.handleObj = handleObj;
                    event.data = handleObj.data;

                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle ||
                      handleObj.handler).apply(matched.elem, args);

                    if (ret !== undefined) {
                      if ((event.result = ret) === false) {
                        event.preventDefault();
                        event.stopPropagation();
                      }
                    }
                  }
                }
              }

              // Call the postDispatch hook for the mapped type
              if (special.postDispatch) {
                special.postDispatch.call(this, event);
              }

              return event.result;
            },

            handlers: function (event, handlers) {
              var i, handleObj, sel, matchedHandlers, matchedSelectors,
                handlerQueue = [],
                delegateCount = handlers.delegateCount,
                cur = event.target;

              // Find delegate handlers
              if (delegateCount &&

                // Support: IE <=9
                // Black-hole SVG <use> instance trees (trac-13180)
                cur.nodeType &&

                // Support: Firefox <=42
                // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
                // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
                // Support: IE 11 only
                // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
                !(event.type === "click" && event.button >= 1)) {

                for (; cur !== this; cur = cur.parentNode || this) {

                  // Don't check non-elements (#13208)
                  // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
                  if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for (i = 0; i < delegateCount; i++) {
                      handleObj = handlers[i];

                      // Don't conflict with Object.prototype properties (#13203)
                      sel = handleObj.selector + " ";

                      if (matchedSelectors[sel] === undefined) {
                        matchedSelectors[sel] = handleObj.needsContext ?
                          jQuery(sel, this).index(cur) > -1 :
                          jQuery.find(sel, this, null, [cur]).length;
                      }
                      if (matchedSelectors[sel]) {
                        matchedHandlers.push(handleObj);
                      }
                    }
                    if (matchedHandlers.length) {
                      handlerQueue.push({ elem: cur, handlers: matchedHandlers });
                    }
                  }
                }
              }

              // Add the remaining (directly-bound) handlers
              cur = this;
              if (delegateCount < handlers.length) {
                handlerQueue.push({ elem: cur, handlers: handlers.slice(delegateCount) });
              }

              return handlerQueue;
            },

            addProp: function (name, hook) {
              Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,

                get: isFunction(hook) ?
                  function () {
                    if (this.originalEvent) {
                      return hook(this.originalEvent);
                    }
                  } :
                  function () {
                    if (this.originalEvent) {
                      return this.originalEvent[name];
                    }
                  },

                set: function (value) {
                  Object.defineProperty(this, name, {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: value
                  });
                }
              });
            },

            fix: function (originalEvent) {
              return originalEvent[jQuery.expando] ?
                originalEvent :
                new jQuery.Event(originalEvent);
            },

            special: {
              load: {

                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
              },
              click: {

                // Utilize native event to ensure correct state for checkable inputs
                setup: function (data) {

                  // For mutual compressibility with _default, replace `this` access with a local var.
                  // `|| data` is dead code meant only to preserve the variable through minification.
                  var el = this || data;

                  // Claim the first handler
                  if (rcheckableType.test(el.type) &&
                    el.click && nodeName(el, "input")) {

                    // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", returnTrue);
                  }

                  // Return false to allow normal processing in the caller
                  return false;
                },
                trigger: function (data) {

                  // For mutual compressibility with _default, replace `this` access with a local var.
                  // `|| data` is dead code meant only to preserve the variable through minification.
                  var el = this || data;

                  // Force setup before triggering a click
                  if (rcheckableType.test(el.type) &&
                    el.click && nodeName(el, "input")) {

                    leverageNative(el, "click");
                  }

                  // Return non-false to allow normal event-path propagation
                  return true;
                },

                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function (event) {
                  var target = event.target;
                  return rcheckableType.test(target.type) &&
                    target.click && nodeName(target, "input") &&
                    dataPriv.get(target, "click") ||
                    nodeName(target, "a");
                }
              },

              beforeunload: {
                postDispatch: function (event) {

                  // Support: Firefox 20+
                  // Firefox doesn't alert if the returnValue field is not set.
                  if (event.result !== undefined && event.originalEvent) {
                    event.originalEvent.returnValue = event.result;
                  }
                }
              }
            }
          };

          // Ensure the presence of an event listener that handles manually-triggered
          // synthetic events by interrupting progress until reinvoked in response to
          // *native* events that it fires directly, ensuring that state changes have
          // already occurred before other listeners are invoked.
          function leverageNative(el, type, expectSync) {

            // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
            if (!expectSync) {
              if (dataPriv.get(el, type) === undefined) {
                jQuery.event.add(el, type, returnTrue);
              }
              return;
            }

            // Register the controller as a special universal handler for all event namespaces
            dataPriv.set(el, type, false);
            jQuery.event.add(el, type, {
              namespace: false,
              handler: function (event) {
                var notAsync, result,
                  saved = dataPriv.get(this, type);

                if ((event.isTrigger & 1) && this[type]) {

                  // Interrupt processing of the outer synthetic .trigger()ed event
                  // Saved data should be false in such cases, but might be a leftover capture object
                  // from an async native handler (gh-4350)
                  if (!saved.length) {

                    // Store arguments for use when handling the inner native event
                    // There will always be at least one argument (an event object), so this array
                    // will not be confused with a leftover capture object.
                    saved = slice.call(arguments);
                    dataPriv.set(this, type, saved);

                    // Trigger the native event and capture its result
                    // Support: IE <=9 - 11+
                    // focus() and blur() are asynchronous
                    notAsync = expectSync(this, type);
                    this[type]();
                    result = dataPriv.get(this, type);
                    if (saved !== result || notAsync) {
                      dataPriv.set(this, type, false);
                    } else {
                      result = {};
                    }
                    if (saved !== result) {

                      // Cancel the outer synthetic event
                      event.stopImmediatePropagation();
                      event.preventDefault();

                      // Support: Chrome 86+
                      // In Chrome, if an element having a focusout handler is blurred by
                      // clicking outside of it, it invokes the handler synchronously. If
                      // that handler calls `.remove()` on the element, the data is cleared,
                      // leaving `result` undefined. We need to guard against this.
                      return result && result.value;
                    }

                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering the
                    // native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                  } else if ((jQuery.event.special[type] || {}).delegateType) {
                    event.stopPropagation();
                  }

                  // If this is a native event triggered above, everything is now in order
                  // Fire an inner synthetic event with the original arguments
                } else if (saved.length) {

                  // ...and capture the result
                  dataPriv.set(this, type, {
                    value: jQuery.event.trigger(

                      // Support: IE <=9 - 11+
                      // Extend with the prototype to reset the above stopImmediatePropagation()
                      jQuery.extend(saved[0], jQuery.Event.prototype),
                      saved.slice(1),
                      this
                    )
                  });

                  // Abort handling of the native event
                  event.stopImmediatePropagation();
                }
              }
            });
          }

          jQuery.removeEvent = function (elem, type, handle) {

            // This "if" is needed for plain objects
            if (elem.removeEventListener) {
              elem.removeEventListener(type, handle);
            }
          };

          jQuery.Event = function (src, props) {

            // Allow instantiation without the 'new' keyword
            if (!(this instanceof jQuery.Event)) {
              return new jQuery.Event(src, props);
            }

            // Event object
            if (src && src.type) {
              this.originalEvent = src;
              this.type = src.type;

              // Events bubbling up the document may have been marked as prevented
              // by a handler lower down the tree; reflect the correct value.
              this.isDefaultPrevented = src.defaultPrevented ||
                src.defaultPrevented === undefined &&

                // Support: Android <=2.3 only
                src.returnValue === false ?
                returnTrue :
                returnFalse;

              // Create target properties
              // Support: Safari <=6 - 7 only
              // Target should not be a text node (#504, #13143)
              this.target = (src.target && src.target.nodeType === 3) ?
                src.target.parentNode :
                src.target;

              this.currentTarget = src.currentTarget;
              this.relatedTarget = src.relatedTarget;

              // Event type
            } else {
              this.type = src;
            }

            // Put explicitly provided properties onto the event object
            if (props) {
              jQuery.extend(this, props);
            }

            // Create a timestamp if incoming event doesn't have one
            this.timeStamp = src && src.timeStamp || Date.now();

            // Mark it as fixed
            this[jQuery.expando] = true;
          };

          // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
          // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
          jQuery.Event.prototype = {
            constructor: jQuery.Event,
            isDefaultPrevented: returnFalse,
            isPropagationStopped: returnFalse,
            isImmediatePropagationStopped: returnFalse,
            isSimulated: false,

            preventDefault: function () {
              var e = this.originalEvent;

              this.isDefaultPrevented = returnTrue;

              if (e && !this.isSimulated) {
                e.preventDefault();
              }
            },
            stopPropagation: function () {
              var e = this.originalEvent;

              this.isPropagationStopped = returnTrue;

              if (e && !this.isSimulated) {
                e.stopPropagation();
              }
            },
            stopImmediatePropagation: function () {
              var e = this.originalEvent;

              this.isImmediatePropagationStopped = returnTrue;

              if (e && !this.isSimulated) {
                e.stopImmediatePropagation();
              }

              this.stopPropagation();
            }
          };

          // Includes all common event props including KeyEvent and MouseEvent specific props
          jQuery.each({
            altKey: true,
            bubbles: true,
            cancelable: true,
            changedTouches: true,
            ctrlKey: true,
            detail: true,
            eventPhase: true,
            metaKey: true,
            pageX: true,
            pageY: true,
            shiftKey: true,
            view: true,
            "char": true,
            code: true,
            charCode: true,
            key: true,
            keyCode: true,
            button: true,
            buttons: true,
            clientX: true,
            clientY: true,
            offsetX: true,
            offsetY: true,
            pointerId: true,
            pointerType: true,
            screenX: true,
            screenY: true,
            targetTouches: true,
            toElement: true,
            touches: true,
            which: true
          }, jQuery.event.addProp);

          jQuery.each({ focus: "focusin", blur: "focusout" }, function (type, delegateType) {
            jQuery.event.special[type] = {

              // Utilize native event if possible so blur/focus sequence is correct
              setup: function () {

                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, expectSync);

                // Return false to allow normal processing in the caller
                return false;
              },
              trigger: function () {

                // Force setup before trigger
                leverageNative(this, type);

                // Return non-false to allow normal event-path propagation
                return true;
              },

              // Suppress native focus or blur as it's already being fired
              // in leverageNative.
              _default: function () {
                return true;
              },

              delegateType: delegateType
            };
          });

          // Create mouseenter/leave events using mouseover/out and event-time checks
          // so that event delegation works in jQuery.
          // Do the same for pointerenter/pointerleave and pointerover/pointerout
          //
          // Support: Safari 7 only
          // Safari sends mouseenter too often; see:
          // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
          // for the description of the bug (it existed in older Chrome versions as well).
          jQuery.each({
            mouseenter: "mouseover",
            mouseleave: "mouseout",
            pointerenter: "pointerover",
            pointerleave: "pointerout"
          }, function (orig, fix) {
            jQuery.event.special[orig] = {
              delegateType: fix,
              bindType: fix,

              handle: function (event) {
                var ret,
                  target = this,
                  related = event.relatedTarget,
                  handleObj = event.handleObj;

                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || (related !== target && !jQuery.contains(target, related))) {
                  event.type = handleObj.origType;
                  ret = handleObj.handler.apply(this, arguments);
                  event.type = fix;
                }
                return ret;
              }
            };
          });

          jQuery.fn.extend({

            on: function (types, selector, data, fn) {
              return on(this, types, selector, data, fn);
            },
            one: function (types, selector, data, fn) {
              return on(this, types, selector, data, fn, 1);
            },
            off: function (types, selector, fn) {
              var handleObj, type;
              if (types && types.preventDefault && types.handleObj) {

                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(
                  handleObj.namespace ?
                    handleObj.origType + "." + handleObj.namespace :
                    handleObj.origType,
                  handleObj.selector,
                  handleObj.handler
                );
                return this;
              }
              if (typeof types === "object") {

                // ( types-object [, selector] )
                for (type in types) {
                  this.off(type, selector, types[type]);
                }
                return this;
              }
              if (selector === false || typeof selector === "function") {

                // ( types [, fn] )
                fn = selector;
                selector = undefined;
              }
              if (fn === false) {
                fn = returnFalse;
              }
              return this.each(function () {
                jQuery.event.remove(this, types, fn, selector);
              });
            }
          });


          var

            // Support: IE <=10 - 11, Edge 12 - 13 only
            // In IE/Edge using regex groups here causes severe slowdowns.
            // See https://connect.microsoft.com/IE/feedback/details/1736512/
            rnoInnerhtml = /<script|<style|<link/i,

            // checked="checked" or checked
            rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
            rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

          // Prefer a tbody over its parent table for containing new rows
          function manipulationTarget(elem, content) {
            if (nodeName(elem, "table") &&
              nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {

              return jQuery(elem).children("tbody")[0] || elem;
            }

            return elem;
          }

          // Replace/restore the type attribute of script elements for safe DOM manipulation
          function disableScript(elem) {
            elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
            return elem;
          }
          function restoreScript(elem) {
            if ((elem.type || "").slice(0, 5) === "true/") {
              elem.type = elem.type.slice(5);
            } else {
              elem.removeAttribute("type");
            }

            return elem;
          }

          function cloneCopyEvent(src, dest) {
            var i, l, type, pdataOld, udataOld, udataCur, events;

            if (dest.nodeType !== 1) {
              return;
            }

            // 1. Copy private data: events, handlers, etc.
            if (dataPriv.hasData(src)) {
              pdataOld = dataPriv.get(src);
              events = pdataOld.events;

              if (events) {
                dataPriv.remove(dest, "handle events");

                for (type in events) {
                  for (i = 0, l = events[type].length; i < l; i++) {
                    jQuery.event.add(dest, type, events[type][i]);
                  }
                }
              }
            }

            // 2. Copy user data
            if (dataUser.hasData(src)) {
              udataOld = dataUser.access(src);
              udataCur = jQuery.extend({}, udataOld);

              dataUser.set(dest, udataCur);
            }
          }

          // Fix IE bugs, see support tests
          function fixInput(src, dest) {
            var nodeName = dest.nodeName.toLowerCase();

            // Fails to persist the checked state of a cloned checkbox or radio button.
            if (nodeName === "input" && rcheckableType.test(src.type)) {
              dest.checked = src.checked;

              // Fails to return the selected option to the default selected state when cloning options
            } else if (nodeName === "input" || nodeName === "textarea") {
              dest.defaultValue = src.defaultValue;
            }
          }

          function domManip(collection, args, callback, ignored) {

            // Flatten any nested arrays
            args = flat(args);

            var fragment, first, scripts, hasScripts, node, doc,
              i = 0,
              l = collection.length,
              iNoClone = l - 1,
              value = args[0],
              valueIsFunction = isFunction(value);

            // We can't cloneNode fragments that contain checked, in WebKit
            if (valueIsFunction ||
              (l > 1 && typeof value === "string" &&
                !support.checkClone && rchecked.test(value))) {
              return collection.each(function (index) {
                var self = collection.eq(index);
                if (valueIsFunction) {
                  args[0] = value.call(this, index, self.html());
                }
                domManip(self, args, callback, ignored);
              });
            }

            if (l) {
              fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
              first = fragment.firstChild;

              if (fragment.childNodes.length === 1) {
                fragment = first;
              }

              // Require either new content or an interest in ignored elements to invoke the callback
              if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;

                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (#8070).
                for (; i < l; i++) {
                  node = fragment;

                  if (i !== iNoClone) {
                    node = jQuery.clone(node, true, true);

                    // Keep references to cloned scripts for later restoration
                    if (hasScripts) {

                      // Support: Android <=4.0 only, PhantomJS 1 only
                      // push.apply(_, arraylike) throws on ancient WebKit
                      jQuery.merge(scripts, getAll(node, "script"));
                    }
                  }

                  callback.call(collection[i], node, i);
                }

                if (hasScripts) {
                  doc = scripts[scripts.length - 1].ownerDocument;

                  // Reenable scripts
                  jQuery.map(scripts, restoreScript);

                  // Evaluate executable scripts on first document insertion
                  for (i = 0; i < hasScripts; i++) {
                    node = scripts[i];
                    if (rscriptType.test(node.type || "") &&
                      !dataPriv.access(node, "globalEval") &&
                      jQuery.contains(doc, node)) {

                      if (node.src && (node.type || "").toLowerCase() !== "module") {

                        // Optional AJAX dependency, but won't run scripts if not present
                        if (jQuery._evalUrl && !node.noModule) {
                          jQuery._evalUrl(node.src, {
                            nonce: node.nonce || node.getAttribute("nonce")
                          }, doc);
                        }
                      } else {
                        DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                      }
                    }
                  }
                }
              }
            }

            return collection;
          }

          function remove(elem, selector, keepData) {
            var node,
              nodes = selector ? jQuery.filter(selector, elem) : elem,
              i = 0;

            for (; (node = nodes[i]) != null; i++) {
              if (!keepData && node.nodeType === 1) {
                jQuery.cleanData(getAll(node));
              }

              if (node.parentNode) {
                if (keepData && isAttached(node)) {
                  setGlobalEval(getAll(node, "script"));
                }
                node.parentNode.removeChild(node);
              }
            }

            return elem;
          }

          jQuery.extend({
            htmlPrefilter: function (html) {
              return html;
            },

            clone: function (elem, dataAndEvents, deepDataAndEvents) {
              var i, l, srcElements, destElements,
                clone = elem.cloneNode(true),
                inPage = isAttached(elem);

              // Fix IE cloning issues
              if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) &&
                !jQuery.isXMLDoc(elem)) {

                // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);

                for (i = 0, l = srcElements.length; i < l; i++) {
                  fixInput(srcElements[i], destElements[i]);
                }
              }

              // Copy the events from the original to the clone
              if (dataAndEvents) {
                if (deepDataAndEvents) {
                  srcElements = srcElements || getAll(elem);
                  destElements = destElements || getAll(clone);

                  for (i = 0, l = srcElements.length; i < l; i++) {
                    cloneCopyEvent(srcElements[i], destElements[i]);
                  }
                } else {
                  cloneCopyEvent(elem, clone);
                }
              }

              // Preserve script evaluation history
              destElements = getAll(clone, "script");
              if (destElements.length > 0) {
                setGlobalEval(destElements, !inPage && getAll(elem, "script"));
              }

              // Return the cloned set
              return clone;
            },

            cleanData: function (elems) {
              var data, elem, type,
                special = jQuery.event.special,
                i = 0;

              for (; (elem = elems[i]) !== undefined; i++) {
                if (acceptData(elem)) {
                  if ((data = elem[dataPriv.expando])) {
                    if (data.events) {
                      for (type in data.events) {
                        if (special[type]) {
                          jQuery.event.remove(elem, type);

                          // This is a shortcut to avoid jQuery.event.remove's overhead
                        } else {
                          jQuery.removeEvent(elem, type, data.handle);
                        }
                      }
                    }

                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                  }
                  if (elem[dataUser.expando]) {

                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataUser.expando] = undefined;
                  }
                }
              }
            }
          });

          jQuery.fn.extend({
            detach: function (selector) {
              return remove(this, selector, true);
            },

            remove: function (selector) {
              return remove(this, selector);
            },

            text: function (value) {
              return access(this, function (value) {
                return value === undefined ?
                  jQuery.text(this) :
                  this.empty().each(function () {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                      this.textContent = value;
                    }
                  });
              }, null, value, arguments.length);
            },

            append: function () {
              return domManip(this, arguments, function (elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                  var target = manipulationTarget(this, elem);
                  target.appendChild(elem);
                }
              });
            },

            prepend: function () {
              return domManip(this, arguments, function (elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                  var target = manipulationTarget(this, elem);
                  target.insertBefore(elem, target.firstChild);
                }
              });
            },

            before: function () {
              return domManip(this, arguments, function (elem) {
                if (this.parentNode) {
                  this.parentNode.insertBefore(elem, this);
                }
              });
            },

            after: function () {
              return domManip(this, arguments, function (elem) {
                if (this.parentNode) {
                  this.parentNode.insertBefore(elem, this.nextSibling);
                }
              });
            },

            empty: function () {
              var elem,
                i = 0;

              for (; (elem = this[i]) != null; i++) {
                if (elem.nodeType === 1) {

                  // Prevent memory leaks
                  jQuery.cleanData(getAll(elem, false));

                  // Remove any remaining nodes
                  elem.textContent = "";
                }
              }

              return this;
            },

            clone: function (dataAndEvents, deepDataAndEvents) {
              dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
              deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

              return this.map(function () {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
              });
            },

            html: function (value) {
              return access(this, function (value) {
                var elem = this[0] || {},
                  i = 0,
                  l = this.length;

                if (value === undefined && elem.nodeType === 1) {
                  return elem.innerHTML;
                }

                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) &&
                  !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {

                  value = jQuery.htmlPrefilter(value);

                  try {
                    for (; i < l; i++) {
                      elem = this[i] || {};

                      // Remove element nodes and prevent memory leaks
                      if (elem.nodeType === 1) {
                        jQuery.cleanData(getAll(elem, false));
                        elem.innerHTML = value;
                      }
                    }

                    elem = 0;

                    // If using innerHTML throws an exception, use the fallback method
                  } catch (e) { }
                }

                if (elem) {
                  this.empty().append(value);
                }
              }, null, value, arguments.length);
            },

            replaceWith: function () {
              var ignored = [];

              // Make the changes, replacing each non-ignored context element with the new content
              return domManip(this, arguments, function (elem) {
                var parent = this.parentNode;

                if (jQuery.inArray(this, ignored) < 0) {
                  jQuery.cleanData(getAll(this));
                  if (parent) {
                    parent.replaceChild(elem, this);
                  }
                }

                // Force callback invocation
              }, ignored);
            }
          });

          jQuery.each({
            appendTo: "append",
            prependTo: "prepend",
            insertBefore: "before",
            insertAfter: "after",
            replaceAll: "replaceWith"
          }, function (name, original) {
            jQuery.fn[name] = function (selector) {
              var elems,
                ret = [],
                insert = jQuery(selector),
                last = insert.length - 1,
                i = 0;

              for (; i <= last; i++) {
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);

                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
              }

              return this.pushStack(ret);
            };
          });
          var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");

          var getStyles = function (elem) {

            // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
            // IE throws on elements created in popups
            // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
            var view = elem.ownerDocument.defaultView;

            if (!view || !view.opener) {
              view = window;
            }

            return view.getComputedStyle(elem);
          };

          var swap = function (elem, options, callback) {
            var ret, name,
              old = {};

            // Remember the old values, and insert the new ones
            for (name in options) {
              old[name] = elem.style[name];
              elem.style[name] = options[name];
            }

            ret = callback.call(elem);

            // Revert the old values
            for (name in options) {
              elem.style[name] = old[name];
            }

            return ret;
          };


          var rboxStyle = new RegExp(cssExpand.join("|"), "i");



          (function () {

            // Executing both pixelPosition & boxSizingReliable tests require only one layout
            // so they're executed at the same time to save the second computation.
            function computeStyleTests() {

              // This is a singleton, we need to execute it only once
              if (!div) {
                return;
              }

              container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
                "margin-top:1px;padding:0;border:0";
              div.style.cssText =
                "position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
                "margin:auto;border:1px;padding:1px;" +
                "width:60%;top:1%";
              documentElement.appendChild(container).appendChild(div);

              var divStyle = window.getComputedStyle(div);
              pixelPositionVal = divStyle.top !== "1%";

              // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
              reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;

              // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
              // Some styles come back with percentage values, even though they shouldn't
              div.style.right = "60%";
              pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;

              // Support: IE 9 - 11 only
              // Detect misreporting of content dimensions for box-sizing:border-box elements
              boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;

              // Support: IE 9 only
              // Detect overflow:scroll screwiness (gh-3699)
              // Support: Chrome <=64
              // Don't get tricked when zoom affects offsetWidth (gh-4029)
              div.style.position = "absolute";
              scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;

              documentElement.removeChild(container);

              // Nullify the div so it wouldn't be stored in the memory and
              // it will also be a sign that checks already performed
              div = null;
            }

            function roundPixelMeasures(measure) {
              return Math.round(parseFloat(measure));
            }

            var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
              reliableTrDimensionsVal, reliableMarginLeftVal,
              container = document.createElement("div"),
              div = document.createElement("div");

            // Finish early in limited (non-browser) environments
            if (!div.style) {
              return;
            }

            // Support: IE <=9 - 11 only
            // Style of cloned element affects source element cloned (#8908)
            div.style.backgroundClip = "content-box";
            div.cloneNode(true).style.backgroundClip = "";
            support.clearCloneStyle = div.style.backgroundClip === "content-box";

            jQuery.extend(support, {
              boxSizingReliable: function () {
                computeStyleTests();
                return boxSizingReliableVal;
              },
              pixelBoxStyles: function () {
                computeStyleTests();
                return pixelBoxStylesVal;
              },
              pixelPosition: function () {
                computeStyleTests();
                return pixelPositionVal;
              },
              reliableMarginLeft: function () {
                computeStyleTests();
                return reliableMarginLeftVal;
              },
              scrollboxSize: function () {
                computeStyleTests();
                return scrollboxSizeVal;
              },

              // Support: IE 9 - 11+, Edge 15 - 18+
              // IE/Edge misreport `getComputedStyle` of table rows with width/height
              // set in CSS while `offset*` properties report correct values.
              // Behavior in IE 9 is more subtle than in newer versions & it passes
              // some versions of this test; make sure not to make it pass there!
              //
              // Support: Firefox 70+
              // Only Firefox includes border widths
              // in computed dimensions. (gh-4529)
              reliableTrDimensions: function () {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                  table = document.createElement("table");
                  tr = document.createElement("tr");
                  trChild = document.createElement("div");

                  table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                  tr.style.cssText = "border:1px solid";

                  // Support: Chrome 86+
                  // Height set through cssText does not get applied.
                  // Computed height then comes back as 0.
                  tr.style.height = "1px";
                  trChild.style.height = "9px";

                  // Support: Android 8 Chrome 86+
                  // In our bodyBackground.html iframe,
                  // display for all div elements is set to "inline",
                  // which causes a problem only in Android 8 Chrome 86.
                  // Ensuring the div is display: block
                  // gets around this issue.
                  trChild.style.display = "block";

                  documentElement
                    .appendChild(table)
                    .appendChild(tr)
                    .appendChild(trChild);

                  trStyle = window.getComputedStyle(tr);
                  reliableTrDimensionsVal = (parseInt(trStyle.height, 10) +
                    parseInt(trStyle.borderTopWidth, 10) +
                    parseInt(trStyle.borderBottomWidth, 10)) === tr.offsetHeight;

                  documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
              }
            });
          })();


          function curCSS(elem, name, computed) {
            var width, minWidth, maxWidth, ret,

              // Support: Firefox 51+
              // Retrieving style before computed somehow
              // fixes an issue with getting wrong values
              // on detached elements
              style = elem.style;

            computed = computed || getStyles(elem);

            // getPropertyValue is needed for:
            //   .css('filter') (IE 9 only, #12537)
            //   .css('--customProperty) (#3144)
            if (computed) {
              ret = computed.getPropertyValue(name) || computed[name];

              if (ret === "" && !isAttached(elem)) {
                ret = jQuery.style(elem, name);
              }

              // A tribute to the "awesome hack by Dean Edwards"
              // Android Browser returns percentage for some values,
              // but width seems to be reliably pixels.
              // This is against the CSSOM draft spec:
              // https://drafts.csswg.org/cssom/#resolved-values
              if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {

                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;

                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;

                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
              }
            }

            return ret !== undefined ?

              // Support: IE <=9 - 11 only
              // IE returns zIndex value as an integer.
              ret + "" :
              ret;
          }


          function addGetHookIf(conditionFn, hookFn) {

            // Define the hook, we'll check on the first run if it's really needed.
            return {
              get: function () {
                if (conditionFn()) {

                  // Hook not needed (or it's not possible to use it due
                  // to missing dependency), remove it.
                  delete this.get;
                  return;
                }

                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
              }
            };
          }


          var cssPrefixes = ["Webkit", "Moz", "ms"],
            emptyStyle = document.createElement("div").style,
            vendorProps = {};

          // Return a vendor-prefixed property or undefined
          function vendorPropName(name) {

            // Check for vendor prefixed names
            var capName = name[0].toUpperCase() + name.slice(1),
              i = cssPrefixes.length;

            while (i--) {
              name = cssPrefixes[i] + capName;
              if (name in emptyStyle) {
                return name;
              }
            }
          }

          // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
          function finalPropName(name) {
            var final = jQuery.cssProps[name] || vendorProps[name];

            if (final) {
              return final;
            }
            if (name in emptyStyle) {
              return name;
            }
            return vendorProps[name] = vendorPropName(name) || name;
          }


          var

            // Swappable if display is none or starts with table
            // except "table", "table-cell", or "table-caption"
            // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
            rdisplayswap = /^(none|table(?!-c[ea]).+)/,
            rcustomProp = /^--/,
            cssShow = { position: "absolute", visibility: "hidden", display: "block" },
            cssNormalTransform = {
              letterSpacing: "0",
              fontWeight: "400"
            };

          function setPositiveNumber(_elem, value, subtract) {

            // Any relative (+/-) values have already been
            // normalized at this point
            var matches = rcssNum.exec(value);
            return matches ?

              // Guard against undefined "subtract", e.g., when used as in cssHooks
              Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") :
              value;
          }

          function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
            var i = dimension === "width" ? 1 : 0,
              extra = 0,
              delta = 0;

            // Adjustment may not be necessary
            if (box === (isBorderBox ? "border" : "content")) {
              return 0;
            }

            for (; i < 4; i += 2) {

              // Both box models exclude margin
              if (box === "margin") {
                delta += jQuery.css(elem, box + cssExpand[i], true, styles);
              }

              // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
              if (!isBorderBox) {

                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);

                // For "border" or "margin", add border
                if (box !== "padding") {
                  delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);

                  // But still keep track of it otherwise
                } else {
                  extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                }

                // If we get here with a border-box (content + padding + border), we're seeking "content" or
                // "padding" or "margin"
              } else {

                // For "content", subtract padding
                if (box === "content") {
                  delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                }

                // For "content" or "padding", subtract border
                if (box !== "margin") {
                  delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                }
              }
            }

            // Account for positive content-box scroll gutter when requested by providing computedVal
            if (!isBorderBox && computedVal >= 0) {

              // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
              // Assuming integer scroll gutter, subtract the rest and round down
              delta += Math.max(0, Math.ceil(
                elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] -
                computedVal -
                delta -
                extra -
                0.5

                // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
                // Use an explicit zero to avoid NaN (gh-3964)
              )) || 0;
            }

            return delta;
          }

          function getWidthOrHeight(elem, dimension, extra) {

            // Start with computed style
            var styles = getStyles(elem),

              // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
              // Fake content-box until we know it's needed to know the true value.
              boxSizingNeeded = !support.boxSizingReliable() || extra,
              isBorderBox = boxSizingNeeded &&
                jQuery.css(elem, "boxSizing", false, styles) === "border-box",
              valueIsBorderBox = isBorderBox,

              val = curCSS(elem, dimension, styles),
              offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);

            // Support: Firefox <=54
            // Return a confounding non-pixel value or feign ignorance, as appropriate.
            if (rnumnonpx.test(val)) {
              if (!extra) {
                return val;
              }
              val = "auto";
            }


            // Support: IE 9 - 11 only
            // Use offsetWidth/offsetHeight for when box sizing is unreliable.
            // In those cases, the computed value can be trusted to be border-box.
            if ((!support.boxSizingReliable() && isBorderBox ||

              // Support: IE 10 - 11+, Edge 15 - 18+
              // IE/Edge misreport `getComputedStyle` of table rows with width/height
              // set in CSS while `offset*` properties report correct values.
              // Interestingly, in some cases IE 9 doesn't suffer from this issue.
              !support.reliableTrDimensions() && nodeName(elem, "tr") ||

              // Fall back to offsetWidth/offsetHeight when value is "auto"
              // This happens for inline elements with no explicit setting (gh-3571)
              val === "auto" ||

              // Support: Android <=4.1 - 4.3 only
              // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
              !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") &&

              // Make sure the element is visible & connected
              elem.getClientRects().length) {

              isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";

              // Where available, offsetWidth/offsetHeight approximate border box dimensions.
              // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
              // retrieved value as a content box dimension.
              valueIsBorderBox = offsetProp in elem;
              if (valueIsBorderBox) {
                val = elem[offsetProp];
              }
            }

            // Normalize "" and auto
            val = parseFloat(val) || 0;

            // Adjust for the element's box model
            return (val +
              boxModelAdjustment(
                elem,
                dimension,
                extra || (isBorderBox ? "border" : "content"),
                valueIsBorderBox,
                styles,

                // Provide the current computed size to request scroll gutter calculation (gh-3589)
                val
              )
            ) + "px";
          }

          jQuery.extend({

            // Add in style property hooks for overriding the default
            // behavior of getting and setting a style property
            cssHooks: {
              opacity: {
                get: function (elem, computed) {
                  if (computed) {

                    // We should always get a number back from opacity
                    var ret = curCSS(elem, "opacity");
                    return ret === "" ? "1" : ret;
                  }
                }
              }
            },

            // Don't automatically add "px" to these possibly-unitless properties
            cssNumber: {
              "animationIterationCount": true,
              "columnCount": true,
              "fillOpacity": true,
              "flexGrow": true,
              "flexShrink": true,
              "fontWeight": true,
              "gridArea": true,
              "gridColumn": true,
              "gridColumnEnd": true,
              "gridColumnStart": true,
              "gridRow": true,
              "gridRowEnd": true,
              "gridRowStart": true,
              "lineHeight": true,
              "opacity": true,
              "order": true,
              "orphans": true,
              "widows": true,
              "zIndex": true,
              "zoom": true
            },

            // Add in properties whose names you wish to fix before
            // setting or getting the value
            cssProps: {},

            // Get and set the style property on a DOM Node
            style: function (elem, name, value, extra) {

              // Don't set styles on text and comment nodes
              if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
                return;
              }

              // Make sure that we're working with the right name
              var ret, type, hooks,
                origName = camelCase(name),
                isCustomProp = rcustomProp.test(name),
                style = elem.style;

              // Make sure that we're working with the right name. We don't
              // want to query the value if it is a CSS custom property
              // since they are user-defined.
              if (!isCustomProp) {
                name = finalPropName(origName);
              }

              // Gets hook for the prefixed version, then unprefixed version
              hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

              // Check if we're setting a value
              if (value !== undefined) {
                type = typeof value;

                // Convert "+=" or "-=" to relative numbers (#7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                  value = adjustCSS(elem, name, ret);

                  // Fixes bug #9237
                  type = "number";
                }

                // Make sure that null and NaN values aren't set (#7116)
                if (value == null || value !== value) {
                  return;
                }

                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) {
                  value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                }

                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
                  style[name] = "inherit";
                }

                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) ||
                  (value = hooks.set(elem, value, extra)) !== undefined) {

                  if (isCustomProp) {
                    style.setProperty(name, value);
                  } else {
                    style[name] = value;
                  }
                }

              } else {

                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks &&
                  (ret = hooks.get(elem, false, extra)) !== undefined) {

                  return ret;
                }

                // Otherwise just get the value from the style object
                return style[name];
              }
            },

            css: function (elem, name, extra, styles) {
              var val, num, hooks,
                origName = camelCase(name),
                isCustomProp = rcustomProp.test(name);

              // Make sure that we're working with the right name. We don't
              // want to modify the value if it is a CSS custom property
              // since they are user-defined.
              if (!isCustomProp) {
                name = finalPropName(origName);
              }

              // Try prefixed name followed by the unprefixed name
              hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

              // If a hook was provided get the computed value from there
              if (hooks && "get" in hooks) {
                val = hooks.get(elem, true, extra);
              }

              // Otherwise, if a way to get the computed value exists, use that
              if (val === undefined) {
                val = curCSS(elem, name, styles);
              }

              // Convert "normal" to computed value
              if (val === "normal" && name in cssNormalTransform) {
                val = cssNormalTransform[name];
              }

              // Make numeric if forced or a qualifier was provided and val looks numeric
              if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
              }

              return val;
            }
          });

          jQuery.each(["height", "width"], function (_i, dimension) {
            jQuery.cssHooks[dimension] = {
              get: function (elem, computed, extra) {
                if (computed) {

                  // Certain elements can have dimension info if we invisibly show them
                  // but it must have a current display style that would benefit
                  return rdisplayswap.test(jQuery.css(elem, "display")) &&

                    // Support: Safari 8+
                    // Table columns in Safari have non-zero offsetWidth & zero
                    // getBoundingClientRect().width unless display is changed.
                    // Support: IE <=11 only
                    // Running getBoundingClientRect on a disconnected node
                    // in IE throws an error.
                    (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ?
                    swap(elem, cssShow, function () {
                      return getWidthOrHeight(elem, dimension, extra);
                    }) :
                    getWidthOrHeight(elem, dimension, extra);
                }
              },

              set: function (elem, value, extra) {
                var matches,
                  styles = getStyles(elem),

                  // Only read styles.position if the test has a chance to fail
                  // to avoid forcing a reflow.
                  scrollboxSizeBuggy = !support.scrollboxSize() &&
                    styles.position === "absolute",

                  // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                  boxSizingNeeded = scrollboxSizeBuggy || extra,
                  isBorderBox = boxSizingNeeded &&
                    jQuery.css(elem, "boxSizing", false, styles) === "border-box",
                  subtract = extra ?
                    boxModelAdjustment(
                      elem,
                      dimension,
                      extra,
                      isBorderBox,
                      styles
                    ) :
                    0;

                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) {
                  subtract -= Math.ceil(
                    elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] -
                    parseFloat(styles[dimension]) -
                    boxModelAdjustment(elem, dimension, "border", false, styles) -
                    0.5
                  );
                }

                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) &&
                  (matches[3] || "px") !== "px") {

                  elem.style[dimension] = value;
                  value = jQuery.css(elem, dimension);
                }

                return setPositiveNumber(elem, value, subtract);
              }
            };
          });

          jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft,
            function (elem, computed) {
              if (computed) {
                return (parseFloat(curCSS(elem, "marginLeft")) ||
                  elem.getBoundingClientRect().left -
                  swap(elem, { marginLeft: 0 }, function () {
                    return elem.getBoundingClientRect().left;
                  })
                ) + "px";
              }
            }
          );

          // These hooks are used by animate to expand properties
          jQuery.each({
            margin: "",
            padding: "",
            border: "Width"
          }, function (prefix, suffix) {
            jQuery.cssHooks[prefix + suffix] = {
              expand: function (value) {
                var i = 0,
                  expanded = {},

                  // Assumes a single number if not a string
                  parts = typeof value === "string" ? value.split(" ") : [value];

                for (; i < 4; i++) {
                  expanded[prefix + cssExpand[i] + suffix] =
                    parts[i] || parts[i - 2] || parts[0];
                }

                return expanded;
              }
            };

            if (prefix !== "margin") {
              jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
            }
          });

          jQuery.fn.extend({
            css: function (name, value) {
              return access(this, function (elem, name, value) {
                var styles, len,
                  map = {},
                  i = 0;

                if (Array.isArray(name)) {
                  styles = getStyles(elem);
                  len = name.length;

                  for (; i < len; i++) {
                    map[name[i]] = jQuery.css(elem, name[i], false, styles);
                  }

                  return map;
                }

                return value !== undefined ?
                  jQuery.style(elem, name, value) :
                  jQuery.css(elem, name);
              }, name, value, arguments.length > 1);
            }
          });


          function Tween(elem, options, prop, end, easing) {
            return new Tween.prototype.init(elem, options, prop, end, easing);
          }
          jQuery.Tween = Tween;

          Tween.prototype = {
            constructor: Tween,
            init: function (elem, options, prop, end, easing, unit) {
              this.elem = elem;
              this.prop = prop;
              this.easing = easing || jQuery.easing._default;
              this.options = options;
              this.start = this.now = this.cur();
              this.end = end;
              this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
            },
            cur: function () {
              var hooks = Tween.propHooks[this.prop];

              return hooks && hooks.get ?
                hooks.get(this) :
                Tween.propHooks._default.get(this);
            },
            run: function (percent) {
              var eased,
                hooks = Tween.propHooks[this.prop];

              if (this.options.duration) {
                this.pos = eased = jQuery.easing[this.easing](
                  percent, this.options.duration * percent, 0, 1, this.options.duration
                );
              } else {
                this.pos = eased = percent;
              }
              this.now = (this.end - this.start) * eased + this.start;

              if (this.options.step) {
                this.options.step.call(this.elem, this.now, this);
              }

              if (hooks && hooks.set) {
                hooks.set(this);
              } else {
                Tween.propHooks._default.set(this);
              }
              return this;
            }
          };

          Tween.prototype.init.prototype = Tween.prototype;

          Tween.propHooks = {
            _default: {
              get: function (tween) {
                var result;

                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 ||
                  tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
                  return tween.elem[tween.prop];
                }

                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");

                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
              },
              set: function (tween) {

                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) {
                  jQuery.fx.step[tween.prop](tween);
                } else if (tween.elem.nodeType === 1 && (
                  jQuery.cssHooks[tween.prop] ||
                  tween.elem.style[finalPropName(tween.prop)] != null)) {
                  jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                } else {
                  tween.elem[tween.prop] = tween.now;
                }
              }
            }
          };

          // Support: IE <=9 only
          // Panic based approach to setting things on disconnected nodes
          Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
            set: function (tween) {
              if (tween.elem.nodeType && tween.elem.parentNode) {
                tween.elem[tween.prop] = tween.now;
              }
            }
          };

          jQuery.easing = {
            linear: function (p) {
              return p;
            },
            swing: function (p) {
              return 0.5 - Math.cos(p * Math.PI) / 2;
            },
            _default: "swing"
          };

          jQuery.fx = Tween.prototype.init;

          // Back compat <1.8 extension point
          jQuery.fx.step = {};




          var
            fxNow, inProgress,
            rfxtypes = /^(?:toggle|show|hide)$/,
            rrun = /queueHooks$/;

          function schedule() {
            if (inProgress) {
              if (document.hidden === false && window.requestAnimationFrame) {
                window.requestAnimationFrame(schedule);
              } else {
                window.setTimeout(schedule, jQuery.fx.interval);
              }

              jQuery.fx.tick();
            }
          }

          // Animations created synchronously will run synchronously
          function createFxNow() {
            window.setTimeout(function () {
              fxNow = undefined;
            });
            return (fxNow = Date.now());
          }

          // Generate parameters to create a standard animation
          function genFx(type, includeWidth) {
            var which,
              i = 0,
              attrs = { height: type };

            // If we include width, step value is 1 to do all cssExpand values,
            // otherwise step value is 2 to skip over Left and Right
            includeWidth = includeWidth ? 1 : 0;
            for (; i < 4; i += 2 - includeWidth) {
              which = cssExpand[i];
              attrs["margin" + which] = attrs["padding" + which] = type;
            }

            if (includeWidth) {
              attrs.opacity = attrs.width = type;
            }

            return attrs;
          }

          function createTween(value, prop, animation) {
            var tween,
              collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]),
              index = 0,
              length = collection.length;
            for (; index < length; index++) {
              if ((tween = collection[index].call(animation, prop, value))) {

                // We're done with this property
                return tween;
              }
            }
          }

          function defaultPrefilter(elem, props, opts) {
            var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
              isBox = "width" in props || "height" in props,
              anim = this,
              orig = {},
              style = elem.style,
              hidden = elem.nodeType && isHiddenWithinTree(elem),
              dataShow = dataPriv.get(elem, "fxshow");

            // Queue-skipping animations hijack the fx hooks
            if (!opts.queue) {
              hooks = jQuery._queueHooks(elem, "fx");
              if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function () {
                  if (!hooks.unqueued) {
                    oldfire();
                  }
                };
              }
              hooks.unqueued++;

              anim.always(function () {

                // Ensure the complete handler is called before this completes
                anim.always(function () {
                  hooks.unqueued--;
                  if (!jQuery.queue(elem, "fx").length) {
                    hooks.empty.fire();
                  }
                });
              });
            }

            // Detect show/hide animations
            for (prop in props) {
              value = props[prop];
              if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {

                  // Pretend to be hidden if this is a "show" and
                  // there is still data from a stopped show/hide
                  if (value === "show" && dataShow && dataShow[prop] !== undefined) {
                    hidden = true;

                    // Ignore all other no-op show/hide data
                  } else {
                    continue;
                  }
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
              }
            }

            // Bail out if this is a no-op like .hide().hide()
            propTween = !jQuery.isEmptyObject(props);
            if (!propTween && jQuery.isEmptyObject(orig)) {
              return;
            }

            // Restrict "overflow" and "display" styles during box animations
            if (isBox && elem.nodeType === 1) {

              // Support: IE <=9 - 11, Edge 12 - 15
              // Record all 3 overflow attributes because IE does not infer the shorthand
              // from identically-valued overflowX and overflowY and Edge just mirrors
              // the overflowX value there.
              opts.overflow = [style.overflow, style.overflowX, style.overflowY];

              // Identify a display type, preferring old show/hide data over the CSS cascade
              restoreDisplay = dataShow && dataShow.display;
              if (restoreDisplay == null) {
                restoreDisplay = dataPriv.get(elem, "display");
              }
              display = jQuery.css(elem, "display");
              if (display === "none") {
                if (restoreDisplay) {
                  display = restoreDisplay;
                } else {

                  // Get nonempty value(s) by temporarily forcing visibility
                  showHide([elem], true);
                  restoreDisplay = elem.style.display || restoreDisplay;
                  display = jQuery.css(elem, "display");
                  showHide([elem]);
                }
              }

              // Animate inline elements as inline-block
              if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {

                  // Restore the original display value at the end of pure show/hide animations
                  if (!propTween) {
                    anim.done(function () {
                      style.display = restoreDisplay;
                    });
                    if (restoreDisplay == null) {
                      display = style.display;
                      restoreDisplay = display === "none" ? "" : display;
                    }
                  }
                  style.display = "inline-block";
                }
              }
            }

            if (opts.overflow) {
              style.overflow = "hidden";
              anim.always(function () {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
              });
            }

            // Implement show/hide animations
            propTween = false;
            for (prop in orig) {

              // General show/hide setup for this element animation
              if (!propTween) {
                if (dataShow) {
                  if ("hidden" in dataShow) {
                    hidden = dataShow.hidden;
                  }
                } else {
                  dataShow = dataPriv.access(elem, "fxshow", { display: restoreDisplay });
                }

                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) {
                  dataShow.hidden = !hidden;
                }

                // Show elements before animating them
                if (hidden) {
                  showHide([elem], true);
                }

                /* eslint-disable no-loop-func */

                anim.done(function () {

                  /* eslint-enable no-loop-func */

                  // The final step of a "hide" animation is actually hiding the element
                  if (!hidden) {
                    showHide([elem]);
                  }
                  dataPriv.remove(elem, "fxshow");
                  for (prop in orig) {
                    jQuery.style(elem, prop, orig[prop]);
                  }
                });
              }

              // Per-property setup
              propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
              if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                  propTween.end = propTween.start;
                  propTween.start = 0;
                }
              }
            }
          }

          function propFilter(props, specialEasing) {
            var index, name, easing, value, hooks;

            // camelCase, specialEasing and expand cssHook pass
            for (index in props) {
              name = camelCase(index);
              easing = specialEasing[name];
              value = props[index];
              if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
              }

              if (index !== name) {
                props[name] = value;
                delete props[index];
              }

              hooks = jQuery.cssHooks[name];
              if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];

                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for (index in value) {
                  if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                  }
                }
              } else {
                specialEasing[name] = easing;
              }
            }
          }

          function Animation(elem, properties, options) {
            var result,
              stopped,
              index = 0,
              length = Animation.prefilters.length,
              deferred = jQuery.Deferred().always(function () {

                // Don't match elem in the :animated selector
                delete tick.elem;
              }),
              tick = function () {
                if (stopped) {
                  return false;
                }
                var currentTime = fxNow || createFxNow(),
                  remaining = Math.max(0, animation.startTime + animation.duration - currentTime),

                  // Support: Android 2.3 only
                  // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
                  temp = remaining / animation.duration || 0,
                  percent = 1 - temp,
                  index = 0,
                  length = animation.tweens.length;

                for (; index < length; index++) {
                  animation.tweens[index].run(percent);
                }

                deferred.notifyWith(elem, [animation, percent, remaining]);

                // If there's more to do, yield
                if (percent < 1 && length) {
                  return remaining;
                }

                // If this was an empty animation, synthesize a final progress notification
                if (!length) {
                  deferred.notifyWith(elem, [animation, 1, 0]);
                }

                // Resolve the animation and report its conclusion
                deferred.resolveWith(elem, [animation]);
                return false;
              },
              animation = deferred.promise({
                elem: elem,
                props: jQuery.extend({}, properties),
                opts: jQuery.extend(true, {
                  specialEasing: {},
                  easing: jQuery.easing._default
                }, options),
                originalProperties: properties,
                originalOptions: options,
                startTime: fxNow || createFxNow(),
                duration: options.duration,
                tweens: [],
                createTween: function (prop, end) {
                  var tween = jQuery.Tween(elem, animation.opts, prop, end,
                    animation.opts.specialEasing[prop] || animation.opts.easing);
                  animation.tweens.push(tween);
                  return tween;
                },
                stop: function (gotoEnd) {
                  var index = 0,

                    // If we are going to the end, we want to run all the tweens
                    // otherwise we skip this part
                    length = gotoEnd ? animation.tweens.length : 0;
                  if (stopped) {
                    return this;
                  }
                  stopped = true;
                  for (; index < length; index++) {
                    animation.tweens[index].run(1);
                  }

                  // Resolve when we played the last frame; otherwise, reject
                  if (gotoEnd) {
                    deferred.notifyWith(elem, [animation, 1, 0]);
                    deferred.resolveWith(elem, [animation, gotoEnd]);
                  } else {
                    deferred.rejectWith(elem, [animation, gotoEnd]);
                  }
                  return this;
                }
              }),
              props = animation.props;

            propFilter(props, animation.opts.specialEasing);

            for (; index < length; index++) {
              result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
              if (result) {
                if (isFunction(result.stop)) {
                  jQuery._queueHooks(animation.elem, animation.opts.queue).stop =
                    result.stop.bind(result);
                }
                return result;
              }
            }

            jQuery.map(props, createTween, animation);

            if (isFunction(animation.opts.start)) {
              animation.opts.start.call(elem, animation);
            }

            // Attach callbacks from options
            animation
              .progress(animation.opts.progress)
              .done(animation.opts.done, animation.opts.complete)
              .fail(animation.opts.fail)
              .always(animation.opts.always);

            jQuery.fx.timer(
              jQuery.extend(tick, {
                elem: elem,
                anim: animation,
                queue: animation.opts.queue
              })
            );

            return animation;
          }

          jQuery.Animation = jQuery.extend(Animation, {

            tweeners: {
              "*": [function (prop, value) {
                var tween = this.createTween(prop, value);
                adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                return tween;
              }]
            },

            tweener: function (props, callback) {
              if (isFunction(props)) {
                callback = props;
                props = ["*"];
              } else {
                props = props.match(rnothtmlwhite);
              }

              var prop,
                index = 0,
                length = props.length;

              for (; index < length; index++) {
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
              }
            },

            prefilters: [defaultPrefilter],

            prefilter: function (callback, prepend) {
              if (prepend) {
                Animation.prefilters.unshift(callback);
              } else {
                Animation.prefilters.push(callback);
              }
            }
          });

          jQuery.speed = function (speed, easing, fn) {
            var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
              complete: fn || !fn && easing ||
                isFunction(speed) && speed,
              duration: speed,
              easing: fn && easing || easing && !isFunction(easing) && easing
            };

            // Go to the end state if fx are off
            if (jQuery.fx.off) {
              opt.duration = 0;

            } else {
              if (typeof opt.duration !== "number") {
                if (opt.duration in jQuery.fx.speeds) {
                  opt.duration = jQuery.fx.speeds[opt.duration];

                } else {
                  opt.duration = jQuery.fx.speeds._default;
                }
              }
            }

            // Normalize opt.queue - true/undefined/null -> "fx"
            if (opt.queue == null || opt.queue === true) {
              opt.queue = "fx";
            }

            // Queueing
            opt.old = opt.complete;

            opt.complete = function () {
              if (isFunction(opt.old)) {
                opt.old.call(this);
              }

              if (opt.queue) {
                jQuery.dequeue(this, opt.queue);
              }
            };

            return opt;
          };

          jQuery.fn.extend({
            fadeTo: function (speed, to, easing, callback) {

              // Show any hidden elements after setting opacity to 0
              return this.filter(isHiddenWithinTree).css("opacity", 0).show()

                // Animate to the value specified
                .end().animate({ opacity: to }, speed, easing, callback);
            },
            animate: function (prop, speed, easing, callback) {
              var empty = jQuery.isEmptyObject(prop),
                optall = jQuery.speed(speed, easing, callback),
                doAnimation = function () {

                  // Operate on a copy of prop so per-property easing won't be lost
                  var anim = Animation(this, jQuery.extend({}, prop), optall);

                  // Empty animations, or finishing resolves immediately
                  if (empty || dataPriv.get(this, "finish")) {
                    anim.stop(true);
                  }
                };

              doAnimation.finish = doAnimation;

              return empty || optall.queue === false ?
                this.each(doAnimation) :
                this.queue(optall.queue, doAnimation);
            },
            stop: function (type, clearQueue, gotoEnd) {
              var stopQueue = function (hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
              };

              if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
              }
              if (clearQueue) {
                this.queue(type || "fx", []);
              }

              return this.each(function () {
                var dequeue = true,
                  index = type != null && type + "queueHooks",
                  timers = jQuery.timers,
                  data = dataPriv.get(this);

                if (index) {
                  if (data[index] && data[index].stop) {
                    stopQueue(data[index]);
                  }
                } else {
                  for (index in data) {
                    if (data[index] && data[index].stop && rrun.test(index)) {
                      stopQueue(data[index]);
                    }
                  }
                }

                for (index = timers.length; index--;) {
                  if (timers[index].elem === this &&
                    (type == null || timers[index].queue === type)) {

                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                  }
                }

                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) {
                  jQuery.dequeue(this, type);
                }
              });
            },
            finish: function (type) {
              if (type !== false) {
                type = type || "fx";
              }
              return this.each(function () {
                var index,
                  data = dataPriv.get(this),
                  queue = data[type + "queue"],
                  hooks = data[type + "queueHooks"],
                  timers = jQuery.timers,
                  length = queue ? queue.length : 0;

                // Enable finishing flag on private data
                data.finish = true;

                // Empty the queue first
                jQuery.queue(this, type, []);

                if (hooks && hooks.stop) {
                  hooks.stop.call(this, true);
                }

                // Look for any active animations, and finish them
                for (index = timers.length; index--;) {
                  if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                  }
                }

                // Look for any animations in the old queue and finish them
                for (index = 0; index < length; index++) {
                  if (queue[index] && queue[index].finish) {
                    queue[index].finish.call(this);
                  }
                }

                // Turn off finishing flag
                delete data.finish;
              });
            }
          });

          jQuery.each(["toggle", "show", "hide"], function (_i, name) {
            var cssFn = jQuery.fn[name];
            jQuery.fn[name] = function (speed, easing, callback) {
              return speed == null || typeof speed === "boolean" ?
                cssFn.apply(this, arguments) :
                this.animate(genFx(name, true), speed, easing, callback);
            };
          });

          // Generate shortcuts for custom animations
          jQuery.each({
            slideDown: genFx("show"),
            slideUp: genFx("hide"),
            slideToggle: genFx("toggle"),
            fadeIn: { opacity: "show" },
            fadeOut: { opacity: "hide" },
            fadeToggle: { opacity: "toggle" }
          }, function (name, props) {
            jQuery.fn[name] = function (speed, easing, callback) {
              return this.animate(props, speed, easing, callback);
            };
          });

          jQuery.timers = [];
          jQuery.fx.tick = function () {
            var timer,
              i = 0,
              timers = jQuery.timers;

            fxNow = Date.now();

            for (; i < timers.length; i++) {
              timer = timers[i];

              // Run the timer and safely remove it when done (allowing for external removal)
              if (!timer() && timers[i] === timer) {
                timers.splice(i--, 1);
              }
            }

            if (!timers.length) {
              jQuery.fx.stop();
            }
            fxNow = undefined;
          };

          jQuery.fx.timer = function (timer) {
            jQuery.timers.push(timer);
            jQuery.fx.start();
          };

          jQuery.fx.interval = 13;
          jQuery.fx.start = function () {
            if (inProgress) {
              return;
            }

            inProgress = true;
            schedule();
          };

          jQuery.fx.stop = function () {
            inProgress = null;
          };

          jQuery.fx.speeds = {
            slow: 600,
            fast: 200,

            // Default speed
            _default: 400
          };


          // Based off of the plugin by Clint Helfers, with permission.
          // https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
          jQuery.fn.delay = function (time, type) {
            time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
            type = type || "fx";

            return this.queue(type, function (next, hooks) {
              var timeout = window.setTimeout(next, time);
              hooks.stop = function () {
                window.clearTimeout(timeout);
              };
            });
          };


          (function () {
            var input = document.createElement("input"),
              select = document.createElement("select"),
              opt = select.appendChild(document.createElement("option"));

            input.type = "checkbox";

            // Support: Android <=4.3 only
            // Default value for a checkbox should be "on"
            support.checkOn = input.value !== "";

            // Support: IE <=11 only
            // Must access selectedIndex to make default options select
            support.optSelected = opt.selected;

            // Support: IE <=11 only
            // An input loses its value after becoming a radio
            input = document.createElement("input");
            input.value = "t";
            input.type = "radio";
            support.radioValue = input.value === "t";
          })();


          var boolHook,
            attrHandle = jQuery.expr.attrHandle;

          jQuery.fn.extend({
            attr: function (name, value) {
              return access(this, jQuery.attr, name, value, arguments.length > 1);
            },

            removeAttr: function (name) {
              return this.each(function () {
                jQuery.removeAttr(this, name);
              });
            }
          });

          jQuery.extend({
            attr: function (elem, name, value) {
              var ret, hooks,
                nType = elem.nodeType;

              // Don't get/set attributes on text, comment and attribute nodes
              if (nType === 3 || nType === 8 || nType === 2) {
                return;
              }

              // Fallback to prop when attributes are not supported
              if (typeof elem.getAttribute === "undefined") {
                return jQuery.prop(elem, name, value);
              }

              // Attribute hooks are determined by the lowercase version
              // Grab necessary hook if one is defined
              if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                hooks = jQuery.attrHooks[name.toLowerCase()] ||
                  (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
              }

              if (value !== undefined) {
                if (value === null) {
                  jQuery.removeAttr(elem, name);
                  return;
                }

                if (hooks && "set" in hooks &&
                  (ret = hooks.set(elem, value, name)) !== undefined) {
                  return ret;
                }

                elem.setAttribute(name, value + "");
                return value;
              }

              if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
                return ret;
              }

              ret = jQuery.find.attr(elem, name);

              // Non-existent attributes return null, we normalize to undefined
              return ret == null ? undefined : ret;
            },

            attrHooks: {
              type: {
                set: function (elem, value) {
                  if (!support.radioValue && value === "radio" &&
                    nodeName(elem, "input")) {
                    var val = elem.value;
                    elem.setAttribute("type", value);
                    if (val) {
                      elem.value = val;
                    }
                    return value;
                  }
                }
              }
            },

            removeAttr: function (elem, value) {
              var name,
                i = 0,

                // Attribute names can contain non-HTML whitespace characters
                // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
                attrNames = value && value.match(rnothtmlwhite);

              if (attrNames && elem.nodeType === 1) {
                while ((name = attrNames[i++])) {
                  elem.removeAttribute(name);
                }
              }
            }
          });

          // Hooks for boolean attributes
          boolHook = {
            set: function (elem, value, name) {
              if (value === false) {

                // Remove boolean attributes when set to false
                jQuery.removeAttr(elem, name);
              } else {
                elem.setAttribute(name, name);
              }
              return name;
            }
          };

          jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (_i, name) {
            var getter = attrHandle[name] || jQuery.find.attr;

            attrHandle[name] = function (elem, name, isXML) {
              var ret, handle,
                lowercaseName = name.toLowerCase();

              if (!isXML) {

                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ?
                  lowercaseName :
                  null;
                attrHandle[lowercaseName] = handle;
              }
              return ret;
            };
          });




          var rfocusable = /^(?:input|select|textarea|button)$/i,
            rclickable = /^(?:a|area)$/i;

          jQuery.fn.extend({
            prop: function (name, value) {
              return access(this, jQuery.prop, name, value, arguments.length > 1);
            },

            removeProp: function (name) {
              return this.each(function () {
                delete this[jQuery.propFix[name] || name];
              });
            }
          });

          jQuery.extend({
            prop: function (elem, name, value) {
              var ret, hooks,
                nType = elem.nodeType;

              // Don't get/set properties on text, comment and attribute nodes
              if (nType === 3 || nType === 8 || nType === 2) {
                return;
              }

              if (nType !== 1 || !jQuery.isXMLDoc(elem)) {

                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
              }

              if (value !== undefined) {
                if (hooks && "set" in hooks &&
                  (ret = hooks.set(elem, value, name)) !== undefined) {
                  return ret;
                }

                return (elem[name] = value);
              }

              if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
                return ret;
              }

              return elem[name];
            },

            propHooks: {
              tabIndex: {
                get: function (elem) {

                  // Support: IE <=9 - 11 only
                  // elem.tabIndex doesn't always return the
                  // correct value when it hasn't been explicitly set
                  // https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
                  // Use proper attribute retrieval(#12072)
                  var tabindex = jQuery.find.attr(elem, "tabindex");

                  if (tabindex) {
                    return parseInt(tabindex, 10);
                  }

                  if (
                    rfocusable.test(elem.nodeName) ||
                    rclickable.test(elem.nodeName) &&
                    elem.href
                  ) {
                    return 0;
                  }

                  return -1;
                }
              }
            },

            propFix: {
              "for": "htmlFor",
              "class": "className"
            }
          });

          // Support: IE <=11 only
          // Accessing the selectedIndex property
          // forces the browser to respect setting selected
          // on the option
          // The getter ensures a default option is selected
          // when in an optgroup
          // eslint rule "no-unused-expressions" is disabled for this code
          // since it considers such accessions noop
          if (!support.optSelected) {
            jQuery.propHooks.selected = {
              get: function (elem) {

                /* eslint no-unused-expressions: "off" */

                var parent = elem.parentNode;
                if (parent && parent.parentNode) {
                  parent.parentNode.selectedIndex;
                }
                return null;
              },
              set: function (elem) {

                /* eslint no-unused-expressions: "off" */

                var parent = elem.parentNode;
                if (parent) {
                  parent.selectedIndex;

                  if (parent.parentNode) {
                    parent.parentNode.selectedIndex;
                  }
                }
              }
            };
          }

          jQuery.each([
            "tabIndex",
            "readOnly",
            "maxLength",
            "cellSpacing",
            "cellPadding",
            "rowSpan",
            "colSpan",
            "useMap",
            "frameBorder",
            "contentEditable"
          ], function () {
            jQuery.propFix[this.toLowerCase()] = this;
          });




          // Strip and collapse whitespace according to HTML spec
          // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
          function stripAndCollapse(value) {
            var tokens = value.match(rnothtmlwhite) || [];
            return tokens.join(" ");
          }


          function getClass(elem) {
            return elem.getAttribute && elem.getAttribute("class") || "";
          }

          function classesToArray(value) {
            if (Array.isArray(value)) {
              return value;
            }
            if (typeof value === "string") {
              return value.match(rnothtmlwhite) || [];
            }
            return [];
          }

          jQuery.fn.extend({
            addClass: function (value) {
              var classes, elem, cur, curValue, clazz, j, finalValue,
                i = 0;

              if (isFunction(value)) {
                return this.each(function (j) {
                  jQuery(this).addClass(value.call(this, j, getClass(this)));
                });
              }

              classes = classesToArray(value);

              if (classes.length) {
                while ((elem = this[i++])) {
                  curValue = getClass(elem);
                  cur = elem.nodeType === 1 && (" " + stripAndCollapse(curValue) + " ");

                  if (cur) {
                    j = 0;
                    while ((clazz = classes[j++])) {
                      if (cur.indexOf(" " + clazz + " ") < 0) {
                        cur += clazz + " ";
                      }
                    }

                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) {
                      elem.setAttribute("class", finalValue);
                    }
                  }
                }
              }

              return this;
            },

            removeClass: function (value) {
              var classes, elem, cur, curValue, clazz, j, finalValue,
                i = 0;

              if (isFunction(value)) {
                return this.each(function (j) {
                  jQuery(this).removeClass(value.call(this, j, getClass(this)));
                });
              }

              if (!arguments.length) {
                return this.attr("class", "");
              }

              classes = classesToArray(value);

              if (classes.length) {
                while ((elem = this[i++])) {
                  curValue = getClass(elem);

                  // This expression is here for better compressibility (see addClass)
                  cur = elem.nodeType === 1 && (" " + stripAndCollapse(curValue) + " ");

                  if (cur) {
                    j = 0;
                    while ((clazz = classes[j++])) {

                      // Remove *all* instances
                      while (cur.indexOf(" " + clazz + " ") > -1) {
                        cur = cur.replace(" " + clazz + " ", " ");
                      }
                    }

                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) {
                      elem.setAttribute("class", finalValue);
                    }
                  }
                }
              }

              return this;
            },

            toggleClass: function (value, stateVal) {
              var type = typeof value,
                isValidValue = type === "string" || Array.isArray(value);

              if (typeof stateVal === "boolean" && isValidValue) {
                return stateVal ? this.addClass(value) : this.removeClass(value);
              }

              if (isFunction(value)) {
                return this.each(function (i) {
                  jQuery(this).toggleClass(
                    value.call(this, i, getClass(this), stateVal),
                    stateVal
                  );
                });
              }

              return this.each(function () {
                var className, i, self, classNames;

                if (isValidValue) {

                  // Toggle individual class names
                  i = 0;
                  self = jQuery(this);
                  classNames = classesToArray(value);

                  while ((className = classNames[i++])) {

                    // Check each className given, space separated list
                    if (self.hasClass(className)) {
                      self.removeClass(className);
                    } else {
                      self.addClass(className);
                    }
                  }

                  // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                  className = getClass(this);
                  if (className) {

                    // Store className if set
                    dataPriv.set(this, "__className__", className);
                  }

                  // If the element has a class name or if we're passed `false`,
                  // then remove the whole classname (if there was one, the above saved it).
                  // Otherwise bring back whatever was previously saved (if anything),
                  // falling back to the empty string if nothing was stored.
                  if (this.setAttribute) {
                    this.setAttribute("class",
                      className || value === false ?
                        "" :
                        dataPriv.get(this, "__className__") || ""
                    );
                  }
                }
              });
            },

            hasClass: function (selector) {
              var className, elem,
                i = 0;

              className = " " + selector + " ";
              while ((elem = this[i++])) {
                if (elem.nodeType === 1 &&
                  (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
                  return true;
                }
              }

              return false;
            }
          });




          var rreturn = /\r/g;

          jQuery.fn.extend({
            val: function (value) {
              var hooks, ret, valueIsFunction,
                elem = this[0];

              if (!arguments.length) {
                if (elem) {
                  hooks = jQuery.valHooks[elem.type] ||
                    jQuery.valHooks[elem.nodeName.toLowerCase()];

                  if (hooks &&
                    "get" in hooks &&
                    (ret = hooks.get(elem, "value")) !== undefined
                  ) {
                    return ret;
                  }

                  ret = elem.value;

                  // Handle most common string cases
                  if (typeof ret === "string") {
                    return ret.replace(rreturn, "");
                  }

                  // Handle cases where value is null/undef or number
                  return ret == null ? "" : ret;
                }

                return;
              }

              valueIsFunction = isFunction(value);

              return this.each(function (i) {
                var val;

                if (this.nodeType !== 1) {
                  return;
                }

                if (valueIsFunction) {
                  val = value.call(this, i, jQuery(this).val());
                } else {
                  val = value;
                }

                // Treat null/undefined as ""; convert numbers to string
                if (val == null) {
                  val = "";

                } else if (typeof val === "number") {
                  val += "";

                } else if (Array.isArray(val)) {
                  val = jQuery.map(val, function (value) {
                    return value == null ? "" : value + "";
                  });
                }

                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];

                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
                  this.value = val;
                }
              });
            }
          });

          jQuery.extend({
            valHooks: {
              option: {
                get: function (elem) {

                  var val = jQuery.find.attr(elem, "value");
                  return val != null ?
                    val :

                    // Support: IE <=10 - 11 only
                    // option.text throws exceptions (#14686, #14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
              },
              select: {
                get: function (elem) {
                  var value, option, i,
                    options = elem.options,
                    index = elem.selectedIndex,
                    one = elem.type === "select-one",
                    values = one ? null : [],
                    max = one ? index + 1 : options.length;

                  if (index < 0) {
                    i = max;

                  } else {
                    i = one ? index : 0;
                  }

                  // Loop through all the selected options
                  for (; i < max; i++) {
                    option = options[i];

                    // Support: IE <=9 only
                    // IE8-9 doesn't update selected after form reset (#2551)
                    if ((option.selected || i === index) &&

                      // Don't return options that are disabled or in a disabled optgroup
                      !option.disabled &&
                      (!option.parentNode.disabled ||
                        !nodeName(option.parentNode, "optgroup"))) {

                      // Get the specific value for the option
                      value = jQuery(option).val();

                      // We don't need an array for one selects
                      if (one) {
                        return value;
                      }

                      // Multi-Selects return an array
                      values.push(value);
                    }
                  }

                  return values;
                },

                set: function (elem, value) {
                  var optionSet, option,
                    options = elem.options,
                    values = jQuery.makeArray(value),
                    i = options.length;

                  while (i--) {
                    option = options[i];

                    /* eslint-disable no-cond-assign */

                    if (option.selected =
                      jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1
                    ) {
                      optionSet = true;
                    }

                    /* eslint-enable no-cond-assign */
                  }

                  // Force browsers to behave consistently when non-matching value is set
                  if (!optionSet) {
                    elem.selectedIndex = -1;
                  }
                  return values;
                }
              }
            }
          });

          // Radios and checkboxes getter/setter
          jQuery.each(["radio", "checkbox"], function () {
            jQuery.valHooks[this] = {
              set: function (elem, value) {
                if (Array.isArray(value)) {
                  return (elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1);
                }
              }
            };
            if (!support.checkOn) {
              jQuery.valHooks[this].get = function (elem) {
                return elem.getAttribute("value") === null ? "on" : elem.value;
              };
            }
          });




          // Return jQuery for attributes-only inclusion


          support.focusin = "onfocusin" in window;


          var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
            stopPropagationCallback = function (e) {
              e.stopPropagation();
            };

          jQuery.extend(jQuery.event, {

            trigger: function (event, data, elem, onlyHandlers) {

              var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
                eventPath = [elem || document],
                type = hasOwn.call(event, "type") ? event.type : event,
                namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];

              cur = lastElement = tmp = elem = elem || document;

              // Don't do events on text and comment nodes
              if (elem.nodeType === 3 || elem.nodeType === 8) {
                return;
              }

              // focus/blur morphs to focusin/out; ensure we're not firing them right now
              if (rfocusMorph.test(type + jQuery.event.triggered)) {
                return;
              }

              if (type.indexOf(".") > -1) {

                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
              }
              ontype = type.indexOf(":") < 0 && "on" + type;

              // Caller can pass in a jQuery.Event object, Object, or just an event type string
              event = event[jQuery.expando] ?
                event :
                new jQuery.Event(type, typeof event === "object" && event);

              // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
              event.isTrigger = onlyHandlers ? 2 : 3;
              event.namespace = namespaces.join(".");
              event.rnamespace = event.namespace ?
                new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") :
                null;

              // Clean up the event in case it is being reused
              event.result = undefined;
              if (!event.target) {
                event.target = elem;
              }

              // Clone any incoming data and prepend the event, creating the handler arg list
              data = data == null ?
                [event] :
                jQuery.makeArray(data, [event]);

              // Allow special events to draw outside the lines
              special = jQuery.event.special[type] || {};
              if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
                return;
              }

              // Determine event propagation path in advance, per W3C events spec (#9951)
              // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
              if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {

                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) {
                  cur = cur.parentNode;
                }
                for (; cur; cur = cur.parentNode) {
                  eventPath.push(cur);
                  tmp = cur;
                }

                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) {
                  eventPath.push(tmp.defaultView || tmp.parentWindow || window);
                }
              }

              // Fire handlers on the event path
              i = 0;
              while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
                lastElement = cur;
                event.type = i > 1 ?
                  bubbleType :
                  special.bindType || type;

                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] &&
                  dataPriv.get(cur, "handle");
                if (handle) {
                  handle.apply(cur, data);
                }

                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                  event.result = handle.apply(cur, data);
                  if (event.result === false) {
                    event.preventDefault();
                  }
                }
              }
              event.type = type;

              // If nobody prevented the default action, do it now
              if (!onlyHandlers && !event.isDefaultPrevented()) {

                if ((!special._default ||
                  special._default.apply(eventPath.pop(), data) === false) &&
                  acceptData(elem)) {

                  // Call a native DOM method on the target with the same name as the event.
                  // Don't do default actions on window, that's where global variables be (#6170)
                  if (ontype && isFunction(elem[type]) && !isWindow(elem)) {

                    // Don't re-trigger an onFOO event when we call its FOO() method
                    tmp = elem[ontype];

                    if (tmp) {
                      elem[ontype] = null;
                    }

                    // Prevent re-triggering of the same event, since we already bubbled it above
                    jQuery.event.triggered = type;

                    if (event.isPropagationStopped()) {
                      lastElement.addEventListener(type, stopPropagationCallback);
                    }

                    elem[type]();

                    if (event.isPropagationStopped()) {
                      lastElement.removeEventListener(type, stopPropagationCallback);
                    }

                    jQuery.event.triggered = undefined;

                    if (tmp) {
                      elem[ontype] = tmp;
                    }
                  }
                }
              }

              return event.result;
            },

            // Piggyback on a donor event to simulate a different one
            // Used only for `focus(in | out)` events
            simulate: function (type, elem, event) {
              var e = jQuery.extend(
                new jQuery.Event(),
                event,
                {
                  type: type,
                  isSimulated: true
                }
              );

              jQuery.event.trigger(e, null, elem);
            }

          });

          jQuery.fn.extend({

            trigger: function (type, data) {
              return this.each(function () {
                jQuery.event.trigger(type, data, this);
              });
            },
            triggerHandler: function (type, data) {
              var elem = this[0];
              if (elem) {
                return jQuery.event.trigger(type, data, elem, true);
              }
            }
          });


          // Support: Firefox <=44
          // Firefox doesn't have focus(in | out) events
          // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
          //
          // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
          // focus(in | out) events fire after focus & blur events,
          // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
          // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
          if (!support.focusin) {
            jQuery.each({ focus: "focusin", blur: "focusout" }, function (orig, fix) {

              // Attach a single capturing handler on the document while someone wants focusin/focusout
              var handler = function (event) {
                jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
              };

              jQuery.event.special[fix] = {
                setup: function () {

                  // Handle: regular nodes (via `this.ownerDocument`), window
                  // (via `this.document`) & document (via `this`).
                  var doc = this.ownerDocument || this.document || this,
                    attaches = dataPriv.access(doc, fix);

                  if (!attaches) {
                    doc.addEventListener(orig, handler, true);
                  }
                  dataPriv.access(doc, fix, (attaches || 0) + 1);
                },
                teardown: function () {
                  var doc = this.ownerDocument || this.document || this,
                    attaches = dataPriv.access(doc, fix) - 1;

                  if (!attaches) {
                    doc.removeEventListener(orig, handler, true);
                    dataPriv.remove(doc, fix);

                  } else {
                    dataPriv.access(doc, fix, attaches);
                  }
                }
              };
            });
          }
          var location = window.location;

          var nonce = { guid: Date.now() };

          var rquery = (/\?/);



          // Cross-browser xml parsing
          jQuery.parseXML = function (data) {
            var xml, parserErrorElem;
            if (!data || typeof data !== "string") {
              return null;
            }

            // Support: IE 9 - 11 only
            // IE throws on parseFromString with invalid input.
            try {
              xml = (new window.DOMParser()).parseFromString(data, "text/xml");
            } catch (e) { }

            parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
            if (!xml || parserErrorElem) {
              jQuery.error("Invalid XML: " + (
                parserErrorElem ?
                  jQuery.map(parserErrorElem.childNodes, function (el) {
                    return el.textContent;
                  }).join("\n") :
                  data
              ));
            }
            return xml;
          };


          var
            rbracket = /\[\]$/,
            rCRLF = /\r?\n/g,
            rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
            rsubmittable = /^(?:input|select|textarea|keygen)/i;

          function buildParams(prefix, obj, traditional, add) {
            var name;

            if (Array.isArray(obj)) {

              // Serialize array item.
              jQuery.each(obj, function (i, v) {
                if (traditional || rbracket.test(prefix)) {

                  // Treat each array item as a scalar.
                  add(prefix, v);

                } else {

                  // Item is non-scalar (array or object), encode its numeric index.
                  buildParams(
                    prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]",
                    v,
                    traditional,
                    add
                  );
                }
              });

            } else if (!traditional && toType(obj) === "object") {

              // Serialize object item.
              for (name in obj) {
                buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
              }

            } else {

              // Serialize scalar item.
              add(prefix, obj);
            }
          }

          // Serialize an array of form elements or a set of
          // key/values into a query string
          jQuery.param = function (a, traditional) {
            var prefix,
              s = [],
              add = function (key, valueOrFunction) {

                // If value is a function, invoke it and use its return value
                var value = isFunction(valueOrFunction) ?
                  valueOrFunction() :
                  valueOrFunction;

                s[s.length] = encodeURIComponent(key) + "=" +
                  encodeURIComponent(value == null ? "" : value);
              };

            if (a == null) {
              return "";
            }

            // If an array was passed in, assume that it is an array of form elements.
            if (Array.isArray(a) || (a.jquery && !jQuery.isPlainObject(a))) {

              // Serialize the form elements
              jQuery.each(a, function () {
                add(this.name, this.value);
              });

            } else {

              // If traditional, encode the "old" way (the way 1.3.2 or older
              // did it), otherwise encode params recursively.
              for (prefix in a) {
                buildParams(prefix, a[prefix], traditional, add);
              }
            }

            // Return the resulting serialization
            return s.join("&");
          };

          jQuery.fn.extend({
            serialize: function () {
              return jQuery.param(this.serializeArray());
            },
            serializeArray: function () {
              return this.map(function () {

                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
              }).filter(function () {
                var type = this.type;

                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") &&
                  rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) &&
                  (this.checked || !rcheckableType.test(type));
              }).map(function (_i, elem) {
                var val = jQuery(this).val();

                if (val == null) {
                  return null;
                }

                if (Array.isArray(val)) {
                  return jQuery.map(val, function (val) {
                    return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
                  });
                }

                return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
              }).get();
            }
          });


          var
            r20 = /%20/g,
            rhash = /#.*$/,
            rantiCache = /([?&])_=[^&]*/,
            rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

            // #7653, #8125, #8152: local protocol detection
            rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
            rnoContent = /^(?:GET|HEAD)$/,
            rprotocol = /^\/\//,

            /* Prefilters
             * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
             * 2) These are called:
             *    - BEFORE asking for a transport
             *    - AFTER param serialization (s.data is a string if s.processData is true)
             * 3) key is the dataType
             * 4) the catchall symbol "*" can be used
             * 5) execution will start with transport dataType and THEN continue down to "*" if needed
             */
            prefilters = {},

            /* Transports bindings
             * 1) key is the dataType
             * 2) the catchall symbol "*" can be used
             * 3) selection will start with transport dataType and THEN go to "*" if needed
             */
            transports = {},

            // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
            allTypes = "*/".concat("*"),

            // Anchor tag for parsing the document origin
            originAnchor = document.createElement("a");

          originAnchor.href = location.href;

          // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
          function addToPrefiltersOrTransports(structure) {

            // dataTypeExpression is optional and defaults to "*"
            return function (dataTypeExpression, func) {

              if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
              }

              var dataType,
                i = 0,
                dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];

              if (isFunction(func)) {

                // For each dataType in the dataTypeExpression
                while ((dataType = dataTypes[i++])) {

                  // Prepend if requested
                  if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);

                    // Otherwise append
                  } else {
                    (structure[dataType] = structure[dataType] || []).push(func);
                  }
                }
              }
            };
          }

          // Base inspection function for prefilters and transports
          function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {

            var inspected = {},
              seekingTransport = (structure === transports);

            function inspect(dataType) {
              var selected;
              inspected[dataType] = true;
              jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" &&
                  !seekingTransport && !inspected[dataTypeOrTransport]) {

                  options.dataTypes.unshift(dataTypeOrTransport);
                  inspect(dataTypeOrTransport);
                  return false;
                } else if (seekingTransport) {
                  return !(selected = dataTypeOrTransport);
                }
              });
              return selected;
            }

            return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
          }

          // A special extend for ajax options
          // that takes "flat" options (not to be deep extended)
          // Fixes #9887
          function ajaxExtend(target, src) {
            var key, deep,
              flatOptions = jQuery.ajaxSettings.flatOptions || {};

            for (key in src) {
              if (src[key] !== undefined) {
                (flatOptions[key] ? target : (deep || (deep = {})))[key] = src[key];
              }
            }
            if (deep) {
              jQuery.extend(true, target, deep);
            }

            return target;
          }

          /* Handles responses to an ajax request:
           * - finds the right dataType (mediates between content-type and expected dataType)
           * - returns the corresponding response
           */
          function ajaxHandleResponses(s, jqXHR, responses) {

            var ct, type, finalDataType, firstDataType,
              contents = s.contents,
              dataTypes = s.dataTypes;

            // Remove auto dataType and get content-type in the process
            while (dataTypes[0] === "*") {
              dataTypes.shift();
              if (ct === undefined) {
                ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
              }
            }

            // Check if we're dealing with a known content-type
            if (ct) {
              for (type in contents) {
                if (contents[type] && contents[type].test(ct)) {
                  dataTypes.unshift(type);
                  break;
                }
              }
            }

            // Check to see if we have a response for the expected dataType
            if (dataTypes[0] in responses) {
              finalDataType = dataTypes[0];
            } else {

              // Try convertible dataTypes
              for (type in responses) {
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                  finalDataType = type;
                  break;
                }
                if (!firstDataType) {
                  firstDataType = type;
                }
              }

              // Or just use first one
              finalDataType = finalDataType || firstDataType;
            }

            // If we found a dataType
            // We add the dataType to the list if needed
            // and return the corresponding response
            if (finalDataType) {
              if (finalDataType !== dataTypes[0]) {
                dataTypes.unshift(finalDataType);
              }
              return responses[finalDataType];
            }
          }

          /* Chain conversions given the request and the original response
           * Also sets the responseXXX fields on the jqXHR instance
           */
          function ajaxConvert(s, response, jqXHR, isSuccess) {
            var conv2, current, conv, tmp, prev,
              converters = {},

              // Work with a copy of dataTypes in case we need to modify it for conversion
              dataTypes = s.dataTypes.slice();

            // Create converters map with lowercased keys
            if (dataTypes[1]) {
              for (conv in s.converters) {
                converters[conv.toLowerCase()] = s.converters[conv];
              }
            }

            current = dataTypes.shift();

            // Convert to each sequential dataType
            while (current) {

              if (s.responseFields[current]) {
                jqXHR[s.responseFields[current]] = response;
              }

              // Apply the dataFilter if provided
              if (!prev && isSuccess && s.dataFilter) {
                response = s.dataFilter(response, s.dataType);
              }

              prev = current;
              current = dataTypes.shift();

              if (current) {

                // There's only work to do if current dataType is non-auto
                if (current === "*") {

                  current = prev;

                  // Convert response if prev dataType is non-auto and differs from current
                } else if (prev !== "*" && prev !== current) {

                  // Seek a direct converter
                  conv = converters[prev + " " + current] || converters["* " + current];

                  // If none found, seek a pair
                  if (!conv) {
                    for (conv2 in converters) {

                      // If conv2 outputs current
                      tmp = conv2.split(" ");
                      if (tmp[1] === current) {

                        // If prev can be converted to accepted input
                        conv = converters[prev + " " + tmp[0]] ||
                          converters["* " + tmp[0]];
                        if (conv) {

                          // Condense equivalence converters
                          if (conv === true) {
                            conv = converters[conv2];

                            // Otherwise, insert the intermediate dataType
                          } else if (converters[conv2] !== true) {
                            current = tmp[0];
                            dataTypes.unshift(tmp[1]);
                          }
                          break;
                        }
                      }
                    }
                  }

                  // Apply converter (if not an equivalence)
                  if (conv !== true) {

                    // Unless errors are allowed to bubble, catch and return them
                    if (conv && s.throws) {
                      response = conv(response);
                    } else {
                      try {
                        response = conv(response);
                      } catch (e) {
                        return {
                          state: "parsererror",
                          error: conv ? e : "No conversion from " + prev + " to " + current
                        };
                      }
                    }
                  }
                }
              }
            }

            return { state: "success", data: response };
          }

          jQuery.extend({

            // Counter for holding the number of active queries
            active: 0,

            // Last-Modified header cache for next request
            lastModified: {},
            etag: {},

            ajaxSettings: {
              url: location.href,
              type: "GET",
              isLocal: rlocalProtocol.test(location.protocol),
              global: true,
              processData: true,
              async: true,
              contentType: "application/x-www-form-urlencoded; charset=UTF-8",

              /*
              timeout: 0,
              data: null,
              dataType: null,
              username: null,
              password: null,
              cache: null,
              throws: false,
              traditional: false,
              headers: {},
              */

              accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
              },

              contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
              },

              responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
              },

              // Data converters
              // Keys separate source (or catchall "*") and destination types with a single space
              converters: {

                // Convert anything to text
                "* text": String,

                // Text to html (true = no transformation)
                "text html": true,

                // Evaluate text as a json expression
                "text json": JSON.parse,

                // Parse text as xml
                "text xml": jQuery.parseXML
              },

              // For options that shouldn't be deep extended:
              // you can add your own custom options here if
              // and when you create one that shouldn't be
              // deep extended (see ajaxExtend)
              flatOptions: {
                url: true,
                context: true
              }
            },

            // Creates a full fledged settings object into target
            // with both ajaxSettings and settings fields.
            // If target is omitted, writes into ajaxSettings.
            ajaxSetup: function (target, settings) {
              return settings ?

                // Building a settings object
                ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) :

                // Extending ajaxSettings
                ajaxExtend(jQuery.ajaxSettings, target);
            },

            ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
            ajaxTransport: addToPrefiltersOrTransports(transports),

            // Main method
            ajax: function (url, options) {

              // If url is an object, simulate pre-1.5 signature
              if (typeof url === "object") {
                options = url;
                url = undefined;
              }

              // Force options to be an object
              options = options || {};

              var transport,

                // URL without anti-cache param
                cacheURL,

                // Response headers
                responseHeadersString,
                responseHeaders,

                // timeout handle
                timeoutTimer,

                // Url cleanup var
                urlAnchor,

                // Request state (becomes false upon send and true upon completion)
                completed,

                // To know if global events are to be dispatched
                fireGlobals,

                // Loop variable
                i,

                // uncached part of the url
                uncached,

                // Create the final options object
                s = jQuery.ajaxSetup({}, options),

                // Callbacks context
                callbackContext = s.context || s,

                // Context for global events is callbackContext if it is a DOM node or jQuery collection
                globalEventContext = s.context &&
                  (callbackContext.nodeType || callbackContext.jquery) ?
                  jQuery(callbackContext) :
                  jQuery.event,

                // Deferreds
                deferred = jQuery.Deferred(),
                completeDeferred = jQuery.Callbacks("once memory"),

                // Status-dependent callbacks
                statusCode = s.statusCode || {},

                // Headers (they are sent all at once)
                requestHeaders = {},
                requestHeadersNames = {},

                // Default abort message
                strAbort = "canceled",

                // Fake xhr
                jqXHR = {
                  readyState: 0,

                  // Builds headers hashtable if needed
                  getResponseHeader: function (key) {
                    var match;
                    if (completed) {
                      if (!responseHeaders) {
                        responseHeaders = {};
                        while ((match = rheaders.exec(responseHeadersString))) {
                          responseHeaders[match[1].toLowerCase() + " "] =
                            (responseHeaders[match[1].toLowerCase() + " "] || [])
                              .concat(match[2]);
                        }
                      }
                      match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                  },

                  // Raw string
                  getAllResponseHeaders: function () {
                    return completed ? responseHeadersString : null;
                  },

                  // Caches the header
                  setRequestHeader: function (name, value) {
                    if (completed == null) {
                      name = requestHeadersNames[name.toLowerCase()] =
                        requestHeadersNames[name.toLowerCase()] || name;
                      requestHeaders[name] = value;
                    }
                    return this;
                  },

                  // Overrides response content-type header
                  overrideMimeType: function (type) {
                    if (completed == null) {
                      s.mimeType = type;
                    }
                    return this;
                  },

                  // Status-dependent callbacks
                  statusCode: function (map) {
                    var code;
                    if (map) {
                      if (completed) {

                        // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                      } else {

                        // Lazy-add the new callbacks in a way that preserves old ones
                        for (code in map) {
                          statusCode[code] = [statusCode[code], map[code]];
                        }
                      }
                    }
                    return this;
                  },

                  // Cancel the request
                  abort: function (statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) {
                      transport.abort(finalText);
                    }
                    done(0, finalText);
                    return this;
                  }
                };

              // Attach deferreds
              deferred.promise(jqXHR);

              // Add protocol if not provided (prefilters might expect it)
              // Handle falsy url in the settings object (#10093: consistency with old signature)
              // We also use the url parameter if available
              s.url = ((url || s.url || location.href) + "")
                .replace(rprotocol, location.protocol + "//");

              // Alias method option to type as per ticket #12004
              s.type = options.method || options.type || s.method || s.type;

              // Extract dataTypes list
              s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];

              // A cross-domain request is in order when the origin doesn't match the current origin.
              if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");

                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                  urlAnchor.href = s.url;

                  // Support: IE <=8 - 11 only
                  // Anchor's host property isn't correctly set when s.url is relative
                  urlAnchor.href = urlAnchor.href;
                  s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
                    urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {

                  // If there is an error parsing the URL, assume it is crossDomain,
                  // it can be rejected by the transport if it is invalid
                  s.crossDomain = true;
                }
              }

              // Convert data if not already a string
              if (s.data && s.processData && typeof s.data !== "string") {
                s.data = jQuery.param(s.data, s.traditional);
              }

              // Apply prefilters
              inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);

              // If request was aborted inside a prefilter, stop there
              if (completed) {
                return jqXHR;
              }

              // We can fire global events as of now if asked to
              // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
              fireGlobals = jQuery.event && s.global;

              // Watch for a new set of requests
              if (fireGlobals && jQuery.active++ === 0) {
                jQuery.event.trigger("ajaxStart");
              }

              // Uppercase the type
              s.type = s.type.toUpperCase();

              // Determine if request has content
              s.hasContent = !rnoContent.test(s.type);

              // Save the URL in case we're toying with the If-Modified-Since
              // and/or If-None-Match header later on
              // Remove hash to simplify url manipulation
              cacheURL = s.url.replace(rhash, "");

              // More options handling for requests with no content
              if (!s.hasContent) {

                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);

                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                  cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;

                  // #9682: remove data so that it's not used in an eventual retry
                  delete s.data;
                }

                // Add or update anti-cache param if needed
                if (s.cache === false) {
                  cacheURL = cacheURL.replace(rantiCache, "$1");
                  uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + (nonce.guid++) +
                    uncached;
                }

                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;

                // Change '%20' to '+' if this is encoded form body content (gh-2658)
              } else if (s.data && s.processData &&
                (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
                s.data = s.data.replace(r20, "+");
              }

              // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
              if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) {
                  jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                }
                if (jQuery.etag[cacheURL]) {
                  jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
                }
              }

              // Set the correct header, if data is being sent
              if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
                jqXHR.setRequestHeader("Content-Type", s.contentType);
              }

              // Set the Accepts header for the server, depending on the dataType
              jqXHR.setRequestHeader(
                "Accept",
                s.dataTypes[0] && s.accepts[s.dataTypes[0]] ?
                  s.accepts[s.dataTypes[0]] +
                  (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") :
                  s.accepts["*"]
              );

              // Check for headers option
              for (i in s.headers) {
                jqXHR.setRequestHeader(i, s.headers[i]);
              }

              // Allow custom headers/mimetypes and early abort
              if (s.beforeSend &&
                (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) {

                // Abort if not done already and return
                return jqXHR.abort();
              }

              // Aborting is no longer a cancellation
              strAbort = "abort";

              // Install callbacks on deferreds
              completeDeferred.add(s.complete);
              jqXHR.done(s.success);
              jqXHR.fail(s.error);

              // Get transport
              transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);

              // If no transport, we auto-abort
              if (!transport) {
                done(-1, "No Transport");
              } else {
                jqXHR.readyState = 1;

                // Send global event
                if (fireGlobals) {
                  globalEventContext.trigger("ajaxSend", [jqXHR, s]);
                }

                // If request was aborted inside ajaxSend, stop there
                if (completed) {
                  return jqXHR;
                }

                // Timeout
                if (s.async && s.timeout > 0) {
                  timeoutTimer = window.setTimeout(function () {
                    jqXHR.abort("timeout");
                  }, s.timeout);
                }

                try {
                  completed = false;
                  transport.send(requestHeaders, done);
                } catch (e) {

                  // Rethrow post-completion exceptions
                  if (completed) {
                    throw e;
                  }

                  // Propagate others as results
                  done(-1, e);
                }
              }

              // Callback for when everything is done
              function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified,
                  statusText = nativeStatusText;

                // Ignore repeat invocations
                if (completed) {
                  return;
                }

                completed = true;

                // Clear timeout if it exists
                if (timeoutTimer) {
                  window.clearTimeout(timeoutTimer);
                }

                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;

                // Cache response headers
                responseHeadersString = headers || "";

                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;

                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;

                // Get response data
                if (responses) {
                  response = ajaxHandleResponses(s, jqXHR, responses);
                }

                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess &&
                  jQuery.inArray("script", s.dataTypes) > -1 &&
                  jQuery.inArray("json", s.dataTypes) < 0) {
                  s.converters["text script"] = function () { };
                }

                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);

                // If successful, handle type chaining
                if (isSuccess) {

                  // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                  if (s.ifModified) {
                    modified = jqXHR.getResponseHeader("Last-Modified");
                    if (modified) {
                      jQuery.lastModified[cacheURL] = modified;
                    }
                    modified = jqXHR.getResponseHeader("etag");
                    if (modified) {
                      jQuery.etag[cacheURL] = modified;
                    }
                  }

                  // if no content
                  if (status === 204 || s.type === "HEAD") {
                    statusText = "nocontent";

                    // if not modified
                  } else if (status === 304) {
                    statusText = "notmodified";

                    // If we have data, let's convert it
                  } else {
                    statusText = response.state;
                    success = response.data;
                    error = response.error;
                    isSuccess = !error;
                  }
                } else {

                  // Extract error from statusText and normalize for non-aborts
                  error = statusText;
                  if (status || !statusText) {
                    statusText = "error";
                    if (status < 0) {
                      status = 0;
                    }
                  }
                }

                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";

                // Success/Error
                if (isSuccess) {
                  deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
                } else {
                  deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
                }

                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;

                if (fireGlobals) {
                  globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError",
                    [jqXHR, s, isSuccess ? success : error]);
                }

                // Complete
                completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);

                if (fireGlobals) {
                  globalEventContext.trigger("ajaxComplete", [jqXHR, s]);

                  // Handle the global AJAX counter
                  if (!(--jQuery.active)) {
                    jQuery.event.trigger("ajaxStop");
                  }
                }
              }

              return jqXHR;
            },

            getJSON: function (url, data, callback) {
              return jQuery.get(url, data, callback, "json");
            },

            getScript: function (url, callback) {
              return jQuery.get(url, undefined, callback, "script");
            }
          });

          jQuery.each(["get", "post"], function (_i, method) {
            jQuery[method] = function (url, data, callback, type) {

              // Shift arguments if data argument was omitted
              if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
              }

              // The url can be an options object (which then must have .url)
              return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
              }, jQuery.isPlainObject(url) && url));
            };
          });

          jQuery.ajaxPrefilter(function (s) {
            var i;
            for (i in s.headers) {
              if (i.toLowerCase() === "content-type") {
                s.contentType = s.headers[i] || "";
              }
            }
          });


          jQuery._evalUrl = function (url, options, doc) {
            return jQuery.ajax({
              url: url,

              // Make this explicit, since user can override this through ajaxSetup (#11264)
              type: "GET",
              dataType: "script",
              cache: true,
              async: false,
              global: false,

              // Only evaluate the response if it is successful (gh-4126)
              // dataFilter is not invoked for failure responses, so using it instead
              // of the default converter is kludgy but it works.
              converters: {
                "text script": function () { }
              },
              dataFilter: function (response) {
                jQuery.globalEval(response, options, doc);
              }
            });
          };


          jQuery.fn.extend({
            wrapAll: function (html) {
              var wrap;

              if (this[0]) {
                if (isFunction(html)) {
                  html = html.call(this[0]);
                }

                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);

                if (this[0].parentNode) {
                  wrap.insertBefore(this[0]);
                }

                wrap.map(function () {
                  var elem = this;

                  while (elem.firstElementChild) {
                    elem = elem.firstElementChild;
                  }

                  return elem;
                }).append(this);
              }

              return this;
            },

            wrapInner: function (html) {
              if (isFunction(html)) {
                return this.each(function (i) {
                  jQuery(this).wrapInner(html.call(this, i));
                });
              }

              return this.each(function () {
                var self = jQuery(this),
                  contents = self.contents();

                if (contents.length) {
                  contents.wrapAll(html);

                } else {
                  self.append(html);
                }
              });
            },

            wrap: function (html) {
              var htmlIsFunction = isFunction(html);

              return this.each(function (i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
              });
            },

            unwrap: function (selector) {
              this.parent(selector).not("body").each(function () {
                jQuery(this).replaceWith(this.childNodes);
              });
              return this;
            }
          });


          jQuery.expr.pseudos.hidden = function (elem) {
            return !jQuery.expr.pseudos.visible(elem);
          };
          jQuery.expr.pseudos.visible = function (elem) {
            return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
          };




          jQuery.ajaxSettings.xhr = function () {
            try {
              return new window.XMLHttpRequest();
            } catch (e) { }
          };

          var xhrSuccessStatus = {

            // File protocol always yields status code 0, assume 200
            0: 200,

            // Support: IE <=9 only
            // #1450: sometimes IE returns 1223 when it should be 204
            1223: 204
          },
            xhrSupported = jQuery.ajaxSettings.xhr();

          support.cors = !!xhrSupported && ("withCredentials" in xhrSupported);
          support.ajax = xhrSupported = !!xhrSupported;

          jQuery.ajaxTransport(function (options) {
            var callback, errorCallback;

            // Cross domain only allowed if supported through XMLHttpRequest
            if (support.cors || xhrSupported && !options.crossDomain) {
              return {
                send: function (headers, complete) {
                  var i,
                    xhr = options.xhr();

                  xhr.open(
                    options.type,
                    options.url,
                    options.async,
                    options.username,
                    options.password
                  );

                  // Apply custom fields if provided
                  if (options.xhrFields) {
                    for (i in options.xhrFields) {
                      xhr[i] = options.xhrFields[i];
                    }
                  }

                  // Override mime type if needed
                  if (options.mimeType && xhr.overrideMimeType) {
                    xhr.overrideMimeType(options.mimeType);
                  }

                  // X-Requested-With header
                  // For cross-domain requests, seeing as conditions for a preflight are
                  // akin to a jigsaw puzzle, we simply never set it to be sure.
                  // (it can always be set on a per-request basis or even using ajaxSetup)
                  // For same-domain requests, won't change header if already provided.
                  if (!options.crossDomain && !headers["X-Requested-With"]) {
                    headers["X-Requested-With"] = "XMLHttpRequest";
                  }

                  // Set headers
                  for (i in headers) {
                    xhr.setRequestHeader(i, headers[i]);
                  }

                  // Callback
                  callback = function (type) {
                    return function () {
                      if (callback) {
                        callback = errorCallback = xhr.onload =
                          xhr.onerror = xhr.onabort = xhr.ontimeout =
                          xhr.onreadystatechange = null;

                        if (type === "abort") {
                          xhr.abort();
                        } else if (type === "error") {

                          // Support: IE <=9 only
                          // On a manual native abort, IE9 throws
                          // errors on any property access that is not readyState
                          if (typeof xhr.status !== "number") {
                            complete(0, "error");
                          } else {
                            complete(

                              // File: protocol always yields status 0; see #8605, #14207
                              xhr.status,
                              xhr.statusText
                            );
                          }
                        } else {
                          complete(
                            xhrSuccessStatus[xhr.status] || xhr.status,
                            xhr.statusText,

                            // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" ||
                              typeof xhr.responseText !== "string" ?
                              { binary: xhr.response } :
                              { text: xhr.responseText },
                            xhr.getAllResponseHeaders()
                          );
                        }
                      }
                    };
                  };

                  // Listen to events
                  xhr.onload = callback();
                  errorCallback = xhr.onerror = xhr.ontimeout = callback("error");

                  // Support: IE 9 only
                  // Use onreadystatechange to replace onabort
                  // to handle uncaught aborts
                  if (xhr.onabort !== undefined) {
                    xhr.onabort = errorCallback;
                  } else {
                    xhr.onreadystatechange = function () {

                      // Check readyState before timeout as it changes
                      if (xhr.readyState === 4) {

                        // Allow onerror to be called first,
                        // but that will not handle a native abort
                        // Also, save errorCallback to a variable
                        // as xhr.onerror cannot be accessed
                        window.setTimeout(function () {
                          if (callback) {
                            errorCallback();
                          }
                        });
                      }
                    };
                  }

                  // Create the abort callback
                  callback = callback("abort");

                  try {

                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                  } catch (e) {

                    // #14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) {
                      throw e;
                    }
                  }
                },

                abort: function () {
                  if (callback) {
                    callback();
                  }
                }
              };
            }
          });




          // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
          jQuery.ajaxPrefilter(function (s) {
            if (s.crossDomain) {
              s.contents.script = false;
            }
          });

          // Install script dataType
          jQuery.ajaxSetup({
            accepts: {
              script: "text/javascript, application/javascript, " +
                "application/ecmascript, application/x-ecmascript"
            },
            contents: {
              script: /\b(?:java|ecma)script\b/
            },
            converters: {
              "text script": function (text) {
                jQuery.globalEval(text);
                return text;
              }
            }
          });

          // Handle cache's special case and crossDomain
          jQuery.ajaxPrefilter("script", function (s) {
            if (s.cache === undefined) {
              s.cache = false;
            }
            if (s.crossDomain) {
              s.type = "GET";
            }
          });

          // Bind script tag hack transport
          jQuery.ajaxTransport("script", function (s) {

            // This transport only deals with cross domain or forced-by-attrs requests
            if (s.crossDomain || s.scriptAttrs) {
              var script, callback;
              return {
                send: function (_, complete) {
                  script = jQuery("<script>")
                    .attr(s.scriptAttrs || {})
                    .prop({ charset: s.scriptCharset, src: s.url })
                    .on("load error", callback = function (evt) {
                      script.remove();
                      callback = null;
                      if (evt) {
                        complete(evt.type === "error" ? 404 : 200, evt.type);
                      }
                    });

                  // Use native DOM manipulation to avoid our domManip AJAX trickery
                  document.head.appendChild(script[0]);
                },
                abort: function () {
                  if (callback) {
                    callback();
                  }
                }
              };
            }
          });




          var oldCallbacks = [],
            rjsonp = /(=)\?(?=&|$)|\?\?/;

          // Default jsonp settings
          jQuery.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function () {
              var callback = oldCallbacks.pop() || (jQuery.expando + "_" + (nonce.guid++));
              this[callback] = true;
              return callback;
            }
          });

          // Detect, normalize options and install callbacks for jsonp requests
          jQuery.ajaxPrefilter("json jsonp", function (s, originalSettings, jqXHR) {

            var callbackName, overwritten, responseContainer,
              jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ?
                "url" :
                typeof s.data === "string" &&
                (s.contentType || "")
                  .indexOf("application/x-www-form-urlencoded") === 0 &&
                rjsonp.test(s.data) && "data"
              );

            // Handle iff the expected data type is "jsonp" or we have a parameter to set
            if (jsonProp || s.dataTypes[0] === "jsonp") {

              // Get callback name, remembering preexisting value associated with it
              callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ?
                s.jsonpCallback() :
                s.jsonpCallback;

              // Insert callback into url or form data
              if (jsonProp) {
                s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
              } else if (s.jsonp !== false) {
                s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
              }

              // Use data converter to retrieve json after script execution
              s.converters["script json"] = function () {
                if (!responseContainer) {
                  jQuery.error(callbackName + " was not called");
                }
                return responseContainer[0];
              };

              // Force json dataType
              s.dataTypes[0] = "json";

              // Install callback
              overwritten = window[callbackName];
              window[callbackName] = function () {
                responseContainer = arguments;
              };

              // Clean-up function (fires after converters)
              jqXHR.always(function () {

                // If previous value didn't exist - remove it
                if (overwritten === undefined) {
                  jQuery(window).removeProp(callbackName);

                  // Otherwise restore preexisting value
                } else {
                  window[callbackName] = overwritten;
                }

                // Save back as free
                if (s[callbackName]) {

                  // Make sure that re-using the options doesn't screw things around
                  s.jsonpCallback = originalSettings.jsonpCallback;

                  // Save the callback name for future use
                  oldCallbacks.push(callbackName);
                }

                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) {
                  overwritten(responseContainer[0]);
                }

                responseContainer = overwritten = undefined;
              });

              // Delegate to script
              return "script";
            }
          });




          // Support: Safari 8 only
          // In Safari 8 documents created via document.implementation.createHTMLDocument
          // collapse sibling forms: the second one becomes a child of the first one.
          // Because of that, this security measure has to be disabled in Safari 8.
          // https://bugs.webkit.org/show_bug.cgi?id=137337
          support.createHTMLDocument = (function () {
            var body = document.implementation.createHTMLDocument("").body;
            body.innerHTML = "<form></form><form></form>";
            return body.childNodes.length === 2;
          })();


          // Argument "data" should be string of html
          // context (optional): If specified, the fragment will be created in this context,
          // defaults to document
          // keepScripts (optional): If true, will include scripts passed in the html string
          jQuery.parseHTML = function (data, context, keepScripts) {
            if (typeof data !== "string") {
              return [];
            }
            if (typeof context === "boolean") {
              keepScripts = context;
              context = false;
            }

            var base, parsed, scripts;

            if (!context) {

              // Stop scripts or inline event handlers from being executed immediately
              // by using document.implementation
              if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");

                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
              } else {
                context = document;
              }
            }

            parsed = rsingleTag.exec(data);
            scripts = !keepScripts && [];

            // Single tag
            if (parsed) {
              return [context.createElement(parsed[1])];
            }

            parsed = buildFragment([data], context, scripts);

            if (scripts && scripts.length) {
              jQuery(scripts).remove();
            }

            return jQuery.merge([], parsed.childNodes);
          };


          /**
           * Load a url into a page
           */
          jQuery.fn.load = function (url, params, callback) {
            var selector, type, response,
              self = this,
              off = url.indexOf(" ");

            if (off > -1) {
              selector = stripAndCollapse(url.slice(off));
              url = url.slice(0, off);
            }

            // If it's a function
            if (isFunction(params)) {

              // We assume that it's the callback
              callback = params;
              params = undefined;

              // Otherwise, build a param string
            } else if (params && typeof params === "object") {
              type = "POST";
            }

            // If we have elements to modify, make the request
            if (self.length > 0) {
              jQuery.ajax({
                url: url,

                // If "type" variable is undefined, then "GET" method will be used.
                // Make value of this field explicit since
                // user can override it through ajaxSetup method
                type: type || "GET",
                dataType: "html",
                data: params
              }).done(function (responseText) {

                // Save response for use in complete callback
                response = arguments;

                self.html(selector ?

                  // If a selector was specified, locate the right elements in a dummy div
                  // Exclude scripts to avoid IE 'Permission Denied' errors
                  jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) :

                  // Otherwise use the full result
                  responseText);

                // If the request succeeds, this function gets "data", "status", "jqXHR"
                // but they are ignored because response was set above.
                // If it fails, this function gets "jqXHR", "status", "error"
              }).always(callback && function (jqXHR, status) {
                self.each(function () {
                  callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
                });
              });
            }

            return this;
          };




          jQuery.expr.pseudos.animated = function (elem) {
            return jQuery.grep(jQuery.timers, function (fn) {
              return elem === fn.elem;
            }).length;
          };




          jQuery.offset = {
            setOffset: function (elem, options, i) {
              var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
                position = jQuery.css(elem, "position"),
                curElem = jQuery(elem),
                props = {};

              // Set position first, in-case top/left are set even on static elem
              if (position === "static") {
                elem.style.position = "relative";
              }

              curOffset = curElem.offset();
              curCSSTop = jQuery.css(elem, "top");
              curCSSLeft = jQuery.css(elem, "left");
              calculatePosition = (position === "absolute" || position === "fixed") &&
                (curCSSTop + curCSSLeft).indexOf("auto") > -1;

              // Need to be able to calculate position if either
              // top or left is auto and position is either absolute or fixed
              if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;

              } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
              }

              if (isFunction(options)) {

                // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
                options = options.call(elem, i, jQuery.extend({}, curOffset));
              }

              if (options.top != null) {
                props.top = (options.top - curOffset.top) + curTop;
              }
              if (options.left != null) {
                props.left = (options.left - curOffset.left) + curLeft;
              }

              if ("using" in options) {
                options.using.call(elem, props);

              } else {
                curElem.css(props);
              }
            }
          };

          jQuery.fn.extend({

            // offset() relates an element's border box to the document origin
            offset: function (options) {

              // Preserve chaining for setter
              if (arguments.length) {
                return options === undefined ?
                  this :
                  this.each(function (i) {
                    jQuery.offset.setOffset(this, options, i);
                  });
              }

              var rect, win,
                elem = this[0];

              if (!elem) {
                return;
              }

              // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
              // Support: IE <=11 only
              // Running getBoundingClientRect on a
              // disconnected node in IE throws an error
              if (!elem.getClientRects().length) {
                return { top: 0, left: 0 };
              }

              // Get document-relative position by adding viewport scroll to viewport-relative gBCR
              rect = elem.getBoundingClientRect();
              win = elem.ownerDocument.defaultView;
              return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
              };
            },

            // position() relates an element's margin box to its offset parent's padding box
            // This corresponds to the behavior of CSS absolute positioning
            position: function () {
              if (!this[0]) {
                return;
              }

              var offsetParent, offset, doc,
                elem = this[0],
                parentOffset = { top: 0, left: 0 };

              // position:fixed elements are offset from the viewport, which itself always has zero offset
              if (jQuery.css(elem, "position") === "fixed") {

                // Assume position:fixed implies availability of getBoundingClientRect
                offset = elem.getBoundingClientRect();

              } else {
                offset = this.offset();

                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while (offsetParent &&
                  (offsetParent === doc.body || offsetParent === doc.documentElement) &&
                  jQuery.css(offsetParent, "position") === "static") {

                  offsetParent = offsetParent.parentNode;
                }
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {

                  // Incorporate borders into its offset, since they are outside its content origin
                  parentOffset = jQuery(offsetParent).offset();
                  parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                  parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
              }

              // Subtract parent offsets and element margins
              return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
              };
            },

            // This method will return documentElement in the following cases:
            // 1) For the element inside the iframe without offsetParent, this method will return
            //    documentElement of the parent window
            // 2) For the hidden or detached element
            // 3) For body or html element, i.e. in case of the html node - it will return itself
            //
            // but those exceptions were never presented as a real life use-cases
            // and might be considered as more preferable results.
            //
            // This logic, however, is not guaranteed and can change at any point in the future
            offsetParent: function () {
              return this.map(function () {
                var offsetParent = this.offsetParent;

                while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
                  offsetParent = offsetParent.offsetParent;
                }

                return offsetParent || documentElement;
              });
            }
          });

          // Create scrollLeft and scrollTop methods
          jQuery.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (method, prop) {
            var top = "pageYOffset" === prop;

            jQuery.fn[method] = function (val) {
              return access(this, function (elem, method, val) {

                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) {
                  win = elem;
                } else if (elem.nodeType === 9) {
                  win = elem.defaultView;
                }

                if (val === undefined) {
                  return win ? win[prop] : elem[method];
                }

                if (win) {
                  win.scrollTo(
                    !top ? val : win.pageXOffset,
                    top ? val : win.pageYOffset
                  );

                } else {
                  elem[method] = val;
                }
              }, method, val, arguments.length);
            };
          });

          // Support: Safari <=7 - 9.1, Chrome <=37 - 49
          // Add the top/left cssHooks using jQuery.fn.position
          // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
          // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
          // getComputedStyle returns percent when specified for top/left/bottom/right;
          // rather than make the css module depend on the offset module, just check for it here
          jQuery.each(["top", "left"], function (_i, prop) {
            jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition,
              function (elem, computed) {
                if (computed) {
                  computed = curCSS(elem, prop);

                  // If curCSS returns percentage, fallback to offset
                  return rnumnonpx.test(computed) ?
                    jQuery(elem).position()[prop] + "px" :
                    computed;
                }
              }
            );
          });


          // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
          jQuery.each({ Height: "height", Width: "width" }, function (name, type) {
            jQuery.each({
              padding: "inner" + name,
              content: type,
              "": "outer" + name
            }, function (defaultExtra, funcName) {

              // Margin is only for outerHeight, outerWidth
              jQuery.fn[funcName] = function (margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
                  extra = defaultExtra || (margin === true || value === true ? "margin" : "border");

                return access(this, function (elem, type, value) {
                  var doc;

                  if (isWindow(elem)) {

                    // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ?
                      elem["inner" + name] :
                      elem.document.documentElement["client" + name];
                  }

                  // Get document width or height
                  if (elem.nodeType === 9) {
                    doc = elem.documentElement;

                    // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                    // whichever is greatest
                    return Math.max(
                      elem.body["scroll" + name], doc["scroll" + name],
                      elem.body["offset" + name], doc["offset" + name],
                      doc["client" + name]
                    );
                  }

                  return value === undefined ?

                    // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) :

                    // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
              };
            });
          });


          jQuery.each([
            "ajaxStart",
            "ajaxStop",
            "ajaxComplete",
            "ajaxError",
            "ajaxSuccess",
            "ajaxSend"
          ], function (_i, type) {
            jQuery.fn[type] = function (fn) {
              return this.on(type, fn);
            };
          });




          jQuery.fn.extend({

            bind: function (types, data, fn) {
              return this.on(types, null, data, fn);
            },
            unbind: function (types, fn) {
              return this.off(types, null, fn);
            },

            delegate: function (selector, types, data, fn) {
              return this.on(types, selector, data, fn);
            },
            undelegate: function (selector, types, fn) {

              // ( namespace ) or ( selector, types [, fn] )
              return arguments.length === 1 ?
                this.off(selector, "**") :
                this.off(types, selector || "**", fn);
            },

            hover: function (fnOver, fnOut) {
              return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
            }
          });

          jQuery.each(
            ("blur focus focusin focusout resize scroll click dblclick " +
              "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
              "change select submit keydown keypress keyup contextmenu").split(" "),
            function (_i, name) {

              // Handle event binding
              jQuery.fn[name] = function (data, fn) {
                return arguments.length > 0 ?
                  this.on(name, null, data, fn) :
                  this.trigger(name);
              };
            }
          );




          // Support: Android <=4.0 only
          // Make sure we trim BOM and NBSP
          var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

          // Bind a function to a context, optionally partially applying any
          // arguments.
          // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
          // However, it is not slated for removal any time soon
          jQuery.proxy = function (fn, context) {
            var tmp, args, proxy;

            if (typeof context === "string") {
              tmp = fn[context];
              context = fn;
              fn = tmp;
            }

            // Quick check to determine if target is callable, in the spec
            // this throws a TypeError, but we will just return undefined.
            if (!isFunction(fn)) {
              return undefined;
            }

            // Simulated bind
            args = slice.call(arguments, 2);
            proxy = function () {
              return fn.apply(context || this, args.concat(slice.call(arguments)));
            };

            // Set the guid of unique handler to the same of original handler, so it can be removed
            proxy.guid = fn.guid = fn.guid || jQuery.guid++;

            return proxy;
          };

          jQuery.holdReady = function (hold) {
            if (hold) {
              jQuery.readyWait++;
            } else {
              jQuery.ready(true);
            }
          };
          jQuery.isArray = Array.isArray;
          jQuery.parseJSON = JSON.parse;
          jQuery.nodeName = nodeName;
          jQuery.isFunction = isFunction;
          jQuery.isWindow = isWindow;
          jQuery.camelCase = camelCase;
          jQuery.type = toType;

          jQuery.now = Date.now;

          jQuery.isNumeric = function (obj) {

            // As of jQuery 3.0, isNumeric is limited to
            // strings and numbers (primitives or objects)
            // that can be coerced to finite numbers (gh-2662)
            var type = jQuery.type(obj);
            return (type === "number" || type === "string") &&

              // parseFloat NaNs numeric-cast false positives ("")
              // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
              // subtraction forces infinities to NaN
              !isNaN(obj - parseFloat(obj));
          };

          jQuery.trim = function (text) {
            return text == null ?
              "" :
              (text + "").replace(rtrim, "");
          };



          // Register as a named AMD module, since jQuery can be concatenated with other
          // files that may use define, but not via a proper concatenation script that
          // understands anonymous AMD modules. A named AMD is safest and most robust
          // way to register. Lowercase jquery is used because AMD module names are
          // derived from file names, and jQuery is normally delivered in a lowercase
          // file name. Do this after creating the global so that if an AMD module wants
          // to call noConflict to hide this version of jQuery, it will work.

          // Note that for maximum portability, libraries that are not jQuery should
          // declare themselves as anonymous modules, and avoid setting a global if an
          // AMD loader is present. jQuery is a special case. For more information, see
          // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

          if (true) {
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
              return jQuery;
            }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
              __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          }




          var

            // Map over jQuery in case of overwrite
            _jQuery = window.jQuery,

            // Map over the $ in case of overwrite
            _$ = window.$;

          jQuery.noConflict = function (deep) {
            if (window.$ === jQuery) {
              window.$ = _$;
            }

            if (deep && window.jQuery === jQuery) {
              window.jQuery = _jQuery;
            }

            return jQuery;
          };

          // Expose jQuery and $ identifiers, even in AMD
          // (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
          // and CommonJS for browser emulators (#13566)
          if (typeof noGlobal === "undefined") {
            window.jQuery = window.$ = jQuery;
          }




          return jQuery;
        });


        /***/
}),

/***/ "./assets/sass/style.scss":
/*!********************************!*\
  !*** ./assets/sass/style.scss ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
        // extracted by mini-css-extract-plugin


        /***/
}),

/***/ "./node_modules/simple-swizzle/index.js":
/*!**********************************************!*\
  !*** ./node_modules/simple-swizzle/index.js ***!
  \**********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

        "use strict";


        var isArrayish = __webpack_require__(/*! is-arrayish */ "./node_modules/simple-swizzle/node_modules/is-arrayish/index.js");

        var concat = Array.prototype.concat;
        var slice = Array.prototype.slice;

        var swizzle = module.exports = function swizzle(args) {
          var results = [];

          for (var i = 0, len = args.length; i < len; i++) {
            var arg = args[i];

            if (isArrayish(arg)) {
              // http://jsperf.com/javascript-array-concat-vs-push/98
              results = concat.call(results, slice.call(arg));
            } else {
              results.push(arg);
            }
          }

          return results;
        };

        swizzle.wrap = function (fn) {
          return function () {
            return fn(swizzle(arguments));
          };
        };


        /***/
}),

/***/ "./node_modules/simple-swizzle/node_modules/is-arrayish/index.js":
/*!***********************************************************************!*\
  !*** ./node_modules/simple-swizzle/node_modules/is-arrayish/index.js ***!
  \***********************************************************************/
/***/ ((module) => {

        module.exports = function isArrayish(obj) {
          if (!obj || typeof obj === 'string') {
            return false;
          }

          return obj instanceof Array || Array.isArray(obj) ||
            (obj.length >= 0 && (obj.splice instanceof Function ||
              (Object.getOwnPropertyDescriptor(obj, (obj.length - 1)) && obj.constructor.name !== 'String')));
        };


        /***/
}),

/***/ "./node_modules/slick-carousel/slick/slick.js":
/*!****************************************************!*\
  !*** ./node_modules/slick-carousel/slick/slick.js ***!
  \****************************************************/
/***/ ((module, exports, __webpack_require__) => {

        var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
        /* global window, document, define, jQuery, setInterval, clearInterval */
        ; (function (factory) {
          'use strict';
          if (true) {
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
              __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
              __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          } else { }

        }(function ($) {
          'use strict';
          var Slick = window.Slick || {};

          Slick = (function () {

            var instanceUid = 0;

            function Slick(element, settings) {

              var _ = this, dataSettings;

              _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function (slider, i) {
                  return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
              };

              _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
              };

              $.extend(_, _.initials);

              _.activeBreakpoint = null;
              _.animType = null;
              _.animProp = null;
              _.breakpoints = [];
              _.breakpointSettings = [];
              _.cssTransitions = false;
              _.focussed = false;
              _.interrupted = false;
              _.hidden = 'hidden';
              _.paused = true;
              _.positionProp = null;
              _.respondTo = null;
              _.rowCount = 1;
              _.shouldClick = true;
              _.$slider = $(element);
              _.$slidesCache = null;
              _.transformType = null;
              _.transitionType = null;
              _.visibilityChange = 'visibilitychange';
              _.windowWidth = 0;
              _.windowTimer = null;

              dataSettings = $(element).data('slick') || {};

              _.options = $.extend({}, _.defaults, settings, dataSettings);

              _.currentSlide = _.options.initialSlide;

              _.originalSettings = _.options;

              if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
              } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
              }

              _.autoPlay = $.proxy(_.autoPlay, _);
              _.autoPlayClear = $.proxy(_.autoPlayClear, _);
              _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
              _.changeSlide = $.proxy(_.changeSlide, _);
              _.clickHandler = $.proxy(_.clickHandler, _);
              _.selectHandler = $.proxy(_.selectHandler, _);
              _.setPosition = $.proxy(_.setPosition, _);
              _.swipeHandler = $.proxy(_.swipeHandler, _);
              _.dragHandler = $.proxy(_.dragHandler, _);
              _.keyHandler = $.proxy(_.keyHandler, _);

              _.instanceUid = instanceUid++;

              // A simple way to check for HTML strings
              // Strict HTML recognition (must start with <)
              // Extracted from jQuery v1.11 source
              _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


              _.registerBreakpoints();
              _.init(true);

            }

            return Slick;

          }());

          Slick.prototype.activateADA = function () {
            var _ = this;

            _.$slideTrack.find('.slick-active').attr({
              'aria-hidden': 'false'
            }).find('a, input, button, select').attr({
              'tabindex': '0'
            });

          };

          Slick.prototype.addSlide = Slick.prototype.slickAdd = function (markup, index, addBefore) {

            var _ = this;

            if (typeof (index) === 'boolean') {
              addBefore = index;
              index = null;
            } else if (index < 0 || (index >= _.slideCount)) {
              return false;
            }

            _.unload();

            if (typeof (index) === 'number') {
              if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
              } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
              } else {
                $(markup).insertAfter(_.$slides.eq(index));
              }
            } else {
              if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
              } else {
                $(markup).appendTo(_.$slideTrack);
              }
            }

            _.$slides = _.$slideTrack.children(this.options.slide);

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.append(_.$slides);

            _.$slides.each(function (index, element) {
              $(element).attr('data-slick-index', index);
            });

            _.$slidesCache = _.$slides;

            _.reinit();

          };

          Slick.prototype.animateHeight = function () {
            var _ = this;
            if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
              var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
              _.$list.animate({
                height: targetHeight
              }, _.options.speed);
            }
          };

          Slick.prototype.animateSlide = function (targetLeft, callback) {

            var animProps = {},
              _ = this;

            _.animateHeight();

            if (_.options.rtl === true && _.options.vertical === false) {
              targetLeft = -targetLeft;
            }
            if (_.transformsEnabled === false) {
              if (_.options.vertical === false) {
                _.$slideTrack.animate({
                  left: targetLeft
                }, _.options.speed, _.options.easing, callback);
              } else {
                _.$slideTrack.animate({
                  top: targetLeft
                }, _.options.speed, _.options.easing, callback);
              }

            } else {

              if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                  _.currentLeft = -(_.currentLeft);
                }
                $({
                  animStart: _.currentLeft
                }).animate({
                  animStart: targetLeft
                }, {
                  duration: _.options.speed,
                  easing: _.options.easing,
                  step: function (now) {
                    now = Math.ceil(now);
                    if (_.options.vertical === false) {
                      animProps[_.animType] = 'translate(' +
                        now + 'px, 0px)';
                      _.$slideTrack.css(animProps);
                    } else {
                      animProps[_.animType] = 'translate(0px,' +
                        now + 'px)';
                      _.$slideTrack.css(animProps);
                    }
                  },
                  complete: function () {
                    if (callback) {
                      callback.call();
                    }
                  }
                });

              } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                  animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                  animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                  setTimeout(function () {

                    _.disableTransition();

                    callback.call();
                  }, _.options.speed);
                }

              }

            }

          };

          Slick.prototype.getNavTarget = function () {

            var _ = this,
              asNavFor = _.options.asNavFor;

            if (asNavFor && asNavFor !== null) {
              asNavFor = $(asNavFor).not(_.$slider);
            }

            return asNavFor;

          };

          Slick.prototype.asNavFor = function (index) {

            var _ = this,
              asNavFor = _.getNavTarget();

            if (asNavFor !== null && typeof asNavFor === 'object') {
              asNavFor.each(function () {
                var target = $(this).slick('getSlick');
                if (!target.unslicked) {
                  target.slideHandler(index, true);
                }
              });
            }

          };

          Slick.prototype.applyTransition = function (slide) {

            var _ = this,
              transition = {};

            if (_.options.fade === false) {
              transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
            } else {
              transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
            }

            if (_.options.fade === false) {
              _.$slideTrack.css(transition);
            } else {
              _.$slides.eq(slide).css(transition);
            }

          };

          Slick.prototype.autoPlay = function () {

            var _ = this;

            _.autoPlayClear();

            if (_.slideCount > _.options.slidesToShow) {
              _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
            }

          };

          Slick.prototype.autoPlayClear = function () {

            var _ = this;

            if (_.autoPlayTimer) {
              clearInterval(_.autoPlayTimer);
            }

          };

          Slick.prototype.autoPlayIterator = function () {

            var _ = this,
              slideTo = _.currentSlide + _.options.slidesToScroll;

            if (!_.paused && !_.interrupted && !_.focussed) {

              if (_.options.infinite === false) {

                if (_.direction === 1 && (_.currentSlide + 1) === (_.slideCount - 1)) {
                  _.direction = 0;
                }

                else if (_.direction === 0) {

                  slideTo = _.currentSlide - _.options.slidesToScroll;

                  if (_.currentSlide - 1 === 0) {
                    _.direction = 1;
                  }

                }

              }

              _.slideHandler(slideTo);

            }

          };

          Slick.prototype.buildArrows = function () {

            var _ = this;

            if (_.options.arrows === true) {

              _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
              _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

              if (_.slideCount > _.options.slidesToShow) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                  _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                  _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                  _.$prevArrow
                    .addClass('slick-disabled')
                    .attr('aria-disabled', 'true');
                }

              } else {

                _.$prevArrow.add(_.$nextArrow)

                  .addClass('slick-hidden')
                  .attr({
                    'aria-disabled': 'true',
                    'tabindex': '-1'
                  });

              }

            }

          };

          Slick.prototype.buildDots = function () {

            var _ = this,
              i, dot;

            if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

              _.$slider.addClass('slick-dotted');

              dot = $('<ul />').addClass(_.options.dotsClass);

              for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
              }

              _.$dots = dot.appendTo(_.options.appendDots);

              _.$dots.find('li').first().addClass('slick-active');

            }

          };

          Slick.prototype.buildOut = function () {

            var _ = this;

            _.$slides =
              _.$slider
                .children(_.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

            _.slideCount = _.$slides.length;

            _.$slides.each(function (index, element) {
              $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');
            });

            _.$slider.addClass('slick-slider');

            _.$slideTrack = (_.slideCount === 0) ?
              $('<div class="slick-track"/>').appendTo(_.$slider) :
              _.$slides.wrapAll('<div class="slick-track"/>').parent();

            _.$list = _.$slideTrack.wrap(
              '<div class="slick-list"/>').parent();
            _.$slideTrack.css('opacity', 0);

            if (_.options.centerMode === true || _.options.swipeToSlide === true) {
              _.options.slidesToScroll = 1;
            }

            $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

            _.setupInfinite();

            _.buildArrows();

            _.buildDots();

            _.updateDots();


            _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

            if (_.options.draggable === true) {
              _.$list.addClass('draggable');
            }

          };

          Slick.prototype.buildRows = function () {

            var _ = this, a, b, c, newSlides, numOfSlides, originalSlides, slidesPerSection;

            newSlides = document.createDocumentFragment();
            originalSlides = _.$slider.children();

            if (_.options.rows > 0) {

              slidesPerSection = _.options.slidesPerRow * _.options.rows;
              numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
              );

              for (a = 0; a < numOfSlides; a++) {
                var slide = document.createElement('div');
                for (b = 0; b < _.options.rows; b++) {
                  var row = document.createElement('div');
                  for (c = 0; c < _.options.slidesPerRow; c++) {
                    var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                    if (originalSlides.get(target)) {
                      row.appendChild(originalSlides.get(target));
                    }
                  }
                  slide.appendChild(row);
                }
                newSlides.appendChild(slide);
              }

              _.$slider.empty().append(newSlides);
              _.$slider.children().children().children()
                .css({
                  'width': (100 / _.options.slidesPerRow) + '%',
                  'display': 'inline-block'
                });

            }

          };

          Slick.prototype.checkResponsive = function (initial, forceUpdate) {

            var _ = this,
              breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
            var sliderWidth = _.$slider.width();
            var windowWidth = window.innerWidth || $(window).width();

            if (_.respondTo === 'window') {
              respondToWidth = windowWidth;
            } else if (_.respondTo === 'slider') {
              respondToWidth = sliderWidth;
            } else if (_.respondTo === 'min') {
              respondToWidth = Math.min(windowWidth, sliderWidth);
            }

            if (_.options.responsive &&
              _.options.responsive.length &&
              _.options.responsive !== null) {

              targetBreakpoint = null;

              for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                  if (_.originalSettings.mobileFirst === false) {
                    if (respondToWidth < _.breakpoints[breakpoint]) {
                      targetBreakpoint = _.breakpoints[breakpoint];
                    }
                  } else {
                    if (respondToWidth > _.breakpoints[breakpoint]) {
                      targetBreakpoint = _.breakpoints[breakpoint];
                    }
                  }
                }
              }

              if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                  if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                    _.activeBreakpoint =
                      targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                      _.unslick(targetBreakpoint);
                    } else {
                      _.options = $.extend({}, _.originalSettings,
                        _.breakpointSettings[
                        targetBreakpoint]);
                      if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                      }
                      _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                  }
                } else {
                  _.activeBreakpoint = targetBreakpoint;
                  if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                    _.unslick(targetBreakpoint);
                  } else {
                    _.options = $.extend({}, _.originalSettings,
                      _.breakpointSettings[
                      targetBreakpoint]);
                    if (initial === true) {
                      _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                  }
                  triggerBreakpoint = targetBreakpoint;
                }
              } else {
                if (_.activeBreakpoint !== null) {
                  _.activeBreakpoint = null;
                  _.options = _.originalSettings;
                  if (initial === true) {
                    _.currentSlide = _.options.initialSlide;
                  }
                  _.refresh(initial);
                  triggerBreakpoint = targetBreakpoint;
                }
              }

              // only trigger breakpoints during an actual break. not on initialize.
              if (!initial && triggerBreakpoint !== false) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
              }
            }

          };

          Slick.prototype.changeSlide = function (event, dontAnimate) {

            var _ = this,
              $target = $(event.currentTarget),
              indexOffset, slideOffset, unevenOffset;

            // If target is a link, prevent default action.
            if ($target.is('a')) {
              event.preventDefault();
            }

            // If target is not the <li> element (ie: a child), find the <li>.
            if (!$target.is('li')) {
              $target = $target.closest('li');
            }

            unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
            indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

            switch (event.data.message) {

              case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                  _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

              case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                  _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

              case 'index':
                var index = event.data.index === 0 ? 0 :
                  event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

              default:
                return;
            }

          };

          Slick.prototype.checkNavigable = function (index) {

            var _ = this,
              navigables, prevNavigable;

            navigables = _.getNavigableIndexes();
            prevNavigable = 0;
            if (index > navigables[navigables.length - 1]) {
              index = navigables[navigables.length - 1];
            } else {
              for (var n in navigables) {
                if (index < navigables[n]) {
                  index = prevNavigable;
                  break;
                }
                prevNavigable = navigables[n];
              }
            }

            return index;
          };

          Slick.prototype.cleanUpEvents = function () {

            var _ = this;

            if (_.options.dots && _.$dots !== null) {

              $('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

              if (_.options.accessibility === true) {
                _.$dots.off('keydown.slick', _.keyHandler);
              }
            }

            _.$slider.off('focus.slick blur.slick');

            if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
              _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
              _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

              if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
              }
            }

            _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
            _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
            _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
            _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

            _.$list.off('click.slick', _.clickHandler);

            $(document).off(_.visibilityChange, _.visibility);

            _.cleanUpSlideEvents();

            if (_.options.accessibility === true) {
              _.$list.off('keydown.slick', _.keyHandler);
            }

            if (_.options.focusOnSelect === true) {
              $(_.$slideTrack).children().off('click.slick', _.selectHandler);
            }

            $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

            $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

            $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

            $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

          };

          Slick.prototype.cleanUpSlideEvents = function () {

            var _ = this;

            _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

          };

          Slick.prototype.cleanUpRows = function () {

            var _ = this, originalSlides;

            if (_.options.rows > 0) {
              originalSlides = _.$slides.children().children();
              originalSlides.removeAttr('style');
              _.$slider.empty().append(originalSlides);
            }

          };

          Slick.prototype.clickHandler = function (event) {

            var _ = this;

            if (_.shouldClick === false) {
              event.stopImmediatePropagation();
              event.stopPropagation();
              event.preventDefault();
            }

          };

          Slick.prototype.destroy = function (refresh) {

            var _ = this;

            _.autoPlayClear();

            _.touchObject = {};

            _.cleanUpEvents();

            $('.slick-cloned', _.$slider).detach();

            if (_.$dots) {
              _.$dots.remove();
            }

            if (_.$prevArrow && _.$prevArrow.length) {

              _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display', '');

              if (_.htmlExpr.test(_.options.prevArrow)) {
                _.$prevArrow.remove();
              }
            }

            if (_.$nextArrow && _.$nextArrow.length) {

              _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display', '');

              if (_.htmlExpr.test(_.options.nextArrow)) {
                _.$nextArrow.remove();
              }
            }


            if (_.$slides) {

              _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function () {
                  $(this).attr('style', $(this).data('originalStyling'));
                });

              _.$slideTrack.children(this.options.slide).detach();

              _.$slideTrack.detach();

              _.$list.detach();

              _.$slider.append(_.$slides);
            }

            _.cleanUpRows();

            _.$slider.removeClass('slick-slider');
            _.$slider.removeClass('slick-initialized');
            _.$slider.removeClass('slick-dotted');

            _.unslicked = true;

            if (!refresh) {
              _.$slider.trigger('destroy', [_]);
            }

          };

          Slick.prototype.disableTransition = function (slide) {

            var _ = this,
              transition = {};

            transition[_.transitionType] = '';

            if (_.options.fade === false) {
              _.$slideTrack.css(transition);
            } else {
              _.$slides.eq(slide).css(transition);
            }

          };

          Slick.prototype.fadeSlide = function (slideIndex, callback) {

            var _ = this;

            if (_.cssTransitions === false) {

              _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
              });

              _.$slides.eq(slideIndex).animate({
                opacity: 1
              }, _.options.speed, _.options.easing, callback);

            } else {

              _.applyTransition(slideIndex);

              _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
              });

              if (callback) {
                setTimeout(function () {

                  _.disableTransition(slideIndex);

                  callback.call();
                }, _.options.speed);
              }

            }

          };

          Slick.prototype.fadeSlideOut = function (slideIndex) {

            var _ = this;

            if (_.cssTransitions === false) {

              _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
              }, _.options.speed, _.options.easing);

            } else {

              _.applyTransition(slideIndex);

              _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
              });

            }

          };

          Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (filter) {

            var _ = this;

            if (filter !== null) {

              _.$slidesCache = _.$slides;

              _.unload();

              _.$slideTrack.children(this.options.slide).detach();

              _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

              _.reinit();

            }

          };

          Slick.prototype.focusHandler = function () {

            var _ = this;

            _.$slider
              .off('focus.slick blur.slick')
              .on('focus.slick blur.slick', '*', function (event) {

                event.stopImmediatePropagation();
                var $sf = $(this);

                setTimeout(function () {

                  if (_.options.pauseOnFocus) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                  }

                }, 0);

              });
          };

          Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {

            var _ = this;
            return _.currentSlide;

          };

          Slick.prototype.getDotCount = function () {

            var _ = this;

            var breakPoint = 0;
            var counter = 0;
            var pagerQty = 0;

            if (_.options.infinite === true) {
              if (_.slideCount <= _.options.slidesToShow) {
                ++pagerQty;
              } else {
                while (breakPoint < _.slideCount) {
                  ++pagerQty;
                  breakPoint = counter + _.options.slidesToScroll;
                  counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                }
              }
            } else if (_.options.centerMode === true) {
              pagerQty = _.slideCount;
            } else if (!_.options.asNavFor) {
              pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
            } else {
              while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
              }
            }

            return pagerQty - 1;

          };

          Slick.prototype.getLeft = function (slideIndex) {

            var _ = this,
              targetLeft,
              verticalHeight,
              verticalOffset = 0,
              targetSlide,
              coef;

            _.slideOffset = 0;
            verticalHeight = _.$slides.first().outerHeight(true);

            if (_.options.infinite === true) {
              if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                coef = -1

                if (_.options.vertical === true && _.options.centerMode === true) {
                  if (_.options.slidesToShow === 2) {
                    coef = -1.5;
                  } else if (_.options.slidesToShow === 1) {
                    coef = -2
                  }
                }
                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
              }
              if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                  if (slideIndex > _.slideCount) {
                    _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                    verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                  } else {
                    _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                    verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                  }
                }
              }
            } else {
              if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
              }
            }

            if (_.slideCount <= _.options.slidesToShow) {
              _.slideOffset = 0;
              verticalOffset = 0;
            }

            if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
              _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
            } else if (_.options.centerMode === true && _.options.infinite === true) {
              _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
            } else if (_.options.centerMode === true) {
              _.slideOffset = 0;
              _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
            }

            if (_.options.vertical === false) {
              targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
            } else {
              targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
            }

            if (_.options.variableWidth === true) {

              if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
              } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
              }

              if (_.options.rtl === true) {
                if (targetSlide[0]) {
                  targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                  targetLeft = 0;
                }
              } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
              }

              if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                  targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                  targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                  if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                  } else {
                    targetLeft = 0;
                  }
                } else {
                  targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
              }
            }

            return targetLeft;

          };

          Slick.prototype.getOption = Slick.prototype.slickGetOption = function (option) {

            var _ = this;

            return _.options[option];

          };

          Slick.prototype.getNavigableIndexes = function () {

            var _ = this,
              breakPoint = 0,
              counter = 0,
              indexes = [],
              max;

            if (_.options.infinite === false) {
              max = _.slideCount;
            } else {
              breakPoint = _.options.slidesToScroll * -1;
              counter = _.options.slidesToScroll * -1;
              max = _.slideCount * 2;
            }

            while (breakPoint < max) {
              indexes.push(breakPoint);
              breakPoint = counter + _.options.slidesToScroll;
              counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }

            return indexes;

          };

          Slick.prototype.getSlick = function () {

            return this;

          };

          Slick.prototype.getSlideCount = function () {

            var _ = this,
              slidesTraversed, swipedSlide, centerOffset;

            centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

            if (_.options.swipeToSlide === true) {
              _.$slideTrack.find('.slick-slide').each(function (index, slide) {
                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                  swipedSlide = slide;
                  return false;
                }
              });

              slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

              return slidesTraversed;

            } else {
              return _.options.slidesToScroll;
            }

          };

          Slick.prototype.goTo = Slick.prototype.slickGoTo = function (slide, dontAnimate) {

            var _ = this;

            _.changeSlide({
              data: {
                message: 'index',
                index: parseInt(slide)
              }
            }, dontAnimate);

          };

          Slick.prototype.init = function (creation) {

            var _ = this;

            if (!$(_.$slider).hasClass('slick-initialized')) {

              $(_.$slider).addClass('slick-initialized');

              _.buildRows();
              _.buildOut();
              _.setProps();
              _.startLoad();
              _.loadSlider();
              _.initializeEvents();
              _.updateArrows();
              _.updateDots();
              _.checkResponsive(true);
              _.focusHandler();

            }

            if (creation) {
              _.$slider.trigger('init', [_]);
            }

            if (_.options.accessibility === true) {
              _.initADA();
            }

            if (_.options.autoplay) {

              _.paused = false;
              _.autoPlay();

            }

          };

          Slick.prototype.initADA = function () {
            var _ = this,
              numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
              tabControlIndexes = _.getNavigableIndexes().filter(function (val) {
                return (val >= 0) && (val < _.slideCount);
              });

            _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
              'aria-hidden': 'true',
              'tabindex': '-1'
            }).find('a, input, button, select').attr({
              'tabindex': '-1'
            });

            if (_.$dots !== null) {
              _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function (i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);

                $(this).attr({
                  'role': 'tabpanel',
                  'id': 'slick-slide' + _.instanceUid + i,
                  'tabindex': -1
                });

                if (slideControlIndex !== -1) {
                  var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex
                  if ($('#' + ariaButtonControl).length) {
                    $(this).attr({
                      'aria-describedby': ariaButtonControl
                    });
                  }
                }
              });

              _.$dots.attr('role', 'tablist').find('li').each(function (i) {
                var mappedSlideIndex = tabControlIndexes[i];

                $(this).attr({
                  'role': 'presentation'
                });

                $(this).find('button').first().attr({
                  'role': 'tab',
                  'id': 'slick-slide-control' + _.instanceUid + i,
                  'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                  'aria-label': (i + 1) + ' of ' + numDotGroups,
                  'aria-selected': null,
                  'tabindex': '-1'
                });

              }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
              }).end();
            }

            for (var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++) {
              if (_.options.focusOnChange) {
                _.$slides.eq(i).attr({ 'tabindex': '0' });
              } else {
                _.$slides.eq(i).removeAttr('tabindex');
              }
            }

            _.activateADA();

          };

          Slick.prototype.initArrowEvents = function () {

            var _ = this;

            if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
              _.$prevArrow
                .off('click.slick')
                .on('click.slick', {
                  message: 'previous'
                }, _.changeSlide);
              _.$nextArrow
                .off('click.slick')
                .on('click.slick', {
                  message: 'next'
                }, _.changeSlide);

              if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
              }
            }

          };

          Slick.prototype.initDotEvents = function () {

            var _ = this;

            if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
              $('li', _.$dots).on('click.slick', {
                message: 'index'
              }, _.changeSlide);

              if (_.options.accessibility === true) {
                _.$dots.on('keydown.slick', _.keyHandler);
              }
            }

            if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

              $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

            }

          };

          Slick.prototype.initSlideEvents = function () {

            var _ = this;

            if (_.options.pauseOnHover) {

              _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
              _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

            }

          };

          Slick.prototype.initializeEvents = function () {

            var _ = this;

            _.initArrowEvents();

            _.initDotEvents();
            _.initSlideEvents();

            _.$list.on('touchstart.slick mousedown.slick', {
              action: 'start'
            }, _.swipeHandler);
            _.$list.on('touchmove.slick mousemove.slick', {
              action: 'move'
            }, _.swipeHandler);
            _.$list.on('touchend.slick mouseup.slick', {
              action: 'end'
            }, _.swipeHandler);
            _.$list.on('touchcancel.slick mouseleave.slick', {
              action: 'end'
            }, _.swipeHandler);

            _.$list.on('click.slick', _.clickHandler);

            $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

            if (_.options.accessibility === true) {
              _.$list.on('keydown.slick', _.keyHandler);
            }

            if (_.options.focusOnSelect === true) {
              $(_.$slideTrack).children().on('click.slick', _.selectHandler);
            }

            $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

            $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

            $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

            $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
            $(_.setPosition);

          };

          Slick.prototype.initUI = function () {

            var _ = this;

            if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

              _.$prevArrow.show();
              _.$nextArrow.show();

            }

            if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

              _.$dots.show();

            }

          };

          Slick.prototype.keyHandler = function (event) {

            var _ = this;
            //Dont slide if the cursor is inside the form fields and arrow keys are pressed
            if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
              if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                  data: {
                    message: _.options.rtl === true ? 'next' : 'previous'
                  }
                });
              } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                  data: {
                    message: _.options.rtl === true ? 'previous' : 'next'
                  }
                });
              }
            }

          };

          Slick.prototype.lazyLoad = function () {

            var _ = this,
              loadRange, cloneRange, rangeStart, rangeEnd;

            function loadImages(imagesScope) {

              $('img[data-lazy]', imagesScope).each(function () {

                var image = $(this),
                  imageSource = $(this).attr('data-lazy'),
                  imageSrcSet = $(this).attr('data-srcset'),
                  imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                  imageToLoad = document.createElement('img');

                imageToLoad.onload = function () {

                  image
                    .animate({ opacity: 0 }, 100, function () {

                      if (imageSrcSet) {
                        image
                          .attr('srcset', imageSrcSet);

                        if (imageSizes) {
                          image
                            .attr('sizes', imageSizes);
                        }
                      }

                      image
                        .attr('src', imageSource)
                        .animate({ opacity: 1 }, 200, function () {
                          image
                            .removeAttr('data-lazy data-srcset data-sizes')
                            .removeClass('slick-loading');
                        });
                      _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                    });

                };

                imageToLoad.onerror = function () {

                  image
                    .removeAttr('data-lazy')
                    .removeClass('slick-loading')
                    .addClass('slick-lazyload-error');

                  _.$slider.trigger('lazyLoadError', [_, image, imageSource]);

                };

                imageToLoad.src = imageSource;

              });

            }

            if (_.options.centerMode === true) {
              if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
              } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
              }
            } else {
              rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
              rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
              if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
              }
            }

            loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

            if (_.options.lazyLoad === 'anticipated') {
              var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find('.slick-slide');

              for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
              }
            }

            loadImages(loadRange);

            if (_.slideCount <= _.options.slidesToShow) {
              cloneRange = _.$slider.find('.slick-slide');
              loadImages(cloneRange);
            } else
              if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
                cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
                loadImages(cloneRange);
              } else if (_.currentSlide === 0) {
                cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
                loadImages(cloneRange);
              }

          };

          Slick.prototype.loadSlider = function () {

            var _ = this;

            _.setPosition();

            _.$slideTrack.css({
              opacity: 1
            });

            _.$slider.removeClass('slick-loading');

            _.initUI();

            if (_.options.lazyLoad === 'progressive') {
              _.progressiveLazyLoad();
            }

          };

          Slick.prototype.next = Slick.prototype.slickNext = function () {

            var _ = this;

            _.changeSlide({
              data: {
                message: 'next'
              }
            });

          };

          Slick.prototype.orientationChange = function () {

            var _ = this;

            _.checkResponsive();
            _.setPosition();

          };

          Slick.prototype.pause = Slick.prototype.slickPause = function () {

            var _ = this;

            _.autoPlayClear();
            _.paused = true;

          };

          Slick.prototype.play = Slick.prototype.slickPlay = function () {

            var _ = this;

            _.autoPlay();
            _.options.autoplay = true;
            _.paused = false;
            _.focussed = false;
            _.interrupted = false;

          };

          Slick.prototype.postSlide = function (index) {

            var _ = this;

            if (!_.unslicked) {

              _.$slider.trigger('afterChange', [_, index]);

              _.animating = false;

              if (_.slideCount > _.options.slidesToShow) {
                _.setPosition();
              }

              _.swipeLeft = null;

              if (_.options.autoplay) {
                _.autoPlay();
              }

              if (_.options.accessibility === true) {
                _.initADA();

                if (_.options.focusOnChange) {
                  var $currentSlide = $(_.$slides.get(_.currentSlide));
                  $currentSlide.attr('tabindex', 0).focus();
                }
              }

            }

          };

          Slick.prototype.prev = Slick.prototype.slickPrev = function () {

            var _ = this;

            _.changeSlide({
              data: {
                message: 'previous'
              }
            });

          };

          Slick.prototype.preventDefault = function (event) {

            event.preventDefault();

          };

          Slick.prototype.progressiveLazyLoad = function (tryCount) {

            tryCount = tryCount || 1;

            var _ = this,
              $imgsToLoad = $('img[data-lazy]', _.$slider),
              image,
              imageSource,
              imageSrcSet,
              imageSizes,
              imageToLoad;

            if ($imgsToLoad.length) {

              image = $imgsToLoad.first();
              imageSource = image.attr('data-lazy');
              imageSrcSet = image.attr('data-srcset');
              imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
              imageToLoad = document.createElement('img');

              imageToLoad.onload = function () {

                if (imageSrcSet) {
                  image
                    .attr('srcset', imageSrcSet);

                  if (imageSizes) {
                    image
                      .attr('sizes', imageSizes);
                  }
                }

                image
                  .attr('src', imageSource)
                  .removeAttr('data-lazy data-srcset data-sizes')
                  .removeClass('slick-loading');

                if (_.options.adaptiveHeight === true) {
                  _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                _.progressiveLazyLoad();

              };

              imageToLoad.onerror = function () {

                if (tryCount < 3) {

                  /**
                   * try to load the image 3 times,
                   * leave a slight delay so we don't get
                   * servers blocking the request.
                   */
                  setTimeout(function () {
                    _.progressiveLazyLoad(tryCount + 1);
                  }, 500);

                } else {

                  image
                    .removeAttr('data-lazy')
                    .removeClass('slick-loading')
                    .addClass('slick-lazyload-error');

                  _.$slider.trigger('lazyLoadError', [_, image, imageSource]);

                  _.progressiveLazyLoad();

                }

              };

              imageToLoad.src = imageSource;

            } else {

              _.$slider.trigger('allImagesLoaded', [_]);

            }

          };

          Slick.prototype.refresh = function (initializing) {

            var _ = this, currentSlide, lastVisibleIndex;

            lastVisibleIndex = _.slideCount - _.options.slidesToShow;

            // in non-infinite sliders, we don't want to go past the
            // last visible index.
            if (!_.options.infinite && (_.currentSlide > lastVisibleIndex)) {
              _.currentSlide = lastVisibleIndex;
            }

            // if less slides than to show, go to start.
            if (_.slideCount <= _.options.slidesToShow) {
              _.currentSlide = 0;

            }

            currentSlide = _.currentSlide;

            _.destroy(true);

            $.extend(_, _.initials, { currentSlide: currentSlide });

            _.init();

            if (!initializing) {

              _.changeSlide({
                data: {
                  message: 'index',
                  index: currentSlide
                }
              }, false);

            }

          };

          Slick.prototype.registerBreakpoints = function () {

            var _ = this, breakpoint, currentBreakpoint, l,
              responsiveSettings = _.options.responsive || null;

            if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {

              _.respondTo = _.options.respondTo || 'window';

              for (breakpoint in responsiveSettings) {

                l = _.breakpoints.length - 1;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                  currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                  // loop through the breakpoints and cut out any existing
                  // ones with the same breakpoint number, we don't want dupes.
                  while (l >= 0) {
                    if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
                      _.breakpoints.splice(l, 1);
                    }
                    l--;
                  }

                  _.breakpoints.push(currentBreakpoint);
                  _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

              }

              _.breakpoints.sort(function (a, b) {
                return (_.options.mobileFirst) ? a - b : b - a;
              });

            }

          };

          Slick.prototype.reinit = function () {

            var _ = this;

            _.$slides =
              _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

            _.slideCount = _.$slides.length;

            if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
              _.currentSlide = _.currentSlide - _.options.slidesToScroll;
            }

            if (_.slideCount <= _.options.slidesToShow) {
              _.currentSlide = 0;
            }

            _.registerBreakpoints();

            _.setProps();
            _.setupInfinite();
            _.buildArrows();
            _.updateArrows();
            _.initArrowEvents();
            _.buildDots();
            _.updateDots();
            _.initDotEvents();
            _.cleanUpSlideEvents();
            _.initSlideEvents();

            _.checkResponsive(false, true);

            if (_.options.focusOnSelect === true) {
              $(_.$slideTrack).children().on('click.slick', _.selectHandler);
            }

            _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

            _.setPosition();
            _.focusHandler();

            _.paused = !_.options.autoplay;
            _.autoPlay();

            _.$slider.trigger('reInit', [_]);

          };

          Slick.prototype.resize = function () {

            var _ = this;

            if ($(window).width() !== _.windowWidth) {
              clearTimeout(_.windowDelay);
              _.windowDelay = window.setTimeout(function () {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if (!_.unslicked) { _.setPosition(); }
              }, 50);
            }
          };

          Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (index, removeBefore, removeAll) {

            var _ = this;

            if (typeof (index) === 'boolean') {
              removeBefore = index;
              index = removeBefore === true ? 0 : _.slideCount - 1;
            } else {
              index = removeBefore === true ? --index : index;
            }

            if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
              return false;
            }

            _.unload();

            if (removeAll === true) {
              _.$slideTrack.children().remove();
            } else {
              _.$slideTrack.children(this.options.slide).eq(index).remove();
            }

            _.$slides = _.$slideTrack.children(this.options.slide);

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.append(_.$slides);

            _.$slidesCache = _.$slides;

            _.reinit();

          };

          Slick.prototype.setCSS = function (position) {

            var _ = this,
              positionProps = {},
              x, y;

            if (_.options.rtl === true) {
              position = -position;
            }
            x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
            y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

            positionProps[_.positionProp] = position;

            if (_.transformsEnabled === false) {
              _.$slideTrack.css(positionProps);
            } else {
              positionProps = {};
              if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
              } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
              }
            }

          };

          Slick.prototype.setDimensions = function () {

            var _ = this;

            if (_.options.vertical === false) {
              if (_.options.centerMode === true) {
                _.$list.css({
                  padding: ('0px ' + _.options.centerPadding)
                });
              }
            } else {
              _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
              if (_.options.centerMode === true) {
                _.$list.css({
                  padding: (_.options.centerPadding + ' 0px')
                });
              }
            }

            _.listWidth = _.$list.width();
            _.listHeight = _.$list.height();


            if (_.options.vertical === false && _.options.variableWidth === false) {
              _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
              _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

            } else if (_.options.variableWidth === true) {
              _.$slideTrack.width(5000 * _.slideCount);
            } else {
              _.slideWidth = Math.ceil(_.listWidth);
              _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
            }

            var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
            if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

          };

          Slick.prototype.setFade = function () {

            var _ = this,
              targetLeft;

            _.$slides.each(function (index, element) {
              targetLeft = (_.slideWidth * index) * -1;
              if (_.options.rtl === true) {
                $(element).css({
                  position: 'relative',
                  right: targetLeft,
                  top: 0,
                  zIndex: _.options.zIndex - 2,
                  opacity: 0
                });
              } else {
                $(element).css({
                  position: 'relative',
                  left: targetLeft,
                  top: 0,
                  zIndex: _.options.zIndex - 2,
                  opacity: 0
                });
              }
            });

            _.$slides.eq(_.currentSlide).css({
              zIndex: _.options.zIndex - 1,
              opacity: 1
            });

          };

          Slick.prototype.setHeight = function () {

            var _ = this;

            if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
              var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
              _.$list.css('height', targetHeight);
            }

          };

          Slick.prototype.setOption =
            Slick.prototype.slickSetOption = function () {

              /**
               * accepts arguments in format of:
               *
               *  - for changing a single option's value:
               *     .slick("setOption", option, value, refresh )
               *
               *  - for changing a set of responsive options:
               *     .slick("setOption", 'responsive', [{}, ...], refresh )
               *
               *  - for updating multiple values at once (not responsive)
               *     .slick("setOption", { 'option': value, ... }, refresh )
               */

              var _ = this, l, item, option, value, refresh = false, type;

              if ($.type(arguments[0]) === 'object') {

                option = arguments[0];
                refresh = arguments[1];
                type = 'multiple';

              } else if ($.type(arguments[0]) === 'string') {

                option = arguments[0];
                value = arguments[1];
                refresh = arguments[2];

                if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') {

                  type = 'responsive';

                } else if (typeof arguments[1] !== 'undefined') {

                  type = 'single';

                }

              }

              if (type === 'single') {

                _.options[option] = value;


              } else if (type === 'multiple') {

                $.each(option, function (opt, val) {

                  _.options[opt] = val;

                });


              } else if (type === 'responsive') {

                for (item in value) {

                  if ($.type(_.options.responsive) !== 'array') {

                    _.options.responsive = [value[item]];

                  } else {

                    l = _.options.responsive.length - 1;

                    // loop through the responsive object and splice out duplicates.
                    while (l >= 0) {

                      if (_.options.responsive[l].breakpoint === value[item].breakpoint) {

                        _.options.responsive.splice(l, 1);

                      }

                      l--;

                    }

                    _.options.responsive.push(value[item]);

                  }

                }

              }

              if (refresh) {

                _.unload();
                _.reinit();

              }

            };

          Slick.prototype.setPosition = function () {

            var _ = this;

            _.setDimensions();

            _.setHeight();

            if (_.options.fade === false) {
              _.setCSS(_.getLeft(_.currentSlide));
            } else {
              _.setFade();
            }

            _.$slider.trigger('setPosition', [_]);

          };

          Slick.prototype.setProps = function () {

            var _ = this,
              bodyStyle = document.body.style;

            _.positionProp = _.options.vertical === true ? 'top' : 'left';

            if (_.positionProp === 'top') {
              _.$slider.addClass('slick-vertical');
            } else {
              _.$slider.removeClass('slick-vertical');
            }

            if (bodyStyle.WebkitTransition !== undefined ||
              bodyStyle.MozTransition !== undefined ||
              bodyStyle.msTransition !== undefined) {
              if (_.options.useCSS === true) {
                _.cssTransitions = true;
              }
            }

            if (_.options.fade) {
              if (typeof _.options.zIndex === 'number') {
                if (_.options.zIndex < 3) {
                  _.options.zIndex = 3;
                }
              } else {
                _.options.zIndex = _.defaults.zIndex;
              }
            }

            if (bodyStyle.OTransform !== undefined) {
              _.animType = 'OTransform';
              _.transformType = '-o-transform';
              _.transitionType = 'OTransition';
              if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
            }
            if (bodyStyle.MozTransform !== undefined) {
              _.animType = 'MozTransform';
              _.transformType = '-moz-transform';
              _.transitionType = 'MozTransition';
              if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
            }
            if (bodyStyle.webkitTransform !== undefined) {
              _.animType = 'webkitTransform';
              _.transformType = '-webkit-transform';
              _.transitionType = 'webkitTransition';
              if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
            }
            if (bodyStyle.msTransform !== undefined) {
              _.animType = 'msTransform';
              _.transformType = '-ms-transform';
              _.transitionType = 'msTransition';
              if (bodyStyle.msTransform === undefined) _.animType = false;
            }
            if (bodyStyle.transform !== undefined && _.animType !== false) {
              _.animType = 'transform';
              _.transformType = 'transform';
              _.transitionType = 'transition';
            }
            _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
          };


          Slick.prototype.setSlideClasses = function (index) {

            var _ = this,
              centerOffset, allSlides, indexOffset, remainder;

            allSlides = _.$slider
              .find('.slick-slide')
              .removeClass('slick-active slick-center slick-current')
              .attr('aria-hidden', 'true');

            _.$slides
              .eq(index)
              .addClass('slick-current');

            if (_.options.centerMode === true) {

              var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

              centerOffset = Math.floor(_.options.slidesToShow / 2);

              if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
                  _.$slides
                    .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

                } else {

                  indexOffset = _.options.slidesToShow + index;
                  allSlides
                    .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                  allSlides
                    .eq(allSlides.length - 1 - _.options.slidesToShow)
                    .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                  allSlides
                    .eq(_.options.slidesToShow)
                    .addClass('slick-center');

                }

              }

              _.$slides
                .eq(index)
                .addClass('slick-center');

            } else {

              if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                  .slice(index, index + _.options.slidesToShow)
                  .addClass('slick-active')
                  .attr('aria-hidden', 'false');

              } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                  .addClass('slick-active')
                  .attr('aria-hidden', 'false');

              } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                  allSlides
                    .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

                } else {

                  allSlides
                    .slice(indexOffset, indexOffset + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

                }

              }

            }

            if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
              _.lazyLoad();
            }
          };

          Slick.prototype.setupInfinite = function () {

            var _ = this,
              i, slideIndex, infiniteCount;

            if (_.options.fade === true) {
              _.options.centerMode = false;
            }

            if (_.options.infinite === true && _.options.fade === false) {

              slideIndex = null;

              if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                  infiniteCount = _.options.slidesToShow + 1;
                } else {
                  infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                  infiniteCount); i -= 1) {
                  slideIndex = i - 1;
                  $(_.$slides[slideIndex]).clone(true).attr('id', '')
                    .attr('data-slick-index', slideIndex - _.slideCount)
                    .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount + _.slideCount; i += 1) {
                  slideIndex = i;
                  $(_.$slides[slideIndex]).clone(true).attr('id', '')
                    .attr('data-slick-index', slideIndex + _.slideCount)
                    .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
                  $(this).attr('id', '');
                });

              }

            }

          };

          Slick.prototype.interrupt = function (toggle) {

            var _ = this;

            if (!toggle) {
              _.autoPlay();
            }
            _.interrupted = toggle;

          };

          Slick.prototype.selectHandler = function (event) {

            var _ = this;

            var targetElement =
              $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

            var index = parseInt(targetElement.attr('data-slick-index'));

            if (!index) index = 0;

            if (_.slideCount <= _.options.slidesToShow) {

              _.slideHandler(index, false, true);
              return;

            }

            _.slideHandler(index);

          };

          Slick.prototype.slideHandler = function (index, sync, dontAnimate) {

            var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
              _ = this, navTarget;

            sync = sync || false;

            if (_.animating === true && _.options.waitForAnimate === true) {
              return;
            }

            if (_.options.fade === true && _.currentSlide === index) {
              return;
            }

            if (sync === false) {
              _.asNavFor(index);
            }

            targetSlide = index;
            targetLeft = _.getLeft(targetSlide);
            slideLeft = _.getLeft(_.currentSlide);

            _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

            if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
              if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                  _.animateSlide(slideLeft, function () {
                    _.postSlide(targetSlide);
                  });
                } else {
                  _.postSlide(targetSlide);
                }
              }
              return;
            } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
              if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                  _.animateSlide(slideLeft, function () {
                    _.postSlide(targetSlide);
                  });
                } else {
                  _.postSlide(targetSlide);
                }
              }
              return;
            }

            if (_.options.autoplay) {
              clearInterval(_.autoPlayTimer);
            }

            if (targetSlide < 0) {
              if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
              } else {
                animSlide = _.slideCount + targetSlide;
              }
            } else if (targetSlide >= _.slideCount) {
              if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
              } else {
                animSlide = targetSlide - _.slideCount;
              }
            } else {
              animSlide = targetSlide;
            }

            _.animating = true;

            _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

            oldSlide = _.currentSlide;
            _.currentSlide = animSlide;

            _.setSlideClasses(_.currentSlide);

            if (_.options.asNavFor) {

              navTarget = _.getNavTarget();
              navTarget = navTarget.slick('getSlick');

              if (navTarget.slideCount <= navTarget.options.slidesToShow) {
                navTarget.setSlideClasses(_.currentSlide);
              }

            }

            _.updateDots();
            _.updateArrows();

            if (_.options.fade === true) {
              if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function () {
                  _.postSlide(animSlide);
                });

              } else {
                _.postSlide(animSlide);
              }
              _.animateHeight();
              return;
            }

            if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
              _.animateSlide(targetLeft, function () {
                _.postSlide(animSlide);
              });
            } else {
              _.postSlide(animSlide);
            }

          };

          Slick.prototype.startLoad = function () {

            var _ = this;

            if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

              _.$prevArrow.hide();
              _.$nextArrow.hide();

            }

            if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

              _.$dots.hide();

            }

            _.$slider.addClass('slick-loading');

          };

          Slick.prototype.swipeDirection = function () {

            var xDist, yDist, r, swipeAngle, _ = this;

            xDist = _.touchObject.startX - _.touchObject.curX;
            yDist = _.touchObject.startY - _.touchObject.curY;
            r = Math.atan2(yDist, xDist);

            swipeAngle = Math.round(r * 180 / Math.PI);
            if (swipeAngle < 0) {
              swipeAngle = 360 - Math.abs(swipeAngle);
            }

            if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
              return (_.options.rtl === false ? 'left' : 'right');
            }
            if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
              return (_.options.rtl === false ? 'left' : 'right');
            }
            if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
              return (_.options.rtl === false ? 'right' : 'left');
            }
            if (_.options.verticalSwiping === true) {
              if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
              } else {
                return 'up';
              }
            }

            return 'vertical';

          };

          Slick.prototype.swipeEnd = function (event) {

            var _ = this,
              slideCount,
              direction;

            _.dragging = false;
            _.swiping = false;

            if (_.scrolling) {
              _.scrolling = false;
              return false;
            }

            _.interrupted = false;
            _.shouldClick = (_.touchObject.swipeLength > 10) ? false : true;

            if (_.touchObject.curX === undefined) {
              return false;
            }

            if (_.touchObject.edgeHit === true) {
              _.$slider.trigger('edge', [_, _.swipeDirection()]);
            }

            if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {

              direction = _.swipeDirection();

              switch (direction) {

                case 'left':
                case 'down':

                  slideCount =
                    _.options.swipeToSlide ?
                      _.checkNavigable(_.currentSlide + _.getSlideCount()) :
                      _.currentSlide + _.getSlideCount();

                  _.currentDirection = 0;

                  break;

                case 'right':
                case 'up':

                  slideCount =
                    _.options.swipeToSlide ?
                      _.checkNavigable(_.currentSlide - _.getSlideCount()) :
                      _.currentSlide - _.getSlideCount();

                  _.currentDirection = 1;

                  break;

                default:


              }

              if (direction != 'vertical') {

                _.slideHandler(slideCount);
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction]);

              }

            } else {

              if (_.touchObject.startX !== _.touchObject.curX) {

                _.slideHandler(_.currentSlide);
                _.touchObject = {};

              }

            }

          };

          Slick.prototype.swipeHandler = function (event) {

            var _ = this;

            if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
              return;
            } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
              return;
            }

            _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
              event.originalEvent.touches.length : 1;

            _.touchObject.minSwipe = _.listWidth / _.options
              .touchThreshold;

            if (_.options.verticalSwiping === true) {
              _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
            }

            switch (event.data.action) {

              case 'start':
                _.swipeStart(event);
                break;

              case 'move':
                _.swipeMove(event);
                break;

              case 'end':
                _.swipeEnd(event);
                break;

            }

          };

          Slick.prototype.swipeMove = function (event) {

            var _ = this,
              edgeWasHit = false,
              curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;

            touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

            if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
              return false;
            }

            curLeft = _.getLeft(_.currentSlide);

            _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
            _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

            _.touchObject.swipeLength = Math.round(Math.sqrt(
              Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

            verticalSwipeLength = Math.round(Math.sqrt(
              Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

            if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
              _.scrolling = true;
              return false;
            }

            if (_.options.verticalSwiping === true) {
              _.touchObject.swipeLength = verticalSwipeLength;
            }

            swipeDirection = _.swipeDirection();

            if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
              _.swiping = true;
              event.preventDefault();
            }

            positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
            if (_.options.verticalSwiping === true) {
              positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
            }


            swipeLength = _.touchObject.swipeLength;

            _.touchObject.edgeHit = false;

            if (_.options.infinite === false) {
              if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
              }
            }

            if (_.options.vertical === false) {
              _.swipeLeft = curLeft + swipeLength * positionOffset;
            } else {
              _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
            }
            if (_.options.verticalSwiping === true) {
              _.swipeLeft = curLeft + swipeLength * positionOffset;
            }

            if (_.options.fade === true || _.options.touchMove === false) {
              return false;
            }

            if (_.animating === true) {
              _.swipeLeft = null;
              return false;
            }

            _.setCSS(_.swipeLeft);

          };

          Slick.prototype.swipeStart = function (event) {

            var _ = this,
              touches;

            _.interrupted = true;

            if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
              _.touchObject = {};
              return false;
            }

            if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
              touches = event.originalEvent.touches[0];
            }

            _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
            _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

            _.dragging = true;

          };

          Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {

            var _ = this;

            if (_.$slidesCache !== null) {

              _.unload();

              _.$slideTrack.children(this.options.slide).detach();

              _.$slidesCache.appendTo(_.$slideTrack);

              _.reinit();

            }

          };

          Slick.prototype.unload = function () {

            var _ = this;

            $('.slick-cloned', _.$slider).remove();

            if (_.$dots) {
              _.$dots.remove();
            }

            if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
              _.$prevArrow.remove();
            }

            if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
              _.$nextArrow.remove();
            }

            _.$slides
              .removeClass('slick-slide slick-active slick-visible slick-current')
              .attr('aria-hidden', 'true')
              .css('width', '');

          };

          Slick.prototype.unslick = function (fromBreakpoint) {

            var _ = this;
            _.$slider.trigger('unslick', [_, fromBreakpoint]);
            _.destroy();

          };

          Slick.prototype.updateArrows = function () {

            var _ = this,
              centerOffset;

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.arrows === true &&
              _.slideCount > _.options.slidesToShow &&
              !_.options.infinite) {

              _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
              _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

              if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

              } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

              } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

              }

            }

          };

          Slick.prototype.updateDots = function () {

            var _ = this;

            if (_.$dots !== null) {

              _.$dots
                .find('li')
                .removeClass('slick-active')
                .end();

              _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active');

            }

          };

          Slick.prototype.visibility = function () {

            var _ = this;

            if (_.options.autoplay) {

              if (document[_.hidden]) {

                _.interrupted = true;

              } else {

                _.interrupted = false;

              }

            }

          };

          $.fn.slick = function () {
            var _ = this,
              opt = arguments[0],
              args = Array.prototype.slice.call(arguments, 1),
              l = _.length,
              i,
              ret;
            for (i = 0; i < l; i++) {
              if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].slick = new Slick(_[i], opt);
              else
                ret = _[i].slick[opt].apply(_[i].slick, args);
              if (typeof ret != 'undefined') return ret;
            }
            return _;
          };

        }));


        /***/
}),

/***/ "./node_modules/ua-parser-js/src/ua-parser.js":
/*!****************************************************!*\
  !*** ./node_modules/ua-parser-js/src/ua-parser.js ***!
  \****************************************************/
/***/ (function (module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_RESULT__;/////////////////////////////////////////////////////////////////////////////////
        /* UAParser.js v1.0.2
           Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
           MIT License *//*
        Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
        Supports browser & node.js environment. 
        Demo   : https://faisalman.github.io/ua-parser-js
        Source : https://github.com/faisalman/ua-parser-js */
        /////////////////////////////////////////////////////////////////////////////////

        (function (window, undefined) {

          'use strict';

          //////////////
          // Constants
          /////////////


          var LIBVERSION = '1.0.2',
            EMPTY = '',
            UNKNOWN = '?',
            FUNC_TYPE = 'function',
            UNDEF_TYPE = 'undefined',
            OBJ_TYPE = 'object',
            STR_TYPE = 'string',
            MAJOR = 'major',
            MODEL = 'model',
            NAME = 'name',
            TYPE = 'type',
            VENDOR = 'vendor',
            VERSION = 'version',
            ARCHITECTURE = 'architecture',
            CONSOLE = 'console',
            MOBILE = 'mobile',
            TABLET = 'tablet',
            SMARTTV = 'smarttv',
            WEARABLE = 'wearable',
            EMBEDDED = 'embedded',
            UA_MAX_LENGTH = 255;

          var AMAZON = 'Amazon',
            APPLE = 'Apple',
            ASUS = 'ASUS',
            BLACKBERRY = 'BlackBerry',
            BROWSER = 'Browser',
            CHROME = 'Chrome',
            EDGE = 'Edge',
            FIREFOX = 'Firefox',
            GOOGLE = 'Google',
            HUAWEI = 'Huawei',
            LG = 'LG',
            MICROSOFT = 'Microsoft',
            MOTOROLA = 'Motorola',
            OPERA = 'Opera',
            SAMSUNG = 'Samsung',
            SONY = 'Sony',
            XIAOMI = 'Xiaomi',
            ZEBRA = 'Zebra',
            FACEBOOK = 'Facebook';

          ///////////
          // Helper
          //////////

          var extend = function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
              if (extensions[i] && extensions[i].length % 2 === 0) {
                mergedRegexes[i] = extensions[i].concat(regexes[i]);
              } else {
                mergedRegexes[i] = regexes[i];
              }
            }
            return mergedRegexes;
          },
            enumerize = function (arr) {
              var enums = {};
              for (var i = 0; i < arr.length; i++) {
                enums[arr[i].toUpperCase()] = arr[i];
              }
              return enums;
            },
            has = function (str1, str2) {
              return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
            },
            lowerize = function (str) {
              return str.toLowerCase();
            },
            majorize = function (version) {
              return typeof (version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
            },
            trim = function (str, len) {
              if (typeof (str) === STR_TYPE) {
                str = str.replace(/^\s\s*/, EMPTY).replace(/\s\s*$/, EMPTY);
                return typeof (len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
              }
            };

          ///////////////
          // Map helper
          //////////////

          var rgxMapper = function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

              var regex = arrays[i],       // even sequence (0,2,4,..)
                props = arrays[i + 1];   // odd sequence (1,3,5,..)
              j = k = 0;

              // try matching uastring with regexes
              while (j < regex.length && !matches) {

                matches = regex[j++].exec(ua);

                if (!!matches) {
                  for (p = 0; p < props.length; p++) {
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                      if (q.length === 2) {
                        if (typeof q[1] == FUNC_TYPE) {
                          // assign modified match
                          this[q[0]] = q[1].call(this, match);
                        } else {
                          // assign given value, ignore regex match
                          this[q[0]] = q[1];
                        }
                      } else if (q.length === 3) {
                        // check whether function or regex
                        if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                          // call function (usually string mapper)
                          this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                        } else {
                          // sanitize match using given regex
                          this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        }
                      } else if (q.length === 4) {
                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                      }
                    } else {
                      this[q] = match ? match : undefined;
                    }
                  }
                }
              }
              i += 2;
            }
          },

            strMapper = function (str, map) {

              for (var i in map) {
                // check if current value is array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                  for (var j = 0; j < map[i].length; j++) {
                    if (has(map[i][j], str)) {
                      return (i === UNKNOWN) ? undefined : i;
                    }
                  }
                } else if (has(map[i], str)) {
                  return (i === UNKNOWN) ? undefined : i;
                }
              }
              return str;
            };

          ///////////////
          // String map
          //////////////

          // Safari < 3.0
          var oldSafariMap = {
            '1.0': '/8',
            '1.2': '/1',
            '1.3': '/3',
            '2.0': '/412',
            '2.0.2': '/416',
            '2.0.3': '/417',
            '2.0.4': '/419',
            '?': '/'
          },
            windowsVersionMap = {
              'ME': '4.90',
              'NT 3.11': 'NT3.51',
              'NT 4.0': 'NT4.0',
              '2000': 'NT 5.0',
              'XP': ['NT 5.1', 'NT 5.2'],
              'Vista': 'NT 6.0',
              '7': 'NT 6.1',
              '8': 'NT 6.2',
              '8.1': 'NT 6.3',
              '10': ['NT 6.4', 'NT 10.0'],
              'RT': 'ARM'
            };

          //////////////
          // Regex map
          /////////////

          var regexes = {

            browser: [[

              /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
            ], [VERSION, [NAME, 'Chrome']], [
              /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
            ], [VERSION, [NAME, 'Edge']], [

              // Presto based
              /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
              /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
              /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
            ], [NAME, VERSION], [
              /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
            ], [VERSION, [NAME, OPERA + ' Mini']], [
              /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
            ], [VERSION, [NAME, OPERA]], [

              // Mixed
              /(kindle)\/([\w\.]+)/i,                                             // Kindle
              /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
              // Trident based
              /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,               // Avant/IEMobile/SlimBrowser
              /(ba?idubrowser)[\/ ]?([\w\.]+)/i,                                  // Baidu Browser
              /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

              // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
              /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
              // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
              /(weibo)__([\d\.]+)/i                                               // Weibo
            ], [NAME, VERSION], [
              /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
            ], [VERSION, [NAME, 'UC' + BROWSER]], [
              /\bqbcore\/([\w\.]+)/i                                              // WeChat Desktop for Windows Built-in Browser
            ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [
              /micromessenger\/([\w\.]+)/i                                        // WeChat
            ], [VERSION, [NAME, 'WeChat']], [
              /konqueror\/([\w\.]+)/i                                             // Konqueror
            ], [VERSION, [NAME, 'Konqueror']], [
              /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
            ], [VERSION, [NAME, 'IE']], [
              /yabrowser\/([\w\.]+)/i                                             // Yandex
            ], [VERSION, [NAME, 'Yandex']], [
              /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
            ], [[NAME, /(.+)/, '$1 Secure ' + BROWSER], VERSION], [
              /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
            ], [VERSION, [NAME, FIREFOX + ' Focus']], [
              /\bopt\/([\w\.]+)/i                                                 // Opera Touch
            ], [VERSION, [NAME, OPERA + ' Touch']], [
              /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
            ], [VERSION, [NAME, 'Coc Coc']], [
              /dolfin\/([\w\.]+)/i                                                // Dolphin
            ], [VERSION, [NAME, 'Dolphin']], [
              /coast\/([\w\.]+)/i                                                 // Opera Coast
            ], [VERSION, [NAME, OPERA + ' Coast']], [
              /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
            ], [VERSION, [NAME, 'MIUI ' + BROWSER]], [
              /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, FIREFOX]], [
              /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
            ], [[NAME, '360 ' + BROWSER]], [
              /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
            ], [[NAME, /(.+)/, '$1 ' + BROWSER], VERSION], [                      // Oculus/Samsung/Sailfish Browser
              /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [
              /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
              /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
              /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i            // QQBrowser/Baidu App/2345 Browser
            ], [NAME, VERSION], [
              /(metasr)[\/ ]?([\w\.]+)/i,                                         // SouGouBrowser
              /(lbbrowser)/i                                                      // LieBao Browser
            ], [NAME], [

              // WebView
              /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
            ], [[NAME, FACEBOOK], VERSION], [
              /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
              /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
              /(chromium|instagram)[\/ ]([-\w\.]+)/i                              // Chromium/Instagram
            ], [NAME, VERSION], [
              /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
            ], [VERSION, [NAME, 'GSA']], [

              /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
            ], [VERSION, [NAME, CHROME + ' Headless']], [

              / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
            ], [[NAME, CHROME + ' WebView'], VERSION], [

              /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
            ], [VERSION, [NAME, 'Android ' + BROWSER]], [

              /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

              /version\/([\w\.]+) .*mobile\/\w+ (safari)/i                        // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [
              /version\/([\w\.]+) .*(mobile ?safari|safari)/i                     // Safari & Safari Mobile
            ], [VERSION, NAME], [
              /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

              /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

              // Gecko based
              /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
              /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
            ], [VERSION, [NAME, FIREFOX + ' Reality']], [
              /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
              /(swiftfox)/i,                                                      // Swiftfox
              /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
              // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
              /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
              // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
              /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
              /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

              // Other
              /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
              // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
              /(links) \(([\w\.]+)/i                                              // Links
            ], [NAME, VERSION]
            ],

            cpu: [[

              /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
            ], [[ARCHITECTURE, 'amd64']], [

              /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, lowerize]], [

              /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
            ], [[ARCHITECTURE, 'ia32']], [

              /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
            ], [[ARCHITECTURE, 'arm64']], [

              /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
            ], [[ARCHITECTURE, 'armhf']], [

              // PocketPC mistakenly identified as PowerPC
              /windows (ce|mobile); ppc;/i
            ], [[ARCHITECTURE, 'arm']], [

              /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

              /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

              /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
              // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, lowerize]]
            ],

            device: [[

              //////////////////////////
              // MOBILES & TABLETS
              // Ordered by popularity
              /////////////////////////

              // Samsung
              /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
              /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
              /samsung[- ]([-\w]+)/i,
              /sec-(sgh\w+)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

              // Apple
              /\((ip(?:hone|od)[\w ]*);/i                                         // iPod/iPhone
            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
              /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
              /applecoremedia\/[\w\.]+ \((ipad)/i,
              /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [

              // Huawei
              /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
              /(?:huawei|honor)([-\w ]+)[;\)]/i,
              /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

              // Xiaomi
              /\b(poco[\w ]+)(?: bui|\))/i,                                       // Xiaomi POCO
              /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
              /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
              /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
              /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
              /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

              // OPPO
              /; (\w+) bui.+ oppo/i,
              /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [

              // Vivo
              /vivo (\w+)(?: bui|\))/i,
              /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

              // Realme
              /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

              // Motorola
              /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
              /\bmot(?:orola)?[- ](\w*)/i,
              /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
              /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

              // LG
              /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
              /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
              /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
              /\blg-?([\d\w]+) bui/i
            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

              // Lenovo
              /(ideatab[-\w ]+)/i,
              /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

              // Nokia
              /(?:maemo|nokia).*(n900|lumia \d+)/i,
              /nokia[-_ ]?([-\w\.]*)/i
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

              // Google
              /(pixel c)\b/i                                                      // Google Pixel C
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
              /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

              // Sony
              /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
              /sony tablet [ps]/i,
              /\b(?:sony)?sgp\w+(?: bui|\))/i
            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

              // OnePlus
              / (kb2005|in20[12]5|be20[12][59])\b/i,
              /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

              // Amazon
              /(alexa)webm/i,
              /(kf[a-z]{2}wi)( bui|\))/i,                                         // Kindle Fire without Silk
              /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
              /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

              // BlackBerry
              /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [
              /\b((?:bb[a-f]|st[hv])100-\d)/i,
              /\(bb10; (\w+)/i                                                    // BlackBerry 10
            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

              // Asus
              /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
              / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

              // HTC
              /(nexus 9)/i                                                        // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
              /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

              // ZTE
              /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
              /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

              // Acer
              /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

              // Meizu
              /droid.+; (m[1-5] note) bui/i,
              /\bmz-([-\w]{2,})/i
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [

              // Sharp
              /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, MOBILE]], [

              // MIXED
              /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
              // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
              /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
              /(asus)-?(\w+)/i,                                                   // Asus
              /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
              /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
              /(jolla)/i,                                                         // Jolla
              /(oppo) ?([\w ]+) bui/i                                             // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

              /(archos) (gamepad2?)/i,                                            // Archos
              /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
              /(kindle)\/([\w\.]+)/i,                                             // Kindle
              /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
              /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
              /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
              /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
              /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
              /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

              /(surface duo)/i                                                    // Surface Duo
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
              /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
              /(u304aa)/i                                                         // AT&T
            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
              /\bsie-(\w*)/i                                                      // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
              /\b(rct\w+) b/i                                                     // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
              /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
              /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
              /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
              /\b(tm\d{3}\w+) b/i
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
              /\b(k88) b/i                                                        // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
              /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
              /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
              /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
              /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
              /\b([yr]\d{2}) b/i,
              /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
              /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
              /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
              /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
              /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
              /\b(ph-1) /i                                                        // Essential PH-1
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
              /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
              /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
              /\btu_(1491) b/i                                                    // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
              /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
              /(sprint) (\w+)/i                                                   // Sprint Phones
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
              /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
              /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
              /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

              ///////////////////
              // CONSOLES
              ///////////////////

              /(ouya)/i,                                                          // Ouya
              /(nintendo) ([wids3utch]+)/i                                        // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
              /droid.+; (shield) bui/i                                            // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
              /(playstation [345portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
              /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

              ///////////////////
              // SMARTTVS
              ///////////////////

              /smart-tv.+(samsung)/i                                              // Samsung
            ], [VENDOR, [TYPE, SMARTTV]], [
              /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
              /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
              /(apple) ?tv/i                                                      // Apple TV
            ], [VENDOR, [MODEL, APPLE + ' TV'], [TYPE, SMARTTV]], [
              /crkey/i                                                            // Google Chromecast
            ], [[MODEL, CHROME + 'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
              /droid.+aft(\w)( bui|\))/i                                          // Fire TV
            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
              /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
              /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
              /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i               // HbbTV devices
            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
              /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
            ], [[TYPE, SMARTTV]], [

              ///////////////////
              // WEARABLES
              ///////////////////

              /((pebble))app/i                                                    // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
              /droid.+; (glass) \d/i                                              // Google Glass
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
              /droid.+; (wt63?0{2,3})\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
              /(quest( 2)?)/i                                                     // Oculus Quest
            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

              ///////////////////
              // EMBEDDED
              ///////////////////

              /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
            ], [VENDOR, [TYPE, EMBEDDED]], [

              ////////////////////
              // MIXED (GENERIC)
              ///////////////////

              /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i           // Android Phones from Unidentified Vendors
            ], [MODEL, [TYPE, MOBILE]], [
              /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
            ], [MODEL, [TYPE, TABLET]], [
              /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
            ], [[TYPE, TABLET]], [
              /(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i              // Unidentifiable Mobile
            ], [[TYPE, MOBILE]], [
              /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
            ],

            engine: [[

              /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, EDGE + 'HTML']], [

              /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
            ], [VERSION, [NAME, 'Blink']], [

              /(presto)\/([\w\.]+)/i,                                             // Presto
              /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
              /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
              /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
              /(icab)[\/ ]([23]\.[\d\.]+)/i                                       // iCab
            ], [NAME, VERSION], [

              /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
            ], [VERSION, NAME]
            ],

            os: [[

              // Windows
              /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
            ], [NAME, VERSION], [
              /(windows) nt 6\.2; (arm)/i,                                        // Windows RT
              /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,            // Windows Phone
              /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
              /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, strMapper, windowsVersionMap]], [

              // iOS/macOS
              /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
              /cfnetwork\/.+darwin/i
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
              /(mac os x) ?([\w\. ]*)/i,
              /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

              // Mobile OSes
              /droid ([\w\.]+)\b.+(android[- ]x86)/i                              // Android-x86
            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
              /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
              /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
              /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
              /\((series40);/i                                                    // Series 40
            ], [NAME, VERSION], [
              /\(bb(10);/i                                                        // BlackBerry 10
            ], [VERSION, [NAME, BLACKBERRY]], [
              /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
            ], [VERSION, [NAME, 'Symbian']], [
              /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ], [VERSION, [NAME, FIREFOX + ' OS']], [
              /web0s;.+rt(tv)/i,
              /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
            ], [VERSION, [NAME, 'webOS']], [

              // Google Chromecast
              /crkey\/([\d\.]+)/i                                                 // Google Chromecast
            ], [VERSION, [NAME, CHROME + 'cast']], [
              /(cros) [\w]+ ([\w\.]+\w)/i                                         // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION], [

              // Console
              /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
              /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

              // Other
              /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
              /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
              /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
              /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
              // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
              /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
              /(gnu) ?([\w\.]*)/i,                                                // GNU
              /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
              /(haiku) (\w+)/i                                                    // Haiku
            ], [NAME, VERSION], [
              /(sunos) ?([\w\.\d]*)/i                                             // Solaris
            ], [[NAME, 'Solaris'], VERSION], [
              /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
              /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
              /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,            // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
              /(unix) ?([\w\.]*)/i                                                // UNIX
            ], [NAME, VERSION]
            ]
          };

          /////////////////
          // Constructor
          ////////////////

          var UAParser = function (ua, extensions) {

            if (typeof ua === OBJ_TYPE) {
              extensions = ua;
              ua = undefined;
            }

            if (!(this instanceof UAParser)) {
              return new UAParser(ua, extensions).getResult();
            }

            var _ua = ua || ((typeof window !== UNDEF_TYPE && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
            var _rgxmap = extensions ? extend(regexes, extensions) : regexes;

            this.getBrowser = function () {
              var _browser = {};
              _browser[NAME] = undefined;
              _browser[VERSION] = undefined;
              rgxMapper.call(_browser, _ua, _rgxmap.browser);
              _browser.major = majorize(_browser.version);
              return _browser;
            };
            this.getCPU = function () {
              var _cpu = {};
              _cpu[ARCHITECTURE] = undefined;
              rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
              return _cpu;
            };
            this.getDevice = function () {
              var _device = {};
              _device[VENDOR] = undefined;
              _device[MODEL] = undefined;
              _device[TYPE] = undefined;
              rgxMapper.call(_device, _ua, _rgxmap.device);
              return _device;
            };
            this.getEngine = function () {
              var _engine = {};
              _engine[NAME] = undefined;
              _engine[VERSION] = undefined;
              rgxMapper.call(_engine, _ua, _rgxmap.engine);
              return _engine;
            };
            this.getOS = function () {
              var _os = {};
              _os[NAME] = undefined;
              _os[VERSION] = undefined;
              rgxMapper.call(_os, _ua, _rgxmap.os);
              return _os;
            };
            this.getResult = function () {
              return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
              };
            };
            this.getUA = function () {
              return _ua;
            };
            this.setUA = function (ua) {
              _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
              return this;
            };
            this.setUA(_ua);
            return this;
          };

          UAParser.VERSION = LIBVERSION;
          UAParser.BROWSER = enumerize([NAME, VERSION, MAJOR]);
          UAParser.CPU = enumerize([ARCHITECTURE]);
          UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
          UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

          ///////////
          // Export
          //////////

          // check js environment
          if (typeof (exports) !== UNDEF_TYPE) {
            // nodejs env
            if ("object" !== UNDEF_TYPE && module.exports) {
              exports = module.exports = UAParser;
            }
            exports.UAParser = UAParser;
          } else {
            // requirejs env (optional)
            if ("function" === FUNC_TYPE && __webpack_require__.amdO) {
              !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
              }).call(exports, __webpack_require__, exports, module),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else if (typeof window !== UNDEF_TYPE) {
              // browser env
              window.UAParser = UAParser;
            }
          }

          // jQuery/Zepto specific (optional)
          // Note:
          //   In AMD env the global scope should be kept clean, but jQuery is an exception.
          //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
          //   and we should catch that.
          var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
          if ($ && !$.ua) {
            var parser = new UAParser();
            $.ua = parser.getResult();
            $.ua.get = function () {
              return parser.getUA();
            };
            $.ua.set = function (ua) {
              parser.setUA(ua);
              var result = parser.getResult();
              for (var prop in result) {
                $.ua[prop] = result[prop];
              }
            };
          }

        })(typeof window === 'object' ? window : this);


        /***/
}),

/***/ "./node_modules/throttle-debounce/esm/index.js":
/*!*****************************************************!*\
  !*** ./node_modules/throttle-debounce/esm/index.js ***!
  \*****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "debounce": () => (/* binding */ debounce),
/* harmony export */   "throttle": () => (/* binding */ throttle)
          /* harmony export */
});
        /* eslint-disable no-undefined,no-param-reassign,no-shadow */

        /**
         * Throttle execution of a function. Especially useful for rate limiting
         * execution of handlers on events like resize and scroll.
         *
         * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
         *                                            are most useful.
         * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
         *                                            as-is, to `callback` when the throttled-function is executed.
         * @param {object} [options] -              An object to configure options.
         * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
         *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
         *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
         *                                            `delay` milliseconds, the internal counter is reset).
         * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
         *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
         *                                            callback will never executed if both noLeading = true and noTrailing = true.
         * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
         *                                            false (at end), schedule `callback` to execute after `delay` ms.
         *
         * @returns {Function} A new, throttled, function.
         */
        function throttle(delay, callback, options) {
          var _ref = options || {},
            _ref$noTrailing = _ref.noTrailing,
            noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing,
            _ref$noLeading = _ref.noLeading,
            noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading,
            _ref$debounceMode = _ref.debounceMode,
            debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
          /*
           * After wrapper has stopped being called, this timeout ensures that
           * `callback` is executed at the proper times in `throttle` and `end`
           * debounce modes.
           */


          var timeoutID;
          var cancelled = false; // Keep track of the last time `callback` was executed.

          var lastExec = 0; // Function to clear existing timeout

          function clearExistingTimeout() {
            if (timeoutID) {
              clearTimeout(timeoutID);
            }
          } // Function to cancel next exec


          function cancel(options) {
            var _ref2 = options || {},
              _ref2$upcomingOnly = _ref2.upcomingOnly,
              upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;

            clearExistingTimeout();
            cancelled = !upcomingOnly;
          }
          /*
           * The `wrapper` function encapsulates all of the throttling / debouncing
           * functionality and when executed will limit the rate at which `callback`
           * is executed.
           */


          function wrapper() {
            for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
              arguments_[_key] = arguments[_key];
            }

            var self = this;
            var elapsed = Date.now() - lastExec;

            if (cancelled) {
              return;
            } // Execute `callback` and update the `lastExec` timestamp.


            function exec() {
              lastExec = Date.now();
              callback.apply(self, arguments_);
            }
            /*
             * If `debounceMode` is true (at begin) this is used to clear the flag
             * to allow future `callback` executions.
             */


            function clear() {
              timeoutID = undefined;
            }

            if (!noLeading && debounceMode && !timeoutID) {
              /*
               * Since `wrapper` is being called for the first time and
               * `debounceMode` is true (at begin), execute `callback`
               * and noLeading != true.
               */
              exec();
            }

            clearExistingTimeout();

            if (debounceMode === undefined && elapsed > delay) {
              if (noLeading) {
                /*
                 * In throttle mode with noLeading, if `delay` time has
                 * been exceeded, update `lastExec` and schedule `callback`
                 * to execute after `delay` ms.
                 */
                lastExec = Date.now();

                if (!noTrailing) {
                  timeoutID = setTimeout(debounceMode ? clear : exec, delay);
                }
              } else {
                /*
                 * In throttle mode without noLeading, if `delay` time has been exceeded, execute
                 * `callback`.
                 */
                exec();
              }
            } else if (noTrailing !== true) {
              /*
               * In trailing throttle mode, since `delay` time has not been
               * exceeded, schedule `callback` to execute `delay` ms after most
               * recent execution.
               *
               * If `debounceMode` is true (at begin), schedule `clear` to execute
               * after `delay` ms.
               *
               * If `debounceMode` is false (at end), schedule `callback` to
               * execute after `delay` ms.
               */
              timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
            }
          }

          wrapper.cancel = cancel; // Return the wrapper function.

          return wrapper;
        }

        /* eslint-disable no-undefined */
        /**
         * Debounce execution of a function. Debouncing, unlike throttling,
         * guarantees that a function is only executed a single time, either at the
         * very beginning of a series of calls, or at the very end.
         *
         * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
         * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
         *                                        to `callback` when the debounced-function is executed.
         * @param {object} [options] -           An object to configure options.
         * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
         *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
         *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
         *
         * @returns {Function} A new, debounced function.
         */

        function debounce(delay, callback, options) {
          var _ref = options || {},
            _ref$atBegin = _ref.atBegin,
            atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;

          return throttle(delay, callback, {
            debounceMode: atBegin !== false
          });
        }


        //# sourceMappingURL=index.js.map


        /***/
})

    /******/
});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
      /******/
}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
      /******/
};
/******/
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
    /******/
}
/******/
/************************************************************************/
/******/ 	/* webpack/runtime/amd options */
/******/ 	(() => {
/******/ 		__webpack_require__.amdO = {};
    /******/
})();
/******/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
      /******/
};
    /******/
})();
/******/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for (var key in definition) {
/******/ 				if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
          /******/
}
        /******/
}
      /******/
};
    /******/
})();
/******/
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
    /******/
})();
/******/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
        /******/
}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
      /******/
};
    /******/
})();
  /******/
  /************************************************************************/
  var __webpack_exports__ = {};
  // This entry need to be wrapped in an IIFE because it need to be in strict mode.
  (() => {
    "use strict";
    /*!***************************!*\
      !*** ./assets/js/main.js ***!
      \***************************/
    __webpack_require__.r(__webpack_exports__);
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-carousel */ "./node_modules/slick-carousel/slick/slick.js");
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_carousel__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _foundation_ua_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation/ua.js */ "./assets/js/foundation/ua.js");
/* harmony import */ var _layout_l_wrapper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./layout/l-wrapper.js */ "./assets/js/layout/l-wrapper.js");
/* harmony import */ var _layout_l_container_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./layout/l-container.js */ "./assets/js/layout/l-container.js");
/* harmony import */ var _component_c_announce_bar_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./component/c-announce_bar.js */ "./assets/js/component/c-announce_bar.js");
/* harmony import */ var _component_c_gmenu_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./component/c-gmenu.js */ "./assets/js/component/c-gmenu.js");
/* harmony import */ var _component_c_fixed_popup_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./component/c-fixed_popup.js */ "./assets/js/component/c-fixed_popup.js");
/* harmony import */ var _component_c_welcome_modal_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./component/c-welcome_modal.js */ "./assets/js/component/c-welcome_modal.js");
/* harmony import */ var _component_c_product_img_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./component/c-product_img.js */ "./assets/js/component/c-product_img.js");
/* harmony import */ var _component_c_review_star_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./component/c-review_star.js */ "./assets/js/component/c-review_star.js");
/* harmony import */ var _component_c_order_quantity_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./component/c-order_quantity.js */ "./assets/js/component/c-order_quantity.js");
/* harmony import */ var _component_c_account_menu_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./component/c-account_menu.js */ "./assets/js/component/c-account_menu.js");
/* harmony import */ var _component_c_subscribe_form__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./component/c-subscribe-form */ "./assets/js/component/c-subscribe-form.js");
/* harmony import */ var _component_c_subscribe_form__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_component_c_subscribe_form__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _component_c_recommend_product__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./component/c-recommend_product */ "./assets/js/component/c-recommend_product.js");
/* harmony import */ var _project_p_kv_slider_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./project/p-kv_slider.js */ "./assets/js/project/p-kv_slider.js");
/* harmony import */ var _project_p_movie_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./project/p-movie.js */ "./assets/js/project/p-movie.js");
/* harmony import */ var _project_p_review_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./project/p-review.js */ "./assets/js/project/p-review.js");
/* harmony import */ var _project_p_faq_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./project/p-faq.js */ "./assets/js/project/p-faq.js");
/* harmony import */ var _project_p_checkout_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./project/p-checkout.js */ "./assets/js/project/p-checkout.js");
/* harmony import */ var _project_p_payment_list_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./project/p-payment_list.js */ "./assets/js/project/p-payment_list.js");
/* harmony import */ var _project_p_registration__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./project/p-registration */ "./assets/js/project/p-registration.js");
/* harmony import */ var _project_p_registration__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_project_p_registration__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _project_p_instagram__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./project/p-instagram */ "./assets/js/project/p-instagram.js");
/* harmony import */ var _project_p_set__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./project/p-set */ "./assets/js/project/p-set.js");
/* harmony import */ var _project_p_browsing_history__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./project/p-browsing_history */ "./assets/js/project/p-browsing_history.js");
/* harmony import */ var _project_p_subscription_detail__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./project/p-subscription_detail */ "./assets/js/project/p-subscription_detail.js");
/* harmony import */ var _project_p_product_slider__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./project/p-product_slider */ "./assets/js/project/p-product_slider.js");
/* harmony import */ var _project_p_product_slider__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_project_p_product_slider__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _sass_style_scss__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../sass/style.scss */ "./assets/sass/style.scss");
    // polyfill
    // import "core-js/stable"
    // import "regenerator-runtime/runtime"

    // foundation

    // layout


    // component










    // project













    /*
     * Not included in bundle.js because ecforce has the code.
     * https://super-studio.atlassian.net/browse/ECFTHEME-76
     */
    // import "./project/p-carousel_slider"
    // scss


  })();

  /******/
})()
  ;